export const 
  locations = [
    {
      "linea": 1,
      "punto": 1,
      "latitudeE7": 5.371689,
      "longitudeE7": -71.833868,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 1,
      "punto": 2,
      "latitudeE7": 5.371683,
      "longitudeE7": -71.83383,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 1,
      "punto": 3,
      "latitudeE7": 5.371677,
      "longitudeE7": -71.833793,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 1,
      "punto": 4,
      "latitudeE7": 5.371671,
      "longitudeE7": -71.833755,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 1,
      "punto": 5,
      "latitudeE7": 5.371665,
      "longitudeE7": -71.833717,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 1,
      "punto": 6,
      "latitudeE7": 5.371659,
      "longitudeE7": -71.833679,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 1,
      "punto": 7,
      "latitudeE7": 5.371653,
      "longitudeE7": -71.833642,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 1,
      "punto": 8,
      "latitudeE7": 5.371647,
      "longitudeE7": -71.833604,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 1,
      "punto": 9,
      "latitudeE7": 5.371641,
      "longitudeE7": -71.833566,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 1,
      "punto": 10,
      "latitudeE7": 5.371635,
      "longitudeE7": -71.833529,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 1,
      "punto": 11,
      "latitudeE7": 5.371629,
      "longitudeE7": -71.833491,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 1,
      "punto": 12,
      "latitudeE7": 5.371623,
      "longitudeE7": -71.833453,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 1,
      "punto": 13,
      "latitudeE7": 5.371617,
      "longitudeE7": -71.833415,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 1,
      "punto": 14,
      "latitudeE7": 5.371611,
      "longitudeE7": -71.833378,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 1,
      "punto": 15,
      "latitudeE7": 5.371605,
      "longitudeE7": -71.83334,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 1,
      "punto": 16,
      "latitudeE7": 5.371599,
      "longitudeE7": -71.833302,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 1,
      "punto": 17,
      "latitudeE7": 5.371593,
      "longitudeE7": -71.833264,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 1,
      "punto": 18,
      "latitudeE7": 5.371587,
      "longitudeE7": -71.833227,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 1,
      "punto": 19,
      "latitudeE7": 5.371581,
      "longitudeE7": -71.833189,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 1,
      "punto": 20,
      "latitudeE7": 5.371575,
      "longitudeE7": -71.833151,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 1,
      "punto": 21,
      "latitudeE7": 5.371569,
      "longitudeE7": -71.833114,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 1,
      "punto": 22,
      "latitudeE7": 5.371563,
      "longitudeE7": -71.833076,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 1,
      "punto": 23,
      "latitudeE7": 5.371557,
      "longitudeE7": -71.833038,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 1,
      "punto": 24,
      "latitudeE7": 5.371551,
      "longitudeE7": -71.833,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 1,
      "punto": 25,
      "latitudeE7": 5.371545,
      "longitudeE7": -71.832963,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 1,
      "punto": 26,
      "latitudeE7": 5.371539,
      "longitudeE7": -71.832925,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 1,
      "punto": 27,
      "latitudeE7": 5.371533,
      "longitudeE7": -71.832887,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 1,
      "punto": 28,
      "latitudeE7": 5.371527,
      "longitudeE7": -71.83285,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 1,
      "punto": 29,
      "latitudeE7": 5.371521,
      "longitudeE7": -71.832812,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 1,
      "punto": 30,
      "latitudeE7": 5.371515,
      "longitudeE7": -71.832774,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 1,
      "punto": 31,
      "latitudeE7": 5.371509,
      "longitudeE7": -71.832736,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 1,
      "punto": 32,
      "latitudeE7": 5.371503,
      "longitudeE7": -71.832699,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 1,
      "punto": 33,
      "latitudeE7": 5.371497,
      "longitudeE7": -71.832661,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 1,
      "punto": 34,
      "latitudeE7": 5.371491,
      "longitudeE7": -71.832623,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 1,
      "punto": 35,
      "latitudeE7": 5.371485,
      "longitudeE7": -71.832586,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 1,
      "punto": 36,
      "latitudeE7": 5.371479,
      "longitudeE7": -71.832548,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 1,
      "punto": 37,
      "latitudeE7": 5.371473,
      "longitudeE7": -71.83251,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 1,
      "punto": 38,
      "latitudeE7": 5.371467,
      "longitudeE7": -71.832472,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 1,
      "punto": 39,
      "latitudeE7": 5.371461,
      "longitudeE7": -71.832435,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 1,
      "punto": 40,
      "latitudeE7": 5.371455,
      "longitudeE7": -71.832397,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 1,
      "punto": 41,
      "latitudeE7": 5.371449,
      "longitudeE7": -71.832359,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 1,
      "punto": 42,
      "latitudeE7": 5.371443,
      "longitudeE7": -71.832321,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 1,
      "punto": 43,
      "latitudeE7": 5.371437,
      "longitudeE7": -71.832284,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 1,
      "punto": 44,
      "latitudeE7": 5.371431,
      "longitudeE7": -71.832246,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 1,
      "punto": 45,
      "latitudeE7": 5.371425,
      "longitudeE7": -71.832208,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 1,
      "punto": 46,
      "latitudeE7": 5.371419,
      "longitudeE7": -71.832171,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 1,
      "punto": 47,
      "latitudeE7": 5.371413,
      "longitudeE7": -71.832133,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 1,
      "punto": 48,
      "latitudeE7": 5.371407,
      "longitudeE7": -71.832095,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 1,
      "punto": 49,
      "latitudeE7": 5.371401,
      "longitudeE7": -71.832057,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 1,
      "punto": 50,
      "latitudeE7": 5.371395,
      "longitudeE7": -71.83202,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 1,
      "punto": 51,
      "latitudeE7": 5.371389,
      "longitudeE7": -71.831982,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 1,
      "punto": 52,
      "latitudeE7": 5.371383,
      "longitudeE7": -71.831944,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 1,
      "punto": 53,
      "latitudeE7": 5.371377,
      "longitudeE7": -71.831907,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 1,
      "punto": 54,
      "latitudeE7": 5.371371,
      "longitudeE7": -71.831869,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 1,
      "punto": 55,
      "latitudeE7": 5.371365,
      "longitudeE7": -71.831831,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 1,
      "punto": 56,
      "latitudeE7": 5.371359,
      "longitudeE7": -71.831793,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 1,
      "punto": 57,
      "latitudeE7": 5.371353,
      "longitudeE7": -71.831756,
      "accuracy": 15,
      "porcentaje": 0.4
    },
    {
      "linea": 1,
      "punto": 58,
      "latitudeE7": 5.371347,
      "longitudeE7": -71.831718,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 1,
      "punto": 59,
      "latitudeE7": 5.371341,
      "longitudeE7": -71.83168,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 1,
      "punto": 60,
      "latitudeE7": 5.371335,
      "longitudeE7": -71.831643,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 1,
      "punto": 61,
      "latitudeE7": 5.371329,
      "longitudeE7": -71.831605,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 1,
      "punto": 62,
      "latitudeE7": 5.371323,
      "longitudeE7": -71.831567,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 1,
      "punto": 63,
      "latitudeE7": 5.371317,
      "longitudeE7": -71.831529,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 1,
      "punto": 64,
      "latitudeE7": 5.371311,
      "longitudeE7": -71.831492,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 1,
      "punto": 65,
      "latitudeE7": 5.371305,
      "longitudeE7": -71.831454,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 1,
      "punto": 66,
      "latitudeE7": 5.371299,
      "longitudeE7": -71.831416,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 1,
      "punto": 67,
      "latitudeE7": 5.371293,
      "longitudeE7": -71.831378,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 1,
      "punto": 68,
      "latitudeE7": 5.371287,
      "longitudeE7": -71.831341,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 1,
      "punto": 69,
      "latitudeE7": 5.371281,
      "longitudeE7": -71.831303,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 1,
      "punto": 70,
      "latitudeE7": 5.371275,
      "longitudeE7": -71.831265,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 1,
      "punto": 71,
      "latitudeE7": 5.371269,
      "longitudeE7": -71.831228,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 1,
      "punto": 72,
      "latitudeE7": 5.371263,
      "longitudeE7": -71.83119,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 1,
      "punto": 73,
      "latitudeE7": 5.371257,
      "longitudeE7": -71.831152,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 1,
      "punto": 74,
      "latitudeE7": 5.371251,
      "longitudeE7": -71.831114,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 1,
      "punto": 75,
      "latitudeE7": 5.371245,
      "longitudeE7": -71.831077,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 1,
      "punto": 76,
      "latitudeE7": 5.371239,
      "longitudeE7": -71.831039,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 1,
      "punto": 77,
      "latitudeE7": 5.371233,
      "longitudeE7": -71.831001,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 1,
      "punto": 78,
      "latitudeE7": 5.371227,
      "longitudeE7": -71.830964,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 1,
      "punto": 79,
      "latitudeE7": 5.371221,
      "longitudeE7": -71.830926,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 1,
      "punto": 80,
      "latitudeE7": 5.371215,
      "longitudeE7": -71.830888,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 1,
      "punto": 81,
      "latitudeE7": 5.371209,
      "longitudeE7": -71.83085,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 1,
      "punto": 82,
      "latitudeE7": 5.371203,
      "longitudeE7": -71.830813,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 1,
      "punto": 83,
      "latitudeE7": 5.371197,
      "longitudeE7": -71.830775,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 1,
      "punto": 84,
      "latitudeE7": 5.371191,
      "longitudeE7": -71.830737,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 1,
      "punto": 85,
      "latitudeE7": 5.371185,
      "longitudeE7": -71.8307,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 1,
      "punto": 86,
      "latitudeE7": 5.371179,
      "longitudeE7": -71.830662,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 1,
      "punto": 87,
      "latitudeE7": 5.371173,
      "longitudeE7": -71.830624,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 1,
      "punto": 88,
      "latitudeE7": 5.371167,
      "longitudeE7": -71.830586,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 1,
      "punto": 89,
      "latitudeE7": 5.371161,
      "longitudeE7": -71.830549,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 1,
      "punto": 90,
      "latitudeE7": 5.371155,
      "longitudeE7": -71.830511,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 1,
      "punto": 91,
      "latitudeE7": 5.371149,
      "longitudeE7": -71.830473,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 1,
      "punto": 92,
      "latitudeE7": 5.371143,
      "longitudeE7": -71.830435,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 1,
      "punto": 93,
      "latitudeE7": 5.371137,
      "longitudeE7": -71.830398,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 1,
      "punto": 94,
      "latitudeE7": 5.371131,
      "longitudeE7": -71.83036,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 1,
      "punto": 95,
      "latitudeE7": 5.371125,
      "longitudeE7": -71.830322,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 1,
      "punto": 96,
      "latitudeE7": 5.371119,
      "longitudeE7": -71.830285,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 1,
      "punto": 97,
      "latitudeE7": 5.371113,
      "longitudeE7": -71.830247,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 1,
      "punto": 98,
      "latitudeE7": 5.371107,
      "longitudeE7": -71.830209,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 1,
      "punto": 99,
      "latitudeE7": 5.371101,
      "longitudeE7": -71.830171,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 1,
      "punto": 100,
      "latitudeE7": 5.371095,
      "longitudeE7": -71.830134,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 1,
      "punto": 101,
      "latitudeE7": 5.371089,
      "longitudeE7": -71.830096,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 1,
      "punto": 102,
      "latitudeE7": 5.371083,
      "longitudeE7": -71.830058,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 1,
      "punto": 103,
      "latitudeE7": 5.371077,
      "longitudeE7": -71.830021,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 1,
      "punto": 104,
      "latitudeE7": 5.371071,
      "longitudeE7": -71.829983,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 1,
      "punto": 105,
      "latitudeE7": 5.371065,
      "longitudeE7": -71.829945,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 1,
      "punto": 106,
      "latitudeE7": 5.371059,
      "longitudeE7": -71.829907,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 1,
      "punto": 107,
      "latitudeE7": 5.371053,
      "longitudeE7": -71.82987,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 1,
      "punto": 108,
      "latitudeE7": 5.371047,
      "longitudeE7": -71.829832,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 1,
      "punto": 109,
      "latitudeE7": 5.371041,
      "longitudeE7": -71.829794,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 1,
      "punto": 110,
      "latitudeE7": 5.371035,
      "longitudeE7": -71.829757,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 1,
      "punto": 111,
      "latitudeE7": 5.371029,
      "longitudeE7": -71.829719,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 1,
      "punto": 112,
      "latitudeE7": 5.371023,
      "longitudeE7": -71.829681,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 1,
      "punto": 113,
      "latitudeE7": 5.371017,
      "longitudeE7": -71.829643,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 1,
      "punto": 114,
      "latitudeE7": 5.371011,
      "longitudeE7": -71.829606,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 2,
      "punto": 1,
      "latitudeE7": 5.371649,
      "longitudeE7": -71.833893,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 2,
      "punto": 2,
      "latitudeE7": 5.371643,
      "longitudeE7": -71.833855,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 2,
      "punto": 3,
      "latitudeE7": 5.371637,
      "longitudeE7": -71.833818,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 2,
      "punto": 4,
      "latitudeE7": 5.371631,
      "longitudeE7": -71.83378,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 2,
      "punto": 5,
      "latitudeE7": 5.371625,
      "longitudeE7": -71.833742,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 2,
      "punto": 6,
      "latitudeE7": 5.371619,
      "longitudeE7": -71.833704,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 2,
      "punto": 7,
      "latitudeE7": 5.371613,
      "longitudeE7": -71.833667,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 2,
      "punto": 8,
      "latitudeE7": 5.371607,
      "longitudeE7": -71.833629,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 2,
      "punto": 9,
      "latitudeE7": 5.371601,
      "longitudeE7": -71.833591,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 2,
      "punto": 10,
      "latitudeE7": 5.371595,
      "longitudeE7": -71.833553,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 2,
      "punto": 11,
      "latitudeE7": 5.371589,
      "longitudeE7": -71.833516,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 2,
      "punto": 12,
      "latitudeE7": 5.371583,
      "longitudeE7": -71.833478,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 2,
      "punto": 13,
      "latitudeE7": 5.371577,
      "longitudeE7": -71.83344,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 2,
      "punto": 14,
      "latitudeE7": 5.371571,
      "longitudeE7": -71.833403,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 2,
      "punto": 15,
      "latitudeE7": 5.371565,
      "longitudeE7": -71.833365,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 2,
      "punto": 16,
      "latitudeE7": 5.371559,
      "longitudeE7": -71.833327,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 2,
      "punto": 17,
      "latitudeE7": 5.371553,
      "longitudeE7": -71.833289,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 2,
      "punto": 18,
      "latitudeE7": 5.371547,
      "longitudeE7": -71.833252,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 2,
      "punto": 19,
      "latitudeE7": 5.371541,
      "longitudeE7": -71.833214,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 2,
      "punto": 20,
      "latitudeE7": 5.371535,
      "longitudeE7": -71.833176,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 2,
      "punto": 21,
      "latitudeE7": 5.371529,
      "longitudeE7": -71.833139,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 2,
      "punto": 22,
      "latitudeE7": 5.371523,
      "longitudeE7": -71.833101,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 2,
      "punto": 23,
      "latitudeE7": 5.371517,
      "longitudeE7": -71.833063,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 2,
      "punto": 24,
      "latitudeE7": 5.371511,
      "longitudeE7": -71.833025,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 2,
      "punto": 25,
      "latitudeE7": 5.371505,
      "longitudeE7": -71.832988,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 2,
      "punto": 26,
      "latitudeE7": 5.371499,
      "longitudeE7": -71.83295,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 2,
      "punto": 27,
      "latitudeE7": 5.371493,
      "longitudeE7": -71.832912,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 2,
      "punto": 28,
      "latitudeE7": 5.371487,
      "longitudeE7": -71.832875,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 2,
      "punto": 29,
      "latitudeE7": 5.371481,
      "longitudeE7": -71.832837,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 2,
      "punto": 30,
      "latitudeE7": 5.371475,
      "longitudeE7": -71.832799,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 2,
      "punto": 31,
      "latitudeE7": 5.371469,
      "longitudeE7": -71.832761,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 2,
      "punto": 32,
      "latitudeE7": 5.371463,
      "longitudeE7": -71.832724,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 2,
      "punto": 33,
      "latitudeE7": 5.371457,
      "longitudeE7": -71.832686,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 2,
      "punto": 34,
      "latitudeE7": 5.371451,
      "longitudeE7": -71.832648,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 2,
      "punto": 35,
      "latitudeE7": 5.371445,
      "longitudeE7": -71.83261,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 2,
      "punto": 36,
      "latitudeE7": 5.371439,
      "longitudeE7": -71.832573,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 2,
      "punto": 37,
      "latitudeE7": 5.371433,
      "longitudeE7": -71.832535,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 2,
      "punto": 38,
      "latitudeE7": 5.371427,
      "longitudeE7": -71.832497,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 2,
      "punto": 39,
      "latitudeE7": 5.371421,
      "longitudeE7": -71.83246,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 2,
      "punto": 40,
      "latitudeE7": 5.371415,
      "longitudeE7": -71.832422,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 2,
      "punto": 41,
      "latitudeE7": 5.371409,
      "longitudeE7": -71.832384,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 2,
      "punto": 42,
      "latitudeE7": 5.371403,
      "longitudeE7": -71.832346,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 2,
      "punto": 43,
      "latitudeE7": 5.371397,
      "longitudeE7": -71.832309,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 2,
      "punto": 44,
      "latitudeE7": 5.371391,
      "longitudeE7": -71.832271,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 2,
      "punto": 45,
      "latitudeE7": 5.371385,
      "longitudeE7": -71.832233,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 2,
      "punto": 46,
      "latitudeE7": 5.371379,
      "longitudeE7": -71.832196,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 2,
      "punto": 47,
      "latitudeE7": 5.371373,
      "longitudeE7": -71.832158,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 2,
      "punto": 48,
      "latitudeE7": 5.371367,
      "longitudeE7": -71.83212,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 2,
      "punto": 49,
      "latitudeE7": 5.371361,
      "longitudeE7": -71.832082,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 2,
      "punto": 50,
      "latitudeE7": 5.371355,
      "longitudeE7": -71.832045,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 2,
      "punto": 51,
      "latitudeE7": 5.371349,
      "longitudeE7": -71.832007,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 2,
      "punto": 52,
      "latitudeE7": 5.371343,
      "longitudeE7": -71.831969,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 2,
      "punto": 53,
      "latitudeE7": 5.371337,
      "longitudeE7": -71.831932,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 2,
      "punto": 54,
      "latitudeE7": 5.371331,
      "longitudeE7": -71.831894,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 2,
      "punto": 55,
      "latitudeE7": 5.371325,
      "longitudeE7": -71.831856,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 2,
      "punto": 56,
      "latitudeE7": 5.371319,
      "longitudeE7": -71.831818,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 2,
      "punto": 57,
      "latitudeE7": 5.371313,
      "longitudeE7": -71.831781,
      "accuracy": 15,
      "porcentaje": 0.28
    },
    {
      "linea": 2,
      "punto": 58,
      "latitudeE7": 5.371307,
      "longitudeE7": -71.831743,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 2,
      "punto": 59,
      "latitudeE7": 5.371301,
      "longitudeE7": -71.831705,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 2,
      "punto": 60,
      "latitudeE7": 5.371295,
      "longitudeE7": -71.831667,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 2,
      "punto": 61,
      "latitudeE7": 5.371289,
      "longitudeE7": -71.83163,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 2,
      "punto": 62,
      "latitudeE7": 5.371283,
      "longitudeE7": -71.831592,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 2,
      "punto": 63,
      "latitudeE7": 5.371277,
      "longitudeE7": -71.831554,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 2,
      "punto": 64,
      "latitudeE7": 5.371271,
      "longitudeE7": -71.831517,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 2,
      "punto": 65,
      "latitudeE7": 5.371265,
      "longitudeE7": -71.831479,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 2,
      "punto": 66,
      "latitudeE7": 5.371259,
      "longitudeE7": -71.831441,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 2,
      "punto": 67,
      "latitudeE7": 5.371253,
      "longitudeE7": -71.831403,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 2,
      "punto": 68,
      "latitudeE7": 5.371247,
      "longitudeE7": -71.831366,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 2,
      "punto": 69,
      "latitudeE7": 5.371241,
      "longitudeE7": -71.831328,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 2,
      "punto": 70,
      "latitudeE7": 5.371235,
      "longitudeE7": -71.83129,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 2,
      "punto": 71,
      "latitudeE7": 5.371229,
      "longitudeE7": -71.831253,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 2,
      "punto": 72,
      "latitudeE7": 5.371223,
      "longitudeE7": -71.831215,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 2,
      "punto": 73,
      "latitudeE7": 5.371217,
      "longitudeE7": -71.831177,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 2,
      "punto": 74,
      "latitudeE7": 5.371211,
      "longitudeE7": -71.831139,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 2,
      "punto": 75,
      "latitudeE7": 5.371205,
      "longitudeE7": -71.831102,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 2,
      "punto": 76,
      "latitudeE7": 5.371199,
      "longitudeE7": -71.831064,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 2,
      "punto": 77,
      "latitudeE7": 5.371193,
      "longitudeE7": -71.831026,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 2,
      "punto": 78,
      "latitudeE7": 5.371187,
      "longitudeE7": -71.830989,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 2,
      "punto": 79,
      "latitudeE7": 5.371181,
      "longitudeE7": -71.830951,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 2,
      "punto": 80,
      "latitudeE7": 5.371175,
      "longitudeE7": -71.830913,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 2,
      "punto": 81,
      "latitudeE7": 5.371169,
      "longitudeE7": -71.830875,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 2,
      "punto": 82,
      "latitudeE7": 5.371163,
      "longitudeE7": -71.830838,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 2,
      "punto": 83,
      "latitudeE7": 5.371157,
      "longitudeE7": -71.8308,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 2,
      "punto": 84,
      "latitudeE7": 5.371151,
      "longitudeE7": -71.830762,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 2,
      "punto": 85,
      "latitudeE7": 5.371145,
      "longitudeE7": -71.830724,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 2,
      "punto": 86,
      "latitudeE7": 5.371139,
      "longitudeE7": -71.830687,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 2,
      "punto": 87,
      "latitudeE7": 5.371133,
      "longitudeE7": -71.830649,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 2,
      "punto": 88,
      "latitudeE7": 5.371127,
      "longitudeE7": -71.830611,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 2,
      "punto": 89,
      "latitudeE7": 5.371121,
      "longitudeE7": -71.830574,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 2,
      "punto": 90,
      "latitudeE7": 5.371115,
      "longitudeE7": -71.830536,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 2,
      "punto": 91,
      "latitudeE7": 5.371109,
      "longitudeE7": -71.830498,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 2,
      "punto": 92,
      "latitudeE7": 5.371103,
      "longitudeE7": -71.83046,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 2,
      "punto": 93,
      "latitudeE7": 5.371097,
      "longitudeE7": -71.830423,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 2,
      "punto": 94,
      "latitudeE7": 5.371091,
      "longitudeE7": -71.830385,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 2,
      "punto": 95,
      "latitudeE7": 5.371085,
      "longitudeE7": -71.830347,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 2,
      "punto": 96,
      "latitudeE7": 5.371079,
      "longitudeE7": -71.83031,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 2,
      "punto": 97,
      "latitudeE7": 5.371073,
      "longitudeE7": -71.830272,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 2,
      "punto": 98,
      "latitudeE7": 5.371067,
      "longitudeE7": -71.830234,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 2,
      "punto": 99,
      "latitudeE7": 5.371061,
      "longitudeE7": -71.830196,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 2,
      "punto": 100,
      "latitudeE7": 5.371055,
      "longitudeE7": -71.830159,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 2,
      "punto": 101,
      "latitudeE7": 5.371049,
      "longitudeE7": -71.830121,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 2,
      "punto": 102,
      "latitudeE7": 5.371043,
      "longitudeE7": -71.830083,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 2,
      "punto": 103,
      "latitudeE7": 5.371037,
      "longitudeE7": -71.830046,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 2,
      "punto": 104,
      "latitudeE7": 5.371031,
      "longitudeE7": -71.830008,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 2,
      "punto": 105,
      "latitudeE7": 5.371025,
      "longitudeE7": -71.82997,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 2,
      "punto": 106,
      "latitudeE7": 5.371019,
      "longitudeE7": -71.829932,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 2,
      "punto": 107,
      "latitudeE7": 5.371013,
      "longitudeE7": -71.829895,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 2,
      "punto": 108,
      "latitudeE7": 5.371007,
      "longitudeE7": -71.829857,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 2,
      "punto": 109,
      "latitudeE7": 5.371001,
      "longitudeE7": -71.829819,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 2,
      "punto": 110,
      "latitudeE7": 5.370995,
      "longitudeE7": -71.829781,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 2,
      "punto": 111,
      "latitudeE7": 5.370989,
      "longitudeE7": -71.829744,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 2,
      "punto": 112,
      "latitudeE7": 5.370983,
      "longitudeE7": -71.829706,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 2,
      "punto": 113,
      "latitudeE7": 5.370977,
      "longitudeE7": -71.829668,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 2,
      "punto": 114,
      "latitudeE7": 5.370971,
      "longitudeE7": -71.829631,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 3,
      "punto": 1,
      "latitudeE7": 5.371609,
      "longitudeE7": -71.833918,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 3,
      "punto": 2,
      "latitudeE7": 5.371603,
      "longitudeE7": -71.83388,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 3,
      "punto": 3,
      "latitudeE7": 5.371597,
      "longitudeE7": -71.833842,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 3,
      "punto": 4,
      "latitudeE7": 5.371591,
      "longitudeE7": -71.833805,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 3,
      "punto": 5,
      "latitudeE7": 5.371585,
      "longitudeE7": -71.833767,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 3,
      "punto": 6,
      "latitudeE7": 5.371579,
      "longitudeE7": -71.833729,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 3,
      "punto": 7,
      "latitudeE7": 5.371573,
      "longitudeE7": -71.833692,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 3,
      "punto": 8,
      "latitudeE7": 5.371567,
      "longitudeE7": -71.833654,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 3,
      "punto": 9,
      "latitudeE7": 5.371561,
      "longitudeE7": -71.833616,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 3,
      "punto": 10,
      "latitudeE7": 5.371555,
      "longitudeE7": -71.833578,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 3,
      "punto": 11,
      "latitudeE7": 5.371549,
      "longitudeE7": -71.833541,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 3,
      "punto": 12,
      "latitudeE7": 5.371543,
      "longitudeE7": -71.833503,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 3,
      "punto": 13,
      "latitudeE7": 5.371537,
      "longitudeE7": -71.833465,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 3,
      "punto": 14,
      "latitudeE7": 5.371531,
      "longitudeE7": -71.833428,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 3,
      "punto": 15,
      "latitudeE7": 5.371525,
      "longitudeE7": -71.83339,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 3,
      "punto": 16,
      "latitudeE7": 5.371519,
      "longitudeE7": -71.833352,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 3,
      "punto": 17,
      "latitudeE7": 5.371513,
      "longitudeE7": -71.833314,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 3,
      "punto": 18,
      "latitudeE7": 5.371507,
      "longitudeE7": -71.833277,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 3,
      "punto": 19,
      "latitudeE7": 5.371501,
      "longitudeE7": -71.833239,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 3,
      "punto": 20,
      "latitudeE7": 5.371495,
      "longitudeE7": -71.833201,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 3,
      "punto": 21,
      "latitudeE7": 5.371489,
      "longitudeE7": -71.833164,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 3,
      "punto": 22,
      "latitudeE7": 5.371483,
      "longitudeE7": -71.833126,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 3,
      "punto": 23,
      "latitudeE7": 5.371477,
      "longitudeE7": -71.833088,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 3,
      "punto": 24,
      "latitudeE7": 5.371471,
      "longitudeE7": -71.83305,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 3,
      "punto": 25,
      "latitudeE7": 5.371465,
      "longitudeE7": -71.833013,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 3,
      "punto": 26,
      "latitudeE7": 5.371459,
      "longitudeE7": -71.832975,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 3,
      "punto": 27,
      "latitudeE7": 5.371453,
      "longitudeE7": -71.832937,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 3,
      "punto": 28,
      "latitudeE7": 5.371447,
      "longitudeE7": -71.832899,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 3,
      "punto": 29,
      "latitudeE7": 5.371441,
      "longitudeE7": -71.832862,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 3,
      "punto": 30,
      "latitudeE7": 5.371435,
      "longitudeE7": -71.832824,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 3,
      "punto": 31,
      "latitudeE7": 5.371429,
      "longitudeE7": -71.832786,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 3,
      "punto": 32,
      "latitudeE7": 5.371423,
      "longitudeE7": -71.832749,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 3,
      "punto": 33,
      "latitudeE7": 5.371417,
      "longitudeE7": -71.832711,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 3,
      "punto": 34,
      "latitudeE7": 5.371411,
      "longitudeE7": -71.832673,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 3,
      "punto": 35,
      "latitudeE7": 5.371405,
      "longitudeE7": -71.832635,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 3,
      "punto": 36,
      "latitudeE7": 5.371399,
      "longitudeE7": -71.832598,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 3,
      "punto": 37,
      "latitudeE7": 5.371393,
      "longitudeE7": -71.83256,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 3,
      "punto": 38,
      "latitudeE7": 5.371387,
      "longitudeE7": -71.832522,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 3,
      "punto": 39,
      "latitudeE7": 5.371381,
      "longitudeE7": -71.832485,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 3,
      "punto": 40,
      "latitudeE7": 5.371375,
      "longitudeE7": -71.832447,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 3,
      "punto": 41,
      "latitudeE7": 5.371369,
      "longitudeE7": -71.832409,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 3,
      "punto": 42,
      "latitudeE7": 5.371363,
      "longitudeE7": -71.832371,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 3,
      "punto": 43,
      "latitudeE7": 5.371357,
      "longitudeE7": -71.832334,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 3,
      "punto": 44,
      "latitudeE7": 5.371351,
      "longitudeE7": -71.832296,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 3,
      "punto": 45,
      "latitudeE7": 5.371345,
      "longitudeE7": -71.832258,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 3,
      "punto": 46,
      "latitudeE7": 5.371339,
      "longitudeE7": -71.832221,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 3,
      "punto": 47,
      "latitudeE7": 5.371333,
      "longitudeE7": -71.832183,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 3,
      "punto": 48,
      "latitudeE7": 5.371327,
      "longitudeE7": -71.832145,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 3,
      "punto": 49,
      "latitudeE7": 5.371321,
      "longitudeE7": -71.832107,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 3,
      "punto": 50,
      "latitudeE7": 5.371315,
      "longitudeE7": -71.83207,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 3,
      "punto": 51,
      "latitudeE7": 5.371309,
      "longitudeE7": -71.832032,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 3,
      "punto": 52,
      "latitudeE7": 5.371303,
      "longitudeE7": -71.831994,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 3,
      "punto": 53,
      "latitudeE7": 5.371297,
      "longitudeE7": -71.831956,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 3,
      "punto": 54,
      "latitudeE7": 5.371291,
      "longitudeE7": -71.831919,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 3,
      "punto": 55,
      "latitudeE7": 5.371285,
      "longitudeE7": -71.831881,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 3,
      "punto": 56,
      "latitudeE7": 5.371279,
      "longitudeE7": -71.831843,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 3,
      "punto": 57,
      "latitudeE7": 5.371273,
      "longitudeE7": -71.831806,
      "accuracy": 15,
      "porcentaje": 0.44
    },
    {
      "linea": 3,
      "punto": 58,
      "latitudeE7": 5.371267,
      "longitudeE7": -71.831768,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 3,
      "punto": 59,
      "latitudeE7": 5.371261,
      "longitudeE7": -71.83173,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 3,
      "punto": 60,
      "latitudeE7": 5.371255,
      "longitudeE7": -71.831692,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 3,
      "punto": 61,
      "latitudeE7": 5.371249,
      "longitudeE7": -71.831655,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 3,
      "punto": 62,
      "latitudeE7": 5.371243,
      "longitudeE7": -71.831617,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 3,
      "punto": 63,
      "latitudeE7": 5.371237,
      "longitudeE7": -71.831579,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 3,
      "punto": 64,
      "latitudeE7": 5.371231,
      "longitudeE7": -71.831542,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 3,
      "punto": 65,
      "latitudeE7": 5.371225,
      "longitudeE7": -71.831504,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 3,
      "punto": 66,
      "latitudeE7": 5.371219,
      "longitudeE7": -71.831466,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 3,
      "punto": 67,
      "latitudeE7": 5.371213,
      "longitudeE7": -71.831428,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 3,
      "punto": 68,
      "latitudeE7": 5.371207,
      "longitudeE7": -71.831391,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 3,
      "punto": 69,
      "latitudeE7": 5.371201,
      "longitudeE7": -71.831353,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 3,
      "punto": 70,
      "latitudeE7": 5.371195,
      "longitudeE7": -71.831315,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 3,
      "punto": 71,
      "latitudeE7": 5.371189,
      "longitudeE7": -71.831278,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 3,
      "punto": 72,
      "latitudeE7": 5.371183,
      "longitudeE7": -71.83124,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 3,
      "punto": 73,
      "latitudeE7": 5.371177,
      "longitudeE7": -71.831202,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 3,
      "punto": 74,
      "latitudeE7": 5.371171,
      "longitudeE7": -71.831164,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 3,
      "punto": 75,
      "latitudeE7": 5.371165,
      "longitudeE7": -71.831127,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 3,
      "punto": 76,
      "latitudeE7": 5.371159,
      "longitudeE7": -71.831089,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 3,
      "punto": 77,
      "latitudeE7": 5.371153,
      "longitudeE7": -71.831051,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 3,
      "punto": 78,
      "latitudeE7": 5.371147,
      "longitudeE7": -71.831013,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 3,
      "punto": 79,
      "latitudeE7": 5.371141,
      "longitudeE7": -71.830976,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 3,
      "punto": 80,
      "latitudeE7": 5.371135,
      "longitudeE7": -71.830938,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 3,
      "punto": 81,
      "latitudeE7": 5.371129,
      "longitudeE7": -71.8309,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 3,
      "punto": 82,
      "latitudeE7": 5.371123,
      "longitudeE7": -71.830863,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 3,
      "punto": 83,
      "latitudeE7": 5.371117,
      "longitudeE7": -71.830825,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 3,
      "punto": 84,
      "latitudeE7": 5.371111,
      "longitudeE7": -71.830787,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 3,
      "punto": 85,
      "latitudeE7": 5.371105,
      "longitudeE7": -71.830749,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 3,
      "punto": 86,
      "latitudeE7": 5.371099,
      "longitudeE7": -71.830712,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 3,
      "punto": 87,
      "latitudeE7": 5.371093,
      "longitudeE7": -71.830674,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 3,
      "punto": 88,
      "latitudeE7": 5.371087,
      "longitudeE7": -71.830636,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 3,
      "punto": 89,
      "latitudeE7": 5.371081,
      "longitudeE7": -71.830599,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 3,
      "punto": 90,
      "latitudeE7": 5.371075,
      "longitudeE7": -71.830561,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 3,
      "punto": 91,
      "latitudeE7": 5.371069,
      "longitudeE7": -71.830523,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 3,
      "punto": 92,
      "latitudeE7": 5.371063,
      "longitudeE7": -71.830485,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 3,
      "punto": 93,
      "latitudeE7": 5.371057,
      "longitudeE7": -71.830448,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 3,
      "punto": 94,
      "latitudeE7": 5.371051,
      "longitudeE7": -71.83041,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 3,
      "punto": 95,
      "latitudeE7": 5.371045,
      "longitudeE7": -71.830372,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 3,
      "punto": 96,
      "latitudeE7": 5.371039,
      "longitudeE7": -71.830335,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 3,
      "punto": 97,
      "latitudeE7": 5.371033,
      "longitudeE7": -71.830297,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 3,
      "punto": 98,
      "latitudeE7": 5.371027,
      "longitudeE7": -71.830259,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 3,
      "punto": 99,
      "latitudeE7": 5.371021,
      "longitudeE7": -71.830221,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 3,
      "punto": 100,
      "latitudeE7": 5.371015,
      "longitudeE7": -71.830184,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 3,
      "punto": 101,
      "latitudeE7": 5.371009,
      "longitudeE7": -71.830146,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 3,
      "punto": 102,
      "latitudeE7": 5.371003,
      "longitudeE7": -71.830108,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 3,
      "punto": 103,
      "latitudeE7": 5.370997,
      "longitudeE7": -71.83007,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 3,
      "punto": 104,
      "latitudeE7": 5.370991,
      "longitudeE7": -71.830033,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 3,
      "punto": 105,
      "latitudeE7": 5.370985,
      "longitudeE7": -71.829995,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 3,
      "punto": 106,
      "latitudeE7": 5.370979,
      "longitudeE7": -71.829957,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 3,
      "punto": 107,
      "latitudeE7": 5.370973,
      "longitudeE7": -71.82992,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 3,
      "punto": 108,
      "latitudeE7": 5.370967,
      "longitudeE7": -71.829882,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 3,
      "punto": 109,
      "latitudeE7": 5.370961,
      "longitudeE7": -71.829844,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 3,
      "punto": 110,
      "latitudeE7": 5.370955,
      "longitudeE7": -71.829806,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 3,
      "punto": 111,
      "latitudeE7": 5.370949,
      "longitudeE7": -71.829769,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 3,
      "punto": 112,
      "latitudeE7": 5.370943,
      "longitudeE7": -71.829731,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 3,
      "punto": 113,
      "latitudeE7": 5.370937,
      "longitudeE7": -71.829693,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 3,
      "punto": 114,
      "latitudeE7": 5.370931,
      "longitudeE7": -71.829656,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 4,
      "punto": 1,
      "latitudeE7": 5.371569,
      "longitudeE7": -71.833943,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 4,
      "punto": 2,
      "latitudeE7": 5.371563,
      "longitudeE7": -71.833905,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 4,
      "punto": 3,
      "latitudeE7": 5.371557,
      "longitudeE7": -71.833867,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 4,
      "punto": 4,
      "latitudeE7": 5.371551,
      "longitudeE7": -71.83383,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 4,
      "punto": 5,
      "latitudeE7": 5.371545,
      "longitudeE7": -71.833792,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 4,
      "punto": 6,
      "latitudeE7": 5.371539,
      "longitudeE7": -71.833754,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 4,
      "punto": 7,
      "latitudeE7": 5.371533,
      "longitudeE7": -71.833717,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 4,
      "punto": 8,
      "latitudeE7": 5.371527,
      "longitudeE7": -71.833679,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 4,
      "punto": 9,
      "latitudeE7": 5.371521,
      "longitudeE7": -71.833641,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 4,
      "punto": 10,
      "latitudeE7": 5.371515,
      "longitudeE7": -71.833603,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 4,
      "punto": 11,
      "latitudeE7": 5.371509,
      "longitudeE7": -71.833566,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 4,
      "punto": 12,
      "latitudeE7": 5.371503,
      "longitudeE7": -71.833528,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 4,
      "punto": 13,
      "latitudeE7": 5.371497,
      "longitudeE7": -71.83349,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 4,
      "punto": 14,
      "latitudeE7": 5.371491,
      "longitudeE7": -71.833453,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 4,
      "punto": 15,
      "latitudeE7": 5.371485,
      "longitudeE7": -71.833415,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 4,
      "punto": 16,
      "latitudeE7": 5.371479,
      "longitudeE7": -71.833377,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 4,
      "punto": 17,
      "latitudeE7": 5.371473,
      "longitudeE7": -71.833339,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 4,
      "punto": 18,
      "latitudeE7": 5.371467,
      "longitudeE7": -71.833302,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 4,
      "punto": 19,
      "latitudeE7": 5.371461,
      "longitudeE7": -71.833264,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 4,
      "punto": 20,
      "latitudeE7": 5.371455,
      "longitudeE7": -71.833226,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 4,
      "punto": 21,
      "latitudeE7": 5.371449,
      "longitudeE7": -71.833188,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 4,
      "punto": 22,
      "latitudeE7": 5.371443,
      "longitudeE7": -71.833151,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 4,
      "punto": 23,
      "latitudeE7": 5.371437,
      "longitudeE7": -71.833113,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 4,
      "punto": 24,
      "latitudeE7": 5.371431,
      "longitudeE7": -71.833075,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 4,
      "punto": 25,
      "latitudeE7": 5.371425,
      "longitudeE7": -71.833038,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 4,
      "punto": 26,
      "latitudeE7": 5.371419,
      "longitudeE7": -71.833,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 4,
      "punto": 27,
      "latitudeE7": 5.371413,
      "longitudeE7": -71.832962,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 4,
      "punto": 28,
      "latitudeE7": 5.371407,
      "longitudeE7": -71.832924,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 4,
      "punto": 29,
      "latitudeE7": 5.371401,
      "longitudeE7": -71.832887,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 4,
      "punto": 30,
      "latitudeE7": 5.371395,
      "longitudeE7": -71.832849,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 4,
      "punto": 31,
      "latitudeE7": 5.371389,
      "longitudeE7": -71.832811,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 4,
      "punto": 32,
      "latitudeE7": 5.371383,
      "longitudeE7": -71.832774,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 4,
      "punto": 33,
      "latitudeE7": 5.371377,
      "longitudeE7": -71.832736,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 4,
      "punto": 34,
      "latitudeE7": 5.371371,
      "longitudeE7": -71.832698,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 4,
      "punto": 35,
      "latitudeE7": 5.371365,
      "longitudeE7": -71.83266,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 4,
      "punto": 36,
      "latitudeE7": 5.371359,
      "longitudeE7": -71.832623,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 4,
      "punto": 37,
      "latitudeE7": 5.371353,
      "longitudeE7": -71.832585,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 4,
      "punto": 38,
      "latitudeE7": 5.371347,
      "longitudeE7": -71.832547,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 4,
      "punto": 39,
      "latitudeE7": 5.371341,
      "longitudeE7": -71.83251,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 4,
      "punto": 40,
      "latitudeE7": 5.371335,
      "longitudeE7": -71.832472,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 4,
      "punto": 41,
      "latitudeE7": 5.371329,
      "longitudeE7": -71.832434,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 4,
      "punto": 42,
      "latitudeE7": 5.371323,
      "longitudeE7": -71.832396,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 4,
      "punto": 43,
      "latitudeE7": 5.371317,
      "longitudeE7": -71.832359,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 4,
      "punto": 44,
      "latitudeE7": 5.371311,
      "longitudeE7": -71.832321,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 4,
      "punto": 45,
      "latitudeE7": 5.371305,
      "longitudeE7": -71.832283,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 4,
      "punto": 46,
      "latitudeE7": 5.371299,
      "longitudeE7": -71.832245,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 4,
      "punto": 47,
      "latitudeE7": 5.371293,
      "longitudeE7": -71.832208,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 4,
      "punto": 48,
      "latitudeE7": 5.371287,
      "longitudeE7": -71.83217,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 4,
      "punto": 49,
      "latitudeE7": 5.371281,
      "longitudeE7": -71.832132,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 4,
      "punto": 50,
      "latitudeE7": 5.371275,
      "longitudeE7": -71.832095,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 4,
      "punto": 51,
      "latitudeE7": 5.371269,
      "longitudeE7": -71.832057,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 4,
      "punto": 52,
      "latitudeE7": 5.371263,
      "longitudeE7": -71.832019,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 4,
      "punto": 53,
      "latitudeE7": 5.371257,
      "longitudeE7": -71.831981,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 4,
      "punto": 54,
      "latitudeE7": 5.371251,
      "longitudeE7": -71.831944,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 4,
      "punto": 55,
      "latitudeE7": 5.371245,
      "longitudeE7": -71.831906,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 4,
      "punto": 56,
      "latitudeE7": 5.371239,
      "longitudeE7": -71.831868,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 4,
      "punto": 57,
      "latitudeE7": 5.371233,
      "longitudeE7": -71.831831,
      "accuracy": 15,
      "porcentaje": 0.48
    },
    {
      "linea": 4,
      "punto": 58,
      "latitudeE7": 5.371227,
      "longitudeE7": -71.831793,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 4,
      "punto": 59,
      "latitudeE7": 5.371221,
      "longitudeE7": -71.831755,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 4,
      "punto": 60,
      "latitudeE7": 5.371215,
      "longitudeE7": -71.831717,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 4,
      "punto": 61,
      "latitudeE7": 5.371209,
      "longitudeE7": -71.83168,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 4,
      "punto": 62,
      "latitudeE7": 5.371203,
      "longitudeE7": -71.831642,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 4,
      "punto": 63,
      "latitudeE7": 5.371197,
      "longitudeE7": -71.831604,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 4,
      "punto": 64,
      "latitudeE7": 5.371191,
      "longitudeE7": -71.831567,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 4,
      "punto": 65,
      "latitudeE7": 5.371185,
      "longitudeE7": -71.831529,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 4,
      "punto": 66,
      "latitudeE7": 5.371179,
      "longitudeE7": -71.831491,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 4,
      "punto": 67,
      "latitudeE7": 5.371173,
      "longitudeE7": -71.831453,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 4,
      "punto": 68,
      "latitudeE7": 5.371167,
      "longitudeE7": -71.831416,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 4,
      "punto": 69,
      "latitudeE7": 5.371161,
      "longitudeE7": -71.831378,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 4,
      "punto": 70,
      "latitudeE7": 5.371155,
      "longitudeE7": -71.83134,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 4,
      "punto": 71,
      "latitudeE7": 5.371149,
      "longitudeE7": -71.831302,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 4,
      "punto": 72,
      "latitudeE7": 5.371143,
      "longitudeE7": -71.831265,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 4,
      "punto": 73,
      "latitudeE7": 5.371137,
      "longitudeE7": -71.831227,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 4,
      "punto": 74,
      "latitudeE7": 5.371131,
      "longitudeE7": -71.831189,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 4,
      "punto": 75,
      "latitudeE7": 5.371125,
      "longitudeE7": -71.831152,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 4,
      "punto": 76,
      "latitudeE7": 5.371119,
      "longitudeE7": -71.831114,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 4,
      "punto": 77,
      "latitudeE7": 5.371113,
      "longitudeE7": -71.831076,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 4,
      "punto": 78,
      "latitudeE7": 5.371107,
      "longitudeE7": -71.831038,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 4,
      "punto": 79,
      "latitudeE7": 5.371101,
      "longitudeE7": -71.831001,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 4,
      "punto": 80,
      "latitudeE7": 5.371095,
      "longitudeE7": -71.830963,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 4,
      "punto": 81,
      "latitudeE7": 5.371089,
      "longitudeE7": -71.830925,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 4,
      "punto": 82,
      "latitudeE7": 5.371083,
      "longitudeE7": -71.830888,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 4,
      "punto": 83,
      "latitudeE7": 5.371077,
      "longitudeE7": -71.83085,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 4,
      "punto": 84,
      "latitudeE7": 5.371071,
      "longitudeE7": -71.830812,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 4,
      "punto": 85,
      "latitudeE7": 5.371065,
      "longitudeE7": -71.830774,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 4,
      "punto": 86,
      "latitudeE7": 5.371059,
      "longitudeE7": -71.830737,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 4,
      "punto": 87,
      "latitudeE7": 5.371053,
      "longitudeE7": -71.830699,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 4,
      "punto": 88,
      "latitudeE7": 5.371047,
      "longitudeE7": -71.830661,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 4,
      "punto": 89,
      "latitudeE7": 5.371041,
      "longitudeE7": -71.830624,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 4,
      "punto": 90,
      "latitudeE7": 5.371035,
      "longitudeE7": -71.830586,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 4,
      "punto": 91,
      "latitudeE7": 5.371029,
      "longitudeE7": -71.830548,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 4,
      "punto": 92,
      "latitudeE7": 5.371023,
      "longitudeE7": -71.83051,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 4,
      "punto": 93,
      "latitudeE7": 5.371017,
      "longitudeE7": -71.830473,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 4,
      "punto": 94,
      "latitudeE7": 5.371011,
      "longitudeE7": -71.830435,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 4,
      "punto": 95,
      "latitudeE7": 5.371005,
      "longitudeE7": -71.830397,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 4,
      "punto": 96,
      "latitudeE7": 5.370999,
      "longitudeE7": -71.830359,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 4,
      "punto": 97,
      "latitudeE7": 5.370993,
      "longitudeE7": -71.830322,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 4,
      "punto": 98,
      "latitudeE7": 5.370987,
      "longitudeE7": -71.830284,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 4,
      "punto": 99,
      "latitudeE7": 5.370981,
      "longitudeE7": -71.830246,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 4,
      "punto": 100,
      "latitudeE7": 5.370975,
      "longitudeE7": -71.830209,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 4,
      "punto": 101,
      "latitudeE7": 5.370969,
      "longitudeE7": -71.830171,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 4,
      "punto": 102,
      "latitudeE7": 5.370963,
      "longitudeE7": -71.830133,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 4,
      "punto": 103,
      "latitudeE7": 5.370957,
      "longitudeE7": -71.830095,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 4,
      "punto": 104,
      "latitudeE7": 5.370951,
      "longitudeE7": -71.830058,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 4,
      "punto": 105,
      "latitudeE7": 5.370945,
      "longitudeE7": -71.83002,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 4,
      "punto": 106,
      "latitudeE7": 5.370939,
      "longitudeE7": -71.829982,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 4,
      "punto": 107,
      "latitudeE7": 5.370933,
      "longitudeE7": -71.829945,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 4,
      "punto": 108,
      "latitudeE7": 5.370927,
      "longitudeE7": -71.829907,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 4,
      "punto": 109,
      "latitudeE7": 5.370921,
      "longitudeE7": -71.829869,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 4,
      "punto": 110,
      "latitudeE7": 5.370915,
      "longitudeE7": -71.829831,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 4,
      "punto": 111,
      "latitudeE7": 5.370909,
      "longitudeE7": -71.829794,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 4,
      "punto": 112,
      "latitudeE7": 5.370903,
      "longitudeE7": -71.829756,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 4,
      "punto": 113,
      "latitudeE7": 5.370897,
      "longitudeE7": -71.829718,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 4,
      "punto": 114,
      "latitudeE7": 5.370891,
      "longitudeE7": -71.829681,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 5,
      "punto": 1,
      "latitudeE7": 5.371529,
      "longitudeE7": -71.833968,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 5,
      "punto": 2,
      "latitudeE7": 5.371523,
      "longitudeE7": -71.83393,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 5,
      "punto": 3,
      "latitudeE7": 5.371517,
      "longitudeE7": -71.833892,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 5,
      "punto": 4,
      "latitudeE7": 5.371511,
      "longitudeE7": -71.833855,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 5,
      "punto": 5,
      "latitudeE7": 5.371505,
      "longitudeE7": -71.833817,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 5,
      "punto": 6,
      "latitudeE7": 5.371499,
      "longitudeE7": -71.833779,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 5,
      "punto": 7,
      "latitudeE7": 5.371493,
      "longitudeE7": -71.833742,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 5,
      "punto": 8,
      "latitudeE7": 5.371487,
      "longitudeE7": -71.833704,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 5,
      "punto": 9,
      "latitudeE7": 5.371481,
      "longitudeE7": -71.833666,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 5,
      "punto": 10,
      "latitudeE7": 5.371475,
      "longitudeE7": -71.833628,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 5,
      "punto": 11,
      "latitudeE7": 5.371469,
      "longitudeE7": -71.833591,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 5,
      "punto": 12,
      "latitudeE7": 5.371463,
      "longitudeE7": -71.833553,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 5,
      "punto": 13,
      "latitudeE7": 5.371457,
      "longitudeE7": -71.833515,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 5,
      "punto": 14,
      "latitudeE7": 5.371451,
      "longitudeE7": -71.833477,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 5,
      "punto": 15,
      "latitudeE7": 5.371445,
      "longitudeE7": -71.83344,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 5,
      "punto": 16,
      "latitudeE7": 5.371439,
      "longitudeE7": -71.833402,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 5,
      "punto": 17,
      "latitudeE7": 5.371433,
      "longitudeE7": -71.833364,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 5,
      "punto": 18,
      "latitudeE7": 5.371427,
      "longitudeE7": -71.833327,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 5,
      "punto": 19,
      "latitudeE7": 5.371421,
      "longitudeE7": -71.833289,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 5,
      "punto": 20,
      "latitudeE7": 5.371415,
      "longitudeE7": -71.833251,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 5,
      "punto": 21,
      "latitudeE7": 5.371409,
      "longitudeE7": -71.833213,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 5,
      "punto": 22,
      "latitudeE7": 5.371403,
      "longitudeE7": -71.833176,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 5,
      "punto": 23,
      "latitudeE7": 5.371397,
      "longitudeE7": -71.833138,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 5,
      "punto": 24,
      "latitudeE7": 5.371391,
      "longitudeE7": -71.8331,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 5,
      "punto": 25,
      "latitudeE7": 5.371385,
      "longitudeE7": -71.833063,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 5,
      "punto": 26,
      "latitudeE7": 5.371379,
      "longitudeE7": -71.833025,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 5,
      "punto": 27,
      "latitudeE7": 5.371373,
      "longitudeE7": -71.832987,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 5,
      "punto": 28,
      "latitudeE7": 5.371367,
      "longitudeE7": -71.832949,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 5,
      "punto": 29,
      "latitudeE7": 5.371361,
      "longitudeE7": -71.832912,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 5,
      "punto": 30,
      "latitudeE7": 5.371355,
      "longitudeE7": -71.832874,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 5,
      "punto": 31,
      "latitudeE7": 5.371349,
      "longitudeE7": -71.832836,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 5,
      "punto": 32,
      "latitudeE7": 5.371343,
      "longitudeE7": -71.832799,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 5,
      "punto": 33,
      "latitudeE7": 5.371337,
      "longitudeE7": -71.832761,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 5,
      "punto": 34,
      "latitudeE7": 5.371331,
      "longitudeE7": -71.832723,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 5,
      "punto": 35,
      "latitudeE7": 5.371325,
      "longitudeE7": -71.832685,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 5,
      "punto": 36,
      "latitudeE7": 5.371319,
      "longitudeE7": -71.832648,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 5,
      "punto": 37,
      "latitudeE7": 5.371313,
      "longitudeE7": -71.83261,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 5,
      "punto": 38,
      "latitudeE7": 5.371307,
      "longitudeE7": -71.832572,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 5,
      "punto": 39,
      "latitudeE7": 5.371301,
      "longitudeE7": -71.832534,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 5,
      "punto": 40,
      "latitudeE7": 5.371295,
      "longitudeE7": -71.832497,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 5,
      "punto": 41,
      "latitudeE7": 5.371289,
      "longitudeE7": -71.832459,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 5,
      "punto": 42,
      "latitudeE7": 5.371283,
      "longitudeE7": -71.832421,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 5,
      "punto": 43,
      "latitudeE7": 5.371277,
      "longitudeE7": -71.832384,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 5,
      "punto": 44,
      "latitudeE7": 5.371271,
      "longitudeE7": -71.832346,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 5,
      "punto": 45,
      "latitudeE7": 5.371265,
      "longitudeE7": -71.832308,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 5,
      "punto": 46,
      "latitudeE7": 5.371259,
      "longitudeE7": -71.83227,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 5,
      "punto": 47,
      "latitudeE7": 5.371253,
      "longitudeE7": -71.832233,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 5,
      "punto": 48,
      "latitudeE7": 5.371247,
      "longitudeE7": -71.832195,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 5,
      "punto": 49,
      "latitudeE7": 5.371241,
      "longitudeE7": -71.832157,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 5,
      "punto": 50,
      "latitudeE7": 5.371235,
      "longitudeE7": -71.83212,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 5,
      "punto": 51,
      "latitudeE7": 5.371229,
      "longitudeE7": -71.832082,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 5,
      "punto": 52,
      "latitudeE7": 5.371223,
      "longitudeE7": -71.832044,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 5,
      "punto": 53,
      "latitudeE7": 5.371217,
      "longitudeE7": -71.832006,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 5,
      "punto": 54,
      "latitudeE7": 5.371211,
      "longitudeE7": -71.831969,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 5,
      "punto": 55,
      "latitudeE7": 5.371205,
      "longitudeE7": -71.831931,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 5,
      "punto": 56,
      "latitudeE7": 5.371199,
      "longitudeE7": -71.831893,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 5,
      "punto": 57,
      "latitudeE7": 5.371193,
      "longitudeE7": -71.831856,
      "accuracy": 15,
      "porcentaje": 0.68
    },
    {
      "linea": 5,
      "punto": 58,
      "latitudeE7": 5.371187,
      "longitudeE7": -71.831818,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 5,
      "punto": 59,
      "latitudeE7": 5.371181,
      "longitudeE7": -71.83178,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 5,
      "punto": 60,
      "latitudeE7": 5.371175,
      "longitudeE7": -71.831742,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 5,
      "punto": 61,
      "latitudeE7": 5.371169,
      "longitudeE7": -71.831705,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 5,
      "punto": 62,
      "latitudeE7": 5.371163,
      "longitudeE7": -71.831667,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 5,
      "punto": 63,
      "latitudeE7": 5.371157,
      "longitudeE7": -71.831629,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 5,
      "punto": 64,
      "latitudeE7": 5.371151,
      "longitudeE7": -71.831591,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 5,
      "punto": 65,
      "latitudeE7": 5.371145,
      "longitudeE7": -71.831554,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 5,
      "punto": 66,
      "latitudeE7": 5.371139,
      "longitudeE7": -71.831516,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 5,
      "punto": 67,
      "latitudeE7": 5.371133,
      "longitudeE7": -71.831478,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 5,
      "punto": 68,
      "latitudeE7": 5.371127,
      "longitudeE7": -71.831441,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 5,
      "punto": 69,
      "latitudeE7": 5.371121,
      "longitudeE7": -71.831403,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 5,
      "punto": 70,
      "latitudeE7": 5.371115,
      "longitudeE7": -71.831365,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 5,
      "punto": 71,
      "latitudeE7": 5.371109,
      "longitudeE7": -71.831327,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 5,
      "punto": 72,
      "latitudeE7": 5.371103,
      "longitudeE7": -71.83129,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 5,
      "punto": 73,
      "latitudeE7": 5.371097,
      "longitudeE7": -71.831252,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 5,
      "punto": 74,
      "latitudeE7": 5.371091,
      "longitudeE7": -71.831214,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 5,
      "punto": 75,
      "latitudeE7": 5.371085,
      "longitudeE7": -71.831177,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 5,
      "punto": 76,
      "latitudeE7": 5.371079,
      "longitudeE7": -71.831139,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 5,
      "punto": 77,
      "latitudeE7": 5.371073,
      "longitudeE7": -71.831101,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 5,
      "punto": 78,
      "latitudeE7": 5.371067,
      "longitudeE7": -71.831063,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 5,
      "punto": 79,
      "latitudeE7": 5.371061,
      "longitudeE7": -71.831026,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 5,
      "punto": 80,
      "latitudeE7": 5.371055,
      "longitudeE7": -71.830988,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 5,
      "punto": 81,
      "latitudeE7": 5.371049,
      "longitudeE7": -71.83095,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 5,
      "punto": 82,
      "latitudeE7": 5.371043,
      "longitudeE7": -71.830913,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 5,
      "punto": 83,
      "latitudeE7": 5.371037,
      "longitudeE7": -71.830875,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 5,
      "punto": 84,
      "latitudeE7": 5.371031,
      "longitudeE7": -71.830837,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 5,
      "punto": 85,
      "latitudeE7": 5.371025,
      "longitudeE7": -71.830799,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 5,
      "punto": 86,
      "latitudeE7": 5.371019,
      "longitudeE7": -71.830762,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 5,
      "punto": 87,
      "latitudeE7": 5.371013,
      "longitudeE7": -71.830724,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 5,
      "punto": 88,
      "latitudeE7": 5.371007,
      "longitudeE7": -71.830686,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 5,
      "punto": 89,
      "latitudeE7": 5.371001,
      "longitudeE7": -71.830648,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 5,
      "punto": 90,
      "latitudeE7": 5.370995,
      "longitudeE7": -71.830611,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 5,
      "punto": 91,
      "latitudeE7": 5.370989,
      "longitudeE7": -71.830573,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 5,
      "punto": 92,
      "latitudeE7": 5.370983,
      "longitudeE7": -71.830535,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 5,
      "punto": 93,
      "latitudeE7": 5.370977,
      "longitudeE7": -71.830498,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 5,
      "punto": 94,
      "latitudeE7": 5.370971,
      "longitudeE7": -71.83046,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 5,
      "punto": 95,
      "latitudeE7": 5.370965,
      "longitudeE7": -71.830422,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 5,
      "punto": 96,
      "latitudeE7": 5.370959,
      "longitudeE7": -71.830384,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 5,
      "punto": 97,
      "latitudeE7": 5.370953,
      "longitudeE7": -71.830347,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 5,
      "punto": 98,
      "latitudeE7": 5.370947,
      "longitudeE7": -71.830309,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 5,
      "punto": 99,
      "latitudeE7": 5.370941,
      "longitudeE7": -71.830271,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 5,
      "punto": 100,
      "latitudeE7": 5.370935,
      "longitudeE7": -71.830234,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 5,
      "punto": 101,
      "latitudeE7": 5.370929,
      "longitudeE7": -71.830196,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 5,
      "punto": 102,
      "latitudeE7": 5.370923,
      "longitudeE7": -71.830158,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 5,
      "punto": 103,
      "latitudeE7": 5.370917,
      "longitudeE7": -71.83012,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 5,
      "punto": 104,
      "latitudeE7": 5.370911,
      "longitudeE7": -71.830083,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 5,
      "punto": 105,
      "latitudeE7": 5.370905,
      "longitudeE7": -71.830045,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 5,
      "punto": 106,
      "latitudeE7": 5.370899,
      "longitudeE7": -71.830007,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 5,
      "punto": 107,
      "latitudeE7": 5.370893,
      "longitudeE7": -71.82997,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 5,
      "punto": 108,
      "latitudeE7": 5.370887,
      "longitudeE7": -71.829932,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 5,
      "punto": 109,
      "latitudeE7": 5.370881,
      "longitudeE7": -71.829894,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 5,
      "punto": 110,
      "latitudeE7": 5.370875,
      "longitudeE7": -71.829856,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 5,
      "punto": 111,
      "latitudeE7": 5.370869,
      "longitudeE7": -71.829819,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 5,
      "punto": 112,
      "latitudeE7": 5.370863,
      "longitudeE7": -71.829781,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 5,
      "punto": 113,
      "latitudeE7": 5.370857,
      "longitudeE7": -71.829743,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 5,
      "punto": 114,
      "latitudeE7": 5.370851,
      "longitudeE7": -71.829705,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 6,
      "punto": 1,
      "latitudeE7": 5.371489,
      "longitudeE7": -71.833993,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 6,
      "punto": 2,
      "latitudeE7": 5.371483,
      "longitudeE7": -71.833955,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 6,
      "punto": 3,
      "latitudeE7": 5.371477,
      "longitudeE7": -71.833917,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 6,
      "punto": 4,
      "latitudeE7": 5.371471,
      "longitudeE7": -71.83388,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 6,
      "punto": 5,
      "latitudeE7": 5.371465,
      "longitudeE7": -71.833842,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 6,
      "punto": 6,
      "latitudeE7": 5.371459,
      "longitudeE7": -71.833804,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 6,
      "punto": 7,
      "latitudeE7": 5.371453,
      "longitudeE7": -71.833766,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 6,
      "punto": 8,
      "latitudeE7": 5.371447,
      "longitudeE7": -71.833729,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 6,
      "punto": 9,
      "latitudeE7": 5.371441,
      "longitudeE7": -71.833691,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 6,
      "punto": 10,
      "latitudeE7": 5.371435,
      "longitudeE7": -71.833653,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 6,
      "punto": 11,
      "latitudeE7": 5.371429,
      "longitudeE7": -71.833616,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 6,
      "punto": 12,
      "latitudeE7": 5.371423,
      "longitudeE7": -71.833578,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 6,
      "punto": 13,
      "latitudeE7": 5.371417,
      "longitudeE7": -71.83354,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 6,
      "punto": 14,
      "latitudeE7": 5.371411,
      "longitudeE7": -71.833502,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 6,
      "punto": 15,
      "latitudeE7": 5.371405,
      "longitudeE7": -71.833465,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 6,
      "punto": 16,
      "latitudeE7": 5.371399,
      "longitudeE7": -71.833427,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 6,
      "punto": 17,
      "latitudeE7": 5.371393,
      "longitudeE7": -71.833389,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 6,
      "punto": 18,
      "latitudeE7": 5.371387,
      "longitudeE7": -71.833352,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 6,
      "punto": 19,
      "latitudeE7": 5.371381,
      "longitudeE7": -71.833314,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 6,
      "punto": 20,
      "latitudeE7": 5.371375,
      "longitudeE7": -71.833276,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 6,
      "punto": 21,
      "latitudeE7": 5.371369,
      "longitudeE7": -71.833238,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 6,
      "punto": 22,
      "latitudeE7": 5.371363,
      "longitudeE7": -71.833201,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 6,
      "punto": 23,
      "latitudeE7": 5.371357,
      "longitudeE7": -71.833163,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 6,
      "punto": 24,
      "latitudeE7": 5.371351,
      "longitudeE7": -71.833125,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 6,
      "punto": 25,
      "latitudeE7": 5.371345,
      "longitudeE7": -71.833088,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 6,
      "punto": 26,
      "latitudeE7": 5.371339,
      "longitudeE7": -71.83305,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 6,
      "punto": 27,
      "latitudeE7": 5.371333,
      "longitudeE7": -71.833012,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 6,
      "punto": 28,
      "latitudeE7": 5.371327,
      "longitudeE7": -71.832974,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 6,
      "punto": 29,
      "latitudeE7": 5.371321,
      "longitudeE7": -71.832937,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 6,
      "punto": 30,
      "latitudeE7": 5.371315,
      "longitudeE7": -71.832899,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 6,
      "punto": 31,
      "latitudeE7": 5.371309,
      "longitudeE7": -71.832861,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 6,
      "punto": 32,
      "latitudeE7": 5.371303,
      "longitudeE7": -71.832823,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 6,
      "punto": 33,
      "latitudeE7": 5.371297,
      "longitudeE7": -71.832786,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 6,
      "punto": 34,
      "latitudeE7": 5.371291,
      "longitudeE7": -71.832748,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 6,
      "punto": 35,
      "latitudeE7": 5.371285,
      "longitudeE7": -71.83271,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 6,
      "punto": 36,
      "latitudeE7": 5.371279,
      "longitudeE7": -71.832673,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 6,
      "punto": 37,
      "latitudeE7": 5.371273,
      "longitudeE7": -71.832635,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 6,
      "punto": 38,
      "latitudeE7": 5.371267,
      "longitudeE7": -71.832597,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 6,
      "punto": 39,
      "latitudeE7": 5.371261,
      "longitudeE7": -71.832559,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 6,
      "punto": 40,
      "latitudeE7": 5.371255,
      "longitudeE7": -71.832522,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 6,
      "punto": 41,
      "latitudeE7": 5.371249,
      "longitudeE7": -71.832484,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 6,
      "punto": 42,
      "latitudeE7": 5.371243,
      "longitudeE7": -71.832446,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 6,
      "punto": 43,
      "latitudeE7": 5.371237,
      "longitudeE7": -71.832409,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 6,
      "punto": 44,
      "latitudeE7": 5.371231,
      "longitudeE7": -71.832371,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 6,
      "punto": 45,
      "latitudeE7": 5.371225,
      "longitudeE7": -71.832333,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 6,
      "punto": 46,
      "latitudeE7": 5.371219,
      "longitudeE7": -71.832295,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 6,
      "punto": 47,
      "latitudeE7": 5.371213,
      "longitudeE7": -71.832258,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 6,
      "punto": 48,
      "latitudeE7": 5.371207,
      "longitudeE7": -71.83222,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 6,
      "punto": 49,
      "latitudeE7": 5.371201,
      "longitudeE7": -71.832182,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 6,
      "punto": 50,
      "latitudeE7": 5.371195,
      "longitudeE7": -71.832145,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 6,
      "punto": 51,
      "latitudeE7": 5.371189,
      "longitudeE7": -71.832107,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 6,
      "punto": 52,
      "latitudeE7": 5.371183,
      "longitudeE7": -71.832069,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 6,
      "punto": 53,
      "latitudeE7": 5.371177,
      "longitudeE7": -71.832031,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 6,
      "punto": 54,
      "latitudeE7": 5.371171,
      "longitudeE7": -71.831994,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 6,
      "punto": 55,
      "latitudeE7": 5.371165,
      "longitudeE7": -71.831956,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 6,
      "punto": 56,
      "latitudeE7": 5.371159,
      "longitudeE7": -71.831918,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 6,
      "punto": 57,
      "latitudeE7": 5.371153,
      "longitudeE7": -71.83188,
      "accuracy": 15,
      "porcentaje": 0.56
    },
    {
      "linea": 6,
      "punto": 58,
      "latitudeE7": 5.371147,
      "longitudeE7": -71.831843,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 6,
      "punto": 59,
      "latitudeE7": 5.371141,
      "longitudeE7": -71.831805,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 6,
      "punto": 60,
      "latitudeE7": 5.371135,
      "longitudeE7": -71.831767,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 6,
      "punto": 61,
      "latitudeE7": 5.371129,
      "longitudeE7": -71.83173,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 6,
      "punto": 62,
      "latitudeE7": 5.371123,
      "longitudeE7": -71.831692,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 6,
      "punto": 63,
      "latitudeE7": 5.371117,
      "longitudeE7": -71.831654,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 6,
      "punto": 64,
      "latitudeE7": 5.371111,
      "longitudeE7": -71.831616,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 6,
      "punto": 65,
      "latitudeE7": 5.371105,
      "longitudeE7": -71.831579,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 6,
      "punto": 66,
      "latitudeE7": 5.371099,
      "longitudeE7": -71.831541,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 6,
      "punto": 67,
      "latitudeE7": 5.371093,
      "longitudeE7": -71.831503,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 6,
      "punto": 68,
      "latitudeE7": 5.371087,
      "longitudeE7": -71.831466,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 6,
      "punto": 69,
      "latitudeE7": 5.371081,
      "longitudeE7": -71.831428,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 6,
      "punto": 70,
      "latitudeE7": 5.371075,
      "longitudeE7": -71.83139,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 6,
      "punto": 71,
      "latitudeE7": 5.371069,
      "longitudeE7": -71.831352,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 6,
      "punto": 72,
      "latitudeE7": 5.371063,
      "longitudeE7": -71.831315,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 6,
      "punto": 73,
      "latitudeE7": 5.371057,
      "longitudeE7": -71.831277,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 6,
      "punto": 74,
      "latitudeE7": 5.371051,
      "longitudeE7": -71.831239,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 6,
      "punto": 75,
      "latitudeE7": 5.371045,
      "longitudeE7": -71.831202,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 6,
      "punto": 76,
      "latitudeE7": 5.371039,
      "longitudeE7": -71.831164,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 6,
      "punto": 77,
      "latitudeE7": 5.371033,
      "longitudeE7": -71.831126,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 6,
      "punto": 78,
      "latitudeE7": 5.371027,
      "longitudeE7": -71.831088,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 6,
      "punto": 79,
      "latitudeE7": 5.371021,
      "longitudeE7": -71.831051,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 6,
      "punto": 80,
      "latitudeE7": 5.371015,
      "longitudeE7": -71.831013,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 6,
      "punto": 81,
      "latitudeE7": 5.371009,
      "longitudeE7": -71.830975,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 6,
      "punto": 82,
      "latitudeE7": 5.371003,
      "longitudeE7": -71.830937,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 6,
      "punto": 83,
      "latitudeE7": 5.370997,
      "longitudeE7": -71.8309,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 6,
      "punto": 84,
      "latitudeE7": 5.370991,
      "longitudeE7": -71.830862,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 6,
      "punto": 85,
      "latitudeE7": 5.370985,
      "longitudeE7": -71.830824,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 6,
      "punto": 86,
      "latitudeE7": 5.370979,
      "longitudeE7": -71.830787,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 6,
      "punto": 87,
      "latitudeE7": 5.370973,
      "longitudeE7": -71.830749,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 6,
      "punto": 88,
      "latitudeE7": 5.370967,
      "longitudeE7": -71.830711,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 6,
      "punto": 89,
      "latitudeE7": 5.370961,
      "longitudeE7": -71.830673,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 6,
      "punto": 90,
      "latitudeE7": 5.370955,
      "longitudeE7": -71.830636,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 6,
      "punto": 91,
      "latitudeE7": 5.370949,
      "longitudeE7": -71.830598,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 6,
      "punto": 92,
      "latitudeE7": 5.370943,
      "longitudeE7": -71.83056,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 6,
      "punto": 93,
      "latitudeE7": 5.370937,
      "longitudeE7": -71.830523,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 6,
      "punto": 94,
      "latitudeE7": 5.370931,
      "longitudeE7": -71.830485,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 6,
      "punto": 95,
      "latitudeE7": 5.370925,
      "longitudeE7": -71.830447,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 6,
      "punto": 96,
      "latitudeE7": 5.370919,
      "longitudeE7": -71.830409,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 6,
      "punto": 97,
      "latitudeE7": 5.370913,
      "longitudeE7": -71.830372,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 6,
      "punto": 98,
      "latitudeE7": 5.370907,
      "longitudeE7": -71.830334,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 6,
      "punto": 99,
      "latitudeE7": 5.370901,
      "longitudeE7": -71.830296,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 6,
      "punto": 100,
      "latitudeE7": 5.370895,
      "longitudeE7": -71.830259,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 6,
      "punto": 101,
      "latitudeE7": 5.370889,
      "longitudeE7": -71.830221,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 6,
      "punto": 102,
      "latitudeE7": 5.370883,
      "longitudeE7": -71.830183,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 6,
      "punto": 103,
      "latitudeE7": 5.370877,
      "longitudeE7": -71.830145,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 6,
      "punto": 104,
      "latitudeE7": 5.370871,
      "longitudeE7": -71.830108,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 6,
      "punto": 105,
      "latitudeE7": 5.370865,
      "longitudeE7": -71.83007,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 6,
      "punto": 106,
      "latitudeE7": 5.370859,
      "longitudeE7": -71.830032,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 6,
      "punto": 107,
      "latitudeE7": 5.370853,
      "longitudeE7": -71.829994,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 6,
      "punto": 108,
      "latitudeE7": 5.370847,
      "longitudeE7": -71.829957,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 6,
      "punto": 109,
      "latitudeE7": 5.370841,
      "longitudeE7": -71.829919,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 6,
      "punto": 110,
      "latitudeE7": 5.370835,
      "longitudeE7": -71.829881,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 6,
      "punto": 111,
      "latitudeE7": 5.370829,
      "longitudeE7": -71.829844,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 6,
      "punto": 112,
      "latitudeE7": 5.370823,
      "longitudeE7": -71.829806,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 6,
      "punto": 113,
      "latitudeE7": 5.370817,
      "longitudeE7": -71.829768,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 6,
      "punto": 114,
      "latitudeE7": 5.370811,
      "longitudeE7": -71.82973,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 7,
      "punto": 1,
      "latitudeE7": 5.371449,
      "longitudeE7": -71.834018,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 7,
      "punto": 2,
      "latitudeE7": 5.371443,
      "longitudeE7": -71.83398,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 7,
      "punto": 3,
      "latitudeE7": 5.371437,
      "longitudeE7": -71.833942,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 7,
      "punto": 4,
      "latitudeE7": 5.371431,
      "longitudeE7": -71.833905,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 7,
      "punto": 5,
      "latitudeE7": 5.371425,
      "longitudeE7": -71.833867,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 7,
      "punto": 6,
      "latitudeE7": 5.371419,
      "longitudeE7": -71.833829,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 7,
      "punto": 7,
      "latitudeE7": 5.371413,
      "longitudeE7": -71.833791,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 7,
      "punto": 8,
      "latitudeE7": 5.371407,
      "longitudeE7": -71.833754,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 7,
      "punto": 9,
      "latitudeE7": 5.371401,
      "longitudeE7": -71.833716,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 7,
      "punto": 10,
      "latitudeE7": 5.371395,
      "longitudeE7": -71.833678,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 7,
      "punto": 11,
      "latitudeE7": 5.371389,
      "longitudeE7": -71.833641,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 7,
      "punto": 12,
      "latitudeE7": 5.371383,
      "longitudeE7": -71.833603,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 7,
      "punto": 13,
      "latitudeE7": 5.371377,
      "longitudeE7": -71.833565,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 7,
      "punto": 14,
      "latitudeE7": 5.371371,
      "longitudeE7": -71.833527,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 7,
      "punto": 15,
      "latitudeE7": 5.371365,
      "longitudeE7": -71.83349,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 7,
      "punto": 16,
      "latitudeE7": 5.371359,
      "longitudeE7": -71.833452,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 7,
      "punto": 17,
      "latitudeE7": 5.371353,
      "longitudeE7": -71.833414,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 7,
      "punto": 18,
      "latitudeE7": 5.371347,
      "longitudeE7": -71.833377,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 7,
      "punto": 19,
      "latitudeE7": 5.371341,
      "longitudeE7": -71.833339,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 7,
      "punto": 20,
      "latitudeE7": 5.371335,
      "longitudeE7": -71.833301,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 7,
      "punto": 21,
      "latitudeE7": 5.371329,
      "longitudeE7": -71.833263,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 7,
      "punto": 22,
      "latitudeE7": 5.371323,
      "longitudeE7": -71.833226,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 7,
      "punto": 23,
      "latitudeE7": 5.371317,
      "longitudeE7": -71.833188,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 7,
      "punto": 24,
      "latitudeE7": 5.371311,
      "longitudeE7": -71.83315,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 7,
      "punto": 25,
      "latitudeE7": 5.371305,
      "longitudeE7": -71.833112,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 7,
      "punto": 26,
      "latitudeE7": 5.371299,
      "longitudeE7": -71.833075,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 7,
      "punto": 27,
      "latitudeE7": 5.371293,
      "longitudeE7": -71.833037,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 7,
      "punto": 28,
      "latitudeE7": 5.371287,
      "longitudeE7": -71.832999,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 7,
      "punto": 29,
      "latitudeE7": 5.371281,
      "longitudeE7": -71.832962,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 7,
      "punto": 30,
      "latitudeE7": 5.371275,
      "longitudeE7": -71.832924,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 7,
      "punto": 31,
      "latitudeE7": 5.371269,
      "longitudeE7": -71.832886,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 7,
      "punto": 32,
      "latitudeE7": 5.371263,
      "longitudeE7": -71.832848,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 7,
      "punto": 33,
      "latitudeE7": 5.371257,
      "longitudeE7": -71.832811,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 7,
      "punto": 34,
      "latitudeE7": 5.371251,
      "longitudeE7": -71.832773,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 7,
      "punto": 35,
      "latitudeE7": 5.371245,
      "longitudeE7": -71.832735,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 7,
      "punto": 36,
      "latitudeE7": 5.371239,
      "longitudeE7": -71.832698,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 7,
      "punto": 37,
      "latitudeE7": 5.371233,
      "longitudeE7": -71.83266,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 7,
      "punto": 38,
      "latitudeE7": 5.371227,
      "longitudeE7": -71.832622,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 7,
      "punto": 39,
      "latitudeE7": 5.371221,
      "longitudeE7": -71.832584,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 7,
      "punto": 40,
      "latitudeE7": 5.371215,
      "longitudeE7": -71.832547,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 7,
      "punto": 41,
      "latitudeE7": 5.371209,
      "longitudeE7": -71.832509,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 7,
      "punto": 42,
      "latitudeE7": 5.371203,
      "longitudeE7": -71.832471,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 7,
      "punto": 43,
      "latitudeE7": 5.371197,
      "longitudeE7": -71.832434,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 7,
      "punto": 44,
      "latitudeE7": 5.371191,
      "longitudeE7": -71.832396,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 7,
      "punto": 45,
      "latitudeE7": 5.371185,
      "longitudeE7": -71.832358,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 7,
      "punto": 46,
      "latitudeE7": 5.371179,
      "longitudeE7": -71.83232,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 7,
      "punto": 47,
      "latitudeE7": 5.371173,
      "longitudeE7": -71.832283,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 7,
      "punto": 48,
      "latitudeE7": 5.371167,
      "longitudeE7": -71.832245,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 7,
      "punto": 49,
      "latitudeE7": 5.371161,
      "longitudeE7": -71.832207,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 7,
      "punto": 50,
      "latitudeE7": 5.371155,
      "longitudeE7": -71.832169,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 7,
      "punto": 51,
      "latitudeE7": 5.371149,
      "longitudeE7": -71.832132,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 7,
      "punto": 52,
      "latitudeE7": 5.371143,
      "longitudeE7": -71.832094,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 7,
      "punto": 53,
      "latitudeE7": 5.371137,
      "longitudeE7": -71.832056,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 7,
      "punto": 54,
      "latitudeE7": 5.371131,
      "longitudeE7": -71.832019,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 7,
      "punto": 55,
      "latitudeE7": 5.371125,
      "longitudeE7": -71.831981,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 7,
      "punto": 56,
      "latitudeE7": 5.371119,
      "longitudeE7": -71.831943,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 7,
      "punto": 57,
      "latitudeE7": 5.371113,
      "longitudeE7": -71.831905,
      "accuracy": 15,
      "porcentaje": 0.44
    },
    {
      "linea": 7,
      "punto": 58,
      "latitudeE7": 5.371107,
      "longitudeE7": -71.831868,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 7,
      "punto": 59,
      "latitudeE7": 5.371101,
      "longitudeE7": -71.83183,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 7,
      "punto": 60,
      "latitudeE7": 5.371095,
      "longitudeE7": -71.831792,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 7,
      "punto": 61,
      "latitudeE7": 5.371089,
      "longitudeE7": -71.831755,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 7,
      "punto": 62,
      "latitudeE7": 5.371083,
      "longitudeE7": -71.831717,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 7,
      "punto": 63,
      "latitudeE7": 5.371077,
      "longitudeE7": -71.831679,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 7,
      "punto": 64,
      "latitudeE7": 5.371071,
      "longitudeE7": -71.831641,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 7,
      "punto": 65,
      "latitudeE7": 5.371065,
      "longitudeE7": -71.831604,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 7,
      "punto": 66,
      "latitudeE7": 5.371059,
      "longitudeE7": -71.831566,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 7,
      "punto": 67,
      "latitudeE7": 5.371053,
      "longitudeE7": -71.831528,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 7,
      "punto": 68,
      "latitudeE7": 5.371047,
      "longitudeE7": -71.831491,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 7,
      "punto": 69,
      "latitudeE7": 5.371041,
      "longitudeE7": -71.831453,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 7,
      "punto": 70,
      "latitudeE7": 5.371035,
      "longitudeE7": -71.831415,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 7,
      "punto": 71,
      "latitudeE7": 5.371029,
      "longitudeE7": -71.831377,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 7,
      "punto": 72,
      "latitudeE7": 5.371023,
      "longitudeE7": -71.83134,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 7,
      "punto": 73,
      "latitudeE7": 5.371017,
      "longitudeE7": -71.831302,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 7,
      "punto": 74,
      "latitudeE7": 5.371011,
      "longitudeE7": -71.831264,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 7,
      "punto": 75,
      "latitudeE7": 5.371005,
      "longitudeE7": -71.831226,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 7,
      "punto": 76,
      "latitudeE7": 5.370999,
      "longitudeE7": -71.831189,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 7,
      "punto": 77,
      "latitudeE7": 5.370993,
      "longitudeE7": -71.831151,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 7,
      "punto": 78,
      "latitudeE7": 5.370987,
      "longitudeE7": -71.831113,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 7,
      "punto": 79,
      "latitudeE7": 5.370981,
      "longitudeE7": -71.831076,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 7,
      "punto": 80,
      "latitudeE7": 5.370975,
      "longitudeE7": -71.831038,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 7,
      "punto": 81,
      "latitudeE7": 5.370969,
      "longitudeE7": -71.831,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 7,
      "punto": 82,
      "latitudeE7": 5.370963,
      "longitudeE7": -71.830962,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 7,
      "punto": 83,
      "latitudeE7": 5.370957,
      "longitudeE7": -71.830925,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 7,
      "punto": 84,
      "latitudeE7": 5.370951,
      "longitudeE7": -71.830887,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 7,
      "punto": 85,
      "latitudeE7": 5.370945,
      "longitudeE7": -71.830849,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 7,
      "punto": 86,
      "latitudeE7": 5.370939,
      "longitudeE7": -71.830812,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 7,
      "punto": 87,
      "latitudeE7": 5.370933,
      "longitudeE7": -71.830774,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 7,
      "punto": 88,
      "latitudeE7": 5.370927,
      "longitudeE7": -71.830736,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 7,
      "punto": 89,
      "latitudeE7": 5.370921,
      "longitudeE7": -71.830698,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 7,
      "punto": 90,
      "latitudeE7": 5.370915,
      "longitudeE7": -71.830661,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 7,
      "punto": 91,
      "latitudeE7": 5.370909,
      "longitudeE7": -71.830623,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 7,
      "punto": 92,
      "latitudeE7": 5.370903,
      "longitudeE7": -71.830585,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 7,
      "punto": 93,
      "latitudeE7": 5.370897,
      "longitudeE7": -71.830548,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 7,
      "punto": 94,
      "latitudeE7": 5.370891,
      "longitudeE7": -71.83051,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 7,
      "punto": 95,
      "latitudeE7": 5.370885,
      "longitudeE7": -71.830472,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 7,
      "punto": 96,
      "latitudeE7": 5.370879,
      "longitudeE7": -71.830434,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 7,
      "punto": 97,
      "latitudeE7": 5.370873,
      "longitudeE7": -71.830397,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 7,
      "punto": 98,
      "latitudeE7": 5.370867,
      "longitudeE7": -71.830359,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 7,
      "punto": 99,
      "latitudeE7": 5.370861,
      "longitudeE7": -71.830321,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 7,
      "punto": 100,
      "latitudeE7": 5.370855,
      "longitudeE7": -71.830283,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 7,
      "punto": 101,
      "latitudeE7": 5.370849,
      "longitudeE7": -71.830246,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 7,
      "punto": 102,
      "latitudeE7": 5.370843,
      "longitudeE7": -71.830208,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 7,
      "punto": 103,
      "latitudeE7": 5.370837,
      "longitudeE7": -71.83017,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 7,
      "punto": 104,
      "latitudeE7": 5.370831,
      "longitudeE7": -71.830133,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 7,
      "punto": 105,
      "latitudeE7": 5.370825,
      "longitudeE7": -71.830095,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 7,
      "punto": 106,
      "latitudeE7": 5.370819,
      "longitudeE7": -71.830057,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 7,
      "punto": 107,
      "latitudeE7": 5.370813,
      "longitudeE7": -71.830019,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 7,
      "punto": 108,
      "latitudeE7": 5.370807,
      "longitudeE7": -71.829982,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 7,
      "punto": 109,
      "latitudeE7": 5.370801,
      "longitudeE7": -71.829944,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 7,
      "punto": 110,
      "latitudeE7": 5.370795,
      "longitudeE7": -71.829906,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 7,
      "punto": 111,
      "latitudeE7": 5.370789,
      "longitudeE7": -71.829869,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 7,
      "punto": 112,
      "latitudeE7": 5.370783,
      "longitudeE7": -71.829831,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 7,
      "punto": 113,
      "latitudeE7": 5.370777,
      "longitudeE7": -71.829793,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 7,
      "punto": 114,
      "latitudeE7": 5.370771,
      "longitudeE7": -71.829755,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 8,
      "punto": 1,
      "latitudeE7": 5.371409,
      "longitudeE7": -71.834043,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 8,
      "punto": 2,
      "latitudeE7": 5.371403,
      "longitudeE7": -71.834005,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 8,
      "punto": 3,
      "latitudeE7": 5.371397,
      "longitudeE7": -71.833967,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 8,
      "punto": 4,
      "latitudeE7": 5.371391,
      "longitudeE7": -71.83393,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 8,
      "punto": 5,
      "latitudeE7": 5.371385,
      "longitudeE7": -71.833892,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 8,
      "punto": 6,
      "latitudeE7": 5.371379,
      "longitudeE7": -71.833854,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 8,
      "punto": 7,
      "latitudeE7": 5.371373,
      "longitudeE7": -71.833816,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 8,
      "punto": 8,
      "latitudeE7": 5.371367,
      "longitudeE7": -71.833779,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 8,
      "punto": 9,
      "latitudeE7": 5.371361,
      "longitudeE7": -71.833741,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 8,
      "punto": 10,
      "latitudeE7": 5.371355,
      "longitudeE7": -71.833703,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 8,
      "punto": 11,
      "latitudeE7": 5.371349,
      "longitudeE7": -71.833666,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 8,
      "punto": 12,
      "latitudeE7": 5.371343,
      "longitudeE7": -71.833628,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 8,
      "punto": 13,
      "latitudeE7": 5.371337,
      "longitudeE7": -71.83359,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 8,
      "punto": 14,
      "latitudeE7": 5.371331,
      "longitudeE7": -71.833552,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 8,
      "punto": 15,
      "latitudeE7": 5.371325,
      "longitudeE7": -71.833515,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 8,
      "punto": 16,
      "latitudeE7": 5.371319,
      "longitudeE7": -71.833477,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 8,
      "punto": 17,
      "latitudeE7": 5.371313,
      "longitudeE7": -71.833439,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 8,
      "punto": 18,
      "latitudeE7": 5.371307,
      "longitudeE7": -71.833401,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 8,
      "punto": 19,
      "latitudeE7": 5.371301,
      "longitudeE7": -71.833364,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 8,
      "punto": 20,
      "latitudeE7": 5.371295,
      "longitudeE7": -71.833326,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 8,
      "punto": 21,
      "latitudeE7": 5.371289,
      "longitudeE7": -71.833288,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 8,
      "punto": 22,
      "latitudeE7": 5.371283,
      "longitudeE7": -71.833251,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 8,
      "punto": 23,
      "latitudeE7": 5.371277,
      "longitudeE7": -71.833213,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 8,
      "punto": 24,
      "latitudeE7": 5.371271,
      "longitudeE7": -71.833175,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 8,
      "punto": 25,
      "latitudeE7": 5.371265,
      "longitudeE7": -71.833137,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 8,
      "punto": 26,
      "latitudeE7": 5.371259,
      "longitudeE7": -71.8331,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 8,
      "punto": 27,
      "latitudeE7": 5.371253,
      "longitudeE7": -71.833062,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 8,
      "punto": 28,
      "latitudeE7": 5.371247,
      "longitudeE7": -71.833024,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 8,
      "punto": 29,
      "latitudeE7": 5.371241,
      "longitudeE7": -71.832987,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 8,
      "punto": 30,
      "latitudeE7": 5.371235,
      "longitudeE7": -71.832949,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 8,
      "punto": 31,
      "latitudeE7": 5.371229,
      "longitudeE7": -71.832911,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 8,
      "punto": 32,
      "latitudeE7": 5.371223,
      "longitudeE7": -71.832873,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 8,
      "punto": 33,
      "latitudeE7": 5.371217,
      "longitudeE7": -71.832836,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 8,
      "punto": 34,
      "latitudeE7": 5.371211,
      "longitudeE7": -71.832798,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 8,
      "punto": 35,
      "latitudeE7": 5.371205,
      "longitudeE7": -71.83276,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 8,
      "punto": 36,
      "latitudeE7": 5.371199,
      "longitudeE7": -71.832723,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 8,
      "punto": 37,
      "latitudeE7": 5.371193,
      "longitudeE7": -71.832685,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 8,
      "punto": 38,
      "latitudeE7": 5.371187,
      "longitudeE7": -71.832647,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 8,
      "punto": 39,
      "latitudeE7": 5.371181,
      "longitudeE7": -71.832609,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 8,
      "punto": 40,
      "latitudeE7": 5.371175,
      "longitudeE7": -71.832572,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 8,
      "punto": 41,
      "latitudeE7": 5.371169,
      "longitudeE7": -71.832534,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 8,
      "punto": 42,
      "latitudeE7": 5.371163,
      "longitudeE7": -71.832496,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 8,
      "punto": 43,
      "latitudeE7": 5.371157,
      "longitudeE7": -71.832458,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 8,
      "punto": 44,
      "latitudeE7": 5.371151,
      "longitudeE7": -71.832421,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 8,
      "punto": 45,
      "latitudeE7": 5.371145,
      "longitudeE7": -71.832383,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 8,
      "punto": 46,
      "latitudeE7": 5.371139,
      "longitudeE7": -71.832345,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 8,
      "punto": 47,
      "latitudeE7": 5.371133,
      "longitudeE7": -71.832308,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 8,
      "punto": 48,
      "latitudeE7": 5.371127,
      "longitudeE7": -71.83227,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 8,
      "punto": 49,
      "latitudeE7": 5.371121,
      "longitudeE7": -71.832232,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 8,
      "punto": 50,
      "latitudeE7": 5.371115,
      "longitudeE7": -71.832194,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 8,
      "punto": 51,
      "latitudeE7": 5.371109,
      "longitudeE7": -71.832157,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 8,
      "punto": 52,
      "latitudeE7": 5.371103,
      "longitudeE7": -71.832119,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 8,
      "punto": 53,
      "latitudeE7": 5.371097,
      "longitudeE7": -71.832081,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 8,
      "punto": 54,
      "latitudeE7": 5.371091,
      "longitudeE7": -71.832044,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 8,
      "punto": 55,
      "latitudeE7": 5.371085,
      "longitudeE7": -71.832006,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 8,
      "punto": 56,
      "latitudeE7": 5.371079,
      "longitudeE7": -71.831968,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 8,
      "punto": 57,
      "latitudeE7": 5.371073,
      "longitudeE7": -71.83193,
      "accuracy": 15,
      "porcentaje": 0.56
    },
    {
      "linea": 8,
      "punto": 58,
      "latitudeE7": 5.371067,
      "longitudeE7": -71.831893,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 8,
      "punto": 59,
      "latitudeE7": 5.371061,
      "longitudeE7": -71.831855,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 8,
      "punto": 60,
      "latitudeE7": 5.371055,
      "longitudeE7": -71.831817,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 8,
      "punto": 61,
      "latitudeE7": 5.371049,
      "longitudeE7": -71.83178,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 8,
      "punto": 62,
      "latitudeE7": 5.371043,
      "longitudeE7": -71.831742,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 8,
      "punto": 63,
      "latitudeE7": 5.371037,
      "longitudeE7": -71.831704,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 8,
      "punto": 64,
      "latitudeE7": 5.371031,
      "longitudeE7": -71.831666,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 8,
      "punto": 65,
      "latitudeE7": 5.371025,
      "longitudeE7": -71.831629,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 8,
      "punto": 66,
      "latitudeE7": 5.371019,
      "longitudeE7": -71.831591,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 8,
      "punto": 67,
      "latitudeE7": 5.371013,
      "longitudeE7": -71.831553,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 8,
      "punto": 68,
      "latitudeE7": 5.371007,
      "longitudeE7": -71.831515,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 8,
      "punto": 69,
      "latitudeE7": 5.371001,
      "longitudeE7": -71.831478,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 8,
      "punto": 70,
      "latitudeE7": 5.370995,
      "longitudeE7": -71.83144,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 8,
      "punto": 71,
      "latitudeE7": 5.370989,
      "longitudeE7": -71.831402,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 8,
      "punto": 72,
      "latitudeE7": 5.370983,
      "longitudeE7": -71.831365,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 8,
      "punto": 73,
      "latitudeE7": 5.370977,
      "longitudeE7": -71.831327,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 8,
      "punto": 74,
      "latitudeE7": 5.370971,
      "longitudeE7": -71.831289,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 8,
      "punto": 75,
      "latitudeE7": 5.370965,
      "longitudeE7": -71.831251,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 8,
      "punto": 76,
      "latitudeE7": 5.370959,
      "longitudeE7": -71.831214,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 8,
      "punto": 77,
      "latitudeE7": 5.370953,
      "longitudeE7": -71.831176,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 8,
      "punto": 78,
      "latitudeE7": 5.370947,
      "longitudeE7": -71.831138,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 8,
      "punto": 79,
      "latitudeE7": 5.370941,
      "longitudeE7": -71.831101,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 8,
      "punto": 80,
      "latitudeE7": 5.370935,
      "longitudeE7": -71.831063,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 8,
      "punto": 81,
      "latitudeE7": 5.370929,
      "longitudeE7": -71.831025,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 8,
      "punto": 82,
      "latitudeE7": 5.370923,
      "longitudeE7": -71.830987,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 8,
      "punto": 83,
      "latitudeE7": 5.370917,
      "longitudeE7": -71.83095,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 8,
      "punto": 84,
      "latitudeE7": 5.370911,
      "longitudeE7": -71.830912,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 8,
      "punto": 85,
      "latitudeE7": 5.370905,
      "longitudeE7": -71.830874,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 8,
      "punto": 86,
      "latitudeE7": 5.370899,
      "longitudeE7": -71.830837,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 8,
      "punto": 87,
      "latitudeE7": 5.370893,
      "longitudeE7": -71.830799,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 8,
      "punto": 88,
      "latitudeE7": 5.370887,
      "longitudeE7": -71.830761,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 8,
      "punto": 89,
      "latitudeE7": 5.370881,
      "longitudeE7": -71.830723,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 8,
      "punto": 90,
      "latitudeE7": 5.370875,
      "longitudeE7": -71.830686,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 8,
      "punto": 91,
      "latitudeE7": 5.370869,
      "longitudeE7": -71.830648,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 8,
      "punto": 92,
      "latitudeE7": 5.370863,
      "longitudeE7": -71.83061,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 8,
      "punto": 93,
      "latitudeE7": 5.370857,
      "longitudeE7": -71.830572,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 8,
      "punto": 94,
      "latitudeE7": 5.370851,
      "longitudeE7": -71.830535,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 8,
      "punto": 95,
      "latitudeE7": 5.370845,
      "longitudeE7": -71.830497,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 8,
      "punto": 96,
      "latitudeE7": 5.370839,
      "longitudeE7": -71.830459,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 8,
      "punto": 97,
      "latitudeE7": 5.370833,
      "longitudeE7": -71.830422,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 8,
      "punto": 98,
      "latitudeE7": 5.370827,
      "longitudeE7": -71.830384,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 8,
      "punto": 99,
      "latitudeE7": 5.370821,
      "longitudeE7": -71.830346,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 8,
      "punto": 100,
      "latitudeE7": 5.370815,
      "longitudeE7": -71.830308,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 8,
      "punto": 101,
      "latitudeE7": 5.370809,
      "longitudeE7": -71.830271,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 8,
      "punto": 102,
      "latitudeE7": 5.370803,
      "longitudeE7": -71.830233,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 8,
      "punto": 103,
      "latitudeE7": 5.370797,
      "longitudeE7": -71.830195,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 8,
      "punto": 104,
      "latitudeE7": 5.370791,
      "longitudeE7": -71.830158,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 8,
      "punto": 105,
      "latitudeE7": 5.370785,
      "longitudeE7": -71.83012,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 8,
      "punto": 106,
      "latitudeE7": 5.370779,
      "longitudeE7": -71.830082,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 8,
      "punto": 107,
      "latitudeE7": 5.370773,
      "longitudeE7": -71.830044,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 8,
      "punto": 108,
      "latitudeE7": 5.370767,
      "longitudeE7": -71.830007,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 8,
      "punto": 109,
      "latitudeE7": 5.370761,
      "longitudeE7": -71.829969,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 8,
      "punto": 110,
      "latitudeE7": 5.370755,
      "longitudeE7": -71.829931,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 8,
      "punto": 111,
      "latitudeE7": 5.370749,
      "longitudeE7": -71.829894,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 8,
      "punto": 112,
      "latitudeE7": 5.370743,
      "longitudeE7": -71.829856,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 8,
      "punto": 113,
      "latitudeE7": 5.370737,
      "longitudeE7": -71.829818,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 8,
      "punto": 114,
      "latitudeE7": 5.370731,
      "longitudeE7": -71.82978,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 9,
      "punto": 1,
      "latitudeE7": 5.371369,
      "longitudeE7": -71.834068,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 9,
      "punto": 2,
      "latitudeE7": 5.371363,
      "longitudeE7": -71.83403,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 9,
      "punto": 3,
      "latitudeE7": 5.371357,
      "longitudeE7": -71.833992,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 9,
      "punto": 4,
      "latitudeE7": 5.371351,
      "longitudeE7": -71.833955,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 9,
      "punto": 5,
      "latitudeE7": 5.371345,
      "longitudeE7": -71.833917,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 9,
      "punto": 6,
      "latitudeE7": 5.371339,
      "longitudeE7": -71.833879,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 9,
      "punto": 7,
      "latitudeE7": 5.371333,
      "longitudeE7": -71.833841,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 9,
      "punto": 8,
      "latitudeE7": 5.371327,
      "longitudeE7": -71.833804,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 9,
      "punto": 9,
      "latitudeE7": 5.371321,
      "longitudeE7": -71.833766,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 9,
      "punto": 10,
      "latitudeE7": 5.371315,
      "longitudeE7": -71.833728,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 9,
      "punto": 11,
      "latitudeE7": 5.371309,
      "longitudeE7": -71.83369,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 9,
      "punto": 12,
      "latitudeE7": 5.371303,
      "longitudeE7": -71.833653,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 9,
      "punto": 13,
      "latitudeE7": 5.371297,
      "longitudeE7": -71.833615,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 9,
      "punto": 14,
      "latitudeE7": 5.371291,
      "longitudeE7": -71.833577,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 9,
      "punto": 15,
      "latitudeE7": 5.371285,
      "longitudeE7": -71.83354,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 9,
      "punto": 16,
      "latitudeE7": 5.371279,
      "longitudeE7": -71.833502,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 9,
      "punto": 17,
      "latitudeE7": 5.371273,
      "longitudeE7": -71.833464,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 9,
      "punto": 18,
      "latitudeE7": 5.371267,
      "longitudeE7": -71.833426,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 9,
      "punto": 19,
      "latitudeE7": 5.371261,
      "longitudeE7": -71.833389,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 9,
      "punto": 20,
      "latitudeE7": 5.371255,
      "longitudeE7": -71.833351,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 9,
      "punto": 21,
      "latitudeE7": 5.371249,
      "longitudeE7": -71.833313,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 9,
      "punto": 22,
      "latitudeE7": 5.371243,
      "longitudeE7": -71.833276,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 9,
      "punto": 23,
      "latitudeE7": 5.371237,
      "longitudeE7": -71.833238,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 9,
      "punto": 24,
      "latitudeE7": 5.371231,
      "longitudeE7": -71.8332,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 9,
      "punto": 25,
      "latitudeE7": 5.371225,
      "longitudeE7": -71.833162,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 9,
      "punto": 26,
      "latitudeE7": 5.371219,
      "longitudeE7": -71.833125,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 9,
      "punto": 27,
      "latitudeE7": 5.371213,
      "longitudeE7": -71.833087,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 9,
      "punto": 28,
      "latitudeE7": 5.371207,
      "longitudeE7": -71.833049,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 9,
      "punto": 29,
      "latitudeE7": 5.371201,
      "longitudeE7": -71.833012,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 9,
      "punto": 30,
      "latitudeE7": 5.371195,
      "longitudeE7": -71.832974,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 9,
      "punto": 31,
      "latitudeE7": 5.371189,
      "longitudeE7": -71.832936,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 9,
      "punto": 32,
      "latitudeE7": 5.371183,
      "longitudeE7": -71.832898,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 9,
      "punto": 33,
      "latitudeE7": 5.371177,
      "longitudeE7": -71.832861,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 9,
      "punto": 34,
      "latitudeE7": 5.371171,
      "longitudeE7": -71.832823,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 9,
      "punto": 35,
      "latitudeE7": 5.371165,
      "longitudeE7": -71.832785,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 9,
      "punto": 36,
      "latitudeE7": 5.371159,
      "longitudeE7": -71.832747,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 9,
      "punto": 37,
      "latitudeE7": 5.371153,
      "longitudeE7": -71.83271,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 9,
      "punto": 38,
      "latitudeE7": 5.371147,
      "longitudeE7": -71.832672,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 9,
      "punto": 39,
      "latitudeE7": 5.371141,
      "longitudeE7": -71.832634,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 9,
      "punto": 40,
      "latitudeE7": 5.371135,
      "longitudeE7": -71.832597,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 9,
      "punto": 41,
      "latitudeE7": 5.371129,
      "longitudeE7": -71.832559,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 9,
      "punto": 42,
      "latitudeE7": 5.371123,
      "longitudeE7": -71.832521,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 9,
      "punto": 43,
      "latitudeE7": 5.371117,
      "longitudeE7": -71.832483,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 9,
      "punto": 44,
      "latitudeE7": 5.371111,
      "longitudeE7": -71.832446,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 9,
      "punto": 45,
      "latitudeE7": 5.371105,
      "longitudeE7": -71.832408,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 9,
      "punto": 46,
      "latitudeE7": 5.371099,
      "longitudeE7": -71.83237,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 9,
      "punto": 47,
      "latitudeE7": 5.371093,
      "longitudeE7": -71.832333,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 9,
      "punto": 48,
      "latitudeE7": 5.371087,
      "longitudeE7": -71.832295,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 9,
      "punto": 49,
      "latitudeE7": 5.371081,
      "longitudeE7": -71.832257,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 9,
      "punto": 50,
      "latitudeE7": 5.371075,
      "longitudeE7": -71.832219,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 9,
      "punto": 51,
      "latitudeE7": 5.371069,
      "longitudeE7": -71.832182,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 9,
      "punto": 52,
      "latitudeE7": 5.371063,
      "longitudeE7": -71.832144,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 9,
      "punto": 53,
      "latitudeE7": 5.371057,
      "longitudeE7": -71.832106,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 9,
      "punto": 54,
      "latitudeE7": 5.371051,
      "longitudeE7": -71.832069,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 9,
      "punto": 55,
      "latitudeE7": 5.371045,
      "longitudeE7": -71.832031,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 9,
      "punto": 56,
      "latitudeE7": 5.371039,
      "longitudeE7": -71.831993,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 9,
      "punto": 57,
      "latitudeE7": 5.371033,
      "longitudeE7": -71.831955,
      "accuracy": 15,
      "porcentaje": 0.12
    },
    {
      "linea": 9,
      "punto": 58,
      "latitudeE7": 5.371027,
      "longitudeE7": -71.831918,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 9,
      "punto": 59,
      "latitudeE7": 5.371021,
      "longitudeE7": -71.83188,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 9,
      "punto": 60,
      "latitudeE7": 5.371015,
      "longitudeE7": -71.831842,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 9,
      "punto": 61,
      "latitudeE7": 5.371009,
      "longitudeE7": -71.831804,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 9,
      "punto": 62,
      "latitudeE7": 5.371003,
      "longitudeE7": -71.831767,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 9,
      "punto": 63,
      "latitudeE7": 5.370997,
      "longitudeE7": -71.831729,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 9,
      "punto": 64,
      "latitudeE7": 5.370991,
      "longitudeE7": -71.831691,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 9,
      "punto": 65,
      "latitudeE7": 5.370985,
      "longitudeE7": -71.831654,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 9,
      "punto": 66,
      "latitudeE7": 5.370979,
      "longitudeE7": -71.831616,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 9,
      "punto": 67,
      "latitudeE7": 5.370973,
      "longitudeE7": -71.831578,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 9,
      "punto": 68,
      "latitudeE7": 5.370967,
      "longitudeE7": -71.83154,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 9,
      "punto": 69,
      "latitudeE7": 5.370961,
      "longitudeE7": -71.831503,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 9,
      "punto": 70,
      "latitudeE7": 5.370955,
      "longitudeE7": -71.831465,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 9,
      "punto": 71,
      "latitudeE7": 5.370949,
      "longitudeE7": -71.831427,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 9,
      "punto": 72,
      "latitudeE7": 5.370943,
      "longitudeE7": -71.83139,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 9,
      "punto": 73,
      "latitudeE7": 5.370937,
      "longitudeE7": -71.831352,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 9,
      "punto": 74,
      "latitudeE7": 5.370931,
      "longitudeE7": -71.831314,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 9,
      "punto": 75,
      "latitudeE7": 5.370925,
      "longitudeE7": -71.831276,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 9,
      "punto": 76,
      "latitudeE7": 5.370919,
      "longitudeE7": -71.831239,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 9,
      "punto": 77,
      "latitudeE7": 5.370913,
      "longitudeE7": -71.831201,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 9,
      "punto": 78,
      "latitudeE7": 5.370907,
      "longitudeE7": -71.831163,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 9,
      "punto": 79,
      "latitudeE7": 5.370901,
      "longitudeE7": -71.831126,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 9,
      "punto": 80,
      "latitudeE7": 5.370895,
      "longitudeE7": -71.831088,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 9,
      "punto": 81,
      "latitudeE7": 5.370889,
      "longitudeE7": -71.83105,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 9,
      "punto": 82,
      "latitudeE7": 5.370883,
      "longitudeE7": -71.831012,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 9,
      "punto": 83,
      "latitudeE7": 5.370877,
      "longitudeE7": -71.830975,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 9,
      "punto": 84,
      "latitudeE7": 5.370871,
      "longitudeE7": -71.830937,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 9,
      "punto": 85,
      "latitudeE7": 5.370865,
      "longitudeE7": -71.830899,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 9,
      "punto": 86,
      "latitudeE7": 5.370859,
      "longitudeE7": -71.830861,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 9,
      "punto": 87,
      "latitudeE7": 5.370853,
      "longitudeE7": -71.830824,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 9,
      "punto": 88,
      "latitudeE7": 5.370847,
      "longitudeE7": -71.830786,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 9,
      "punto": 89,
      "latitudeE7": 5.370841,
      "longitudeE7": -71.830748,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 9,
      "punto": 90,
      "latitudeE7": 5.370835,
      "longitudeE7": -71.830711,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 9,
      "punto": 91,
      "latitudeE7": 5.370829,
      "longitudeE7": -71.830673,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 9,
      "punto": 92,
      "latitudeE7": 5.370823,
      "longitudeE7": -71.830635,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 9,
      "punto": 93,
      "latitudeE7": 5.370817,
      "longitudeE7": -71.830597,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 9,
      "punto": 94,
      "latitudeE7": 5.370811,
      "longitudeE7": -71.83056,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 9,
      "punto": 95,
      "latitudeE7": 5.370805,
      "longitudeE7": -71.830522,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 9,
      "punto": 96,
      "latitudeE7": 5.370799,
      "longitudeE7": -71.830484,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 9,
      "punto": 97,
      "latitudeE7": 5.370793,
      "longitudeE7": -71.830447,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 9,
      "punto": 98,
      "latitudeE7": 5.370787,
      "longitudeE7": -71.830409,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 9,
      "punto": 99,
      "latitudeE7": 5.370781,
      "longitudeE7": -71.830371,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 9,
      "punto": 100,
      "latitudeE7": 5.370775,
      "longitudeE7": -71.830333,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 9,
      "punto": 101,
      "latitudeE7": 5.370769,
      "longitudeE7": -71.830296,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 9,
      "punto": 102,
      "latitudeE7": 5.370763,
      "longitudeE7": -71.830258,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 9,
      "punto": 103,
      "latitudeE7": 5.370757,
      "longitudeE7": -71.83022,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 9,
      "punto": 104,
      "latitudeE7": 5.370751,
      "longitudeE7": -71.830183,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 9,
      "punto": 105,
      "latitudeE7": 5.370745,
      "longitudeE7": -71.830145,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 9,
      "punto": 106,
      "latitudeE7": 5.370739,
      "longitudeE7": -71.830107,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 9,
      "punto": 107,
      "latitudeE7": 5.370733,
      "longitudeE7": -71.830069,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 9,
      "punto": 108,
      "latitudeE7": 5.370727,
      "longitudeE7": -71.830032,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 9,
      "punto": 109,
      "latitudeE7": 5.370721,
      "longitudeE7": -71.829994,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 9,
      "punto": 110,
      "latitudeE7": 5.370715,
      "longitudeE7": -71.829956,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 9,
      "punto": 111,
      "latitudeE7": 5.370709,
      "longitudeE7": -71.829918,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 9,
      "punto": 112,
      "latitudeE7": 5.370703,
      "longitudeE7": -71.829881,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 9,
      "punto": 113,
      "latitudeE7": 5.370697,
      "longitudeE7": -71.829843,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 9,
      "punto": 114,
      "latitudeE7": 5.370691,
      "longitudeE7": -71.829805,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 10,
      "punto": 1,
      "latitudeE7": 5.371329,
      "longitudeE7": -71.834093,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 10,
      "punto": 2,
      "latitudeE7": 5.371323,
      "longitudeE7": -71.834055,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 10,
      "punto": 3,
      "latitudeE7": 5.371317,
      "longitudeE7": -71.834017,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 10,
      "punto": 4,
      "latitudeE7": 5.371311,
      "longitudeE7": -71.833979,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 10,
      "punto": 5,
      "latitudeE7": 5.371305,
      "longitudeE7": -71.833942,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 10,
      "punto": 6,
      "latitudeE7": 5.371299,
      "longitudeE7": -71.833904,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 10,
      "punto": 7,
      "latitudeE7": 5.371293,
      "longitudeE7": -71.833866,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 10,
      "punto": 8,
      "latitudeE7": 5.371287,
      "longitudeE7": -71.833829,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 10,
      "punto": 9,
      "latitudeE7": 5.371281,
      "longitudeE7": -71.833791,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 10,
      "punto": 10,
      "latitudeE7": 5.371275,
      "longitudeE7": -71.833753,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 10,
      "punto": 11,
      "latitudeE7": 5.371269,
      "longitudeE7": -71.833715,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 10,
      "punto": 12,
      "latitudeE7": 5.371263,
      "longitudeE7": -71.833678,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 10,
      "punto": 13,
      "latitudeE7": 5.371257,
      "longitudeE7": -71.83364,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 10,
      "punto": 14,
      "latitudeE7": 5.371251,
      "longitudeE7": -71.833602,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 10,
      "punto": 15,
      "latitudeE7": 5.371245,
      "longitudeE7": -71.833565,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 10,
      "punto": 16,
      "latitudeE7": 5.371239,
      "longitudeE7": -71.833527,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 10,
      "punto": 17,
      "latitudeE7": 5.371233,
      "longitudeE7": -71.833489,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 10,
      "punto": 18,
      "latitudeE7": 5.371227,
      "longitudeE7": -71.833451,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 10,
      "punto": 19,
      "latitudeE7": 5.371221,
      "longitudeE7": -71.833414,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 10,
      "punto": 20,
      "latitudeE7": 5.371215,
      "longitudeE7": -71.833376,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 10,
      "punto": 21,
      "latitudeE7": 5.371209,
      "longitudeE7": -71.833338,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 10,
      "punto": 22,
      "latitudeE7": 5.371203,
      "longitudeE7": -71.833301,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 10,
      "punto": 23,
      "latitudeE7": 5.371197,
      "longitudeE7": -71.833263,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 10,
      "punto": 24,
      "latitudeE7": 5.371191,
      "longitudeE7": -71.833225,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 10,
      "punto": 25,
      "latitudeE7": 5.371185,
      "longitudeE7": -71.833187,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 10,
      "punto": 26,
      "latitudeE7": 5.371179,
      "longitudeE7": -71.83315,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 10,
      "punto": 27,
      "latitudeE7": 5.371173,
      "longitudeE7": -71.833112,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 10,
      "punto": 28,
      "latitudeE7": 5.371167,
      "longitudeE7": -71.833074,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 10,
      "punto": 29,
      "latitudeE7": 5.371161,
      "longitudeE7": -71.833036,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 10,
      "punto": 30,
      "latitudeE7": 5.371155,
      "longitudeE7": -71.832999,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 10,
      "punto": 31,
      "latitudeE7": 5.371149,
      "longitudeE7": -71.832961,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 10,
      "punto": 32,
      "latitudeE7": 5.371143,
      "longitudeE7": -71.832923,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 10,
      "punto": 33,
      "latitudeE7": 5.371137,
      "longitudeE7": -71.832886,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 10,
      "punto": 34,
      "latitudeE7": 5.371131,
      "longitudeE7": -71.832848,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 10,
      "punto": 35,
      "latitudeE7": 5.371125,
      "longitudeE7": -71.83281,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 10,
      "punto": 36,
      "latitudeE7": 5.371119,
      "longitudeE7": -71.832772,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 10,
      "punto": 37,
      "latitudeE7": 5.371113,
      "longitudeE7": -71.832735,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 10,
      "punto": 38,
      "latitudeE7": 5.371107,
      "longitudeE7": -71.832697,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 10,
      "punto": 39,
      "latitudeE7": 5.371101,
      "longitudeE7": -71.832659,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 10,
      "punto": 40,
      "latitudeE7": 5.371095,
      "longitudeE7": -71.832622,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 10,
      "punto": 41,
      "latitudeE7": 5.371089,
      "longitudeE7": -71.832584,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 10,
      "punto": 42,
      "latitudeE7": 5.371083,
      "longitudeE7": -71.832546,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 10,
      "punto": 43,
      "latitudeE7": 5.371077,
      "longitudeE7": -71.832508,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 10,
      "punto": 44,
      "latitudeE7": 5.371071,
      "longitudeE7": -71.832471,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 10,
      "punto": 45,
      "latitudeE7": 5.371065,
      "longitudeE7": -71.832433,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 10,
      "punto": 46,
      "latitudeE7": 5.371059,
      "longitudeE7": -71.832395,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 10,
      "punto": 47,
      "latitudeE7": 5.371053,
      "longitudeE7": -71.832358,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 10,
      "punto": 48,
      "latitudeE7": 5.371047,
      "longitudeE7": -71.83232,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 10,
      "punto": 49,
      "latitudeE7": 5.371041,
      "longitudeE7": -71.832282,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 10,
      "punto": 50,
      "latitudeE7": 5.371035,
      "longitudeE7": -71.832244,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 10,
      "punto": 51,
      "latitudeE7": 5.371029,
      "longitudeE7": -71.832207,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 10,
      "punto": 52,
      "latitudeE7": 5.371023,
      "longitudeE7": -71.832169,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 10,
      "punto": 53,
      "latitudeE7": 5.371017,
      "longitudeE7": -71.832131,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 10,
      "punto": 54,
      "latitudeE7": 5.371011,
      "longitudeE7": -71.832093,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 10,
      "punto": 55,
      "latitudeE7": 5.371005,
      "longitudeE7": -71.832056,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 10,
      "punto": 56,
      "latitudeE7": 5.370999,
      "longitudeE7": -71.832018,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 10,
      "punto": 57,
      "latitudeE7": 5.370993,
      "longitudeE7": -71.83198,
      "accuracy": 15,
      "porcentaje": 0.48
    },
    {
      "linea": 10,
      "punto": 58,
      "latitudeE7": 5.370987,
      "longitudeE7": -71.831943,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 10,
      "punto": 59,
      "latitudeE7": 5.370981,
      "longitudeE7": -71.831905,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 10,
      "punto": 60,
      "latitudeE7": 5.370975,
      "longitudeE7": -71.831867,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 10,
      "punto": 61,
      "latitudeE7": 5.370969,
      "longitudeE7": -71.831829,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 10,
      "punto": 62,
      "latitudeE7": 5.370963,
      "longitudeE7": -71.831792,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 10,
      "punto": 63,
      "latitudeE7": 5.370957,
      "longitudeE7": -71.831754,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 10,
      "punto": 64,
      "latitudeE7": 5.370951,
      "longitudeE7": -71.831716,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 10,
      "punto": 65,
      "latitudeE7": 5.370945,
      "longitudeE7": -71.831679,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 10,
      "punto": 66,
      "latitudeE7": 5.370939,
      "longitudeE7": -71.831641,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 10,
      "punto": 67,
      "latitudeE7": 5.370933,
      "longitudeE7": -71.831603,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 10,
      "punto": 68,
      "latitudeE7": 5.370927,
      "longitudeE7": -71.831565,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 10,
      "punto": 69,
      "latitudeE7": 5.370921,
      "longitudeE7": -71.831528,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 10,
      "punto": 70,
      "latitudeE7": 5.370915,
      "longitudeE7": -71.83149,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 10,
      "punto": 71,
      "latitudeE7": 5.370909,
      "longitudeE7": -71.831452,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 10,
      "punto": 72,
      "latitudeE7": 5.370903,
      "longitudeE7": -71.831415,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 10,
      "punto": 73,
      "latitudeE7": 5.370897,
      "longitudeE7": -71.831377,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 10,
      "punto": 74,
      "latitudeE7": 5.370891,
      "longitudeE7": -71.831339,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 10,
      "punto": 75,
      "latitudeE7": 5.370885,
      "longitudeE7": -71.831301,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 10,
      "punto": 76,
      "latitudeE7": 5.370879,
      "longitudeE7": -71.831264,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 10,
      "punto": 77,
      "latitudeE7": 5.370873,
      "longitudeE7": -71.831226,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 10,
      "punto": 78,
      "latitudeE7": 5.370867,
      "longitudeE7": -71.831188,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 10,
      "punto": 79,
      "latitudeE7": 5.370861,
      "longitudeE7": -71.83115,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 10,
      "punto": 80,
      "latitudeE7": 5.370855,
      "longitudeE7": -71.831113,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 10,
      "punto": 81,
      "latitudeE7": 5.370849,
      "longitudeE7": -71.831075,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 10,
      "punto": 82,
      "latitudeE7": 5.370843,
      "longitudeE7": -71.831037,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 10,
      "punto": 83,
      "latitudeE7": 5.370837,
      "longitudeE7": -71.831,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 10,
      "punto": 84,
      "latitudeE7": 5.370831,
      "longitudeE7": -71.830962,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 10,
      "punto": 85,
      "latitudeE7": 5.370825,
      "longitudeE7": -71.830924,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 10,
      "punto": 86,
      "latitudeE7": 5.370819,
      "longitudeE7": -71.830886,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 10,
      "punto": 87,
      "latitudeE7": 5.370813,
      "longitudeE7": -71.830849,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 10,
      "punto": 88,
      "latitudeE7": 5.370807,
      "longitudeE7": -71.830811,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 10,
      "punto": 89,
      "latitudeE7": 5.370801,
      "longitudeE7": -71.830773,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 10,
      "punto": 90,
      "latitudeE7": 5.370795,
      "longitudeE7": -71.830736,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 10,
      "punto": 91,
      "latitudeE7": 5.370789,
      "longitudeE7": -71.830698,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 10,
      "punto": 92,
      "latitudeE7": 5.370783,
      "longitudeE7": -71.83066,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 10,
      "punto": 93,
      "latitudeE7": 5.370777,
      "longitudeE7": -71.830622,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 10,
      "punto": 94,
      "latitudeE7": 5.370771,
      "longitudeE7": -71.830585,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 10,
      "punto": 95,
      "latitudeE7": 5.370765,
      "longitudeE7": -71.830547,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 10,
      "punto": 96,
      "latitudeE7": 5.370759,
      "longitudeE7": -71.830509,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 10,
      "punto": 97,
      "latitudeE7": 5.370753,
      "longitudeE7": -71.830472,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 10,
      "punto": 98,
      "latitudeE7": 5.370747,
      "longitudeE7": -71.830434,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 10,
      "punto": 99,
      "latitudeE7": 5.370741,
      "longitudeE7": -71.830396,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 10,
      "punto": 100,
      "latitudeE7": 5.370735,
      "longitudeE7": -71.830358,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 10,
      "punto": 101,
      "latitudeE7": 5.370729,
      "longitudeE7": -71.830321,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 10,
      "punto": 102,
      "latitudeE7": 5.370723,
      "longitudeE7": -71.830283,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 10,
      "punto": 103,
      "latitudeE7": 5.370717,
      "longitudeE7": -71.830245,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 10,
      "punto": 104,
      "latitudeE7": 5.370711,
      "longitudeE7": -71.830207,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 10,
      "punto": 105,
      "latitudeE7": 5.370705,
      "longitudeE7": -71.83017,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 10,
      "punto": 106,
      "latitudeE7": 5.370699,
      "longitudeE7": -71.830132,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 10,
      "punto": 107,
      "latitudeE7": 5.370693,
      "longitudeE7": -71.830094,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 10,
      "punto": 108,
      "latitudeE7": 5.370687,
      "longitudeE7": -71.830057,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 10,
      "punto": 109,
      "latitudeE7": 5.370681,
      "longitudeE7": -71.830019,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 10,
      "punto": 110,
      "latitudeE7": 5.370675,
      "longitudeE7": -71.829981,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 10,
      "punto": 111,
      "latitudeE7": 5.370669,
      "longitudeE7": -71.829943,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 10,
      "punto": 112,
      "latitudeE7": 5.370663,
      "longitudeE7": -71.829906,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 10,
      "punto": 113,
      "latitudeE7": 5.370657,
      "longitudeE7": -71.829868,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 10,
      "punto": 114,
      "latitudeE7": 5.370651,
      "longitudeE7": -71.82983,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 11,
      "punto": 1,
      "latitudeE7": 5.371289,
      "longitudeE7": -71.834118,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 11,
      "punto": 2,
      "latitudeE7": 5.371283,
      "longitudeE7": -71.83408,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 11,
      "punto": 3,
      "latitudeE7": 5.371277,
      "longitudeE7": -71.834042,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 11,
      "punto": 4,
      "latitudeE7": 5.371271,
      "longitudeE7": -71.834004,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 11,
      "punto": 5,
      "latitudeE7": 5.371265,
      "longitudeE7": -71.833967,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 11,
      "punto": 6,
      "latitudeE7": 5.371259,
      "longitudeE7": -71.833929,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 11,
      "punto": 7,
      "latitudeE7": 5.371253,
      "longitudeE7": -71.833891,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 11,
      "punto": 8,
      "latitudeE7": 5.371247,
      "longitudeE7": -71.833854,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 11,
      "punto": 9,
      "latitudeE7": 5.371241,
      "longitudeE7": -71.833816,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 11,
      "punto": 10,
      "latitudeE7": 5.371235,
      "longitudeE7": -71.833778,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 11,
      "punto": 11,
      "latitudeE7": 5.371229,
      "longitudeE7": -71.83374,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 11,
      "punto": 12,
      "latitudeE7": 5.371223,
      "longitudeE7": -71.833703,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 11,
      "punto": 13,
      "latitudeE7": 5.371217,
      "longitudeE7": -71.833665,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 11,
      "punto": 14,
      "latitudeE7": 5.371211,
      "longitudeE7": -71.833627,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 11,
      "punto": 15,
      "latitudeE7": 5.371205,
      "longitudeE7": -71.83359,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 11,
      "punto": 16,
      "latitudeE7": 5.371199,
      "longitudeE7": -71.833552,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 11,
      "punto": 17,
      "latitudeE7": 5.371193,
      "longitudeE7": -71.833514,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 11,
      "punto": 18,
      "latitudeE7": 5.371187,
      "longitudeE7": -71.833476,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 11,
      "punto": 19,
      "latitudeE7": 5.371181,
      "longitudeE7": -71.833439,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 11,
      "punto": 20,
      "latitudeE7": 5.371175,
      "longitudeE7": -71.833401,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 11,
      "punto": 21,
      "latitudeE7": 5.371169,
      "longitudeE7": -71.833363,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 11,
      "punto": 22,
      "latitudeE7": 5.371163,
      "longitudeE7": -71.833325,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 11,
      "punto": 23,
      "latitudeE7": 5.371157,
      "longitudeE7": -71.833288,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 11,
      "punto": 24,
      "latitudeE7": 5.371151,
      "longitudeE7": -71.83325,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 11,
      "punto": 25,
      "latitudeE7": 5.371145,
      "longitudeE7": -71.833212,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 11,
      "punto": 26,
      "latitudeE7": 5.371139,
      "longitudeE7": -71.833175,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 11,
      "punto": 27,
      "latitudeE7": 5.371133,
      "longitudeE7": -71.833137,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 11,
      "punto": 28,
      "latitudeE7": 5.371127,
      "longitudeE7": -71.833099,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 11,
      "punto": 29,
      "latitudeE7": 5.371121,
      "longitudeE7": -71.833061,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 11,
      "punto": 30,
      "latitudeE7": 5.371115,
      "longitudeE7": -71.833024,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 11,
      "punto": 31,
      "latitudeE7": 5.371109,
      "longitudeE7": -71.832986,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 11,
      "punto": 32,
      "latitudeE7": 5.371103,
      "longitudeE7": -71.832948,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 11,
      "punto": 33,
      "latitudeE7": 5.371097,
      "longitudeE7": -71.832911,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 11,
      "punto": 34,
      "latitudeE7": 5.371091,
      "longitudeE7": -71.832873,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 11,
      "punto": 35,
      "latitudeE7": 5.371085,
      "longitudeE7": -71.832835,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 11,
      "punto": 36,
      "latitudeE7": 5.371079,
      "longitudeE7": -71.832797,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 11,
      "punto": 37,
      "latitudeE7": 5.371073,
      "longitudeE7": -71.83276,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 11,
      "punto": 38,
      "latitudeE7": 5.371067,
      "longitudeE7": -71.832722,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 11,
      "punto": 39,
      "latitudeE7": 5.371061,
      "longitudeE7": -71.832684,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 11,
      "punto": 40,
      "latitudeE7": 5.371055,
      "longitudeE7": -71.832647,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 11,
      "punto": 41,
      "latitudeE7": 5.371049,
      "longitudeE7": -71.832609,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 11,
      "punto": 42,
      "latitudeE7": 5.371043,
      "longitudeE7": -71.832571,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 11,
      "punto": 43,
      "latitudeE7": 5.371037,
      "longitudeE7": -71.832533,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 11,
      "punto": 44,
      "latitudeE7": 5.371031,
      "longitudeE7": -71.832496,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 11,
      "punto": 45,
      "latitudeE7": 5.371025,
      "longitudeE7": -71.832458,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 11,
      "punto": 46,
      "latitudeE7": 5.371019,
      "longitudeE7": -71.83242,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 11,
      "punto": 47,
      "latitudeE7": 5.371013,
      "longitudeE7": -71.832382,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 11,
      "punto": 48,
      "latitudeE7": 5.371007,
      "longitudeE7": -71.832345,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 11,
      "punto": 49,
      "latitudeE7": 5.371001,
      "longitudeE7": -71.832307,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 11,
      "punto": 50,
      "latitudeE7": 5.370995,
      "longitudeE7": -71.832269,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 11,
      "punto": 51,
      "latitudeE7": 5.370989,
      "longitudeE7": -71.832232,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 11,
      "punto": 52,
      "latitudeE7": 5.370983,
      "longitudeE7": -71.832194,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 11,
      "punto": 53,
      "latitudeE7": 5.370977,
      "longitudeE7": -71.832156,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 11,
      "punto": 54,
      "latitudeE7": 5.370971,
      "longitudeE7": -71.832118,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 11,
      "punto": 55,
      "latitudeE7": 5.370965,
      "longitudeE7": -71.832081,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 11,
      "punto": 56,
      "latitudeE7": 5.370959,
      "longitudeE7": -71.832043,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 11,
      "punto": 57,
      "latitudeE7": 5.370953,
      "longitudeE7": -71.832005,
      "accuracy": 15,
      "porcentaje": 0.2
    },
    {
      "linea": 11,
      "punto": 58,
      "latitudeE7": 5.370947,
      "longitudeE7": -71.831968,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 11,
      "punto": 59,
      "latitudeE7": 5.370941,
      "longitudeE7": -71.83193,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 11,
      "punto": 60,
      "latitudeE7": 5.370935,
      "longitudeE7": -71.831892,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 11,
      "punto": 61,
      "latitudeE7": 5.370929,
      "longitudeE7": -71.831854,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 11,
      "punto": 62,
      "latitudeE7": 5.370923,
      "longitudeE7": -71.831817,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 11,
      "punto": 63,
      "latitudeE7": 5.370917,
      "longitudeE7": -71.831779,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 11,
      "punto": 64,
      "latitudeE7": 5.370911,
      "longitudeE7": -71.831741,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 11,
      "punto": 65,
      "latitudeE7": 5.370905,
      "longitudeE7": -71.831704,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 11,
      "punto": 66,
      "latitudeE7": 5.370899,
      "longitudeE7": -71.831666,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 11,
      "punto": 67,
      "latitudeE7": 5.370893,
      "longitudeE7": -71.831628,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 11,
      "punto": 68,
      "latitudeE7": 5.370887,
      "longitudeE7": -71.83159,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 11,
      "punto": 69,
      "latitudeE7": 5.370881,
      "longitudeE7": -71.831553,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 11,
      "punto": 70,
      "latitudeE7": 5.370875,
      "longitudeE7": -71.831515,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 11,
      "punto": 71,
      "latitudeE7": 5.370869,
      "longitudeE7": -71.831477,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 11,
      "punto": 72,
      "latitudeE7": 5.370863,
      "longitudeE7": -71.831439,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 11,
      "punto": 73,
      "latitudeE7": 5.370857,
      "longitudeE7": -71.831402,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 11,
      "punto": 74,
      "latitudeE7": 5.370851,
      "longitudeE7": -71.831364,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 11,
      "punto": 75,
      "latitudeE7": 5.370845,
      "longitudeE7": -71.831326,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 11,
      "punto": 76,
      "latitudeE7": 5.370839,
      "longitudeE7": -71.831289,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 11,
      "punto": 77,
      "latitudeE7": 5.370833,
      "longitudeE7": -71.831251,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 11,
      "punto": 78,
      "latitudeE7": 5.370827,
      "longitudeE7": -71.831213,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 11,
      "punto": 79,
      "latitudeE7": 5.370821,
      "longitudeE7": -71.831175,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 11,
      "punto": 80,
      "latitudeE7": 5.370815,
      "longitudeE7": -71.831138,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 11,
      "punto": 81,
      "latitudeE7": 5.370809,
      "longitudeE7": -71.8311,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 11,
      "punto": 82,
      "latitudeE7": 5.370803,
      "longitudeE7": -71.831062,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 11,
      "punto": 83,
      "latitudeE7": 5.370797,
      "longitudeE7": -71.831025,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 11,
      "punto": 84,
      "latitudeE7": 5.370791,
      "longitudeE7": -71.830987,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 11,
      "punto": 85,
      "latitudeE7": 5.370785,
      "longitudeE7": -71.830949,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 11,
      "punto": 86,
      "latitudeE7": 5.370779,
      "longitudeE7": -71.830911,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 11,
      "punto": 87,
      "latitudeE7": 5.370773,
      "longitudeE7": -71.830874,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 11,
      "punto": 88,
      "latitudeE7": 5.370767,
      "longitudeE7": -71.830836,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 11,
      "punto": 89,
      "latitudeE7": 5.370761,
      "longitudeE7": -71.830798,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 11,
      "punto": 90,
      "latitudeE7": 5.370755,
      "longitudeE7": -71.830761,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 11,
      "punto": 91,
      "latitudeE7": 5.370749,
      "longitudeE7": -71.830723,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 11,
      "punto": 92,
      "latitudeE7": 5.370743,
      "longitudeE7": -71.830685,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 11,
      "punto": 93,
      "latitudeE7": 5.370737,
      "longitudeE7": -71.830647,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 11,
      "punto": 94,
      "latitudeE7": 5.370731,
      "longitudeE7": -71.83061,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 11,
      "punto": 95,
      "latitudeE7": 5.370725,
      "longitudeE7": -71.830572,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 11,
      "punto": 96,
      "latitudeE7": 5.370719,
      "longitudeE7": -71.830534,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 11,
      "punto": 97,
      "latitudeE7": 5.370713,
      "longitudeE7": -71.830496,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 11,
      "punto": 98,
      "latitudeE7": 5.370707,
      "longitudeE7": -71.830459,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 11,
      "punto": 99,
      "latitudeE7": 5.370701,
      "longitudeE7": -71.830421,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 11,
      "punto": 100,
      "latitudeE7": 5.370695,
      "longitudeE7": -71.830383,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 11,
      "punto": 101,
      "latitudeE7": 5.370689,
      "longitudeE7": -71.830346,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 11,
      "punto": 102,
      "latitudeE7": 5.370683,
      "longitudeE7": -71.830308,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 11,
      "punto": 103,
      "latitudeE7": 5.370677,
      "longitudeE7": -71.83027,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 11,
      "punto": 104,
      "latitudeE7": 5.370671,
      "longitudeE7": -71.830232,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 11,
      "punto": 105,
      "latitudeE7": 5.370665,
      "longitudeE7": -71.830195,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 11,
      "punto": 106,
      "latitudeE7": 5.370659,
      "longitudeE7": -71.830157,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 11,
      "punto": 107,
      "latitudeE7": 5.370653,
      "longitudeE7": -71.830119,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 11,
      "punto": 108,
      "latitudeE7": 5.370647,
      "longitudeE7": -71.830082,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 11,
      "punto": 109,
      "latitudeE7": 5.370641,
      "longitudeE7": -71.830044,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 11,
      "punto": 110,
      "latitudeE7": 5.370635,
      "longitudeE7": -71.830006,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 11,
      "punto": 111,
      "latitudeE7": 5.370629,
      "longitudeE7": -71.829968,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 11,
      "punto": 112,
      "latitudeE7": 5.370623,
      "longitudeE7": -71.829931,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 11,
      "punto": 113,
      "latitudeE7": 5.370617,
      "longitudeE7": -71.829893,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 11,
      "punto": 114,
      "latitudeE7": 5.370611,
      "longitudeE7": -71.829855,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 12,
      "punto": 1,
      "latitudeE7": 5.371249,
      "longitudeE7": -71.834143,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 12,
      "punto": 2,
      "latitudeE7": 5.371243,
      "longitudeE7": -71.834105,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 12,
      "punto": 3,
      "latitudeE7": 5.371237,
      "longitudeE7": -71.834067,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 12,
      "punto": 4,
      "latitudeE7": 5.371231,
      "longitudeE7": -71.834029,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 12,
      "punto": 5,
      "latitudeE7": 5.371225,
      "longitudeE7": -71.833992,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 12,
      "punto": 6,
      "latitudeE7": 5.371219,
      "longitudeE7": -71.833954,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 12,
      "punto": 7,
      "latitudeE7": 5.371213,
      "longitudeE7": -71.833916,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 12,
      "punto": 8,
      "latitudeE7": 5.371207,
      "longitudeE7": -71.833879,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 12,
      "punto": 9,
      "latitudeE7": 5.371201,
      "longitudeE7": -71.833841,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 12,
      "punto": 10,
      "latitudeE7": 5.371195,
      "longitudeE7": -71.833803,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 12,
      "punto": 11,
      "latitudeE7": 5.371189,
      "longitudeE7": -71.833765,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 12,
      "punto": 12,
      "latitudeE7": 5.371183,
      "longitudeE7": -71.833728,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 12,
      "punto": 13,
      "latitudeE7": 5.371177,
      "longitudeE7": -71.83369,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 12,
      "punto": 14,
      "latitudeE7": 5.371171,
      "longitudeE7": -71.833652,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 12,
      "punto": 15,
      "latitudeE7": 5.371165,
      "longitudeE7": -71.833614,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 12,
      "punto": 16,
      "latitudeE7": 5.371159,
      "longitudeE7": -71.833577,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 12,
      "punto": 17,
      "latitudeE7": 5.371153,
      "longitudeE7": -71.833539,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 12,
      "punto": 18,
      "latitudeE7": 5.371147,
      "longitudeE7": -71.833501,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 12,
      "punto": 19,
      "latitudeE7": 5.371141,
      "longitudeE7": -71.833464,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 12,
      "punto": 20,
      "latitudeE7": 5.371135,
      "longitudeE7": -71.833426,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 12,
      "punto": 21,
      "latitudeE7": 5.371129,
      "longitudeE7": -71.833388,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 12,
      "punto": 22,
      "latitudeE7": 5.371123,
      "longitudeE7": -71.83335,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 12,
      "punto": 23,
      "latitudeE7": 5.371117,
      "longitudeE7": -71.833313,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 12,
      "punto": 24,
      "latitudeE7": 5.371111,
      "longitudeE7": -71.833275,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 12,
      "punto": 25,
      "latitudeE7": 5.371105,
      "longitudeE7": -71.833237,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 12,
      "punto": 26,
      "latitudeE7": 5.371099,
      "longitudeE7": -71.8332,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 12,
      "punto": 27,
      "latitudeE7": 5.371093,
      "longitudeE7": -71.833162,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 12,
      "punto": 28,
      "latitudeE7": 5.371087,
      "longitudeE7": -71.833124,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 12,
      "punto": 29,
      "latitudeE7": 5.371081,
      "longitudeE7": -71.833086,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 12,
      "punto": 30,
      "latitudeE7": 5.371075,
      "longitudeE7": -71.833049,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 12,
      "punto": 31,
      "latitudeE7": 5.371069,
      "longitudeE7": -71.833011,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 12,
      "punto": 32,
      "latitudeE7": 5.371063,
      "longitudeE7": -71.832973,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 12,
      "punto": 33,
      "latitudeE7": 5.371057,
      "longitudeE7": -71.832936,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 12,
      "punto": 34,
      "latitudeE7": 5.371051,
      "longitudeE7": -71.832898,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 12,
      "punto": 35,
      "latitudeE7": 5.371045,
      "longitudeE7": -71.83286,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 12,
      "punto": 36,
      "latitudeE7": 5.371039,
      "longitudeE7": -71.832822,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 12,
      "punto": 37,
      "latitudeE7": 5.371033,
      "longitudeE7": -71.832785,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 12,
      "punto": 38,
      "latitudeE7": 5.371027,
      "longitudeE7": -71.832747,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 12,
      "punto": 39,
      "latitudeE7": 5.371021,
      "longitudeE7": -71.832709,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 12,
      "punto": 40,
      "latitudeE7": 5.371015,
      "longitudeE7": -71.832671,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 12,
      "punto": 41,
      "latitudeE7": 5.371009,
      "longitudeE7": -71.832634,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 12,
      "punto": 42,
      "latitudeE7": 5.371003,
      "longitudeE7": -71.832596,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 12,
      "punto": 43,
      "latitudeE7": 5.370997,
      "longitudeE7": -71.832558,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 12,
      "punto": 44,
      "latitudeE7": 5.370991,
      "longitudeE7": -71.832521,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 12,
      "punto": 45,
      "latitudeE7": 5.370985,
      "longitudeE7": -71.832483,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 12,
      "punto": 46,
      "latitudeE7": 5.370979,
      "longitudeE7": -71.832445,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 12,
      "punto": 47,
      "latitudeE7": 5.370973,
      "longitudeE7": -71.832407,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 12,
      "punto": 48,
      "latitudeE7": 5.370967,
      "longitudeE7": -71.83237,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 12,
      "punto": 49,
      "latitudeE7": 5.370961,
      "longitudeE7": -71.832332,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 12,
      "punto": 50,
      "latitudeE7": 5.370955,
      "longitudeE7": -71.832294,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 12,
      "punto": 51,
      "latitudeE7": 5.370949,
      "longitudeE7": -71.832257,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 12,
      "punto": 52,
      "latitudeE7": 5.370943,
      "longitudeE7": -71.832219,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 12,
      "punto": 53,
      "latitudeE7": 5.370937,
      "longitudeE7": -71.832181,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 12,
      "punto": 54,
      "latitudeE7": 5.370931,
      "longitudeE7": -71.832143,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 12,
      "punto": 55,
      "latitudeE7": 5.370925,
      "longitudeE7": -71.832106,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 12,
      "punto": 56,
      "latitudeE7": 5.370919,
      "longitudeE7": -71.832068,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 12,
      "punto": 57,
      "latitudeE7": 5.370913,
      "longitudeE7": -71.83203,
      "accuracy": 15,
      "porcentaje": 0.4
    },
    {
      "linea": 12,
      "punto": 58,
      "latitudeE7": 5.370907,
      "longitudeE7": -71.831993,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 12,
      "punto": 59,
      "latitudeE7": 5.370901,
      "longitudeE7": -71.831955,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 12,
      "punto": 60,
      "latitudeE7": 5.370895,
      "longitudeE7": -71.831917,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 12,
      "punto": 61,
      "latitudeE7": 5.370889,
      "longitudeE7": -71.831879,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 12,
      "punto": 62,
      "latitudeE7": 5.370883,
      "longitudeE7": -71.831842,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 12,
      "punto": 63,
      "latitudeE7": 5.370877,
      "longitudeE7": -71.831804,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 12,
      "punto": 64,
      "latitudeE7": 5.370871,
      "longitudeE7": -71.831766,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 12,
      "punto": 65,
      "latitudeE7": 5.370865,
      "longitudeE7": -71.831728,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 12,
      "punto": 66,
      "latitudeE7": 5.370859,
      "longitudeE7": -71.831691,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 12,
      "punto": 67,
      "latitudeE7": 5.370853,
      "longitudeE7": -71.831653,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 12,
      "punto": 68,
      "latitudeE7": 5.370847,
      "longitudeE7": -71.831615,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 12,
      "punto": 69,
      "latitudeE7": 5.370841,
      "longitudeE7": -71.831578,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 12,
      "punto": 70,
      "latitudeE7": 5.370835,
      "longitudeE7": -71.83154,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 12,
      "punto": 71,
      "latitudeE7": 5.370829,
      "longitudeE7": -71.831502,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 12,
      "punto": 72,
      "latitudeE7": 5.370823,
      "longitudeE7": -71.831464,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 12,
      "punto": 73,
      "latitudeE7": 5.370817,
      "longitudeE7": -71.831427,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 12,
      "punto": 74,
      "latitudeE7": 5.370811,
      "longitudeE7": -71.831389,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 12,
      "punto": 75,
      "latitudeE7": 5.370805,
      "longitudeE7": -71.831351,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 12,
      "punto": 76,
      "latitudeE7": 5.370799,
      "longitudeE7": -71.831314,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 12,
      "punto": 77,
      "latitudeE7": 5.370793,
      "longitudeE7": -71.831276,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 12,
      "punto": 78,
      "latitudeE7": 5.370787,
      "longitudeE7": -71.831238,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 12,
      "punto": 79,
      "latitudeE7": 5.370781,
      "longitudeE7": -71.8312,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 12,
      "punto": 80,
      "latitudeE7": 5.370775,
      "longitudeE7": -71.831163,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 12,
      "punto": 81,
      "latitudeE7": 5.370769,
      "longitudeE7": -71.831125,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 12,
      "punto": 82,
      "latitudeE7": 5.370763,
      "longitudeE7": -71.831087,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 12,
      "punto": 83,
      "latitudeE7": 5.370757,
      "longitudeE7": -71.83105,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 12,
      "punto": 84,
      "latitudeE7": 5.370751,
      "longitudeE7": -71.831012,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 12,
      "punto": 85,
      "latitudeE7": 5.370745,
      "longitudeE7": -71.830974,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 12,
      "punto": 86,
      "latitudeE7": 5.370739,
      "longitudeE7": -71.830936,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 12,
      "punto": 87,
      "latitudeE7": 5.370733,
      "longitudeE7": -71.830899,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 12,
      "punto": 88,
      "latitudeE7": 5.370727,
      "longitudeE7": -71.830861,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 12,
      "punto": 89,
      "latitudeE7": 5.370721,
      "longitudeE7": -71.830823,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 12,
      "punto": 90,
      "latitudeE7": 5.370715,
      "longitudeE7": -71.830785,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 12,
      "punto": 91,
      "latitudeE7": 5.370709,
      "longitudeE7": -71.830748,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 12,
      "punto": 92,
      "latitudeE7": 5.370703,
      "longitudeE7": -71.83071,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 12,
      "punto": 93,
      "latitudeE7": 5.370697,
      "longitudeE7": -71.830672,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 12,
      "punto": 94,
      "latitudeE7": 5.370691,
      "longitudeE7": -71.830635,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 12,
      "punto": 95,
      "latitudeE7": 5.370685,
      "longitudeE7": -71.830597,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 12,
      "punto": 96,
      "latitudeE7": 5.370679,
      "longitudeE7": -71.830559,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 12,
      "punto": 97,
      "latitudeE7": 5.370673,
      "longitudeE7": -71.830521,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 12,
      "punto": 98,
      "latitudeE7": 5.370667,
      "longitudeE7": -71.830484,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 12,
      "punto": 99,
      "latitudeE7": 5.370661,
      "longitudeE7": -71.830446,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 12,
      "punto": 100,
      "latitudeE7": 5.370655,
      "longitudeE7": -71.830408,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 12,
      "punto": 101,
      "latitudeE7": 5.370649,
      "longitudeE7": -71.830371,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 12,
      "punto": 102,
      "latitudeE7": 5.370643,
      "longitudeE7": -71.830333,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 12,
      "punto": 103,
      "latitudeE7": 5.370637,
      "longitudeE7": -71.830295,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 12,
      "punto": 104,
      "latitudeE7": 5.370631,
      "longitudeE7": -71.830257,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 12,
      "punto": 105,
      "latitudeE7": 5.370625,
      "longitudeE7": -71.83022,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 12,
      "punto": 106,
      "latitudeE7": 5.370619,
      "longitudeE7": -71.830182,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 12,
      "punto": 107,
      "latitudeE7": 5.370613,
      "longitudeE7": -71.830144,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 12,
      "punto": 108,
      "latitudeE7": 5.370607,
      "longitudeE7": -71.830107,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 12,
      "punto": 109,
      "latitudeE7": 5.370601,
      "longitudeE7": -71.830069,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 12,
      "punto": 110,
      "latitudeE7": 5.370595,
      "longitudeE7": -71.830031,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 12,
      "punto": 111,
      "latitudeE7": 5.370589,
      "longitudeE7": -71.829993,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 12,
      "punto": 112,
      "latitudeE7": 5.370583,
      "longitudeE7": -71.829956,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 12,
      "punto": 113,
      "latitudeE7": 5.370577,
      "longitudeE7": -71.829918,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 12,
      "punto": 114,
      "latitudeE7": 5.370571,
      "longitudeE7": -71.82988,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 13,
      "punto": 1,
      "latitudeE7": 5.371209,
      "longitudeE7": -71.834168,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 13,
      "punto": 2,
      "latitudeE7": 5.371203,
      "longitudeE7": -71.83413,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 13,
      "punto": 3,
      "latitudeE7": 5.371197,
      "longitudeE7": -71.834092,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 13,
      "punto": 4,
      "latitudeE7": 5.371191,
      "longitudeE7": -71.834054,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 13,
      "punto": 5,
      "latitudeE7": 5.371185,
      "longitudeE7": -71.834017,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 13,
      "punto": 6,
      "latitudeE7": 5.371179,
      "longitudeE7": -71.833979,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 13,
      "punto": 7,
      "latitudeE7": 5.371173,
      "longitudeE7": -71.833941,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 13,
      "punto": 8,
      "latitudeE7": 5.371167,
      "longitudeE7": -71.833903,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 13,
      "punto": 9,
      "latitudeE7": 5.371161,
      "longitudeE7": -71.833866,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 13,
      "punto": 10,
      "latitudeE7": 5.371155,
      "longitudeE7": -71.833828,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 13,
      "punto": 11,
      "latitudeE7": 5.371149,
      "longitudeE7": -71.83379,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 13,
      "punto": 12,
      "latitudeE7": 5.371143,
      "longitudeE7": -71.833753,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 13,
      "punto": 13,
      "latitudeE7": 5.371137,
      "longitudeE7": -71.833715,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 13,
      "punto": 14,
      "latitudeE7": 5.371131,
      "longitudeE7": -71.833677,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 13,
      "punto": 15,
      "latitudeE7": 5.371125,
      "longitudeE7": -71.833639,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 13,
      "punto": 16,
      "latitudeE7": 5.371119,
      "longitudeE7": -71.833602,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 13,
      "punto": 17,
      "latitudeE7": 5.371113,
      "longitudeE7": -71.833564,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 13,
      "punto": 18,
      "latitudeE7": 5.371107,
      "longitudeE7": -71.833526,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 13,
      "punto": 19,
      "latitudeE7": 5.371101,
      "longitudeE7": -71.833489,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 13,
      "punto": 20,
      "latitudeE7": 5.371095,
      "longitudeE7": -71.833451,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 13,
      "punto": 21,
      "latitudeE7": 5.371089,
      "longitudeE7": -71.833413,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 13,
      "punto": 22,
      "latitudeE7": 5.371083,
      "longitudeE7": -71.833375,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 13,
      "punto": 23,
      "latitudeE7": 5.371077,
      "longitudeE7": -71.833338,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 13,
      "punto": 24,
      "latitudeE7": 5.371071,
      "longitudeE7": -71.8333,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 13,
      "punto": 25,
      "latitudeE7": 5.371065,
      "longitudeE7": -71.833262,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 13,
      "punto": 26,
      "latitudeE7": 5.371059,
      "longitudeE7": -71.833225,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 13,
      "punto": 27,
      "latitudeE7": 5.371053,
      "longitudeE7": -71.833187,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 13,
      "punto": 28,
      "latitudeE7": 5.371047,
      "longitudeE7": -71.833149,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 13,
      "punto": 29,
      "latitudeE7": 5.371041,
      "longitudeE7": -71.833111,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 13,
      "punto": 30,
      "latitudeE7": 5.371035,
      "longitudeE7": -71.833074,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 13,
      "punto": 31,
      "latitudeE7": 5.371029,
      "longitudeE7": -71.833036,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 13,
      "punto": 32,
      "latitudeE7": 5.371023,
      "longitudeE7": -71.832998,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 13,
      "punto": 33,
      "latitudeE7": 5.371017,
      "longitudeE7": -71.83296,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 13,
      "punto": 34,
      "latitudeE7": 5.371011,
      "longitudeE7": -71.832923,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 13,
      "punto": 35,
      "latitudeE7": 5.371005,
      "longitudeE7": -71.832885,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 13,
      "punto": 36,
      "latitudeE7": 5.370999,
      "longitudeE7": -71.832847,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 13,
      "punto": 37,
      "latitudeE7": 5.370993,
      "longitudeE7": -71.83281,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 13,
      "punto": 38,
      "latitudeE7": 5.370987,
      "longitudeE7": -71.832772,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 13,
      "punto": 39,
      "latitudeE7": 5.370981,
      "longitudeE7": -71.832734,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 13,
      "punto": 40,
      "latitudeE7": 5.370975,
      "longitudeE7": -71.832696,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 13,
      "punto": 41,
      "latitudeE7": 5.370969,
      "longitudeE7": -71.832659,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 13,
      "punto": 42,
      "latitudeE7": 5.370963,
      "longitudeE7": -71.832621,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 13,
      "punto": 43,
      "latitudeE7": 5.370957,
      "longitudeE7": -71.832583,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 13,
      "punto": 44,
      "latitudeE7": 5.370951,
      "longitudeE7": -71.832546,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 13,
      "punto": 45,
      "latitudeE7": 5.370945,
      "longitudeE7": -71.832508,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 13,
      "punto": 46,
      "latitudeE7": 5.370939,
      "longitudeE7": -71.83247,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 13,
      "punto": 47,
      "latitudeE7": 5.370933,
      "longitudeE7": -71.832432,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 13,
      "punto": 48,
      "latitudeE7": 5.370927,
      "longitudeE7": -71.832395,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 13,
      "punto": 49,
      "latitudeE7": 5.370921,
      "longitudeE7": -71.832357,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 13,
      "punto": 50,
      "latitudeE7": 5.370915,
      "longitudeE7": -71.832319,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 13,
      "punto": 51,
      "latitudeE7": 5.370909,
      "longitudeE7": -71.832282,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 13,
      "punto": 52,
      "latitudeE7": 5.370903,
      "longitudeE7": -71.832244,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 13,
      "punto": 53,
      "latitudeE7": 5.370897,
      "longitudeE7": -71.832206,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 13,
      "punto": 54,
      "latitudeE7": 5.370891,
      "longitudeE7": -71.832168,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 13,
      "punto": 55,
      "latitudeE7": 5.370885,
      "longitudeE7": -71.832131,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 13,
      "punto": 56,
      "latitudeE7": 5.370879,
      "longitudeE7": -71.832093,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 13,
      "punto": 57,
      "latitudeE7": 5.370873,
      "longitudeE7": -71.832055,
      "accuracy": 15,
      "porcentaje": 0.16
    },
    {
      "linea": 13,
      "punto": 58,
      "latitudeE7": 5.370867,
      "longitudeE7": -71.832017,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 13,
      "punto": 59,
      "latitudeE7": 5.370861,
      "longitudeE7": -71.83198,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 13,
      "punto": 60,
      "latitudeE7": 5.370855,
      "longitudeE7": -71.831942,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 13,
      "punto": 61,
      "latitudeE7": 5.370849,
      "longitudeE7": -71.831904,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 13,
      "punto": 62,
      "latitudeE7": 5.370843,
      "longitudeE7": -71.831867,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 13,
      "punto": 63,
      "latitudeE7": 5.370837,
      "longitudeE7": -71.831829,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 13,
      "punto": 64,
      "latitudeE7": 5.370831,
      "longitudeE7": -71.831791,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 13,
      "punto": 65,
      "latitudeE7": 5.370825,
      "longitudeE7": -71.831753,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 13,
      "punto": 66,
      "latitudeE7": 5.370819,
      "longitudeE7": -71.831716,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 13,
      "punto": 67,
      "latitudeE7": 5.370813,
      "longitudeE7": -71.831678,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 13,
      "punto": 68,
      "latitudeE7": 5.370807,
      "longitudeE7": -71.83164,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 13,
      "punto": 69,
      "latitudeE7": 5.370801,
      "longitudeE7": -71.831603,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 13,
      "punto": 70,
      "latitudeE7": 5.370795,
      "longitudeE7": -71.831565,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 13,
      "punto": 71,
      "latitudeE7": 5.370789,
      "longitudeE7": -71.831527,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 13,
      "punto": 72,
      "latitudeE7": 5.370783,
      "longitudeE7": -71.831489,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 13,
      "punto": 73,
      "latitudeE7": 5.370777,
      "longitudeE7": -71.831452,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 13,
      "punto": 74,
      "latitudeE7": 5.370771,
      "longitudeE7": -71.831414,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 13,
      "punto": 75,
      "latitudeE7": 5.370765,
      "longitudeE7": -71.831376,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 13,
      "punto": 76,
      "latitudeE7": 5.370759,
      "longitudeE7": -71.831339,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 13,
      "punto": 77,
      "latitudeE7": 5.370753,
      "longitudeE7": -71.831301,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 13,
      "punto": 78,
      "latitudeE7": 5.370747,
      "longitudeE7": -71.831263,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 13,
      "punto": 79,
      "latitudeE7": 5.370741,
      "longitudeE7": -71.831225,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 13,
      "punto": 80,
      "latitudeE7": 5.370735,
      "longitudeE7": -71.831188,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 13,
      "punto": 81,
      "latitudeE7": 5.370729,
      "longitudeE7": -71.83115,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 13,
      "punto": 82,
      "latitudeE7": 5.370723,
      "longitudeE7": -71.831112,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 13,
      "punto": 83,
      "latitudeE7": 5.370717,
      "longitudeE7": -71.831074,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 13,
      "punto": 84,
      "latitudeE7": 5.370711,
      "longitudeE7": -71.831037,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 13,
      "punto": 85,
      "latitudeE7": 5.370705,
      "longitudeE7": -71.830999,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 13,
      "punto": 86,
      "latitudeE7": 5.370699,
      "longitudeE7": -71.830961,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 13,
      "punto": 87,
      "latitudeE7": 5.370693,
      "longitudeE7": -71.830924,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 13,
      "punto": 88,
      "latitudeE7": 5.370687,
      "longitudeE7": -71.830886,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 13,
      "punto": 89,
      "latitudeE7": 5.370681,
      "longitudeE7": -71.830848,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 13,
      "punto": 90,
      "latitudeE7": 5.370675,
      "longitudeE7": -71.83081,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 13,
      "punto": 91,
      "latitudeE7": 5.370669,
      "longitudeE7": -71.830773,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 13,
      "punto": 92,
      "latitudeE7": 5.370663,
      "longitudeE7": -71.830735,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 13,
      "punto": 93,
      "latitudeE7": 5.370657,
      "longitudeE7": -71.830697,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 13,
      "punto": 94,
      "latitudeE7": 5.370651,
      "longitudeE7": -71.83066,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 13,
      "punto": 95,
      "latitudeE7": 5.370645,
      "longitudeE7": -71.830622,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 13,
      "punto": 96,
      "latitudeE7": 5.370639,
      "longitudeE7": -71.830584,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 13,
      "punto": 97,
      "latitudeE7": 5.370633,
      "longitudeE7": -71.830546,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 13,
      "punto": 98,
      "latitudeE7": 5.370627,
      "longitudeE7": -71.830509,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 13,
      "punto": 99,
      "latitudeE7": 5.370621,
      "longitudeE7": -71.830471,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 13,
      "punto": 100,
      "latitudeE7": 5.370615,
      "longitudeE7": -71.830433,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 13,
      "punto": 101,
      "latitudeE7": 5.370609,
      "longitudeE7": -71.830396,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 13,
      "punto": 102,
      "latitudeE7": 5.370603,
      "longitudeE7": -71.830358,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 13,
      "punto": 103,
      "latitudeE7": 5.370597,
      "longitudeE7": -71.83032,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 13,
      "punto": 104,
      "latitudeE7": 5.370591,
      "longitudeE7": -71.830282,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 13,
      "punto": 105,
      "latitudeE7": 5.370585,
      "longitudeE7": -71.830245,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 13,
      "punto": 106,
      "latitudeE7": 5.370579,
      "longitudeE7": -71.830207,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 13,
      "punto": 107,
      "latitudeE7": 5.370573,
      "longitudeE7": -71.830169,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 13,
      "punto": 108,
      "latitudeE7": 5.370567,
      "longitudeE7": -71.830131,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 13,
      "punto": 109,
      "latitudeE7": 5.370561,
      "longitudeE7": -71.830094,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 13,
      "punto": 110,
      "latitudeE7": 5.370555,
      "longitudeE7": -71.830056,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 13,
      "punto": 111,
      "latitudeE7": 5.370549,
      "longitudeE7": -71.830018,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 13,
      "punto": 112,
      "latitudeE7": 5.370543,
      "longitudeE7": -71.829981,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 13,
      "punto": 113,
      "latitudeE7": 5.370537,
      "longitudeE7": -71.829943,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 13,
      "punto": 114,
      "latitudeE7": 5.370531,
      "longitudeE7": -71.829905,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 14,
      "punto": 1,
      "latitudeE7": 5.371169,
      "longitudeE7": -71.834192,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 14,
      "punto": 2,
      "latitudeE7": 5.371163,
      "longitudeE7": -71.834155,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 14,
      "punto": 3,
      "latitudeE7": 5.371157,
      "longitudeE7": -71.834117,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 14,
      "punto": 4,
      "latitudeE7": 5.371151,
      "longitudeE7": -71.834079,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 14,
      "punto": 5,
      "latitudeE7": 5.371145,
      "longitudeE7": -71.834042,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 14,
      "punto": 6,
      "latitudeE7": 5.371139,
      "longitudeE7": -71.834004,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 14,
      "punto": 7,
      "latitudeE7": 5.371133,
      "longitudeE7": -71.833966,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 14,
      "punto": 8,
      "latitudeE7": 5.371127,
      "longitudeE7": -71.833928,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 14,
      "punto": 9,
      "latitudeE7": 5.371121,
      "longitudeE7": -71.833891,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 14,
      "punto": 10,
      "latitudeE7": 5.371115,
      "longitudeE7": -71.833853,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 14,
      "punto": 11,
      "latitudeE7": 5.371109,
      "longitudeE7": -71.833815,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 14,
      "punto": 12,
      "latitudeE7": 5.371103,
      "longitudeE7": -71.833778,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 14,
      "punto": 13,
      "latitudeE7": 5.371097,
      "longitudeE7": -71.83374,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 14,
      "punto": 14,
      "latitudeE7": 5.371091,
      "longitudeE7": -71.833702,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 14,
      "punto": 15,
      "latitudeE7": 5.371085,
      "longitudeE7": -71.833664,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 14,
      "punto": 16,
      "latitudeE7": 5.371079,
      "longitudeE7": -71.833627,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 14,
      "punto": 17,
      "latitudeE7": 5.371073,
      "longitudeE7": -71.833589,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 14,
      "punto": 18,
      "latitudeE7": 5.371067,
      "longitudeE7": -71.833551,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 14,
      "punto": 19,
      "latitudeE7": 5.371061,
      "longitudeE7": -71.833514,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 14,
      "punto": 20,
      "latitudeE7": 5.371055,
      "longitudeE7": -71.833476,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 14,
      "punto": 21,
      "latitudeE7": 5.371049,
      "longitudeE7": -71.833438,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 14,
      "punto": 22,
      "latitudeE7": 5.371043,
      "longitudeE7": -71.8334,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 14,
      "punto": 23,
      "latitudeE7": 5.371037,
      "longitudeE7": -71.833363,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 14,
      "punto": 24,
      "latitudeE7": 5.371031,
      "longitudeE7": -71.833325,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 14,
      "punto": 25,
      "latitudeE7": 5.371025,
      "longitudeE7": -71.833287,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 14,
      "punto": 26,
      "latitudeE7": 5.371019,
      "longitudeE7": -71.833249,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 14,
      "punto": 27,
      "latitudeE7": 5.371013,
      "longitudeE7": -71.833212,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 14,
      "punto": 28,
      "latitudeE7": 5.371007,
      "longitudeE7": -71.833174,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 14,
      "punto": 29,
      "latitudeE7": 5.371001,
      "longitudeE7": -71.833136,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 14,
      "punto": 30,
      "latitudeE7": 5.370995,
      "longitudeE7": -71.833099,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 14,
      "punto": 31,
      "latitudeE7": 5.370989,
      "longitudeE7": -71.833061,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 14,
      "punto": 32,
      "latitudeE7": 5.370983,
      "longitudeE7": -71.833023,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 14,
      "punto": 33,
      "latitudeE7": 5.370977,
      "longitudeE7": -71.832985,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 14,
      "punto": 34,
      "latitudeE7": 5.370971,
      "longitudeE7": -71.832948,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 14,
      "punto": 35,
      "latitudeE7": 5.370965,
      "longitudeE7": -71.83291,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 14,
      "punto": 36,
      "latitudeE7": 5.370959,
      "longitudeE7": -71.832872,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 14,
      "punto": 37,
      "latitudeE7": 5.370953,
      "longitudeE7": -71.832835,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 14,
      "punto": 38,
      "latitudeE7": 5.370947,
      "longitudeE7": -71.832797,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 14,
      "punto": 39,
      "latitudeE7": 5.370941,
      "longitudeE7": -71.832759,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 14,
      "punto": 40,
      "latitudeE7": 5.370935,
      "longitudeE7": -71.832721,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 14,
      "punto": 41,
      "latitudeE7": 5.370929,
      "longitudeE7": -71.832684,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 14,
      "punto": 42,
      "latitudeE7": 5.370923,
      "longitudeE7": -71.832646,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 14,
      "punto": 43,
      "latitudeE7": 5.370917,
      "longitudeE7": -71.832608,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 14,
      "punto": 44,
      "latitudeE7": 5.370911,
      "longitudeE7": -71.832571,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 14,
      "punto": 45,
      "latitudeE7": 5.370905,
      "longitudeE7": -71.832533,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 14,
      "punto": 46,
      "latitudeE7": 5.370899,
      "longitudeE7": -71.832495,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 14,
      "punto": 47,
      "latitudeE7": 5.370893,
      "longitudeE7": -71.832457,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 14,
      "punto": 48,
      "latitudeE7": 5.370887,
      "longitudeE7": -71.83242,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 14,
      "punto": 49,
      "latitudeE7": 5.370881,
      "longitudeE7": -71.832382,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 14,
      "punto": 50,
      "latitudeE7": 5.370875,
      "longitudeE7": -71.832344,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 14,
      "punto": 51,
      "latitudeE7": 5.370869,
      "longitudeE7": -71.832306,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 14,
      "punto": 52,
      "latitudeE7": 5.370863,
      "longitudeE7": -71.832269,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 14,
      "punto": 53,
      "latitudeE7": 5.370857,
      "longitudeE7": -71.832231,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 14,
      "punto": 54,
      "latitudeE7": 5.370851,
      "longitudeE7": -71.832193,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 14,
      "punto": 55,
      "latitudeE7": 5.370845,
      "longitudeE7": -71.832156,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 14,
      "punto": 56,
      "latitudeE7": 5.370839,
      "longitudeE7": -71.832118,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 14,
      "punto": 57,
      "latitudeE7": 5.370833,
      "longitudeE7": -71.83208,
      "accuracy": 15,
      "porcentaje": 0
    },
    {
      "linea": 14,
      "punto": 58,
      "latitudeE7": 5.370827,
      "longitudeE7": -71.832042,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 14,
      "punto": 59,
      "latitudeE7": 5.370821,
      "longitudeE7": -71.832005,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 14,
      "punto": 60,
      "latitudeE7": 5.370815,
      "longitudeE7": -71.831967,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 14,
      "punto": 61,
      "latitudeE7": 5.370809,
      "longitudeE7": -71.831929,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 14,
      "punto": 62,
      "latitudeE7": 5.370803,
      "longitudeE7": -71.831892,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 14,
      "punto": 63,
      "latitudeE7": 5.370797,
      "longitudeE7": -71.831854,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 14,
      "punto": 64,
      "latitudeE7": 5.370791,
      "longitudeE7": -71.831816,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 14,
      "punto": 65,
      "latitudeE7": 5.370785,
      "longitudeE7": -71.831778,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 14,
      "punto": 66,
      "latitudeE7": 5.370779,
      "longitudeE7": -71.831741,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 14,
      "punto": 67,
      "latitudeE7": 5.370773,
      "longitudeE7": -71.831703,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 14,
      "punto": 68,
      "latitudeE7": 5.370767,
      "longitudeE7": -71.831665,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 14,
      "punto": 69,
      "latitudeE7": 5.370761,
      "longitudeE7": -71.831628,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 14,
      "punto": 70,
      "latitudeE7": 5.370755,
      "longitudeE7": -71.83159,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 14,
      "punto": 71,
      "latitudeE7": 5.370749,
      "longitudeE7": -71.831552,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 14,
      "punto": 72,
      "latitudeE7": 5.370743,
      "longitudeE7": -71.831514,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 14,
      "punto": 73,
      "latitudeE7": 5.370737,
      "longitudeE7": -71.831477,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 14,
      "punto": 74,
      "latitudeE7": 5.370731,
      "longitudeE7": -71.831439,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 14,
      "punto": 75,
      "latitudeE7": 5.370725,
      "longitudeE7": -71.831401,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 14,
      "punto": 76,
      "latitudeE7": 5.370719,
      "longitudeE7": -71.831363,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 14,
      "punto": 77,
      "latitudeE7": 5.370713,
      "longitudeE7": -71.831326,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 14,
      "punto": 78,
      "latitudeE7": 5.370707,
      "longitudeE7": -71.831288,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 14,
      "punto": 79,
      "latitudeE7": 5.370701,
      "longitudeE7": -71.83125,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 14,
      "punto": 80,
      "latitudeE7": 5.370695,
      "longitudeE7": -71.831213,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 14,
      "punto": 81,
      "latitudeE7": 5.370689,
      "longitudeE7": -71.831175,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 14,
      "punto": 82,
      "latitudeE7": 5.370683,
      "longitudeE7": -71.831137,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 14,
      "punto": 83,
      "latitudeE7": 5.370677,
      "longitudeE7": -71.831099,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 14,
      "punto": 84,
      "latitudeE7": 5.370671,
      "longitudeE7": -71.831062,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 14,
      "punto": 85,
      "latitudeE7": 5.370665,
      "longitudeE7": -71.831024,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 14,
      "punto": 86,
      "latitudeE7": 5.370659,
      "longitudeE7": -71.830986,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 14,
      "punto": 87,
      "latitudeE7": 5.370653,
      "longitudeE7": -71.830949,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 14,
      "punto": 88,
      "latitudeE7": 5.370647,
      "longitudeE7": -71.830911,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 14,
      "punto": 89,
      "latitudeE7": 5.370641,
      "longitudeE7": -71.830873,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 14,
      "punto": 90,
      "latitudeE7": 5.370635,
      "longitudeE7": -71.830835,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 14,
      "punto": 91,
      "latitudeE7": 5.370629,
      "longitudeE7": -71.830798,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 14,
      "punto": 92,
      "latitudeE7": 5.370623,
      "longitudeE7": -71.83076,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 14,
      "punto": 93,
      "latitudeE7": 5.370617,
      "longitudeE7": -71.830722,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 14,
      "punto": 94,
      "latitudeE7": 5.370611,
      "longitudeE7": -71.830685,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 14,
      "punto": 95,
      "latitudeE7": 5.370605,
      "longitudeE7": -71.830647,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 14,
      "punto": 96,
      "latitudeE7": 5.370599,
      "longitudeE7": -71.830609,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 14,
      "punto": 97,
      "latitudeE7": 5.370593,
      "longitudeE7": -71.830571,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 14,
      "punto": 98,
      "latitudeE7": 5.370587,
      "longitudeE7": -71.830534,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 14,
      "punto": 99,
      "latitudeE7": 5.370581,
      "longitudeE7": -71.830496,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 14,
      "punto": 100,
      "latitudeE7": 5.370575,
      "longitudeE7": -71.830458,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 14,
      "punto": 101,
      "latitudeE7": 5.370569,
      "longitudeE7": -71.83042,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 14,
      "punto": 102,
      "latitudeE7": 5.370563,
      "longitudeE7": -71.830383,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 14,
      "punto": 103,
      "latitudeE7": 5.370557,
      "longitudeE7": -71.830345,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 14,
      "punto": 104,
      "latitudeE7": 5.370551,
      "longitudeE7": -71.830307,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 14,
      "punto": 105,
      "latitudeE7": 5.370545,
      "longitudeE7": -71.83027,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 14,
      "punto": 106,
      "latitudeE7": 5.370539,
      "longitudeE7": -71.830232,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 14,
      "punto": 107,
      "latitudeE7": 5.370533,
      "longitudeE7": -71.830194,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 14,
      "punto": 108,
      "latitudeE7": 5.370527,
      "longitudeE7": -71.830156,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 14,
      "punto": 109,
      "latitudeE7": 5.370521,
      "longitudeE7": -71.830119,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 14,
      "punto": 110,
      "latitudeE7": 5.370515,
      "longitudeE7": -71.830081,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 14,
      "punto": 111,
      "latitudeE7": 5.370509,
      "longitudeE7": -71.830043,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 14,
      "punto": 112,
      "latitudeE7": 5.370503,
      "longitudeE7": -71.830006,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 14,
      "punto": 113,
      "latitudeE7": 5.370497,
      "longitudeE7": -71.829968,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 14,
      "punto": 114,
      "latitudeE7": 5.370491,
      "longitudeE7": -71.82993,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 15,
      "punto": 1,
      "latitudeE7": 5.371129,
      "longitudeE7": -71.834217,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 15,
      "punto": 2,
      "latitudeE7": 5.371123,
      "longitudeE7": -71.83418,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 15,
      "punto": 3,
      "latitudeE7": 5.371117,
      "longitudeE7": -71.834142,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 15,
      "punto": 4,
      "latitudeE7": 5.371111,
      "longitudeE7": -71.834104,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 15,
      "punto": 5,
      "latitudeE7": 5.371105,
      "longitudeE7": -71.834067,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 15,
      "punto": 6,
      "latitudeE7": 5.371099,
      "longitudeE7": -71.834029,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 15,
      "punto": 7,
      "latitudeE7": 5.371093,
      "longitudeE7": -71.833991,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 15,
      "punto": 8,
      "latitudeE7": 5.371087,
      "longitudeE7": -71.833953,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 15,
      "punto": 9,
      "latitudeE7": 5.371081,
      "longitudeE7": -71.833916,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 15,
      "punto": 10,
      "latitudeE7": 5.371075,
      "longitudeE7": -71.833878,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 15,
      "punto": 11,
      "latitudeE7": 5.371069,
      "longitudeE7": -71.83384,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 15,
      "punto": 12,
      "latitudeE7": 5.371063,
      "longitudeE7": -71.833803,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 15,
      "punto": 13,
      "latitudeE7": 5.371057,
      "longitudeE7": -71.833765,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 15,
      "punto": 14,
      "latitudeE7": 5.371051,
      "longitudeE7": -71.833727,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 15,
      "punto": 15,
      "latitudeE7": 5.371045,
      "longitudeE7": -71.833689,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 15,
      "punto": 16,
      "latitudeE7": 5.371039,
      "longitudeE7": -71.833652,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 15,
      "punto": 17,
      "latitudeE7": 5.371033,
      "longitudeE7": -71.833614,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 15,
      "punto": 18,
      "latitudeE7": 5.371027,
      "longitudeE7": -71.833576,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 15,
      "punto": 19,
      "latitudeE7": 5.371021,
      "longitudeE7": -71.833538,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 15,
      "punto": 20,
      "latitudeE7": 5.371015,
      "longitudeE7": -71.833501,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 15,
      "punto": 21,
      "latitudeE7": 5.371009,
      "longitudeE7": -71.833463,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 15,
      "punto": 22,
      "latitudeE7": 5.371003,
      "longitudeE7": -71.833425,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 15,
      "punto": 23,
      "latitudeE7": 5.370997,
      "longitudeE7": -71.833388,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 15,
      "punto": 24,
      "latitudeE7": 5.370991,
      "longitudeE7": -71.83335,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 15,
      "punto": 25,
      "latitudeE7": 5.370985,
      "longitudeE7": -71.833312,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 15,
      "punto": 26,
      "latitudeE7": 5.370979,
      "longitudeE7": -71.833274,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 15,
      "punto": 27,
      "latitudeE7": 5.370973,
      "longitudeE7": -71.833237,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 15,
      "punto": 28,
      "latitudeE7": 5.370967,
      "longitudeE7": -71.833199,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 15,
      "punto": 29,
      "latitudeE7": 5.370961,
      "longitudeE7": -71.833161,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 15,
      "punto": 30,
      "latitudeE7": 5.370955,
      "longitudeE7": -71.833124,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 15,
      "punto": 31,
      "latitudeE7": 5.370949,
      "longitudeE7": -71.833086,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 15,
      "punto": 32,
      "latitudeE7": 5.370943,
      "longitudeE7": -71.833048,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 15,
      "punto": 33,
      "latitudeE7": 5.370937,
      "longitudeE7": -71.83301,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 15,
      "punto": 34,
      "latitudeE7": 5.370931,
      "longitudeE7": -71.832973,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 15,
      "punto": 35,
      "latitudeE7": 5.370925,
      "longitudeE7": -71.832935,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 15,
      "punto": 36,
      "latitudeE7": 5.370919,
      "longitudeE7": -71.832897,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 15,
      "punto": 37,
      "latitudeE7": 5.370913,
      "longitudeE7": -71.83286,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 15,
      "punto": 38,
      "latitudeE7": 5.370907,
      "longitudeE7": -71.832822,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 15,
      "punto": 39,
      "latitudeE7": 5.370901,
      "longitudeE7": -71.832784,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 15,
      "punto": 40,
      "latitudeE7": 5.370895,
      "longitudeE7": -71.832746,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 15,
      "punto": 41,
      "latitudeE7": 5.370889,
      "longitudeE7": -71.832709,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 15,
      "punto": 42,
      "latitudeE7": 5.370883,
      "longitudeE7": -71.832671,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 15,
      "punto": 43,
      "latitudeE7": 5.370877,
      "longitudeE7": -71.832633,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 15,
      "punto": 44,
      "latitudeE7": 5.370871,
      "longitudeE7": -71.832595,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 15,
      "punto": 45,
      "latitudeE7": 5.370865,
      "longitudeE7": -71.832558,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 15,
      "punto": 46,
      "latitudeE7": 5.370859,
      "longitudeE7": -71.83252,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 15,
      "punto": 47,
      "latitudeE7": 5.370853,
      "longitudeE7": -71.832482,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 15,
      "punto": 48,
      "latitudeE7": 5.370847,
      "longitudeE7": -71.832445,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 15,
      "punto": 49,
      "latitudeE7": 5.370841,
      "longitudeE7": -71.832407,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 15,
      "punto": 50,
      "latitudeE7": 5.370835,
      "longitudeE7": -71.832369,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 15,
      "punto": 51,
      "latitudeE7": 5.370829,
      "longitudeE7": -71.832331,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 15,
      "punto": 52,
      "latitudeE7": 5.370823,
      "longitudeE7": -71.832294,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 15,
      "punto": 53,
      "latitudeE7": 5.370817,
      "longitudeE7": -71.832256,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 15,
      "punto": 54,
      "latitudeE7": 5.370811,
      "longitudeE7": -71.832218,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 15,
      "punto": 55,
      "latitudeE7": 5.370805,
      "longitudeE7": -71.832181,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 15,
      "punto": 56,
      "latitudeE7": 5.370799,
      "longitudeE7": -71.832143,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 15,
      "punto": 57,
      "latitudeE7": 5.370793,
      "longitudeE7": -71.832105,
      "accuracy": 15,
      "porcentaje": 0.72
    },
    {
      "linea": 15,
      "punto": 58,
      "latitudeE7": 5.370787,
      "longitudeE7": -71.832067,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 15,
      "punto": 59,
      "latitudeE7": 5.370781,
      "longitudeE7": -71.83203,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 15,
      "punto": 60,
      "latitudeE7": 5.370775,
      "longitudeE7": -71.831992,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 15,
      "punto": 61,
      "latitudeE7": 5.370769,
      "longitudeE7": -71.831954,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 15,
      "punto": 62,
      "latitudeE7": 5.370763,
      "longitudeE7": -71.831917,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 15,
      "punto": 63,
      "latitudeE7": 5.370757,
      "longitudeE7": -71.831879,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 15,
      "punto": 64,
      "latitudeE7": 5.370751,
      "longitudeE7": -71.831841,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 15,
      "punto": 65,
      "latitudeE7": 5.370745,
      "longitudeE7": -71.831803,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 15,
      "punto": 66,
      "latitudeE7": 5.370739,
      "longitudeE7": -71.831766,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 15,
      "punto": 67,
      "latitudeE7": 5.370733,
      "longitudeE7": -71.831728,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 15,
      "punto": 68,
      "latitudeE7": 5.370727,
      "longitudeE7": -71.83169,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 15,
      "punto": 69,
      "latitudeE7": 5.370721,
      "longitudeE7": -71.831652,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 15,
      "punto": 70,
      "latitudeE7": 5.370715,
      "longitudeE7": -71.831615,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 15,
      "punto": 71,
      "latitudeE7": 5.370709,
      "longitudeE7": -71.831577,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 15,
      "punto": 72,
      "latitudeE7": 5.370703,
      "longitudeE7": -71.831539,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 15,
      "punto": 73,
      "latitudeE7": 5.370697,
      "longitudeE7": -71.831502,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 15,
      "punto": 74,
      "latitudeE7": 5.370691,
      "longitudeE7": -71.831464,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 15,
      "punto": 75,
      "latitudeE7": 5.370685,
      "longitudeE7": -71.831426,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 15,
      "punto": 76,
      "latitudeE7": 5.370679,
      "longitudeE7": -71.831388,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 15,
      "punto": 77,
      "latitudeE7": 5.370673,
      "longitudeE7": -71.831351,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 15,
      "punto": 78,
      "latitudeE7": 5.370667,
      "longitudeE7": -71.831313,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 15,
      "punto": 79,
      "latitudeE7": 5.370661,
      "longitudeE7": -71.831275,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 15,
      "punto": 80,
      "latitudeE7": 5.370655,
      "longitudeE7": -71.831238,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 15,
      "punto": 81,
      "latitudeE7": 5.370649,
      "longitudeE7": -71.8312,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 15,
      "punto": 82,
      "latitudeE7": 5.370643,
      "longitudeE7": -71.831162,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 15,
      "punto": 83,
      "latitudeE7": 5.370637,
      "longitudeE7": -71.831124,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 15,
      "punto": 84,
      "latitudeE7": 5.370631,
      "longitudeE7": -71.831087,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 15,
      "punto": 85,
      "latitudeE7": 5.370625,
      "longitudeE7": -71.831049,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 15,
      "punto": 86,
      "latitudeE7": 5.370619,
      "longitudeE7": -71.831011,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 15,
      "punto": 87,
      "latitudeE7": 5.370613,
      "longitudeE7": -71.830974,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 15,
      "punto": 88,
      "latitudeE7": 5.370607,
      "longitudeE7": -71.830936,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 15,
      "punto": 89,
      "latitudeE7": 5.370601,
      "longitudeE7": -71.830898,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 15,
      "punto": 90,
      "latitudeE7": 5.370595,
      "longitudeE7": -71.83086,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 15,
      "punto": 91,
      "latitudeE7": 5.370589,
      "longitudeE7": -71.830823,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 15,
      "punto": 92,
      "latitudeE7": 5.370583,
      "longitudeE7": -71.830785,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 15,
      "punto": 93,
      "latitudeE7": 5.370577,
      "longitudeE7": -71.830747,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 15,
      "punto": 94,
      "latitudeE7": 5.370571,
      "longitudeE7": -71.830709,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 15,
      "punto": 95,
      "latitudeE7": 5.370565,
      "longitudeE7": -71.830672,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 15,
      "punto": 96,
      "latitudeE7": 5.370559,
      "longitudeE7": -71.830634,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 15,
      "punto": 97,
      "latitudeE7": 5.370553,
      "longitudeE7": -71.830596,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 15,
      "punto": 98,
      "latitudeE7": 5.370547,
      "longitudeE7": -71.830559,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 15,
      "punto": 99,
      "latitudeE7": 5.370541,
      "longitudeE7": -71.830521,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 15,
      "punto": 100,
      "latitudeE7": 5.370535,
      "longitudeE7": -71.830483,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 15,
      "punto": 101,
      "latitudeE7": 5.370529,
      "longitudeE7": -71.830445,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 15,
      "punto": 102,
      "latitudeE7": 5.370523,
      "longitudeE7": -71.830408,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 15,
      "punto": 103,
      "latitudeE7": 5.370517,
      "longitudeE7": -71.83037,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 15,
      "punto": 104,
      "latitudeE7": 5.370511,
      "longitudeE7": -71.830332,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 15,
      "punto": 105,
      "latitudeE7": 5.370505,
      "longitudeE7": -71.830295,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 15,
      "punto": 106,
      "latitudeE7": 5.370499,
      "longitudeE7": -71.830257,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 15,
      "punto": 107,
      "latitudeE7": 5.370493,
      "longitudeE7": -71.830219,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 15,
      "punto": 108,
      "latitudeE7": 5.370487,
      "longitudeE7": -71.830181,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 15,
      "punto": 109,
      "latitudeE7": 5.370481,
      "longitudeE7": -71.830144,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 15,
      "punto": 110,
      "latitudeE7": 5.370475,
      "longitudeE7": -71.830106,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 15,
      "punto": 111,
      "latitudeE7": 5.370469,
      "longitudeE7": -71.830068,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 15,
      "punto": 112,
      "latitudeE7": 5.370463,
      "longitudeE7": -71.830031,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 15,
      "punto": 113,
      "latitudeE7": 5.370457,
      "longitudeE7": -71.829993,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 15,
      "punto": 114,
      "latitudeE7": 5.370451,
      "longitudeE7": -71.829955,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 16,
      "punto": 1,
      "latitudeE7": 5.371089,
      "longitudeE7": -71.834242,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 16,
      "punto": 2,
      "latitudeE7": 5.371083,
      "longitudeE7": -71.834205,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 16,
      "punto": 3,
      "latitudeE7": 5.371077,
      "longitudeE7": -71.834167,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 16,
      "punto": 4,
      "latitudeE7": 5.371071,
      "longitudeE7": -71.834129,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 16,
      "punto": 5,
      "latitudeE7": 5.371065,
      "longitudeE7": -71.834092,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 16,
      "punto": 6,
      "latitudeE7": 5.371059,
      "longitudeE7": -71.834054,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 16,
      "punto": 7,
      "latitudeE7": 5.371053,
      "longitudeE7": -71.834016,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 16,
      "punto": 8,
      "latitudeE7": 5.371047,
      "longitudeE7": -71.833978,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 16,
      "punto": 9,
      "latitudeE7": 5.371041,
      "longitudeE7": -71.833941,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 16,
      "punto": 10,
      "latitudeE7": 5.371035,
      "longitudeE7": -71.833903,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 16,
      "punto": 11,
      "latitudeE7": 5.371029,
      "longitudeE7": -71.833865,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 16,
      "punto": 12,
      "latitudeE7": 5.371023,
      "longitudeE7": -71.833827,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 16,
      "punto": 13,
      "latitudeE7": 5.371017,
      "longitudeE7": -71.83379,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 16,
      "punto": 14,
      "latitudeE7": 5.371011,
      "longitudeE7": -71.833752,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 16,
      "punto": 15,
      "latitudeE7": 5.371005,
      "longitudeE7": -71.833714,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 16,
      "punto": 16,
      "latitudeE7": 5.370999,
      "longitudeE7": -71.833677,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 16,
      "punto": 17,
      "latitudeE7": 5.370993,
      "longitudeE7": -71.833639,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 16,
      "punto": 18,
      "latitudeE7": 5.370987,
      "longitudeE7": -71.833601,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 16,
      "punto": 19,
      "latitudeE7": 5.370981,
      "longitudeE7": -71.833563,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 16,
      "punto": 20,
      "latitudeE7": 5.370975,
      "longitudeE7": -71.833526,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 16,
      "punto": 21,
      "latitudeE7": 5.370969,
      "longitudeE7": -71.833488,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 16,
      "punto": 22,
      "latitudeE7": 5.370963,
      "longitudeE7": -71.83345,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 16,
      "punto": 23,
      "latitudeE7": 5.370957,
      "longitudeE7": -71.833413,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 16,
      "punto": 24,
      "latitudeE7": 5.370951,
      "longitudeE7": -71.833375,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 16,
      "punto": 25,
      "latitudeE7": 5.370945,
      "longitudeE7": -71.833337,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 16,
      "punto": 26,
      "latitudeE7": 5.370939,
      "longitudeE7": -71.833299,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 16,
      "punto": 27,
      "latitudeE7": 5.370933,
      "longitudeE7": -71.833262,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 16,
      "punto": 28,
      "latitudeE7": 5.370927,
      "longitudeE7": -71.833224,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 16,
      "punto": 29,
      "latitudeE7": 5.370921,
      "longitudeE7": -71.833186,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 16,
      "punto": 30,
      "latitudeE7": 5.370915,
      "longitudeE7": -71.833149,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 16,
      "punto": 31,
      "latitudeE7": 5.370909,
      "longitudeE7": -71.833111,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 16,
      "punto": 32,
      "latitudeE7": 5.370903,
      "longitudeE7": -71.833073,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 16,
      "punto": 33,
      "latitudeE7": 5.370897,
      "longitudeE7": -71.833035,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 16,
      "punto": 34,
      "latitudeE7": 5.370891,
      "longitudeE7": -71.832998,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 16,
      "punto": 35,
      "latitudeE7": 5.370885,
      "longitudeE7": -71.83296,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 16,
      "punto": 36,
      "latitudeE7": 5.370879,
      "longitudeE7": -71.832922,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 16,
      "punto": 37,
      "latitudeE7": 5.370873,
      "longitudeE7": -71.832884,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 16,
      "punto": 38,
      "latitudeE7": 5.370867,
      "longitudeE7": -71.832847,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 16,
      "punto": 39,
      "latitudeE7": 5.370861,
      "longitudeE7": -71.832809,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 16,
      "punto": 40,
      "latitudeE7": 5.370855,
      "longitudeE7": -71.832771,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 16,
      "punto": 41,
      "latitudeE7": 5.370849,
      "longitudeE7": -71.832734,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 16,
      "punto": 42,
      "latitudeE7": 5.370843,
      "longitudeE7": -71.832696,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 16,
      "punto": 43,
      "latitudeE7": 5.370837,
      "longitudeE7": -71.832658,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 16,
      "punto": 44,
      "latitudeE7": 5.370831,
      "longitudeE7": -71.83262,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 16,
      "punto": 45,
      "latitudeE7": 5.370825,
      "longitudeE7": -71.832583,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 16,
      "punto": 46,
      "latitudeE7": 5.370819,
      "longitudeE7": -71.832545,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 16,
      "punto": 47,
      "latitudeE7": 5.370813,
      "longitudeE7": -71.832507,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 16,
      "punto": 48,
      "latitudeE7": 5.370807,
      "longitudeE7": -71.83247,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 16,
      "punto": 49,
      "latitudeE7": 5.370801,
      "longitudeE7": -71.832432,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 16,
      "punto": 50,
      "latitudeE7": 5.370795,
      "longitudeE7": -71.832394,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 16,
      "punto": 51,
      "latitudeE7": 5.370789,
      "longitudeE7": -71.832356,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 16,
      "punto": 52,
      "latitudeE7": 5.370783,
      "longitudeE7": -71.832319,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 16,
      "punto": 53,
      "latitudeE7": 5.370777,
      "longitudeE7": -71.832281,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 16,
      "punto": 54,
      "latitudeE7": 5.370771,
      "longitudeE7": -71.832243,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 16,
      "punto": 55,
      "latitudeE7": 5.370765,
      "longitudeE7": -71.832206,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 16,
      "punto": 56,
      "latitudeE7": 5.370759,
      "longitudeE7": -71.832168,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 16,
      "punto": 57,
      "latitudeE7": 5.370753,
      "longitudeE7": -71.83213,
      "accuracy": 15,
      "porcentaje": 0.44
    },
    {
      "linea": 16,
      "punto": 58,
      "latitudeE7": 5.370747,
      "longitudeE7": -71.832092,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 16,
      "punto": 59,
      "latitudeE7": 5.370741,
      "longitudeE7": -71.832055,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 16,
      "punto": 60,
      "latitudeE7": 5.370735,
      "longitudeE7": -71.832017,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 16,
      "punto": 61,
      "latitudeE7": 5.370729,
      "longitudeE7": -71.831979,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 16,
      "punto": 62,
      "latitudeE7": 5.370723,
      "longitudeE7": -71.831941,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 16,
      "punto": 63,
      "latitudeE7": 5.370717,
      "longitudeE7": -71.831904,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 16,
      "punto": 64,
      "latitudeE7": 5.370711,
      "longitudeE7": -71.831866,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 16,
      "punto": 65,
      "latitudeE7": 5.370705,
      "longitudeE7": -71.831828,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 16,
      "punto": 66,
      "latitudeE7": 5.370699,
      "longitudeE7": -71.831791,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 16,
      "punto": 67,
      "latitudeE7": 5.370693,
      "longitudeE7": -71.831753,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 16,
      "punto": 68,
      "latitudeE7": 5.370687,
      "longitudeE7": -71.831715,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 16,
      "punto": 69,
      "latitudeE7": 5.370681,
      "longitudeE7": -71.831677,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 16,
      "punto": 70,
      "latitudeE7": 5.370675,
      "longitudeE7": -71.83164,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 16,
      "punto": 71,
      "latitudeE7": 5.370669,
      "longitudeE7": -71.831602,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 16,
      "punto": 72,
      "latitudeE7": 5.370663,
      "longitudeE7": -71.831564,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 16,
      "punto": 73,
      "latitudeE7": 5.370657,
      "longitudeE7": -71.831527,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 16,
      "punto": 74,
      "latitudeE7": 5.370651,
      "longitudeE7": -71.831489,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 16,
      "punto": 75,
      "latitudeE7": 5.370645,
      "longitudeE7": -71.831451,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 16,
      "punto": 76,
      "latitudeE7": 5.370639,
      "longitudeE7": -71.831413,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 16,
      "punto": 77,
      "latitudeE7": 5.370633,
      "longitudeE7": -71.831376,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 16,
      "punto": 78,
      "latitudeE7": 5.370627,
      "longitudeE7": -71.831338,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 16,
      "punto": 79,
      "latitudeE7": 5.370621,
      "longitudeE7": -71.8313,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 16,
      "punto": 80,
      "latitudeE7": 5.370615,
      "longitudeE7": -71.831263,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 16,
      "punto": 81,
      "latitudeE7": 5.370609,
      "longitudeE7": -71.831225,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 16,
      "punto": 82,
      "latitudeE7": 5.370603,
      "longitudeE7": -71.831187,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 16,
      "punto": 83,
      "latitudeE7": 5.370597,
      "longitudeE7": -71.831149,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 16,
      "punto": 84,
      "latitudeE7": 5.370591,
      "longitudeE7": -71.831112,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 16,
      "punto": 85,
      "latitudeE7": 5.370585,
      "longitudeE7": -71.831074,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 16,
      "punto": 86,
      "latitudeE7": 5.370579,
      "longitudeE7": -71.831036,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 16,
      "punto": 87,
      "latitudeE7": 5.370573,
      "longitudeE7": -71.830998,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 16,
      "punto": 88,
      "latitudeE7": 5.370567,
      "longitudeE7": -71.830961,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 16,
      "punto": 89,
      "latitudeE7": 5.370561,
      "longitudeE7": -71.830923,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 16,
      "punto": 90,
      "latitudeE7": 5.370555,
      "longitudeE7": -71.830885,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 16,
      "punto": 91,
      "latitudeE7": 5.370549,
      "longitudeE7": -71.830848,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 16,
      "punto": 92,
      "latitudeE7": 5.370543,
      "longitudeE7": -71.83081,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 16,
      "punto": 93,
      "latitudeE7": 5.370537,
      "longitudeE7": -71.830772,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 16,
      "punto": 94,
      "latitudeE7": 5.370531,
      "longitudeE7": -71.830734,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 16,
      "punto": 95,
      "latitudeE7": 5.370525,
      "longitudeE7": -71.830697,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 16,
      "punto": 96,
      "latitudeE7": 5.370519,
      "longitudeE7": -71.830659,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 16,
      "punto": 97,
      "latitudeE7": 5.370513,
      "longitudeE7": -71.830621,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 16,
      "punto": 98,
      "latitudeE7": 5.370507,
      "longitudeE7": -71.830584,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 16,
      "punto": 99,
      "latitudeE7": 5.370501,
      "longitudeE7": -71.830546,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 16,
      "punto": 100,
      "latitudeE7": 5.370495,
      "longitudeE7": -71.830508,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 16,
      "punto": 101,
      "latitudeE7": 5.370489,
      "longitudeE7": -71.83047,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 16,
      "punto": 102,
      "latitudeE7": 5.370483,
      "longitudeE7": -71.830433,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 16,
      "punto": 103,
      "latitudeE7": 5.370477,
      "longitudeE7": -71.830395,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 16,
      "punto": 104,
      "latitudeE7": 5.370471,
      "longitudeE7": -71.830357,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 16,
      "punto": 105,
      "latitudeE7": 5.370465,
      "longitudeE7": -71.83032,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 16,
      "punto": 106,
      "latitudeE7": 5.370459,
      "longitudeE7": -71.830282,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 16,
      "punto": 107,
      "latitudeE7": 5.370453,
      "longitudeE7": -71.830244,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 16,
      "punto": 108,
      "latitudeE7": 5.370447,
      "longitudeE7": -71.830206,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 16,
      "punto": 109,
      "latitudeE7": 5.370441,
      "longitudeE7": -71.830169,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 16,
      "punto": 110,
      "latitudeE7": 5.370435,
      "longitudeE7": -71.830131,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 16,
      "punto": 111,
      "latitudeE7": 5.370429,
      "longitudeE7": -71.830093,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 16,
      "punto": 112,
      "latitudeE7": 5.370423,
      "longitudeE7": -71.830055,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 16,
      "punto": 113,
      "latitudeE7": 5.370417,
      "longitudeE7": -71.830018,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 16,
      "punto": 114,
      "latitudeE7": 5.370411,
      "longitudeE7": -71.82998,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 17,
      "punto": 1,
      "latitudeE7": 5.371049,
      "longitudeE7": -71.834267,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 17,
      "punto": 2,
      "latitudeE7": 5.371043,
      "longitudeE7": -71.83423,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 17,
      "punto": 3,
      "latitudeE7": 5.371037,
      "longitudeE7": -71.834192,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 17,
      "punto": 4,
      "latitudeE7": 5.371031,
      "longitudeE7": -71.834154,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 17,
      "punto": 5,
      "latitudeE7": 5.371025,
      "longitudeE7": -71.834116,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 17,
      "punto": 6,
      "latitudeE7": 5.371019,
      "longitudeE7": -71.834079,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 17,
      "punto": 7,
      "latitudeE7": 5.371013,
      "longitudeE7": -71.834041,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 17,
      "punto": 8,
      "latitudeE7": 5.371007,
      "longitudeE7": -71.834003,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 17,
      "punto": 9,
      "latitudeE7": 5.371001,
      "longitudeE7": -71.833966,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 17,
      "punto": 10,
      "latitudeE7": 5.370995,
      "longitudeE7": -71.833928,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 17,
      "punto": 11,
      "latitudeE7": 5.370989,
      "longitudeE7": -71.83389,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 17,
      "punto": 12,
      "latitudeE7": 5.370983,
      "longitudeE7": -71.833852,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 17,
      "punto": 13,
      "latitudeE7": 5.370977,
      "longitudeE7": -71.833815,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 17,
      "punto": 14,
      "latitudeE7": 5.370971,
      "longitudeE7": -71.833777,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 17,
      "punto": 15,
      "latitudeE7": 5.370965,
      "longitudeE7": -71.833739,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 17,
      "punto": 16,
      "latitudeE7": 5.370959,
      "longitudeE7": -71.833702,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 17,
      "punto": 17,
      "latitudeE7": 5.370953,
      "longitudeE7": -71.833664,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 17,
      "punto": 18,
      "latitudeE7": 5.370947,
      "longitudeE7": -71.833626,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 17,
      "punto": 19,
      "latitudeE7": 5.370941,
      "longitudeE7": -71.833588,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 17,
      "punto": 20,
      "latitudeE7": 5.370935,
      "longitudeE7": -71.833551,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 17,
      "punto": 21,
      "latitudeE7": 5.370929,
      "longitudeE7": -71.833513,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 17,
      "punto": 22,
      "latitudeE7": 5.370923,
      "longitudeE7": -71.833475,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 17,
      "punto": 23,
      "latitudeE7": 5.370917,
      "longitudeE7": -71.833438,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 17,
      "punto": 24,
      "latitudeE7": 5.370911,
      "longitudeE7": -71.8334,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 17,
      "punto": 25,
      "latitudeE7": 5.370905,
      "longitudeE7": -71.833362,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 17,
      "punto": 26,
      "latitudeE7": 5.370899,
      "longitudeE7": -71.833324,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 17,
      "punto": 27,
      "latitudeE7": 5.370893,
      "longitudeE7": -71.833287,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 17,
      "punto": 28,
      "latitudeE7": 5.370887,
      "longitudeE7": -71.833249,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 17,
      "punto": 29,
      "latitudeE7": 5.370881,
      "longitudeE7": -71.833211,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 17,
      "punto": 30,
      "latitudeE7": 5.370875,
      "longitudeE7": -71.833173,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 17,
      "punto": 31,
      "latitudeE7": 5.370869,
      "longitudeE7": -71.833136,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 17,
      "punto": 32,
      "latitudeE7": 5.370863,
      "longitudeE7": -71.833098,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 17,
      "punto": 33,
      "latitudeE7": 5.370857,
      "longitudeE7": -71.83306,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 17,
      "punto": 34,
      "latitudeE7": 5.370851,
      "longitudeE7": -71.833023,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 17,
      "punto": 35,
      "latitudeE7": 5.370845,
      "longitudeE7": -71.832985,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 17,
      "punto": 36,
      "latitudeE7": 5.370839,
      "longitudeE7": -71.832947,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 17,
      "punto": 37,
      "latitudeE7": 5.370833,
      "longitudeE7": -71.832909,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 17,
      "punto": 38,
      "latitudeE7": 5.370827,
      "longitudeE7": -71.832872,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 17,
      "punto": 39,
      "latitudeE7": 5.370821,
      "longitudeE7": -71.832834,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 17,
      "punto": 40,
      "latitudeE7": 5.370815,
      "longitudeE7": -71.832796,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 17,
      "punto": 41,
      "latitudeE7": 5.370809,
      "longitudeE7": -71.832759,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 17,
      "punto": 42,
      "latitudeE7": 5.370803,
      "longitudeE7": -71.832721,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 17,
      "punto": 43,
      "latitudeE7": 5.370797,
      "longitudeE7": -71.832683,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 17,
      "punto": 44,
      "latitudeE7": 5.370791,
      "longitudeE7": -71.832645,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 17,
      "punto": 45,
      "latitudeE7": 5.370785,
      "longitudeE7": -71.832608,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 17,
      "punto": 46,
      "latitudeE7": 5.370779,
      "longitudeE7": -71.83257,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 17,
      "punto": 47,
      "latitudeE7": 5.370773,
      "longitudeE7": -71.832532,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 17,
      "punto": 48,
      "latitudeE7": 5.370767,
      "longitudeE7": -71.832495,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 17,
      "punto": 49,
      "latitudeE7": 5.370761,
      "longitudeE7": -71.832457,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 17,
      "punto": 50,
      "latitudeE7": 5.370755,
      "longitudeE7": -71.832419,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 17,
      "punto": 51,
      "latitudeE7": 5.370749,
      "longitudeE7": -71.832381,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 17,
      "punto": 52,
      "latitudeE7": 5.370743,
      "longitudeE7": -71.832344,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 17,
      "punto": 53,
      "latitudeE7": 5.370737,
      "longitudeE7": -71.832306,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 17,
      "punto": 54,
      "latitudeE7": 5.370731,
      "longitudeE7": -71.832268,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 17,
      "punto": 55,
      "latitudeE7": 5.370725,
      "longitudeE7": -71.83223,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 17,
      "punto": 56,
      "latitudeE7": 5.370719,
      "longitudeE7": -71.832193,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 17,
      "punto": 57,
      "latitudeE7": 5.370713,
      "longitudeE7": -71.832155,
      "accuracy": 15,
      "porcentaje": 0.52
    },
    {
      "linea": 17,
      "punto": 58,
      "latitudeE7": 5.370707,
      "longitudeE7": -71.832117,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 17,
      "punto": 59,
      "latitudeE7": 5.370701,
      "longitudeE7": -71.83208,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 17,
      "punto": 60,
      "latitudeE7": 5.370695,
      "longitudeE7": -71.832042,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 17,
      "punto": 61,
      "latitudeE7": 5.370689,
      "longitudeE7": -71.832004,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 17,
      "punto": 62,
      "latitudeE7": 5.370683,
      "longitudeE7": -71.831966,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 17,
      "punto": 63,
      "latitudeE7": 5.370677,
      "longitudeE7": -71.831929,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 17,
      "punto": 64,
      "latitudeE7": 5.370671,
      "longitudeE7": -71.831891,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 17,
      "punto": 65,
      "latitudeE7": 5.370665,
      "longitudeE7": -71.831853,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 17,
      "punto": 66,
      "latitudeE7": 5.370659,
      "longitudeE7": -71.831816,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 17,
      "punto": 67,
      "latitudeE7": 5.370653,
      "longitudeE7": -71.831778,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 17,
      "punto": 68,
      "latitudeE7": 5.370647,
      "longitudeE7": -71.83174,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 17,
      "punto": 69,
      "latitudeE7": 5.370641,
      "longitudeE7": -71.831702,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 17,
      "punto": 70,
      "latitudeE7": 5.370635,
      "longitudeE7": -71.831665,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 17,
      "punto": 71,
      "latitudeE7": 5.370629,
      "longitudeE7": -71.831627,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 17,
      "punto": 72,
      "latitudeE7": 5.370623,
      "longitudeE7": -71.831589,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 17,
      "punto": 73,
      "latitudeE7": 5.370617,
      "longitudeE7": -71.831552,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 17,
      "punto": 74,
      "latitudeE7": 5.370611,
      "longitudeE7": -71.831514,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 17,
      "punto": 75,
      "latitudeE7": 5.370605,
      "longitudeE7": -71.831476,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 17,
      "punto": 76,
      "latitudeE7": 5.370599,
      "longitudeE7": -71.831438,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 17,
      "punto": 77,
      "latitudeE7": 5.370593,
      "longitudeE7": -71.831401,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 17,
      "punto": 78,
      "latitudeE7": 5.370587,
      "longitudeE7": -71.831363,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 17,
      "punto": 79,
      "latitudeE7": 5.370581,
      "longitudeE7": -71.831325,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 17,
      "punto": 80,
      "latitudeE7": 5.370575,
      "longitudeE7": -71.831287,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 17,
      "punto": 81,
      "latitudeE7": 5.370569,
      "longitudeE7": -71.83125,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 17,
      "punto": 82,
      "latitudeE7": 5.370563,
      "longitudeE7": -71.831212,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 17,
      "punto": 83,
      "latitudeE7": 5.370557,
      "longitudeE7": -71.831174,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 17,
      "punto": 84,
      "latitudeE7": 5.370551,
      "longitudeE7": -71.831137,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 17,
      "punto": 85,
      "latitudeE7": 5.370545,
      "longitudeE7": -71.831099,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 17,
      "punto": 86,
      "latitudeE7": 5.370539,
      "longitudeE7": -71.831061,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 17,
      "punto": 87,
      "latitudeE7": 5.370533,
      "longitudeE7": -71.831023,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 17,
      "punto": 88,
      "latitudeE7": 5.370527,
      "longitudeE7": -71.830986,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 17,
      "punto": 89,
      "latitudeE7": 5.370521,
      "longitudeE7": -71.830948,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 17,
      "punto": 90,
      "latitudeE7": 5.370515,
      "longitudeE7": -71.83091,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 17,
      "punto": 91,
      "latitudeE7": 5.370509,
      "longitudeE7": -71.830873,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 17,
      "punto": 92,
      "latitudeE7": 5.370503,
      "longitudeE7": -71.830835,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 17,
      "punto": 93,
      "latitudeE7": 5.370497,
      "longitudeE7": -71.830797,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 17,
      "punto": 94,
      "latitudeE7": 5.370491,
      "longitudeE7": -71.830759,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 17,
      "punto": 95,
      "latitudeE7": 5.370485,
      "longitudeE7": -71.830722,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 17,
      "punto": 96,
      "latitudeE7": 5.370479,
      "longitudeE7": -71.830684,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 17,
      "punto": 97,
      "latitudeE7": 5.370473,
      "longitudeE7": -71.830646,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 17,
      "punto": 98,
      "latitudeE7": 5.370467,
      "longitudeE7": -71.830609,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 17,
      "punto": 99,
      "latitudeE7": 5.370461,
      "longitudeE7": -71.830571,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 17,
      "punto": 100,
      "latitudeE7": 5.370455,
      "longitudeE7": -71.830533,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 17,
      "punto": 101,
      "latitudeE7": 5.370449,
      "longitudeE7": -71.830495,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 17,
      "punto": 102,
      "latitudeE7": 5.370443,
      "longitudeE7": -71.830458,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 17,
      "punto": 103,
      "latitudeE7": 5.370437,
      "longitudeE7": -71.83042,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 17,
      "punto": 104,
      "latitudeE7": 5.370431,
      "longitudeE7": -71.830382,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 17,
      "punto": 105,
      "latitudeE7": 5.370425,
      "longitudeE7": -71.830344,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 17,
      "punto": 106,
      "latitudeE7": 5.370419,
      "longitudeE7": -71.830307,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 17,
      "punto": 107,
      "latitudeE7": 5.370413,
      "longitudeE7": -71.830269,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 17,
      "punto": 108,
      "latitudeE7": 5.370407,
      "longitudeE7": -71.830231,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 17,
      "punto": 109,
      "latitudeE7": 5.370401,
      "longitudeE7": -71.830194,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 17,
      "punto": 110,
      "latitudeE7": 5.370395,
      "longitudeE7": -71.830156,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 17,
      "punto": 111,
      "latitudeE7": 5.370389,
      "longitudeE7": -71.830118,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 17,
      "punto": 112,
      "latitudeE7": 5.370383,
      "longitudeE7": -71.83008,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 17,
      "punto": 113,
      "latitudeE7": 5.370377,
      "longitudeE7": -71.830043,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 17,
      "punto": 114,
      "latitudeE7": 5.370371,
      "longitudeE7": -71.830005,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 18,
      "punto": 1,
      "latitudeE7": 5.371009,
      "longitudeE7": -71.834292,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 18,
      "punto": 2,
      "latitudeE7": 5.371003,
      "longitudeE7": -71.834255,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 18,
      "punto": 3,
      "latitudeE7": 5.370997,
      "longitudeE7": -71.834217,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 18,
      "punto": 4,
      "latitudeE7": 5.370991,
      "longitudeE7": -71.834179,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 18,
      "punto": 5,
      "latitudeE7": 5.370985,
      "longitudeE7": -71.834141,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 18,
      "punto": 6,
      "latitudeE7": 5.370979,
      "longitudeE7": -71.834104,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 18,
      "punto": 7,
      "latitudeE7": 5.370973,
      "longitudeE7": -71.834066,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 18,
      "punto": 8,
      "latitudeE7": 5.370967,
      "longitudeE7": -71.834028,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 18,
      "punto": 9,
      "latitudeE7": 5.370961,
      "longitudeE7": -71.833991,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 18,
      "punto": 10,
      "latitudeE7": 5.370955,
      "longitudeE7": -71.833953,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 18,
      "punto": 11,
      "latitudeE7": 5.370949,
      "longitudeE7": -71.833915,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 18,
      "punto": 12,
      "latitudeE7": 5.370943,
      "longitudeE7": -71.833877,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 18,
      "punto": 13,
      "latitudeE7": 5.370937,
      "longitudeE7": -71.83384,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 18,
      "punto": 14,
      "latitudeE7": 5.370931,
      "longitudeE7": -71.833802,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 18,
      "punto": 15,
      "latitudeE7": 5.370925,
      "longitudeE7": -71.833764,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 18,
      "punto": 16,
      "latitudeE7": 5.370919,
      "longitudeE7": -71.833727,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 18,
      "punto": 17,
      "latitudeE7": 5.370913,
      "longitudeE7": -71.833689,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 18,
      "punto": 18,
      "latitudeE7": 5.370907,
      "longitudeE7": -71.833651,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 18,
      "punto": 19,
      "latitudeE7": 5.370901,
      "longitudeE7": -71.833613,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 18,
      "punto": 20,
      "latitudeE7": 5.370895,
      "longitudeE7": -71.833576,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 18,
      "punto": 21,
      "latitudeE7": 5.370889,
      "longitudeE7": -71.833538,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 18,
      "punto": 22,
      "latitudeE7": 5.370883,
      "longitudeE7": -71.8335,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 18,
      "punto": 23,
      "latitudeE7": 5.370877,
      "longitudeE7": -71.833462,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 18,
      "punto": 24,
      "latitudeE7": 5.370871,
      "longitudeE7": -71.833425,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 18,
      "punto": 25,
      "latitudeE7": 5.370865,
      "longitudeE7": -71.833387,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 18,
      "punto": 26,
      "latitudeE7": 5.370859,
      "longitudeE7": -71.833349,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 18,
      "punto": 27,
      "latitudeE7": 5.370853,
      "longitudeE7": -71.833312,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 18,
      "punto": 28,
      "latitudeE7": 5.370847,
      "longitudeE7": -71.833274,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 18,
      "punto": 29,
      "latitudeE7": 5.370841,
      "longitudeE7": -71.833236,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 18,
      "punto": 30,
      "latitudeE7": 5.370835,
      "longitudeE7": -71.833198,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 18,
      "punto": 31,
      "latitudeE7": 5.370829,
      "longitudeE7": -71.833161,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 18,
      "punto": 32,
      "latitudeE7": 5.370823,
      "longitudeE7": -71.833123,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 18,
      "punto": 33,
      "latitudeE7": 5.370817,
      "longitudeE7": -71.833085,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 18,
      "punto": 34,
      "latitudeE7": 5.370811,
      "longitudeE7": -71.833048,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 18,
      "punto": 35,
      "latitudeE7": 5.370805,
      "longitudeE7": -71.83301,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 18,
      "punto": 36,
      "latitudeE7": 5.370799,
      "longitudeE7": -71.832972,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 18,
      "punto": 37,
      "latitudeE7": 5.370793,
      "longitudeE7": -71.832934,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 18,
      "punto": 38,
      "latitudeE7": 5.370787,
      "longitudeE7": -71.832897,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 18,
      "punto": 39,
      "latitudeE7": 5.370781,
      "longitudeE7": -71.832859,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 18,
      "punto": 40,
      "latitudeE7": 5.370775,
      "longitudeE7": -71.832821,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 18,
      "punto": 41,
      "latitudeE7": 5.370769,
      "longitudeE7": -71.832784,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 18,
      "punto": 42,
      "latitudeE7": 5.370763,
      "longitudeE7": -71.832746,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 18,
      "punto": 43,
      "latitudeE7": 5.370757,
      "longitudeE7": -71.832708,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 18,
      "punto": 44,
      "latitudeE7": 5.370751,
      "longitudeE7": -71.83267,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 18,
      "punto": 45,
      "latitudeE7": 5.370745,
      "longitudeE7": -71.832633,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 18,
      "punto": 46,
      "latitudeE7": 5.370739,
      "longitudeE7": -71.832595,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 18,
      "punto": 47,
      "latitudeE7": 5.370733,
      "longitudeE7": -71.832557,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 18,
      "punto": 48,
      "latitudeE7": 5.370727,
      "longitudeE7": -71.832519,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 18,
      "punto": 49,
      "latitudeE7": 5.370721,
      "longitudeE7": -71.832482,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 18,
      "punto": 50,
      "latitudeE7": 5.370715,
      "longitudeE7": -71.832444,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 18,
      "punto": 51,
      "latitudeE7": 5.370709,
      "longitudeE7": -71.832406,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 18,
      "punto": 52,
      "latitudeE7": 5.370703,
      "longitudeE7": -71.832369,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 18,
      "punto": 53,
      "latitudeE7": 5.370697,
      "longitudeE7": -71.832331,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 18,
      "punto": 54,
      "latitudeE7": 5.370691,
      "longitudeE7": -71.832293,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 18,
      "punto": 55,
      "latitudeE7": 5.370685,
      "longitudeE7": -71.832255,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 18,
      "punto": 56,
      "latitudeE7": 5.370679,
      "longitudeE7": -71.832218,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 18,
      "punto": 57,
      "latitudeE7": 5.370673,
      "longitudeE7": -71.83218,
      "accuracy": 15,
      "porcentaje": 0.12
    },
    {
      "linea": 18,
      "punto": 58,
      "latitudeE7": 5.370667,
      "longitudeE7": -71.832142,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 18,
      "punto": 59,
      "latitudeE7": 5.370661,
      "longitudeE7": -71.832105,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 18,
      "punto": 60,
      "latitudeE7": 5.370655,
      "longitudeE7": -71.832067,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 18,
      "punto": 61,
      "latitudeE7": 5.370649,
      "longitudeE7": -71.832029,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 18,
      "punto": 62,
      "latitudeE7": 5.370643,
      "longitudeE7": -71.831991,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 18,
      "punto": 63,
      "latitudeE7": 5.370637,
      "longitudeE7": -71.831954,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 18,
      "punto": 64,
      "latitudeE7": 5.370631,
      "longitudeE7": -71.831916,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 18,
      "punto": 65,
      "latitudeE7": 5.370625,
      "longitudeE7": -71.831878,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 18,
      "punto": 66,
      "latitudeE7": 5.370619,
      "longitudeE7": -71.831841,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 18,
      "punto": 67,
      "latitudeE7": 5.370613,
      "longitudeE7": -71.831803,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 18,
      "punto": 68,
      "latitudeE7": 5.370607,
      "longitudeE7": -71.831765,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 18,
      "punto": 69,
      "latitudeE7": 5.370601,
      "longitudeE7": -71.831727,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 18,
      "punto": 70,
      "latitudeE7": 5.370595,
      "longitudeE7": -71.83169,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 18,
      "punto": 71,
      "latitudeE7": 5.370589,
      "longitudeE7": -71.831652,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 18,
      "punto": 72,
      "latitudeE7": 5.370583,
      "longitudeE7": -71.831614,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 18,
      "punto": 73,
      "latitudeE7": 5.370577,
      "longitudeE7": -71.831576,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 18,
      "punto": 74,
      "latitudeE7": 5.370571,
      "longitudeE7": -71.831539,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 18,
      "punto": 75,
      "latitudeE7": 5.370565,
      "longitudeE7": -71.831501,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 18,
      "punto": 76,
      "latitudeE7": 5.370559,
      "longitudeE7": -71.831463,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 18,
      "punto": 77,
      "latitudeE7": 5.370553,
      "longitudeE7": -71.831426,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 18,
      "punto": 78,
      "latitudeE7": 5.370547,
      "longitudeE7": -71.831388,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 18,
      "punto": 79,
      "latitudeE7": 5.370541,
      "longitudeE7": -71.83135,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 18,
      "punto": 80,
      "latitudeE7": 5.370535,
      "longitudeE7": -71.831312,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 18,
      "punto": 81,
      "latitudeE7": 5.370529,
      "longitudeE7": -71.831275,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 18,
      "punto": 82,
      "latitudeE7": 5.370523,
      "longitudeE7": -71.831237,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 18,
      "punto": 83,
      "latitudeE7": 5.370517,
      "longitudeE7": -71.831199,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 18,
      "punto": 84,
      "latitudeE7": 5.370511,
      "longitudeE7": -71.831162,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 18,
      "punto": 85,
      "latitudeE7": 5.370505,
      "longitudeE7": -71.831124,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 18,
      "punto": 86,
      "latitudeE7": 5.370499,
      "longitudeE7": -71.831086,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 18,
      "punto": 87,
      "latitudeE7": 5.370493,
      "longitudeE7": -71.831048,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 18,
      "punto": 88,
      "latitudeE7": 5.370487,
      "longitudeE7": -71.831011,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 18,
      "punto": 89,
      "latitudeE7": 5.370481,
      "longitudeE7": -71.830973,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 18,
      "punto": 90,
      "latitudeE7": 5.370475,
      "longitudeE7": -71.830935,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 18,
      "punto": 91,
      "latitudeE7": 5.370469,
      "longitudeE7": -71.830898,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 18,
      "punto": 92,
      "latitudeE7": 5.370463,
      "longitudeE7": -71.83086,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 18,
      "punto": 93,
      "latitudeE7": 5.370457,
      "longitudeE7": -71.830822,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 18,
      "punto": 94,
      "latitudeE7": 5.370451,
      "longitudeE7": -71.830784,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 18,
      "punto": 95,
      "latitudeE7": 5.370445,
      "longitudeE7": -71.830747,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 18,
      "punto": 96,
      "latitudeE7": 5.370439,
      "longitudeE7": -71.830709,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 18,
      "punto": 97,
      "latitudeE7": 5.370433,
      "longitudeE7": -71.830671,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 18,
      "punto": 98,
      "latitudeE7": 5.370427,
      "longitudeE7": -71.830633,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 18,
      "punto": 99,
      "latitudeE7": 5.370421,
      "longitudeE7": -71.830596,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 18,
      "punto": 100,
      "latitudeE7": 5.370415,
      "longitudeE7": -71.830558,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 18,
      "punto": 101,
      "latitudeE7": 5.370409,
      "longitudeE7": -71.83052,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 18,
      "punto": 102,
      "latitudeE7": 5.370403,
      "longitudeE7": -71.830483,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 18,
      "punto": 103,
      "latitudeE7": 5.370397,
      "longitudeE7": -71.830445,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 18,
      "punto": 104,
      "latitudeE7": 5.370391,
      "longitudeE7": -71.830407,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 18,
      "punto": 105,
      "latitudeE7": 5.370385,
      "longitudeE7": -71.830369,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 18,
      "punto": 106,
      "latitudeE7": 5.370379,
      "longitudeE7": -71.830332,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 18,
      "punto": 107,
      "latitudeE7": 5.370373,
      "longitudeE7": -71.830294,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 18,
      "punto": 108,
      "latitudeE7": 5.370367,
      "longitudeE7": -71.830256,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 18,
      "punto": 109,
      "latitudeE7": 5.370361,
      "longitudeE7": -71.830219,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 18,
      "punto": 110,
      "latitudeE7": 5.370355,
      "longitudeE7": -71.830181,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 18,
      "punto": 111,
      "latitudeE7": 5.370349,
      "longitudeE7": -71.830143,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 18,
      "punto": 112,
      "latitudeE7": 5.370343,
      "longitudeE7": -71.830105,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 18,
      "punto": 113,
      "latitudeE7": 5.370337,
      "longitudeE7": -71.830068,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 18,
      "punto": 114,
      "latitudeE7": 5.370331,
      "longitudeE7": -71.83003,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 19,
      "punto": 1,
      "latitudeE7": 5.370969,
      "longitudeE7": -71.834317,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 19,
      "punto": 2,
      "latitudeE7": 5.370963,
      "longitudeE7": -71.83428,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 19,
      "punto": 3,
      "latitudeE7": 5.370957,
      "longitudeE7": -71.834242,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 19,
      "punto": 4,
      "latitudeE7": 5.370951,
      "longitudeE7": -71.834204,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 19,
      "punto": 5,
      "latitudeE7": 5.370945,
      "longitudeE7": -71.834166,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 19,
      "punto": 6,
      "latitudeE7": 5.370939,
      "longitudeE7": -71.834129,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 19,
      "punto": 7,
      "latitudeE7": 5.370933,
      "longitudeE7": -71.834091,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 19,
      "punto": 8,
      "latitudeE7": 5.370927,
      "longitudeE7": -71.834053,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 19,
      "punto": 9,
      "latitudeE7": 5.370921,
      "longitudeE7": -71.834016,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 19,
      "punto": 10,
      "latitudeE7": 5.370915,
      "longitudeE7": -71.833978,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 19,
      "punto": 11,
      "latitudeE7": 5.370909,
      "longitudeE7": -71.83394,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 19,
      "punto": 12,
      "latitudeE7": 5.370903,
      "longitudeE7": -71.833902,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 19,
      "punto": 13,
      "latitudeE7": 5.370897,
      "longitudeE7": -71.833865,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 19,
      "punto": 14,
      "latitudeE7": 5.370891,
      "longitudeE7": -71.833827,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 19,
      "punto": 15,
      "latitudeE7": 5.370885,
      "longitudeE7": -71.833789,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 19,
      "punto": 16,
      "latitudeE7": 5.370879,
      "longitudeE7": -71.833751,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 19,
      "punto": 17,
      "latitudeE7": 5.370873,
      "longitudeE7": -71.833714,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 19,
      "punto": 18,
      "latitudeE7": 5.370867,
      "longitudeE7": -71.833676,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 19,
      "punto": 19,
      "latitudeE7": 5.370861,
      "longitudeE7": -71.833638,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 19,
      "punto": 20,
      "latitudeE7": 5.370855,
      "longitudeE7": -71.833601,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 19,
      "punto": 21,
      "latitudeE7": 5.370849,
      "longitudeE7": -71.833563,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 19,
      "punto": 22,
      "latitudeE7": 5.370843,
      "longitudeE7": -71.833525,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 19,
      "punto": 23,
      "latitudeE7": 5.370837,
      "longitudeE7": -71.833487,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 19,
      "punto": 24,
      "latitudeE7": 5.370831,
      "longitudeE7": -71.83345,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 19,
      "punto": 25,
      "latitudeE7": 5.370825,
      "longitudeE7": -71.833412,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 19,
      "punto": 26,
      "latitudeE7": 5.370819,
      "longitudeE7": -71.833374,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 19,
      "punto": 27,
      "latitudeE7": 5.370813,
      "longitudeE7": -71.833337,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 19,
      "punto": 28,
      "latitudeE7": 5.370807,
      "longitudeE7": -71.833299,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 19,
      "punto": 29,
      "latitudeE7": 5.370801,
      "longitudeE7": -71.833261,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 19,
      "punto": 30,
      "latitudeE7": 5.370795,
      "longitudeE7": -71.833223,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 19,
      "punto": 31,
      "latitudeE7": 5.370789,
      "longitudeE7": -71.833186,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 19,
      "punto": 32,
      "latitudeE7": 5.370783,
      "longitudeE7": -71.833148,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 19,
      "punto": 33,
      "latitudeE7": 5.370777,
      "longitudeE7": -71.83311,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 19,
      "punto": 34,
      "latitudeE7": 5.370771,
      "longitudeE7": -71.833073,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 19,
      "punto": 35,
      "latitudeE7": 5.370765,
      "longitudeE7": -71.833035,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 19,
      "punto": 36,
      "latitudeE7": 5.370759,
      "longitudeE7": -71.832997,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 19,
      "punto": 37,
      "latitudeE7": 5.370753,
      "longitudeE7": -71.832959,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 19,
      "punto": 38,
      "latitudeE7": 5.370747,
      "longitudeE7": -71.832922,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 19,
      "punto": 39,
      "latitudeE7": 5.370741,
      "longitudeE7": -71.832884,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 19,
      "punto": 40,
      "latitudeE7": 5.370735,
      "longitudeE7": -71.832846,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 19,
      "punto": 41,
      "latitudeE7": 5.370729,
      "longitudeE7": -71.832808,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 19,
      "punto": 42,
      "latitudeE7": 5.370723,
      "longitudeE7": -71.832771,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 19,
      "punto": 43,
      "latitudeE7": 5.370717,
      "longitudeE7": -71.832733,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 19,
      "punto": 44,
      "latitudeE7": 5.370711,
      "longitudeE7": -71.832695,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 19,
      "punto": 45,
      "latitudeE7": 5.370705,
      "longitudeE7": -71.832658,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 19,
      "punto": 46,
      "latitudeE7": 5.370699,
      "longitudeE7": -71.83262,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 19,
      "punto": 47,
      "latitudeE7": 5.370693,
      "longitudeE7": -71.832582,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 19,
      "punto": 48,
      "latitudeE7": 5.370687,
      "longitudeE7": -71.832544,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 19,
      "punto": 49,
      "latitudeE7": 5.370681,
      "longitudeE7": -71.832507,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 19,
      "punto": 50,
      "latitudeE7": 5.370675,
      "longitudeE7": -71.832469,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 19,
      "punto": 51,
      "latitudeE7": 5.370669,
      "longitudeE7": -71.832431,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 19,
      "punto": 52,
      "latitudeE7": 5.370663,
      "longitudeE7": -71.832394,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 19,
      "punto": 53,
      "latitudeE7": 5.370657,
      "longitudeE7": -71.832356,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 19,
      "punto": 54,
      "latitudeE7": 5.370651,
      "longitudeE7": -71.832318,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 19,
      "punto": 55,
      "latitudeE7": 5.370645,
      "longitudeE7": -71.83228,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 19,
      "punto": 56,
      "latitudeE7": 5.370639,
      "longitudeE7": -71.832243,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 19,
      "punto": 57,
      "latitudeE7": 5.370633,
      "longitudeE7": -71.832205,
      "accuracy": 15,
      "porcentaje": 0.4
    },
    {
      "linea": 19,
      "punto": 58,
      "latitudeE7": 5.370627,
      "longitudeE7": -71.832167,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 19,
      "punto": 59,
      "latitudeE7": 5.370621,
      "longitudeE7": -71.83213,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 19,
      "punto": 60,
      "latitudeE7": 5.370615,
      "longitudeE7": -71.832092,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 19,
      "punto": 61,
      "latitudeE7": 5.370609,
      "longitudeE7": -71.832054,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 19,
      "punto": 62,
      "latitudeE7": 5.370603,
      "longitudeE7": -71.832016,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 19,
      "punto": 63,
      "latitudeE7": 5.370597,
      "longitudeE7": -71.831979,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 19,
      "punto": 64,
      "latitudeE7": 5.370591,
      "longitudeE7": -71.831941,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 19,
      "punto": 65,
      "latitudeE7": 5.370585,
      "longitudeE7": -71.831903,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 19,
      "punto": 66,
      "latitudeE7": 5.370579,
      "longitudeE7": -71.831865,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 19,
      "punto": 67,
      "latitudeE7": 5.370573,
      "longitudeE7": -71.831828,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 19,
      "punto": 68,
      "latitudeE7": 5.370567,
      "longitudeE7": -71.83179,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 19,
      "punto": 69,
      "latitudeE7": 5.370561,
      "longitudeE7": -71.831752,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 19,
      "punto": 70,
      "latitudeE7": 5.370555,
      "longitudeE7": -71.831715,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 19,
      "punto": 71,
      "latitudeE7": 5.370549,
      "longitudeE7": -71.831677,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 19,
      "punto": 72,
      "latitudeE7": 5.370543,
      "longitudeE7": -71.831639,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 19,
      "punto": 73,
      "latitudeE7": 5.370537,
      "longitudeE7": -71.831601,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 19,
      "punto": 74,
      "latitudeE7": 5.370531,
      "longitudeE7": -71.831564,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 19,
      "punto": 75,
      "latitudeE7": 5.370525,
      "longitudeE7": -71.831526,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 19,
      "punto": 76,
      "latitudeE7": 5.370519,
      "longitudeE7": -71.831488,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 19,
      "punto": 77,
      "latitudeE7": 5.370513,
      "longitudeE7": -71.831451,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 19,
      "punto": 78,
      "latitudeE7": 5.370507,
      "longitudeE7": -71.831413,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 19,
      "punto": 79,
      "latitudeE7": 5.370501,
      "longitudeE7": -71.831375,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 19,
      "punto": 80,
      "latitudeE7": 5.370495,
      "longitudeE7": -71.831337,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 19,
      "punto": 81,
      "latitudeE7": 5.370489,
      "longitudeE7": -71.8313,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 19,
      "punto": 82,
      "latitudeE7": 5.370483,
      "longitudeE7": -71.831262,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 19,
      "punto": 83,
      "latitudeE7": 5.370477,
      "longitudeE7": -71.831224,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 19,
      "punto": 84,
      "latitudeE7": 5.370471,
      "longitudeE7": -71.831187,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 19,
      "punto": 85,
      "latitudeE7": 5.370465,
      "longitudeE7": -71.831149,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 19,
      "punto": 86,
      "latitudeE7": 5.370459,
      "longitudeE7": -71.831111,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 19,
      "punto": 87,
      "latitudeE7": 5.370453,
      "longitudeE7": -71.831073,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 19,
      "punto": 88,
      "latitudeE7": 5.370447,
      "longitudeE7": -71.831036,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 19,
      "punto": 89,
      "latitudeE7": 5.370441,
      "longitudeE7": -71.830998,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 19,
      "punto": 90,
      "latitudeE7": 5.370435,
      "longitudeE7": -71.83096,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 19,
      "punto": 91,
      "latitudeE7": 5.370429,
      "longitudeE7": -71.830922,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 19,
      "punto": 92,
      "latitudeE7": 5.370423,
      "longitudeE7": -71.830885,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 19,
      "punto": 93,
      "latitudeE7": 5.370417,
      "longitudeE7": -71.830847,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 19,
      "punto": 94,
      "latitudeE7": 5.370411,
      "longitudeE7": -71.830809,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 19,
      "punto": 95,
      "latitudeE7": 5.370405,
      "longitudeE7": -71.830772,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 19,
      "punto": 96,
      "latitudeE7": 5.370399,
      "longitudeE7": -71.830734,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 19,
      "punto": 97,
      "latitudeE7": 5.370393,
      "longitudeE7": -71.830696,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 19,
      "punto": 98,
      "latitudeE7": 5.370387,
      "longitudeE7": -71.830658,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 19,
      "punto": 99,
      "latitudeE7": 5.370381,
      "longitudeE7": -71.830621,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 19,
      "punto": 100,
      "latitudeE7": 5.370375,
      "longitudeE7": -71.830583,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 19,
      "punto": 101,
      "latitudeE7": 5.370369,
      "longitudeE7": -71.830545,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 19,
      "punto": 102,
      "latitudeE7": 5.370363,
      "longitudeE7": -71.830508,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 19,
      "punto": 103,
      "latitudeE7": 5.370357,
      "longitudeE7": -71.83047,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 19,
      "punto": 104,
      "latitudeE7": 5.370351,
      "longitudeE7": -71.830432,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 19,
      "punto": 105,
      "latitudeE7": 5.370345,
      "longitudeE7": -71.830394,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 19,
      "punto": 106,
      "latitudeE7": 5.370339,
      "longitudeE7": -71.830357,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 19,
      "punto": 107,
      "latitudeE7": 5.370333,
      "longitudeE7": -71.830319,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 19,
      "punto": 108,
      "latitudeE7": 5.370327,
      "longitudeE7": -71.830281,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 19,
      "punto": 109,
      "latitudeE7": 5.370321,
      "longitudeE7": -71.830244,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 19,
      "punto": 110,
      "latitudeE7": 5.370315,
      "longitudeE7": -71.830206,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 19,
      "punto": 111,
      "latitudeE7": 5.370309,
      "longitudeE7": -71.830168,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 19,
      "punto": 112,
      "latitudeE7": 5.370303,
      "longitudeE7": -71.83013,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 19,
      "punto": 113,
      "latitudeE7": 5.370297,
      "longitudeE7": -71.830093,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 19,
      "punto": 114,
      "latitudeE7": 5.370291,
      "longitudeE7": -71.830055,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 20,
      "punto": 1,
      "latitudeE7": 5.370929,
      "longitudeE7": -71.834342,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 20,
      "punto": 2,
      "latitudeE7": 5.370923,
      "longitudeE7": -71.834305,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 20,
      "punto": 3,
      "latitudeE7": 5.370917,
      "longitudeE7": -71.834267,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 20,
      "punto": 4,
      "latitudeE7": 5.370911,
      "longitudeE7": -71.834229,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 20,
      "punto": 5,
      "latitudeE7": 5.370905,
      "longitudeE7": -71.834191,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 20,
      "punto": 6,
      "latitudeE7": 5.370899,
      "longitudeE7": -71.834154,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 20,
      "punto": 7,
      "latitudeE7": 5.370893,
      "longitudeE7": -71.834116,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 20,
      "punto": 8,
      "latitudeE7": 5.370887,
      "longitudeE7": -71.834078,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 20,
      "punto": 9,
      "latitudeE7": 5.370881,
      "longitudeE7": -71.83404,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 20,
      "punto": 10,
      "latitudeE7": 5.370875,
      "longitudeE7": -71.834003,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 20,
      "punto": 11,
      "latitudeE7": 5.370869,
      "longitudeE7": -71.833965,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 20,
      "punto": 12,
      "latitudeE7": 5.370863,
      "longitudeE7": -71.833927,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 20,
      "punto": 13,
      "latitudeE7": 5.370857,
      "longitudeE7": -71.83389,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 20,
      "punto": 14,
      "latitudeE7": 5.370851,
      "longitudeE7": -71.833852,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 20,
      "punto": 15,
      "latitudeE7": 5.370845,
      "longitudeE7": -71.833814,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 20,
      "punto": 16,
      "latitudeE7": 5.370839,
      "longitudeE7": -71.833776,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 20,
      "punto": 17,
      "latitudeE7": 5.370833,
      "longitudeE7": -71.833739,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 20,
      "punto": 18,
      "latitudeE7": 5.370827,
      "longitudeE7": -71.833701,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 20,
      "punto": 19,
      "latitudeE7": 5.370821,
      "longitudeE7": -71.833663,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 20,
      "punto": 20,
      "latitudeE7": 5.370815,
      "longitudeE7": -71.833626,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 20,
      "punto": 21,
      "latitudeE7": 5.370809,
      "longitudeE7": -71.833588,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 20,
      "punto": 22,
      "latitudeE7": 5.370803,
      "longitudeE7": -71.83355,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 20,
      "punto": 23,
      "latitudeE7": 5.370797,
      "longitudeE7": -71.833512,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 20,
      "punto": 24,
      "latitudeE7": 5.370791,
      "longitudeE7": -71.833475,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 20,
      "punto": 25,
      "latitudeE7": 5.370785,
      "longitudeE7": -71.833437,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 20,
      "punto": 26,
      "latitudeE7": 5.370779,
      "longitudeE7": -71.833399,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 20,
      "punto": 27,
      "latitudeE7": 5.370773,
      "longitudeE7": -71.833362,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 20,
      "punto": 28,
      "latitudeE7": 5.370767,
      "longitudeE7": -71.833324,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 20,
      "punto": 29,
      "latitudeE7": 5.370761,
      "longitudeE7": -71.833286,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 20,
      "punto": 30,
      "latitudeE7": 5.370755,
      "longitudeE7": -71.833248,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 20,
      "punto": 31,
      "latitudeE7": 5.370749,
      "longitudeE7": -71.833211,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 20,
      "punto": 32,
      "latitudeE7": 5.370743,
      "longitudeE7": -71.833173,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 20,
      "punto": 33,
      "latitudeE7": 5.370737,
      "longitudeE7": -71.833135,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 20,
      "punto": 34,
      "latitudeE7": 5.370731,
      "longitudeE7": -71.833097,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 20,
      "punto": 35,
      "latitudeE7": 5.370725,
      "longitudeE7": -71.83306,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 20,
      "punto": 36,
      "latitudeE7": 5.370719,
      "longitudeE7": -71.833022,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 20,
      "punto": 37,
      "latitudeE7": 5.370713,
      "longitudeE7": -71.832984,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 20,
      "punto": 38,
      "latitudeE7": 5.370707,
      "longitudeE7": -71.832947,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 20,
      "punto": 39,
      "latitudeE7": 5.370701,
      "longitudeE7": -71.832909,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 20,
      "punto": 40,
      "latitudeE7": 5.370695,
      "longitudeE7": -71.832871,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 20,
      "punto": 41,
      "latitudeE7": 5.370689,
      "longitudeE7": -71.832833,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 20,
      "punto": 42,
      "latitudeE7": 5.370683,
      "longitudeE7": -71.832796,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 20,
      "punto": 43,
      "latitudeE7": 5.370677,
      "longitudeE7": -71.832758,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 20,
      "punto": 44,
      "latitudeE7": 5.370671,
      "longitudeE7": -71.83272,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 20,
      "punto": 45,
      "latitudeE7": 5.370665,
      "longitudeE7": -71.832683,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 20,
      "punto": 46,
      "latitudeE7": 5.370659,
      "longitudeE7": -71.832645,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 20,
      "punto": 47,
      "latitudeE7": 5.370653,
      "longitudeE7": -71.832607,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 20,
      "punto": 48,
      "latitudeE7": 5.370647,
      "longitudeE7": -71.832569,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 20,
      "punto": 49,
      "latitudeE7": 5.370641,
      "longitudeE7": -71.832532,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 20,
      "punto": 50,
      "latitudeE7": 5.370635,
      "longitudeE7": -71.832494,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 20,
      "punto": 51,
      "latitudeE7": 5.370629,
      "longitudeE7": -71.832456,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 20,
      "punto": 52,
      "latitudeE7": 5.370623,
      "longitudeE7": -71.832419,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 20,
      "punto": 53,
      "latitudeE7": 5.370617,
      "longitudeE7": -71.832381,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 20,
      "punto": 54,
      "latitudeE7": 5.370611,
      "longitudeE7": -71.832343,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 20,
      "punto": 55,
      "latitudeE7": 5.370605,
      "longitudeE7": -71.832305,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 20,
      "punto": 56,
      "latitudeE7": 5.370599,
      "longitudeE7": -71.832268,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 20,
      "punto": 57,
      "latitudeE7": 5.370593,
      "longitudeE7": -71.83223,
      "accuracy": 15,
      "porcentaje": 0.24
    },
    {
      "linea": 20,
      "punto": 58,
      "latitudeE7": 5.370587,
      "longitudeE7": -71.832192,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 20,
      "punto": 59,
      "latitudeE7": 5.370581,
      "longitudeE7": -71.832154,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 20,
      "punto": 60,
      "latitudeE7": 5.370575,
      "longitudeE7": -71.832117,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 20,
      "punto": 61,
      "latitudeE7": 5.370569,
      "longitudeE7": -71.832079,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 20,
      "punto": 62,
      "latitudeE7": 5.370563,
      "longitudeE7": -71.832041,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 20,
      "punto": 63,
      "latitudeE7": 5.370557,
      "longitudeE7": -71.832004,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 20,
      "punto": 64,
      "latitudeE7": 5.370551,
      "longitudeE7": -71.831966,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 20,
      "punto": 65,
      "latitudeE7": 5.370545,
      "longitudeE7": -71.831928,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 20,
      "punto": 66,
      "latitudeE7": 5.370539,
      "longitudeE7": -71.83189,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 20,
      "punto": 67,
      "latitudeE7": 5.370533,
      "longitudeE7": -71.831853,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 20,
      "punto": 68,
      "latitudeE7": 5.370527,
      "longitudeE7": -71.831815,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 20,
      "punto": 69,
      "latitudeE7": 5.370521,
      "longitudeE7": -71.831777,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 20,
      "punto": 70,
      "latitudeE7": 5.370515,
      "longitudeE7": -71.83174,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 20,
      "punto": 71,
      "latitudeE7": 5.370509,
      "longitudeE7": -71.831702,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 20,
      "punto": 72,
      "latitudeE7": 5.370503,
      "longitudeE7": -71.831664,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 20,
      "punto": 73,
      "latitudeE7": 5.370497,
      "longitudeE7": -71.831626,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 20,
      "punto": 74,
      "latitudeE7": 5.370491,
      "longitudeE7": -71.831589,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 20,
      "punto": 75,
      "latitudeE7": 5.370485,
      "longitudeE7": -71.831551,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 20,
      "punto": 76,
      "latitudeE7": 5.370479,
      "longitudeE7": -71.831513,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 20,
      "punto": 77,
      "latitudeE7": 5.370473,
      "longitudeE7": -71.831476,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 20,
      "punto": 78,
      "latitudeE7": 5.370467,
      "longitudeE7": -71.831438,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 20,
      "punto": 79,
      "latitudeE7": 5.370461,
      "longitudeE7": -71.8314,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 20,
      "punto": 80,
      "latitudeE7": 5.370455,
      "longitudeE7": -71.831362,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 20,
      "punto": 81,
      "latitudeE7": 5.370449,
      "longitudeE7": -71.831325,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 20,
      "punto": 82,
      "latitudeE7": 5.370443,
      "longitudeE7": -71.831287,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 20,
      "punto": 83,
      "latitudeE7": 5.370437,
      "longitudeE7": -71.831249,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 20,
      "punto": 84,
      "latitudeE7": 5.370431,
      "longitudeE7": -71.831211,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 20,
      "punto": 85,
      "latitudeE7": 5.370425,
      "longitudeE7": -71.831174,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 20,
      "punto": 86,
      "latitudeE7": 5.370419,
      "longitudeE7": -71.831136,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 20,
      "punto": 87,
      "latitudeE7": 5.370413,
      "longitudeE7": -71.831098,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 20,
      "punto": 88,
      "latitudeE7": 5.370407,
      "longitudeE7": -71.831061,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 20,
      "punto": 89,
      "latitudeE7": 5.370401,
      "longitudeE7": -71.831023,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 20,
      "punto": 90,
      "latitudeE7": 5.370395,
      "longitudeE7": -71.830985,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 20,
      "punto": 91,
      "latitudeE7": 5.370389,
      "longitudeE7": -71.830947,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 20,
      "punto": 92,
      "latitudeE7": 5.370383,
      "longitudeE7": -71.83091,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 20,
      "punto": 93,
      "latitudeE7": 5.370377,
      "longitudeE7": -71.830872,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 20,
      "punto": 94,
      "latitudeE7": 5.370371,
      "longitudeE7": -71.830834,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 20,
      "punto": 95,
      "latitudeE7": 5.370365,
      "longitudeE7": -71.830797,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 20,
      "punto": 96,
      "latitudeE7": 5.370359,
      "longitudeE7": -71.830759,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 20,
      "punto": 97,
      "latitudeE7": 5.370353,
      "longitudeE7": -71.830721,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 20,
      "punto": 98,
      "latitudeE7": 5.370347,
      "longitudeE7": -71.830683,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 20,
      "punto": 99,
      "latitudeE7": 5.370341,
      "longitudeE7": -71.830646,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 20,
      "punto": 100,
      "latitudeE7": 5.370335,
      "longitudeE7": -71.830608,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 20,
      "punto": 101,
      "latitudeE7": 5.370329,
      "longitudeE7": -71.83057,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 20,
      "punto": 102,
      "latitudeE7": 5.370323,
      "longitudeE7": -71.830533,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 20,
      "punto": 103,
      "latitudeE7": 5.370317,
      "longitudeE7": -71.830495,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 20,
      "punto": 104,
      "latitudeE7": 5.370311,
      "longitudeE7": -71.830457,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 20,
      "punto": 105,
      "latitudeE7": 5.370305,
      "longitudeE7": -71.830419,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 20,
      "punto": 106,
      "latitudeE7": 5.370299,
      "longitudeE7": -71.830382,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 20,
      "punto": 107,
      "latitudeE7": 5.370293,
      "longitudeE7": -71.830344,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 20,
      "punto": 108,
      "latitudeE7": 5.370287,
      "longitudeE7": -71.830306,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 20,
      "punto": 109,
      "latitudeE7": 5.370281,
      "longitudeE7": -71.830268,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 20,
      "punto": 110,
      "latitudeE7": 5.370275,
      "longitudeE7": -71.830231,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 20,
      "punto": 111,
      "latitudeE7": 5.370269,
      "longitudeE7": -71.830193,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 20,
      "punto": 112,
      "latitudeE7": 5.370263,
      "longitudeE7": -71.830155,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 20,
      "punto": 113,
      "latitudeE7": 5.370257,
      "longitudeE7": -71.830118,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 20,
      "punto": 114,
      "latitudeE7": 5.370251,
      "longitudeE7": -71.83008,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 21,
      "punto": 1,
      "latitudeE7": 5.370889,
      "longitudeE7": -71.834367,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 21,
      "punto": 2,
      "latitudeE7": 5.370883,
      "longitudeE7": -71.834329,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 21,
      "punto": 3,
      "latitudeE7": 5.370877,
      "longitudeE7": -71.834292,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 21,
      "punto": 4,
      "latitudeE7": 5.370871,
      "longitudeE7": -71.834254,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 21,
      "punto": 5,
      "latitudeE7": 5.370865,
      "longitudeE7": -71.834216,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 21,
      "punto": 6,
      "latitudeE7": 5.370859,
      "longitudeE7": -71.834179,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 21,
      "punto": 7,
      "latitudeE7": 5.370853,
      "longitudeE7": -71.834141,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 21,
      "punto": 8,
      "latitudeE7": 5.370847,
      "longitudeE7": -71.834103,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 21,
      "punto": 9,
      "latitudeE7": 5.370841,
      "longitudeE7": -71.834065,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 21,
      "punto": 10,
      "latitudeE7": 5.370835,
      "longitudeE7": -71.834028,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 21,
      "punto": 11,
      "latitudeE7": 5.370829,
      "longitudeE7": -71.83399,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 21,
      "punto": 12,
      "latitudeE7": 5.370823,
      "longitudeE7": -71.833952,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 21,
      "punto": 13,
      "latitudeE7": 5.370817,
      "longitudeE7": -71.833915,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 21,
      "punto": 14,
      "latitudeE7": 5.370811,
      "longitudeE7": -71.833877,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 21,
      "punto": 15,
      "latitudeE7": 5.370805,
      "longitudeE7": -71.833839,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 21,
      "punto": 16,
      "latitudeE7": 5.370799,
      "longitudeE7": -71.833801,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 21,
      "punto": 17,
      "latitudeE7": 5.370793,
      "longitudeE7": -71.833764,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 21,
      "punto": 18,
      "latitudeE7": 5.370787,
      "longitudeE7": -71.833726,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 21,
      "punto": 19,
      "latitudeE7": 5.370781,
      "longitudeE7": -71.833688,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 21,
      "punto": 20,
      "latitudeE7": 5.370775,
      "longitudeE7": -71.833651,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 21,
      "punto": 21,
      "latitudeE7": 5.370769,
      "longitudeE7": -71.833613,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 21,
      "punto": 22,
      "latitudeE7": 5.370763,
      "longitudeE7": -71.833575,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 21,
      "punto": 23,
      "latitudeE7": 5.370757,
      "longitudeE7": -71.833537,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 21,
      "punto": 24,
      "latitudeE7": 5.370751,
      "longitudeE7": -71.8335,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 21,
      "punto": 25,
      "latitudeE7": 5.370745,
      "longitudeE7": -71.833462,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 21,
      "punto": 26,
      "latitudeE7": 5.370739,
      "longitudeE7": -71.833424,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 21,
      "punto": 27,
      "latitudeE7": 5.370733,
      "longitudeE7": -71.833386,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 21,
      "punto": 28,
      "latitudeE7": 5.370727,
      "longitudeE7": -71.833349,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 21,
      "punto": 29,
      "latitudeE7": 5.370721,
      "longitudeE7": -71.833311,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 21,
      "punto": 30,
      "latitudeE7": 5.370715,
      "longitudeE7": -71.833273,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 21,
      "punto": 31,
      "latitudeE7": 5.370709,
      "longitudeE7": -71.833236,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 21,
      "punto": 32,
      "latitudeE7": 5.370703,
      "longitudeE7": -71.833198,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 21,
      "punto": 33,
      "latitudeE7": 5.370697,
      "longitudeE7": -71.83316,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 21,
      "punto": 34,
      "latitudeE7": 5.370691,
      "longitudeE7": -71.833122,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 21,
      "punto": 35,
      "latitudeE7": 5.370685,
      "longitudeE7": -71.833085,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 21,
      "punto": 36,
      "latitudeE7": 5.370679,
      "longitudeE7": -71.833047,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 21,
      "punto": 37,
      "latitudeE7": 5.370673,
      "longitudeE7": -71.833009,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 21,
      "punto": 38,
      "latitudeE7": 5.370667,
      "longitudeE7": -71.832972,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 21,
      "punto": 39,
      "latitudeE7": 5.370661,
      "longitudeE7": -71.832934,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 21,
      "punto": 40,
      "latitudeE7": 5.370655,
      "longitudeE7": -71.832896,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 21,
      "punto": 41,
      "latitudeE7": 5.370649,
      "longitudeE7": -71.832858,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 21,
      "punto": 42,
      "latitudeE7": 5.370643,
      "longitudeE7": -71.832821,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 21,
      "punto": 43,
      "latitudeE7": 5.370637,
      "longitudeE7": -71.832783,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 21,
      "punto": 44,
      "latitudeE7": 5.370631,
      "longitudeE7": -71.832745,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 21,
      "punto": 45,
      "latitudeE7": 5.370625,
      "longitudeE7": -71.832708,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 21,
      "punto": 46,
      "latitudeE7": 5.370619,
      "longitudeE7": -71.83267,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 21,
      "punto": 47,
      "latitudeE7": 5.370613,
      "longitudeE7": -71.832632,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 21,
      "punto": 48,
      "latitudeE7": 5.370607,
      "longitudeE7": -71.832594,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 21,
      "punto": 49,
      "latitudeE7": 5.370601,
      "longitudeE7": -71.832557,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 21,
      "punto": 50,
      "latitudeE7": 5.370595,
      "longitudeE7": -71.832519,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 21,
      "punto": 51,
      "latitudeE7": 5.370589,
      "longitudeE7": -71.832481,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 21,
      "punto": 52,
      "latitudeE7": 5.370583,
      "longitudeE7": -71.832443,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 21,
      "punto": 53,
      "latitudeE7": 5.370577,
      "longitudeE7": -71.832406,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 21,
      "punto": 54,
      "latitudeE7": 5.370571,
      "longitudeE7": -71.832368,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 21,
      "punto": 55,
      "latitudeE7": 5.370565,
      "longitudeE7": -71.83233,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 21,
      "punto": 56,
      "latitudeE7": 5.370559,
      "longitudeE7": -71.832293,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 21,
      "punto": 57,
      "latitudeE7": 5.370553,
      "longitudeE7": -71.832255,
      "accuracy": 15,
      "porcentaje": 0.08
    },
    {
      "linea": 21,
      "punto": 58,
      "latitudeE7": 5.370547,
      "longitudeE7": -71.832217,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 21,
      "punto": 59,
      "latitudeE7": 5.370541,
      "longitudeE7": -71.832179,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 21,
      "punto": 60,
      "latitudeE7": 5.370535,
      "longitudeE7": -71.832142,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 21,
      "punto": 61,
      "latitudeE7": 5.370529,
      "longitudeE7": -71.832104,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 21,
      "punto": 62,
      "latitudeE7": 5.370523,
      "longitudeE7": -71.832066,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 21,
      "punto": 63,
      "latitudeE7": 5.370517,
      "longitudeE7": -71.832029,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 21,
      "punto": 64,
      "latitudeE7": 5.370511,
      "longitudeE7": -71.831991,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 21,
      "punto": 65,
      "latitudeE7": 5.370505,
      "longitudeE7": -71.831953,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 21,
      "punto": 66,
      "latitudeE7": 5.370499,
      "longitudeE7": -71.831915,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 21,
      "punto": 67,
      "latitudeE7": 5.370493,
      "longitudeE7": -71.831878,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 21,
      "punto": 68,
      "latitudeE7": 5.370487,
      "longitudeE7": -71.83184,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 21,
      "punto": 69,
      "latitudeE7": 5.370481,
      "longitudeE7": -71.831802,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 21,
      "punto": 70,
      "latitudeE7": 5.370475,
      "longitudeE7": -71.831765,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 21,
      "punto": 71,
      "latitudeE7": 5.370469,
      "longitudeE7": -71.831727,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 21,
      "punto": 72,
      "latitudeE7": 5.370463,
      "longitudeE7": -71.831689,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 21,
      "punto": 73,
      "latitudeE7": 5.370457,
      "longitudeE7": -71.831651,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 21,
      "punto": 74,
      "latitudeE7": 5.370451,
      "longitudeE7": -71.831614,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 21,
      "punto": 75,
      "latitudeE7": 5.370445,
      "longitudeE7": -71.831576,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 21,
      "punto": 76,
      "latitudeE7": 5.370439,
      "longitudeE7": -71.831538,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 21,
      "punto": 77,
      "latitudeE7": 5.370433,
      "longitudeE7": -71.8315,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 21,
      "punto": 78,
      "latitudeE7": 5.370427,
      "longitudeE7": -71.831463,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 21,
      "punto": 79,
      "latitudeE7": 5.370421,
      "longitudeE7": -71.831425,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 21,
      "punto": 80,
      "latitudeE7": 5.370415,
      "longitudeE7": -71.831387,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 21,
      "punto": 81,
      "latitudeE7": 5.370409,
      "longitudeE7": -71.83135,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 21,
      "punto": 82,
      "latitudeE7": 5.370403,
      "longitudeE7": -71.831312,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 21,
      "punto": 83,
      "latitudeE7": 5.370397,
      "longitudeE7": -71.831274,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 21,
      "punto": 84,
      "latitudeE7": 5.370391,
      "longitudeE7": -71.831236,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 21,
      "punto": 85,
      "latitudeE7": 5.370385,
      "longitudeE7": -71.831199,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 21,
      "punto": 86,
      "latitudeE7": 5.370379,
      "longitudeE7": -71.831161,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 21,
      "punto": 87,
      "latitudeE7": 5.370373,
      "longitudeE7": -71.831123,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 21,
      "punto": 88,
      "latitudeE7": 5.370367,
      "longitudeE7": -71.831086,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 21,
      "punto": 89,
      "latitudeE7": 5.370361,
      "longitudeE7": -71.831048,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 21,
      "punto": 90,
      "latitudeE7": 5.370355,
      "longitudeE7": -71.83101,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 21,
      "punto": 91,
      "latitudeE7": 5.370349,
      "longitudeE7": -71.830972,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 21,
      "punto": 92,
      "latitudeE7": 5.370343,
      "longitudeE7": -71.830935,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 21,
      "punto": 93,
      "latitudeE7": 5.370337,
      "longitudeE7": -71.830897,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 21,
      "punto": 94,
      "latitudeE7": 5.370331,
      "longitudeE7": -71.830859,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 21,
      "punto": 95,
      "latitudeE7": 5.370325,
      "longitudeE7": -71.830822,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 21,
      "punto": 96,
      "latitudeE7": 5.370319,
      "longitudeE7": -71.830784,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 21,
      "punto": 97,
      "latitudeE7": 5.370313,
      "longitudeE7": -71.830746,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 21,
      "punto": 98,
      "latitudeE7": 5.370307,
      "longitudeE7": -71.830708,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 21,
      "punto": 99,
      "latitudeE7": 5.370301,
      "longitudeE7": -71.830671,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 21,
      "punto": 100,
      "latitudeE7": 5.370295,
      "longitudeE7": -71.830633,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 21,
      "punto": 101,
      "latitudeE7": 5.370289,
      "longitudeE7": -71.830595,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 21,
      "punto": 102,
      "latitudeE7": 5.370283,
      "longitudeE7": -71.830557,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 21,
      "punto": 103,
      "latitudeE7": 5.370277,
      "longitudeE7": -71.83052,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 21,
      "punto": 104,
      "latitudeE7": 5.370271,
      "longitudeE7": -71.830482,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 21,
      "punto": 105,
      "latitudeE7": 5.370265,
      "longitudeE7": -71.830444,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 21,
      "punto": 106,
      "latitudeE7": 5.370259,
      "longitudeE7": -71.830407,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 21,
      "punto": 107,
      "latitudeE7": 5.370253,
      "longitudeE7": -71.830369,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 21,
      "punto": 108,
      "latitudeE7": 5.370247,
      "longitudeE7": -71.830331,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 21,
      "punto": 109,
      "latitudeE7": 5.370241,
      "longitudeE7": -71.830293,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 21,
      "punto": 110,
      "latitudeE7": 5.370235,
      "longitudeE7": -71.830256,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 21,
      "punto": 111,
      "latitudeE7": 5.370229,
      "longitudeE7": -71.830218,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 21,
      "punto": 112,
      "latitudeE7": 5.370223,
      "longitudeE7": -71.83018,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 21,
      "punto": 113,
      "latitudeE7": 5.370217,
      "longitudeE7": -71.830143,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 21,
      "punto": 114,
      "latitudeE7": 5.370211,
      "longitudeE7": -71.830105,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 22,
      "punto": 1,
      "latitudeE7": 5.370849,
      "longitudeE7": -71.834392,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 22,
      "punto": 2,
      "latitudeE7": 5.370843,
      "longitudeE7": -71.834354,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 22,
      "punto": 3,
      "latitudeE7": 5.370837,
      "longitudeE7": -71.834317,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 22,
      "punto": 4,
      "latitudeE7": 5.370831,
      "longitudeE7": -71.834279,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 22,
      "punto": 5,
      "latitudeE7": 5.370825,
      "longitudeE7": -71.834241,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 22,
      "punto": 6,
      "latitudeE7": 5.370819,
      "longitudeE7": -71.834204,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 22,
      "punto": 7,
      "latitudeE7": 5.370813,
      "longitudeE7": -71.834166,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 22,
      "punto": 8,
      "latitudeE7": 5.370807,
      "longitudeE7": -71.834128,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 22,
      "punto": 9,
      "latitudeE7": 5.370801,
      "longitudeE7": -71.83409,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 22,
      "punto": 10,
      "latitudeE7": 5.370795,
      "longitudeE7": -71.834053,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 22,
      "punto": 11,
      "latitudeE7": 5.370789,
      "longitudeE7": -71.834015,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 22,
      "punto": 12,
      "latitudeE7": 5.370783,
      "longitudeE7": -71.833977,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 22,
      "punto": 13,
      "latitudeE7": 5.370777,
      "longitudeE7": -71.83394,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 22,
      "punto": 14,
      "latitudeE7": 5.370771,
      "longitudeE7": -71.833902,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 22,
      "punto": 15,
      "latitudeE7": 5.370765,
      "longitudeE7": -71.833864,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 22,
      "punto": 16,
      "latitudeE7": 5.370759,
      "longitudeE7": -71.833826,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 22,
      "punto": 17,
      "latitudeE7": 5.370753,
      "longitudeE7": -71.833789,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 22,
      "punto": 18,
      "latitudeE7": 5.370747,
      "longitudeE7": -71.833751,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 22,
      "punto": 19,
      "latitudeE7": 5.370741,
      "longitudeE7": -71.833713,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 22,
      "punto": 20,
      "latitudeE7": 5.370735,
      "longitudeE7": -71.833675,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 22,
      "punto": 21,
      "latitudeE7": 5.370729,
      "longitudeE7": -71.833638,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 22,
      "punto": 22,
      "latitudeE7": 5.370723,
      "longitudeE7": -71.8336,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 22,
      "punto": 23,
      "latitudeE7": 5.370717,
      "longitudeE7": -71.833562,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 22,
      "punto": 24,
      "latitudeE7": 5.370711,
      "longitudeE7": -71.833525,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 22,
      "punto": 25,
      "latitudeE7": 5.370705,
      "longitudeE7": -71.833487,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 22,
      "punto": 26,
      "latitudeE7": 5.370699,
      "longitudeE7": -71.833449,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 22,
      "punto": 27,
      "latitudeE7": 5.370693,
      "longitudeE7": -71.833411,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 22,
      "punto": 28,
      "latitudeE7": 5.370687,
      "longitudeE7": -71.833374,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 22,
      "punto": 29,
      "latitudeE7": 5.370681,
      "longitudeE7": -71.833336,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 22,
      "punto": 30,
      "latitudeE7": 5.370675,
      "longitudeE7": -71.833298,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 22,
      "punto": 31,
      "latitudeE7": 5.370669,
      "longitudeE7": -71.833261,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 22,
      "punto": 32,
      "latitudeE7": 5.370663,
      "longitudeE7": -71.833223,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 22,
      "punto": 33,
      "latitudeE7": 5.370657,
      "longitudeE7": -71.833185,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 22,
      "punto": 34,
      "latitudeE7": 5.370651,
      "longitudeE7": -71.833147,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 22,
      "punto": 35,
      "latitudeE7": 5.370645,
      "longitudeE7": -71.83311,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 22,
      "punto": 36,
      "latitudeE7": 5.370639,
      "longitudeE7": -71.833072,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 22,
      "punto": 37,
      "latitudeE7": 5.370633,
      "longitudeE7": -71.833034,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 22,
      "punto": 38,
      "latitudeE7": 5.370627,
      "longitudeE7": -71.832997,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 22,
      "punto": 39,
      "latitudeE7": 5.370621,
      "longitudeE7": -71.832959,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 22,
      "punto": 40,
      "latitudeE7": 5.370615,
      "longitudeE7": -71.832921,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 22,
      "punto": 41,
      "latitudeE7": 5.370609,
      "longitudeE7": -71.832883,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 22,
      "punto": 42,
      "latitudeE7": 5.370603,
      "longitudeE7": -71.832846,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 22,
      "punto": 43,
      "latitudeE7": 5.370597,
      "longitudeE7": -71.832808,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 22,
      "punto": 44,
      "latitudeE7": 5.370591,
      "longitudeE7": -71.83277,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 22,
      "punto": 45,
      "latitudeE7": 5.370585,
      "longitudeE7": -71.832732,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 22,
      "punto": 46,
      "latitudeE7": 5.370579,
      "longitudeE7": -71.832695,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 22,
      "punto": 47,
      "latitudeE7": 5.370573,
      "longitudeE7": -71.832657,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 22,
      "punto": 48,
      "latitudeE7": 5.370567,
      "longitudeE7": -71.832619,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 22,
      "punto": 49,
      "latitudeE7": 5.370561,
      "longitudeE7": -71.832582,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 22,
      "punto": 50,
      "latitudeE7": 5.370555,
      "longitudeE7": -71.832544,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 22,
      "punto": 51,
      "latitudeE7": 5.370549,
      "longitudeE7": -71.832506,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 22,
      "punto": 52,
      "latitudeE7": 5.370543,
      "longitudeE7": -71.832468,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 22,
      "punto": 53,
      "latitudeE7": 5.370537,
      "longitudeE7": -71.832431,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 22,
      "punto": 54,
      "latitudeE7": 5.370531,
      "longitudeE7": -71.832393,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 22,
      "punto": 55,
      "latitudeE7": 5.370525,
      "longitudeE7": -71.832355,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 22,
      "punto": 56,
      "latitudeE7": 5.370519,
      "longitudeE7": -71.832318,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 22,
      "punto": 57,
      "latitudeE7": 5.370513,
      "longitudeE7": -71.83228,
      "accuracy": 15,
      "porcentaje": 0.32
    },
    {
      "linea": 22,
      "punto": 58,
      "latitudeE7": 5.370507,
      "longitudeE7": -71.832242,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 22,
      "punto": 59,
      "latitudeE7": 5.370501,
      "longitudeE7": -71.832204,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 22,
      "punto": 60,
      "latitudeE7": 5.370495,
      "longitudeE7": -71.832167,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 22,
      "punto": 61,
      "latitudeE7": 5.370489,
      "longitudeE7": -71.832129,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 22,
      "punto": 62,
      "latitudeE7": 5.370483,
      "longitudeE7": -71.832091,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 22,
      "punto": 63,
      "latitudeE7": 5.370477,
      "longitudeE7": -71.832054,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 22,
      "punto": 64,
      "latitudeE7": 5.370471,
      "longitudeE7": -71.832016,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 22,
      "punto": 65,
      "latitudeE7": 5.370465,
      "longitudeE7": -71.831978,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 22,
      "punto": 66,
      "latitudeE7": 5.370459,
      "longitudeE7": -71.83194,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 22,
      "punto": 67,
      "latitudeE7": 5.370453,
      "longitudeE7": -71.831903,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 22,
      "punto": 68,
      "latitudeE7": 5.370447,
      "longitudeE7": -71.831865,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 22,
      "punto": 69,
      "latitudeE7": 5.370441,
      "longitudeE7": -71.831827,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 22,
      "punto": 70,
      "latitudeE7": 5.370435,
      "longitudeE7": -71.831789,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 22,
      "punto": 71,
      "latitudeE7": 5.370429,
      "longitudeE7": -71.831752,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 22,
      "punto": 72,
      "latitudeE7": 5.370423,
      "longitudeE7": -71.831714,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 22,
      "punto": 73,
      "latitudeE7": 5.370417,
      "longitudeE7": -71.831676,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 22,
      "punto": 74,
      "latitudeE7": 5.370411,
      "longitudeE7": -71.831639,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 22,
      "punto": 75,
      "latitudeE7": 5.370405,
      "longitudeE7": -71.831601,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 22,
      "punto": 76,
      "latitudeE7": 5.370399,
      "longitudeE7": -71.831563,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 22,
      "punto": 77,
      "latitudeE7": 5.370393,
      "longitudeE7": -71.831525,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 22,
      "punto": 78,
      "latitudeE7": 5.370387,
      "longitudeE7": -71.831488,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 22,
      "punto": 79,
      "latitudeE7": 5.370381,
      "longitudeE7": -71.83145,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 22,
      "punto": 80,
      "latitudeE7": 5.370375,
      "longitudeE7": -71.831412,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 22,
      "punto": 81,
      "latitudeE7": 5.370369,
      "longitudeE7": -71.831375,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 22,
      "punto": 82,
      "latitudeE7": 5.370363,
      "longitudeE7": -71.831337,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 22,
      "punto": 83,
      "latitudeE7": 5.370357,
      "longitudeE7": -71.831299,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 22,
      "punto": 84,
      "latitudeE7": 5.370351,
      "longitudeE7": -71.831261,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 22,
      "punto": 85,
      "latitudeE7": 5.370345,
      "longitudeE7": -71.831224,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 22,
      "punto": 86,
      "latitudeE7": 5.370339,
      "longitudeE7": -71.831186,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 22,
      "punto": 87,
      "latitudeE7": 5.370333,
      "longitudeE7": -71.831148,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 22,
      "punto": 88,
      "latitudeE7": 5.370327,
      "longitudeE7": -71.831111,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 22,
      "punto": 89,
      "latitudeE7": 5.370321,
      "longitudeE7": -71.831073,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 22,
      "punto": 90,
      "latitudeE7": 5.370315,
      "longitudeE7": -71.831035,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 22,
      "punto": 91,
      "latitudeE7": 5.370309,
      "longitudeE7": -71.830997,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 22,
      "punto": 92,
      "latitudeE7": 5.370303,
      "longitudeE7": -71.83096,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 22,
      "punto": 93,
      "latitudeE7": 5.370297,
      "longitudeE7": -71.830922,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 22,
      "punto": 94,
      "latitudeE7": 5.370291,
      "longitudeE7": -71.830884,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 22,
      "punto": 95,
      "latitudeE7": 5.370285,
      "longitudeE7": -71.830846,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 22,
      "punto": 96,
      "latitudeE7": 5.370279,
      "longitudeE7": -71.830809,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 22,
      "punto": 97,
      "latitudeE7": 5.370273,
      "longitudeE7": -71.830771,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 22,
      "punto": 98,
      "latitudeE7": 5.370267,
      "longitudeE7": -71.830733,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 22,
      "punto": 99,
      "latitudeE7": 5.370261,
      "longitudeE7": -71.830696,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 22,
      "punto": 100,
      "latitudeE7": 5.370255,
      "longitudeE7": -71.830658,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 22,
      "punto": 101,
      "latitudeE7": 5.370249,
      "longitudeE7": -71.83062,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 22,
      "punto": 102,
      "latitudeE7": 5.370243,
      "longitudeE7": -71.830582,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 22,
      "punto": 103,
      "latitudeE7": 5.370237,
      "longitudeE7": -71.830545,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 22,
      "punto": 104,
      "latitudeE7": 5.370231,
      "longitudeE7": -71.830507,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 22,
      "punto": 105,
      "latitudeE7": 5.370225,
      "longitudeE7": -71.830469,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 22,
      "punto": 106,
      "latitudeE7": 5.370219,
      "longitudeE7": -71.830432,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 22,
      "punto": 107,
      "latitudeE7": 5.370213,
      "longitudeE7": -71.830394,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 22,
      "punto": 108,
      "latitudeE7": 5.370207,
      "longitudeE7": -71.830356,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 22,
      "punto": 109,
      "latitudeE7": 5.370201,
      "longitudeE7": -71.830318,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 22,
      "punto": 110,
      "latitudeE7": 5.370195,
      "longitudeE7": -71.830281,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 22,
      "punto": 111,
      "latitudeE7": 5.370189,
      "longitudeE7": -71.830243,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 22,
      "punto": 112,
      "latitudeE7": 5.370183,
      "longitudeE7": -71.830205,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 22,
      "punto": 113,
      "latitudeE7": 5.370177,
      "longitudeE7": -71.830168,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 22,
      "punto": 114,
      "latitudeE7": 5.370171,
      "longitudeE7": -71.83013,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 23,
      "punto": 1,
      "latitudeE7": 5.370809,
      "longitudeE7": -71.834417,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 23,
      "punto": 2,
      "latitudeE7": 5.370803,
      "longitudeE7": -71.834379,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 23,
      "punto": 3,
      "latitudeE7": 5.370797,
      "longitudeE7": -71.834342,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 23,
      "punto": 4,
      "latitudeE7": 5.370791,
      "longitudeE7": -71.834304,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 23,
      "punto": 5,
      "latitudeE7": 5.370785,
      "longitudeE7": -71.834266,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 23,
      "punto": 6,
      "latitudeE7": 5.370779,
      "longitudeE7": -71.834229,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 23,
      "punto": 7,
      "latitudeE7": 5.370773,
      "longitudeE7": -71.834191,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 23,
      "punto": 8,
      "latitudeE7": 5.370767,
      "longitudeE7": -71.834153,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 23,
      "punto": 9,
      "latitudeE7": 5.370761,
      "longitudeE7": -71.834115,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 23,
      "punto": 10,
      "latitudeE7": 5.370755,
      "longitudeE7": -71.834078,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 23,
      "punto": 11,
      "latitudeE7": 5.370749,
      "longitudeE7": -71.83404,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 23,
      "punto": 12,
      "latitudeE7": 5.370743,
      "longitudeE7": -71.834002,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 23,
      "punto": 13,
      "latitudeE7": 5.370737,
      "longitudeE7": -71.833964,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 23,
      "punto": 14,
      "latitudeE7": 5.370731,
      "longitudeE7": -71.833927,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 23,
      "punto": 15,
      "latitudeE7": 5.370725,
      "longitudeE7": -71.833889,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 23,
      "punto": 16,
      "latitudeE7": 5.370719,
      "longitudeE7": -71.833851,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 23,
      "punto": 17,
      "latitudeE7": 5.370713,
      "longitudeE7": -71.833814,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 23,
      "punto": 18,
      "latitudeE7": 5.370707,
      "longitudeE7": -71.833776,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 23,
      "punto": 19,
      "latitudeE7": 5.370701,
      "longitudeE7": -71.833738,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 23,
      "punto": 20,
      "latitudeE7": 5.370695,
      "longitudeE7": -71.8337,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 23,
      "punto": 21,
      "latitudeE7": 5.370689,
      "longitudeE7": -71.833663,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 23,
      "punto": 22,
      "latitudeE7": 5.370683,
      "longitudeE7": -71.833625,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 23,
      "punto": 23,
      "latitudeE7": 5.370677,
      "longitudeE7": -71.833587,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 23,
      "punto": 24,
      "latitudeE7": 5.370671,
      "longitudeE7": -71.83355,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 23,
      "punto": 25,
      "latitudeE7": 5.370665,
      "longitudeE7": -71.833512,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 23,
      "punto": 26,
      "latitudeE7": 5.370659,
      "longitudeE7": -71.833474,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 23,
      "punto": 27,
      "latitudeE7": 5.370653,
      "longitudeE7": -71.833436,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 23,
      "punto": 28,
      "latitudeE7": 5.370647,
      "longitudeE7": -71.833399,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 23,
      "punto": 29,
      "latitudeE7": 5.370641,
      "longitudeE7": -71.833361,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 23,
      "punto": 30,
      "latitudeE7": 5.370635,
      "longitudeE7": -71.833323,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 23,
      "punto": 31,
      "latitudeE7": 5.370629,
      "longitudeE7": -71.833286,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 23,
      "punto": 32,
      "latitudeE7": 5.370623,
      "longitudeE7": -71.833248,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 23,
      "punto": 33,
      "latitudeE7": 5.370617,
      "longitudeE7": -71.83321,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 23,
      "punto": 34,
      "latitudeE7": 5.370611,
      "longitudeE7": -71.833172,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 23,
      "punto": 35,
      "latitudeE7": 5.370605,
      "longitudeE7": -71.833135,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 23,
      "punto": 36,
      "latitudeE7": 5.370599,
      "longitudeE7": -71.833097,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 23,
      "punto": 37,
      "latitudeE7": 5.370593,
      "longitudeE7": -71.833059,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 23,
      "punto": 38,
      "latitudeE7": 5.370587,
      "longitudeE7": -71.833021,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 23,
      "punto": 39,
      "latitudeE7": 5.370581,
      "longitudeE7": -71.832984,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 23,
      "punto": 40,
      "latitudeE7": 5.370575,
      "longitudeE7": -71.832946,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 23,
      "punto": 41,
      "latitudeE7": 5.370569,
      "longitudeE7": -71.832908,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 23,
      "punto": 42,
      "latitudeE7": 5.370563,
      "longitudeE7": -71.832871,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 23,
      "punto": 43,
      "latitudeE7": 5.370557,
      "longitudeE7": -71.832833,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 23,
      "punto": 44,
      "latitudeE7": 5.370551,
      "longitudeE7": -71.832795,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 23,
      "punto": 45,
      "latitudeE7": 5.370545,
      "longitudeE7": -71.832757,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 23,
      "punto": 46,
      "latitudeE7": 5.370539,
      "longitudeE7": -71.83272,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 23,
      "punto": 47,
      "latitudeE7": 5.370533,
      "longitudeE7": -71.832682,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 23,
      "punto": 48,
      "latitudeE7": 5.370527,
      "longitudeE7": -71.832644,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 23,
      "punto": 49,
      "latitudeE7": 5.370521,
      "longitudeE7": -71.832607,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 23,
      "punto": 50,
      "latitudeE7": 5.370515,
      "longitudeE7": -71.832569,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 23,
      "punto": 51,
      "latitudeE7": 5.370509,
      "longitudeE7": -71.832531,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 23,
      "punto": 52,
      "latitudeE7": 5.370503,
      "longitudeE7": -71.832493,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 23,
      "punto": 53,
      "latitudeE7": 5.370497,
      "longitudeE7": -71.832456,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 23,
      "punto": 54,
      "latitudeE7": 5.370491,
      "longitudeE7": -71.832418,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 23,
      "punto": 55,
      "latitudeE7": 5.370485,
      "longitudeE7": -71.83238,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 23,
      "punto": 56,
      "latitudeE7": 5.370479,
      "longitudeE7": -71.832343,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 23,
      "punto": 57,
      "latitudeE7": 5.370473,
      "longitudeE7": -71.832305,
      "accuracy": 15,
      "porcentaje": 0.28
    },
    {
      "linea": 23,
      "punto": 58,
      "latitudeE7": 5.370467,
      "longitudeE7": -71.832267,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 23,
      "punto": 59,
      "latitudeE7": 5.370461,
      "longitudeE7": -71.832229,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 23,
      "punto": 60,
      "latitudeE7": 5.370455,
      "longitudeE7": -71.832192,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 23,
      "punto": 61,
      "latitudeE7": 5.370449,
      "longitudeE7": -71.832154,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 23,
      "punto": 62,
      "latitudeE7": 5.370443,
      "longitudeE7": -71.832116,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 23,
      "punto": 63,
      "latitudeE7": 5.370437,
      "longitudeE7": -71.832078,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 23,
      "punto": 64,
      "latitudeE7": 5.370431,
      "longitudeE7": -71.832041,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 23,
      "punto": 65,
      "latitudeE7": 5.370425,
      "longitudeE7": -71.832003,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 23,
      "punto": 66,
      "latitudeE7": 5.370419,
      "longitudeE7": -71.831965,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 23,
      "punto": 67,
      "latitudeE7": 5.370413,
      "longitudeE7": -71.831928,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 23,
      "punto": 68,
      "latitudeE7": 5.370407,
      "longitudeE7": -71.83189,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 23,
      "punto": 69,
      "latitudeE7": 5.370401,
      "longitudeE7": -71.831852,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 23,
      "punto": 70,
      "latitudeE7": 5.370395,
      "longitudeE7": -71.831814,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 23,
      "punto": 71,
      "latitudeE7": 5.370389,
      "longitudeE7": -71.831777,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 23,
      "punto": 72,
      "latitudeE7": 5.370383,
      "longitudeE7": -71.831739,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 23,
      "punto": 73,
      "latitudeE7": 5.370377,
      "longitudeE7": -71.831701,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 23,
      "punto": 74,
      "latitudeE7": 5.370371,
      "longitudeE7": -71.831664,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 23,
      "punto": 75,
      "latitudeE7": 5.370365,
      "longitudeE7": -71.831626,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 23,
      "punto": 76,
      "latitudeE7": 5.370359,
      "longitudeE7": -71.831588,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 23,
      "punto": 77,
      "latitudeE7": 5.370353,
      "longitudeE7": -71.83155,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 23,
      "punto": 78,
      "latitudeE7": 5.370347,
      "longitudeE7": -71.831513,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 23,
      "punto": 79,
      "latitudeE7": 5.370341,
      "longitudeE7": -71.831475,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 23,
      "punto": 80,
      "latitudeE7": 5.370335,
      "longitudeE7": -71.831437,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 23,
      "punto": 81,
      "latitudeE7": 5.370329,
      "longitudeE7": -71.8314,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 23,
      "punto": 82,
      "latitudeE7": 5.370323,
      "longitudeE7": -71.831362,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 23,
      "punto": 83,
      "latitudeE7": 5.370317,
      "longitudeE7": -71.831324,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 23,
      "punto": 84,
      "latitudeE7": 5.370311,
      "longitudeE7": -71.831286,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 23,
      "punto": 85,
      "latitudeE7": 5.370305,
      "longitudeE7": -71.831249,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 23,
      "punto": 86,
      "latitudeE7": 5.370299,
      "longitudeE7": -71.831211,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 23,
      "punto": 87,
      "latitudeE7": 5.370293,
      "longitudeE7": -71.831173,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 23,
      "punto": 88,
      "latitudeE7": 5.370287,
      "longitudeE7": -71.831135,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 23,
      "punto": 89,
      "latitudeE7": 5.370281,
      "longitudeE7": -71.831098,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 23,
      "punto": 90,
      "latitudeE7": 5.370275,
      "longitudeE7": -71.83106,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 23,
      "punto": 91,
      "latitudeE7": 5.370269,
      "longitudeE7": -71.831022,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 23,
      "punto": 92,
      "latitudeE7": 5.370263,
      "longitudeE7": -71.830985,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 23,
      "punto": 93,
      "latitudeE7": 5.370257,
      "longitudeE7": -71.830947,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 23,
      "punto": 94,
      "latitudeE7": 5.370251,
      "longitudeE7": -71.830909,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 23,
      "punto": 95,
      "latitudeE7": 5.370245,
      "longitudeE7": -71.830871,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 23,
      "punto": 96,
      "latitudeE7": 5.370239,
      "longitudeE7": -71.830834,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 23,
      "punto": 97,
      "latitudeE7": 5.370233,
      "longitudeE7": -71.830796,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 23,
      "punto": 98,
      "latitudeE7": 5.370227,
      "longitudeE7": -71.830758,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 23,
      "punto": 99,
      "latitudeE7": 5.370221,
      "longitudeE7": -71.830721,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 23,
      "punto": 100,
      "latitudeE7": 5.370215,
      "longitudeE7": -71.830683,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 23,
      "punto": 101,
      "latitudeE7": 5.370209,
      "longitudeE7": -71.830645,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 23,
      "punto": 102,
      "latitudeE7": 5.370203,
      "longitudeE7": -71.830607,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 23,
      "punto": 103,
      "latitudeE7": 5.370197,
      "longitudeE7": -71.83057,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 23,
      "punto": 104,
      "latitudeE7": 5.370191,
      "longitudeE7": -71.830532,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 23,
      "punto": 105,
      "latitudeE7": 5.370185,
      "longitudeE7": -71.830494,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 23,
      "punto": 106,
      "latitudeE7": 5.370179,
      "longitudeE7": -71.830457,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 23,
      "punto": 107,
      "latitudeE7": 5.370173,
      "longitudeE7": -71.830419,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 23,
      "punto": 108,
      "latitudeE7": 5.370167,
      "longitudeE7": -71.830381,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 23,
      "punto": 109,
      "latitudeE7": 5.370161,
      "longitudeE7": -71.830343,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 23,
      "punto": 110,
      "latitudeE7": 5.370155,
      "longitudeE7": -71.830306,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 23,
      "punto": 111,
      "latitudeE7": 5.370149,
      "longitudeE7": -71.830268,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 23,
      "punto": 112,
      "latitudeE7": 5.370143,
      "longitudeE7": -71.83023,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 23,
      "punto": 113,
      "latitudeE7": 5.370137,
      "longitudeE7": -71.830192,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 23,
      "punto": 114,
      "latitudeE7": 5.370131,
      "longitudeE7": -71.830155,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 24,
      "punto": 1,
      "latitudeE7": 5.370769,
      "longitudeE7": -71.834442,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 24,
      "punto": 2,
      "latitudeE7": 5.370763,
      "longitudeE7": -71.834404,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 24,
      "punto": 3,
      "latitudeE7": 5.370757,
      "longitudeE7": -71.834367,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 24,
      "punto": 4,
      "latitudeE7": 5.370751,
      "longitudeE7": -71.834329,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 24,
      "punto": 5,
      "latitudeE7": 5.370745,
      "longitudeE7": -71.834291,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 24,
      "punto": 6,
      "latitudeE7": 5.370739,
      "longitudeE7": -71.834253,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 24,
      "punto": 7,
      "latitudeE7": 5.370733,
      "longitudeE7": -71.834216,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 24,
      "punto": 8,
      "latitudeE7": 5.370727,
      "longitudeE7": -71.834178,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 24,
      "punto": 9,
      "latitudeE7": 5.370721,
      "longitudeE7": -71.83414,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 24,
      "punto": 10,
      "latitudeE7": 5.370715,
      "longitudeE7": -71.834103,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 24,
      "punto": 11,
      "latitudeE7": 5.370709,
      "longitudeE7": -71.834065,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 24,
      "punto": 12,
      "latitudeE7": 5.370703,
      "longitudeE7": -71.834027,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 24,
      "punto": 13,
      "latitudeE7": 5.370697,
      "longitudeE7": -71.833989,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 24,
      "punto": 14,
      "latitudeE7": 5.370691,
      "longitudeE7": -71.833952,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 24,
      "punto": 15,
      "latitudeE7": 5.370685,
      "longitudeE7": -71.833914,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 24,
      "punto": 16,
      "latitudeE7": 5.370679,
      "longitudeE7": -71.833876,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 24,
      "punto": 17,
      "latitudeE7": 5.370673,
      "longitudeE7": -71.833839,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 24,
      "punto": 18,
      "latitudeE7": 5.370667,
      "longitudeE7": -71.833801,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 24,
      "punto": 19,
      "latitudeE7": 5.370661,
      "longitudeE7": -71.833763,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 24,
      "punto": 20,
      "latitudeE7": 5.370655,
      "longitudeE7": -71.833725,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 24,
      "punto": 21,
      "latitudeE7": 5.370649,
      "longitudeE7": -71.833688,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 24,
      "punto": 22,
      "latitudeE7": 5.370643,
      "longitudeE7": -71.83365,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 24,
      "punto": 23,
      "latitudeE7": 5.370637,
      "longitudeE7": -71.833612,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 24,
      "punto": 24,
      "latitudeE7": 5.370631,
      "longitudeE7": -71.833575,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 24,
      "punto": 25,
      "latitudeE7": 5.370625,
      "longitudeE7": -71.833537,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 24,
      "punto": 26,
      "latitudeE7": 5.370619,
      "longitudeE7": -71.833499,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 24,
      "punto": 27,
      "latitudeE7": 5.370613,
      "longitudeE7": -71.833461,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 24,
      "punto": 28,
      "latitudeE7": 5.370607,
      "longitudeE7": -71.833424,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 24,
      "punto": 29,
      "latitudeE7": 5.370601,
      "longitudeE7": -71.833386,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 24,
      "punto": 30,
      "latitudeE7": 5.370595,
      "longitudeE7": -71.833348,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 24,
      "punto": 31,
      "latitudeE7": 5.370589,
      "longitudeE7": -71.83331,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 24,
      "punto": 32,
      "latitudeE7": 5.370583,
      "longitudeE7": -71.833273,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 24,
      "punto": 33,
      "latitudeE7": 5.370577,
      "longitudeE7": -71.833235,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 24,
      "punto": 34,
      "latitudeE7": 5.370571,
      "longitudeE7": -71.833197,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 24,
      "punto": 35,
      "latitudeE7": 5.370565,
      "longitudeE7": -71.83316,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 24,
      "punto": 36,
      "latitudeE7": 5.370559,
      "longitudeE7": -71.833122,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 24,
      "punto": 37,
      "latitudeE7": 5.370553,
      "longitudeE7": -71.833084,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 24,
      "punto": 38,
      "latitudeE7": 5.370547,
      "longitudeE7": -71.833046,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 24,
      "punto": 39,
      "latitudeE7": 5.370541,
      "longitudeE7": -71.833009,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 24,
      "punto": 40,
      "latitudeE7": 5.370535,
      "longitudeE7": -71.832971,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 24,
      "punto": 41,
      "latitudeE7": 5.370529,
      "longitudeE7": -71.832933,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 24,
      "punto": 42,
      "latitudeE7": 5.370523,
      "longitudeE7": -71.832896,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 24,
      "punto": 43,
      "latitudeE7": 5.370517,
      "longitudeE7": -71.832858,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 24,
      "punto": 44,
      "latitudeE7": 5.370511,
      "longitudeE7": -71.83282,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 24,
      "punto": 45,
      "latitudeE7": 5.370505,
      "longitudeE7": -71.832782,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 24,
      "punto": 46,
      "latitudeE7": 5.370499,
      "longitudeE7": -71.832745,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 24,
      "punto": 47,
      "latitudeE7": 5.370493,
      "longitudeE7": -71.832707,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 24,
      "punto": 48,
      "latitudeE7": 5.370487,
      "longitudeE7": -71.832669,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 24,
      "punto": 49,
      "latitudeE7": 5.370481,
      "longitudeE7": -71.832632,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 24,
      "punto": 50,
      "latitudeE7": 5.370475,
      "longitudeE7": -71.832594,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 24,
      "punto": 51,
      "latitudeE7": 5.370469,
      "longitudeE7": -71.832556,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 24,
      "punto": 52,
      "latitudeE7": 5.370463,
      "longitudeE7": -71.832518,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 24,
      "punto": 53,
      "latitudeE7": 5.370457,
      "longitudeE7": -71.832481,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 24,
      "punto": 54,
      "latitudeE7": 5.370451,
      "longitudeE7": -71.832443,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 24,
      "punto": 55,
      "latitudeE7": 5.370445,
      "longitudeE7": -71.832405,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 24,
      "punto": 56,
      "latitudeE7": 5.370439,
      "longitudeE7": -71.832367,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 24,
      "punto": 57,
      "latitudeE7": 5.370433,
      "longitudeE7": -71.83233,
      "accuracy": 15,
      "porcentaje": 0.4
    },
    {
      "linea": 24,
      "punto": 58,
      "latitudeE7": 5.370427,
      "longitudeE7": -71.832292,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 24,
      "punto": 59,
      "latitudeE7": 5.370421,
      "longitudeE7": -71.832254,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 24,
      "punto": 60,
      "latitudeE7": 5.370415,
      "longitudeE7": -71.832217,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 24,
      "punto": 61,
      "latitudeE7": 5.370409,
      "longitudeE7": -71.832179,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 24,
      "punto": 62,
      "latitudeE7": 5.370403,
      "longitudeE7": -71.832141,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 24,
      "punto": 63,
      "latitudeE7": 5.370397,
      "longitudeE7": -71.832103,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 24,
      "punto": 64,
      "latitudeE7": 5.370391,
      "longitudeE7": -71.832066,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 24,
      "punto": 65,
      "latitudeE7": 5.370385,
      "longitudeE7": -71.832028,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 24,
      "punto": 66,
      "latitudeE7": 5.370379,
      "longitudeE7": -71.83199,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 24,
      "punto": 67,
      "latitudeE7": 5.370373,
      "longitudeE7": -71.831953,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 24,
      "punto": 68,
      "latitudeE7": 5.370367,
      "longitudeE7": -71.831915,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 24,
      "punto": 69,
      "latitudeE7": 5.370361,
      "longitudeE7": -71.831877,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 24,
      "punto": 70,
      "latitudeE7": 5.370355,
      "longitudeE7": -71.831839,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 24,
      "punto": 71,
      "latitudeE7": 5.370349,
      "longitudeE7": -71.831802,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 24,
      "punto": 72,
      "latitudeE7": 5.370343,
      "longitudeE7": -71.831764,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 24,
      "punto": 73,
      "latitudeE7": 5.370337,
      "longitudeE7": -71.831726,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 24,
      "punto": 74,
      "latitudeE7": 5.370331,
      "longitudeE7": -71.831689,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 24,
      "punto": 75,
      "latitudeE7": 5.370325,
      "longitudeE7": -71.831651,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 24,
      "punto": 76,
      "latitudeE7": 5.370319,
      "longitudeE7": -71.831613,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 24,
      "punto": 77,
      "latitudeE7": 5.370313,
      "longitudeE7": -71.831575,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 24,
      "punto": 78,
      "latitudeE7": 5.370307,
      "longitudeE7": -71.831538,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 24,
      "punto": 79,
      "latitudeE7": 5.370301,
      "longitudeE7": -71.8315,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 24,
      "punto": 80,
      "latitudeE7": 5.370295,
      "longitudeE7": -71.831462,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 24,
      "punto": 81,
      "latitudeE7": 5.370289,
      "longitudeE7": -71.831424,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 24,
      "punto": 82,
      "latitudeE7": 5.370283,
      "longitudeE7": -71.831387,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 24,
      "punto": 83,
      "latitudeE7": 5.370277,
      "longitudeE7": -71.831349,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 24,
      "punto": 84,
      "latitudeE7": 5.370271,
      "longitudeE7": -71.831311,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 24,
      "punto": 85,
      "latitudeE7": 5.370265,
      "longitudeE7": -71.831274,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 24,
      "punto": 86,
      "latitudeE7": 5.370259,
      "longitudeE7": -71.831236,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 24,
      "punto": 87,
      "latitudeE7": 5.370253,
      "longitudeE7": -71.831198,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 24,
      "punto": 88,
      "latitudeE7": 5.370247,
      "longitudeE7": -71.83116,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 24,
      "punto": 89,
      "latitudeE7": 5.370241,
      "longitudeE7": -71.831123,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 24,
      "punto": 90,
      "latitudeE7": 5.370235,
      "longitudeE7": -71.831085,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 24,
      "punto": 91,
      "latitudeE7": 5.370229,
      "longitudeE7": -71.831047,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 24,
      "punto": 92,
      "latitudeE7": 5.370223,
      "longitudeE7": -71.83101,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 24,
      "punto": 93,
      "latitudeE7": 5.370217,
      "longitudeE7": -71.830972,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 24,
      "punto": 94,
      "latitudeE7": 5.370211,
      "longitudeE7": -71.830934,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 24,
      "punto": 95,
      "latitudeE7": 5.370205,
      "longitudeE7": -71.830896,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 24,
      "punto": 96,
      "latitudeE7": 5.370199,
      "longitudeE7": -71.830859,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 24,
      "punto": 97,
      "latitudeE7": 5.370193,
      "longitudeE7": -71.830821,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 24,
      "punto": 98,
      "latitudeE7": 5.370187,
      "longitudeE7": -71.830783,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 24,
      "punto": 99,
      "latitudeE7": 5.370181,
      "longitudeE7": -71.830746,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 24,
      "punto": 100,
      "latitudeE7": 5.370175,
      "longitudeE7": -71.830708,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 24,
      "punto": 101,
      "latitudeE7": 5.370169,
      "longitudeE7": -71.83067,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 24,
      "punto": 102,
      "latitudeE7": 5.370163,
      "longitudeE7": -71.830632,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 24,
      "punto": 103,
      "latitudeE7": 5.370157,
      "longitudeE7": -71.830595,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 24,
      "punto": 104,
      "latitudeE7": 5.370151,
      "longitudeE7": -71.830557,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 24,
      "punto": 105,
      "latitudeE7": 5.370145,
      "longitudeE7": -71.830519,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 24,
      "punto": 106,
      "latitudeE7": 5.370139,
      "longitudeE7": -71.830481,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 24,
      "punto": 107,
      "latitudeE7": 5.370133,
      "longitudeE7": -71.830444,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 24,
      "punto": 108,
      "latitudeE7": 5.370127,
      "longitudeE7": -71.830406,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 24,
      "punto": 109,
      "latitudeE7": 5.370121,
      "longitudeE7": -71.830368,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 24,
      "punto": 110,
      "latitudeE7": 5.370115,
      "longitudeE7": -71.830331,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 24,
      "punto": 111,
      "latitudeE7": 5.370109,
      "longitudeE7": -71.830293,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 24,
      "punto": 112,
      "latitudeE7": 5.370103,
      "longitudeE7": -71.830255,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 24,
      "punto": 113,
      "latitudeE7": 5.370097,
      "longitudeE7": -71.830217,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 24,
      "punto": 114,
      "latitudeE7": 5.370091,
      "longitudeE7": -71.83018,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 25,
      "punto": 1,
      "latitudeE7": 5.370729,
      "longitudeE7": -71.834467,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 25,
      "punto": 2,
      "latitudeE7": 5.370723,
      "longitudeE7": -71.834429,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 25,
      "punto": 3,
      "latitudeE7": 5.370717,
      "longitudeE7": -71.834392,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 25,
      "punto": 4,
      "latitudeE7": 5.370711,
      "longitudeE7": -71.834354,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 25,
      "punto": 5,
      "latitudeE7": 5.370705,
      "longitudeE7": -71.834316,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 25,
      "punto": 6,
      "latitudeE7": 5.370699,
      "longitudeE7": -71.834278,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 25,
      "punto": 7,
      "latitudeE7": 5.370693,
      "longitudeE7": -71.834241,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 25,
      "punto": 8,
      "latitudeE7": 5.370687,
      "longitudeE7": -71.834203,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 25,
      "punto": 9,
      "latitudeE7": 5.370681,
      "longitudeE7": -71.834165,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 25,
      "punto": 10,
      "latitudeE7": 5.370675,
      "longitudeE7": -71.834128,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 25,
      "punto": 11,
      "latitudeE7": 5.370669,
      "longitudeE7": -71.83409,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 25,
      "punto": 12,
      "latitudeE7": 5.370663,
      "longitudeE7": -71.834052,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 25,
      "punto": 13,
      "latitudeE7": 5.370657,
      "longitudeE7": -71.834014,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 25,
      "punto": 14,
      "latitudeE7": 5.370651,
      "longitudeE7": -71.833977,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 25,
      "punto": 15,
      "latitudeE7": 5.370645,
      "longitudeE7": -71.833939,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 25,
      "punto": 16,
      "latitudeE7": 5.370639,
      "longitudeE7": -71.833901,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 25,
      "punto": 17,
      "latitudeE7": 5.370633,
      "longitudeE7": -71.833864,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 25,
      "punto": 18,
      "latitudeE7": 5.370627,
      "longitudeE7": -71.833826,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 25,
      "punto": 19,
      "latitudeE7": 5.370621,
      "longitudeE7": -71.833788,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 25,
      "punto": 20,
      "latitudeE7": 5.370615,
      "longitudeE7": -71.83375,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 25,
      "punto": 21,
      "latitudeE7": 5.370609,
      "longitudeE7": -71.833713,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 25,
      "punto": 22,
      "latitudeE7": 5.370603,
      "longitudeE7": -71.833675,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 25,
      "punto": 23,
      "latitudeE7": 5.370597,
      "longitudeE7": -71.833637,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 25,
      "punto": 24,
      "latitudeE7": 5.370591,
      "longitudeE7": -71.833599,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 25,
      "punto": 25,
      "latitudeE7": 5.370585,
      "longitudeE7": -71.833562,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 25,
      "punto": 26,
      "latitudeE7": 5.370579,
      "longitudeE7": -71.833524,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 25,
      "punto": 27,
      "latitudeE7": 5.370573,
      "longitudeE7": -71.833486,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 25,
      "punto": 28,
      "latitudeE7": 5.370567,
      "longitudeE7": -71.833449,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 25,
      "punto": 29,
      "latitudeE7": 5.370561,
      "longitudeE7": -71.833411,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 25,
      "punto": 30,
      "latitudeE7": 5.370555,
      "longitudeE7": -71.833373,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 25,
      "punto": 31,
      "latitudeE7": 5.370549,
      "longitudeE7": -71.833335,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 25,
      "punto": 32,
      "latitudeE7": 5.370543,
      "longitudeE7": -71.833298,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 25,
      "punto": 33,
      "latitudeE7": 5.370537,
      "longitudeE7": -71.83326,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 25,
      "punto": 34,
      "latitudeE7": 5.370531,
      "longitudeE7": -71.833222,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 25,
      "punto": 35,
      "latitudeE7": 5.370525,
      "longitudeE7": -71.833185,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 25,
      "punto": 36,
      "latitudeE7": 5.370519,
      "longitudeE7": -71.833147,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 25,
      "punto": 37,
      "latitudeE7": 5.370513,
      "longitudeE7": -71.833109,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 25,
      "punto": 38,
      "latitudeE7": 5.370507,
      "longitudeE7": -71.833071,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 25,
      "punto": 39,
      "latitudeE7": 5.370501,
      "longitudeE7": -71.833034,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 25,
      "punto": 40,
      "latitudeE7": 5.370495,
      "longitudeE7": -71.832996,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 25,
      "punto": 41,
      "latitudeE7": 5.370489,
      "longitudeE7": -71.832958,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 25,
      "punto": 42,
      "latitudeE7": 5.370483,
      "longitudeE7": -71.832921,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 25,
      "punto": 43,
      "latitudeE7": 5.370477,
      "longitudeE7": -71.832883,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 25,
      "punto": 44,
      "latitudeE7": 5.370471,
      "longitudeE7": -71.832845,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 25,
      "punto": 45,
      "latitudeE7": 5.370465,
      "longitudeE7": -71.832807,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 25,
      "punto": 46,
      "latitudeE7": 5.370459,
      "longitudeE7": -71.83277,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 25,
      "punto": 47,
      "latitudeE7": 5.370453,
      "longitudeE7": -71.832732,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 25,
      "punto": 48,
      "latitudeE7": 5.370447,
      "longitudeE7": -71.832694,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 25,
      "punto": 49,
      "latitudeE7": 5.370441,
      "longitudeE7": -71.832656,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 25,
      "punto": 50,
      "latitudeE7": 5.370435,
      "longitudeE7": -71.832619,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 25,
      "punto": 51,
      "latitudeE7": 5.370429,
      "longitudeE7": -71.832581,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 25,
      "punto": 52,
      "latitudeE7": 5.370423,
      "longitudeE7": -71.832543,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 25,
      "punto": 53,
      "latitudeE7": 5.370417,
      "longitudeE7": -71.832506,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 25,
      "punto": 54,
      "latitudeE7": 5.370411,
      "longitudeE7": -71.832468,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 25,
      "punto": 55,
      "latitudeE7": 5.370405,
      "longitudeE7": -71.83243,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 25,
      "punto": 56,
      "latitudeE7": 5.370399,
      "longitudeE7": -71.832392,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 25,
      "punto": 57,
      "latitudeE7": 5.370393,
      "longitudeE7": -71.832355,
      "accuracy": 15,
      "porcentaje": 0.32
    },
    {
      "linea": 25,
      "punto": 58,
      "latitudeE7": 5.370387,
      "longitudeE7": -71.832317,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 25,
      "punto": 59,
      "latitudeE7": 5.370381,
      "longitudeE7": -71.832279,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 25,
      "punto": 60,
      "latitudeE7": 5.370375,
      "longitudeE7": -71.832242,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 25,
      "punto": 61,
      "latitudeE7": 5.370369,
      "longitudeE7": -71.832204,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 25,
      "punto": 62,
      "latitudeE7": 5.370363,
      "longitudeE7": -71.832166,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 25,
      "punto": 63,
      "latitudeE7": 5.370357,
      "longitudeE7": -71.832128,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 25,
      "punto": 64,
      "latitudeE7": 5.370351,
      "longitudeE7": -71.832091,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 25,
      "punto": 65,
      "latitudeE7": 5.370345,
      "longitudeE7": -71.832053,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 25,
      "punto": 66,
      "latitudeE7": 5.370339,
      "longitudeE7": -71.832015,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 25,
      "punto": 67,
      "latitudeE7": 5.370333,
      "longitudeE7": -71.831978,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 25,
      "punto": 68,
      "latitudeE7": 5.370327,
      "longitudeE7": -71.83194,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 25,
      "punto": 69,
      "latitudeE7": 5.370321,
      "longitudeE7": -71.831902,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 25,
      "punto": 70,
      "latitudeE7": 5.370315,
      "longitudeE7": -71.831864,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 25,
      "punto": 71,
      "latitudeE7": 5.370309,
      "longitudeE7": -71.831827,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 25,
      "punto": 72,
      "latitudeE7": 5.370303,
      "longitudeE7": -71.831789,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 25,
      "punto": 73,
      "latitudeE7": 5.370297,
      "longitudeE7": -71.831751,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 25,
      "punto": 74,
      "latitudeE7": 5.370291,
      "longitudeE7": -71.831713,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 25,
      "punto": 75,
      "latitudeE7": 5.370285,
      "longitudeE7": -71.831676,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 25,
      "punto": 76,
      "latitudeE7": 5.370279,
      "longitudeE7": -71.831638,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 25,
      "punto": 77,
      "latitudeE7": 5.370273,
      "longitudeE7": -71.8316,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 25,
      "punto": 78,
      "latitudeE7": 5.370267,
      "longitudeE7": -71.831563,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 25,
      "punto": 79,
      "latitudeE7": 5.370261,
      "longitudeE7": -71.831525,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 25,
      "punto": 80,
      "latitudeE7": 5.370255,
      "longitudeE7": -71.831487,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 25,
      "punto": 81,
      "latitudeE7": 5.370249,
      "longitudeE7": -71.831449,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 25,
      "punto": 82,
      "latitudeE7": 5.370243,
      "longitudeE7": -71.831412,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 25,
      "punto": 83,
      "latitudeE7": 5.370237,
      "longitudeE7": -71.831374,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 25,
      "punto": 84,
      "latitudeE7": 5.370231,
      "longitudeE7": -71.831336,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 25,
      "punto": 85,
      "latitudeE7": 5.370225,
      "longitudeE7": -71.831299,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 25,
      "punto": 86,
      "latitudeE7": 5.370219,
      "longitudeE7": -71.831261,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 25,
      "punto": 87,
      "latitudeE7": 5.370213,
      "longitudeE7": -71.831223,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 25,
      "punto": 88,
      "latitudeE7": 5.370207,
      "longitudeE7": -71.831185,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 25,
      "punto": 89,
      "latitudeE7": 5.370201,
      "longitudeE7": -71.831148,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 25,
      "punto": 90,
      "latitudeE7": 5.370195,
      "longitudeE7": -71.83111,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 25,
      "punto": 91,
      "latitudeE7": 5.370189,
      "longitudeE7": -71.831072,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 25,
      "punto": 92,
      "latitudeE7": 5.370183,
      "longitudeE7": -71.831035,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 25,
      "punto": 93,
      "latitudeE7": 5.370177,
      "longitudeE7": -71.830997,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 25,
      "punto": 94,
      "latitudeE7": 5.370171,
      "longitudeE7": -71.830959,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 25,
      "punto": 95,
      "latitudeE7": 5.370165,
      "longitudeE7": -71.830921,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 25,
      "punto": 96,
      "latitudeE7": 5.370159,
      "longitudeE7": -71.830884,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 25,
      "punto": 97,
      "latitudeE7": 5.370153,
      "longitudeE7": -71.830846,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 25,
      "punto": 98,
      "latitudeE7": 5.370147,
      "longitudeE7": -71.830808,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 25,
      "punto": 99,
      "latitudeE7": 5.370141,
      "longitudeE7": -71.83077,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 25,
      "punto": 100,
      "latitudeE7": 5.370135,
      "longitudeE7": -71.830733,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 25,
      "punto": 101,
      "latitudeE7": 5.370129,
      "longitudeE7": -71.830695,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 25,
      "punto": 102,
      "latitudeE7": 5.370123,
      "longitudeE7": -71.830657,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 25,
      "punto": 103,
      "latitudeE7": 5.370117,
      "longitudeE7": -71.83062,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 25,
      "punto": 104,
      "latitudeE7": 5.370111,
      "longitudeE7": -71.830582,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 25,
      "punto": 105,
      "latitudeE7": 5.370105,
      "longitudeE7": -71.830544,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 25,
      "punto": 106,
      "latitudeE7": 5.370099,
      "longitudeE7": -71.830506,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 25,
      "punto": 107,
      "latitudeE7": 5.370093,
      "longitudeE7": -71.830469,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 25,
      "punto": 108,
      "latitudeE7": 5.370087,
      "longitudeE7": -71.830431,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 25,
      "punto": 109,
      "latitudeE7": 5.370081,
      "longitudeE7": -71.830393,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 25,
      "punto": 110,
      "latitudeE7": 5.370075,
      "longitudeE7": -71.830356,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 25,
      "punto": 111,
      "latitudeE7": 5.370069,
      "longitudeE7": -71.830318,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 25,
      "punto": 112,
      "latitudeE7": 5.370063,
      "longitudeE7": -71.83028,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 25,
      "punto": 113,
      "latitudeE7": 5.370057,
      "longitudeE7": -71.830242,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 25,
      "punto": 114,
      "latitudeE7": 5.370051,
      "longitudeE7": -71.830205,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 26,
      "punto": 1,
      "latitudeE7": 5.370689,
      "longitudeE7": -71.834492,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 26,
      "punto": 2,
      "latitudeE7": 5.370683,
      "longitudeE7": -71.834454,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 26,
      "punto": 3,
      "latitudeE7": 5.370677,
      "longitudeE7": -71.834417,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 26,
      "punto": 4,
      "latitudeE7": 5.370671,
      "longitudeE7": -71.834379,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 26,
      "punto": 5,
      "latitudeE7": 5.370665,
      "longitudeE7": -71.834341,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 26,
      "punto": 6,
      "latitudeE7": 5.370659,
      "longitudeE7": -71.834303,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 26,
      "punto": 7,
      "latitudeE7": 5.370653,
      "longitudeE7": -71.834266,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 26,
      "punto": 8,
      "latitudeE7": 5.370647,
      "longitudeE7": -71.834228,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 26,
      "punto": 9,
      "latitudeE7": 5.370641,
      "longitudeE7": -71.83419,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 26,
      "punto": 10,
      "latitudeE7": 5.370635,
      "longitudeE7": -71.834153,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 26,
      "punto": 11,
      "latitudeE7": 5.370629,
      "longitudeE7": -71.834115,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 26,
      "punto": 12,
      "latitudeE7": 5.370623,
      "longitudeE7": -71.834077,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 26,
      "punto": 13,
      "latitudeE7": 5.370617,
      "longitudeE7": -71.834039,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 26,
      "punto": 14,
      "latitudeE7": 5.370611,
      "longitudeE7": -71.834002,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 26,
      "punto": 15,
      "latitudeE7": 5.370605,
      "longitudeE7": -71.833964,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 26,
      "punto": 16,
      "latitudeE7": 5.370599,
      "longitudeE7": -71.833926,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 26,
      "punto": 17,
      "latitudeE7": 5.370593,
      "longitudeE7": -71.833888,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 26,
      "punto": 18,
      "latitudeE7": 5.370587,
      "longitudeE7": -71.833851,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 26,
      "punto": 19,
      "latitudeE7": 5.370581,
      "longitudeE7": -71.833813,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 26,
      "punto": 20,
      "latitudeE7": 5.370575,
      "longitudeE7": -71.833775,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 26,
      "punto": 21,
      "latitudeE7": 5.370569,
      "longitudeE7": -71.833738,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 26,
      "punto": 22,
      "latitudeE7": 5.370563,
      "longitudeE7": -71.8337,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 26,
      "punto": 23,
      "latitudeE7": 5.370557,
      "longitudeE7": -71.833662,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 26,
      "punto": 24,
      "latitudeE7": 5.370551,
      "longitudeE7": -71.833624,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 26,
      "punto": 25,
      "latitudeE7": 5.370545,
      "longitudeE7": -71.833587,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 26,
      "punto": 26,
      "latitudeE7": 5.370539,
      "longitudeE7": -71.833549,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 26,
      "punto": 27,
      "latitudeE7": 5.370533,
      "longitudeE7": -71.833511,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 26,
      "punto": 28,
      "latitudeE7": 5.370527,
      "longitudeE7": -71.833474,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 26,
      "punto": 29,
      "latitudeE7": 5.370521,
      "longitudeE7": -71.833436,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 26,
      "punto": 30,
      "latitudeE7": 5.370515,
      "longitudeE7": -71.833398,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 26,
      "punto": 31,
      "latitudeE7": 5.370509,
      "longitudeE7": -71.83336,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 26,
      "punto": 32,
      "latitudeE7": 5.370503,
      "longitudeE7": -71.833323,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 26,
      "punto": 33,
      "latitudeE7": 5.370497,
      "longitudeE7": -71.833285,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 26,
      "punto": 34,
      "latitudeE7": 5.370491,
      "longitudeE7": -71.833247,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 26,
      "punto": 35,
      "latitudeE7": 5.370485,
      "longitudeE7": -71.83321,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 26,
      "punto": 36,
      "latitudeE7": 5.370479,
      "longitudeE7": -71.833172,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 26,
      "punto": 37,
      "latitudeE7": 5.370473,
      "longitudeE7": -71.833134,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 26,
      "punto": 38,
      "latitudeE7": 5.370467,
      "longitudeE7": -71.833096,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 26,
      "punto": 39,
      "latitudeE7": 5.370461,
      "longitudeE7": -71.833059,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 26,
      "punto": 40,
      "latitudeE7": 5.370455,
      "longitudeE7": -71.833021,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 26,
      "punto": 41,
      "latitudeE7": 5.370449,
      "longitudeE7": -71.832983,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 26,
      "punto": 42,
      "latitudeE7": 5.370443,
      "longitudeE7": -71.832945,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 26,
      "punto": 43,
      "latitudeE7": 5.370437,
      "longitudeE7": -71.832908,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 26,
      "punto": 44,
      "latitudeE7": 5.370431,
      "longitudeE7": -71.83287,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 26,
      "punto": 45,
      "latitudeE7": 5.370425,
      "longitudeE7": -71.832832,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 26,
      "punto": 46,
      "latitudeE7": 5.370419,
      "longitudeE7": -71.832795,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 26,
      "punto": 47,
      "latitudeE7": 5.370413,
      "longitudeE7": -71.832757,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 26,
      "punto": 48,
      "latitudeE7": 5.370407,
      "longitudeE7": -71.832719,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 26,
      "punto": 49,
      "latitudeE7": 5.370401,
      "longitudeE7": -71.832681,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 26,
      "punto": 50,
      "latitudeE7": 5.370395,
      "longitudeE7": -71.832644,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 26,
      "punto": 51,
      "latitudeE7": 5.370389,
      "longitudeE7": -71.832606,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 26,
      "punto": 52,
      "latitudeE7": 5.370383,
      "longitudeE7": -71.832568,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 26,
      "punto": 53,
      "latitudeE7": 5.370377,
      "longitudeE7": -71.832531,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 26,
      "punto": 54,
      "latitudeE7": 5.370371,
      "longitudeE7": -71.832493,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 26,
      "punto": 55,
      "latitudeE7": 5.370365,
      "longitudeE7": -71.832455,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 26,
      "punto": 56,
      "latitudeE7": 5.370359,
      "longitudeE7": -71.832417,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 26,
      "punto": 57,
      "latitudeE7": 5.370353,
      "longitudeE7": -71.83238,
      "accuracy": 15,
      "porcentaje": 0.76
    },
    {
      "linea": 26,
      "punto": 58,
      "latitudeE7": 5.370347,
      "longitudeE7": -71.832342,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 26,
      "punto": 59,
      "latitudeE7": 5.370341,
      "longitudeE7": -71.832304,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 26,
      "punto": 60,
      "latitudeE7": 5.370335,
      "longitudeE7": -71.832267,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 26,
      "punto": 61,
      "latitudeE7": 5.370329,
      "longitudeE7": -71.832229,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 26,
      "punto": 62,
      "latitudeE7": 5.370323,
      "longitudeE7": -71.832191,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 26,
      "punto": 63,
      "latitudeE7": 5.370317,
      "longitudeE7": -71.832153,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 26,
      "punto": 64,
      "latitudeE7": 5.370311,
      "longitudeE7": -71.832116,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 26,
      "punto": 65,
      "latitudeE7": 5.370305,
      "longitudeE7": -71.832078,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 26,
      "punto": 66,
      "latitudeE7": 5.370299,
      "longitudeE7": -71.83204,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 26,
      "punto": 67,
      "latitudeE7": 5.370293,
      "longitudeE7": -71.832002,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 26,
      "punto": 68,
      "latitudeE7": 5.370287,
      "longitudeE7": -71.831965,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 26,
      "punto": 69,
      "latitudeE7": 5.370281,
      "longitudeE7": -71.831927,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 26,
      "punto": 70,
      "latitudeE7": 5.370275,
      "longitudeE7": -71.831889,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 26,
      "punto": 71,
      "latitudeE7": 5.370269,
      "longitudeE7": -71.831852,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 26,
      "punto": 72,
      "latitudeE7": 5.370263,
      "longitudeE7": -71.831814,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 26,
      "punto": 73,
      "latitudeE7": 5.370257,
      "longitudeE7": -71.831776,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 26,
      "punto": 74,
      "latitudeE7": 5.370251,
      "longitudeE7": -71.831738,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 26,
      "punto": 75,
      "latitudeE7": 5.370245,
      "longitudeE7": -71.831701,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 26,
      "punto": 76,
      "latitudeE7": 5.370239,
      "longitudeE7": -71.831663,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 26,
      "punto": 77,
      "latitudeE7": 5.370233,
      "longitudeE7": -71.831625,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 26,
      "punto": 78,
      "latitudeE7": 5.370227,
      "longitudeE7": -71.831588,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 26,
      "punto": 79,
      "latitudeE7": 5.370221,
      "longitudeE7": -71.83155,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 26,
      "punto": 80,
      "latitudeE7": 5.370215,
      "longitudeE7": -71.831512,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 26,
      "punto": 81,
      "latitudeE7": 5.370209,
      "longitudeE7": -71.831474,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 26,
      "punto": 82,
      "latitudeE7": 5.370203,
      "longitudeE7": -71.831437,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 26,
      "punto": 83,
      "latitudeE7": 5.370197,
      "longitudeE7": -71.831399,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 26,
      "punto": 84,
      "latitudeE7": 5.370191,
      "longitudeE7": -71.831361,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 26,
      "punto": 85,
      "latitudeE7": 5.370185,
      "longitudeE7": -71.831324,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 26,
      "punto": 86,
      "latitudeE7": 5.370179,
      "longitudeE7": -71.831286,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 26,
      "punto": 87,
      "latitudeE7": 5.370173,
      "longitudeE7": -71.831248,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 26,
      "punto": 88,
      "latitudeE7": 5.370167,
      "longitudeE7": -71.83121,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 26,
      "punto": 89,
      "latitudeE7": 5.370161,
      "longitudeE7": -71.831173,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 26,
      "punto": 90,
      "latitudeE7": 5.370155,
      "longitudeE7": -71.831135,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 26,
      "punto": 91,
      "latitudeE7": 5.370149,
      "longitudeE7": -71.831097,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 26,
      "punto": 92,
      "latitudeE7": 5.370143,
      "longitudeE7": -71.831059,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 26,
      "punto": 93,
      "latitudeE7": 5.370137,
      "longitudeE7": -71.831022,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 26,
      "punto": 94,
      "latitudeE7": 5.370131,
      "longitudeE7": -71.830984,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 26,
      "punto": 95,
      "latitudeE7": 5.370125,
      "longitudeE7": -71.830946,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 26,
      "punto": 96,
      "latitudeE7": 5.370119,
      "longitudeE7": -71.830909,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 26,
      "punto": 97,
      "latitudeE7": 5.370113,
      "longitudeE7": -71.830871,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 26,
      "punto": 98,
      "latitudeE7": 5.370107,
      "longitudeE7": -71.830833,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 26,
      "punto": 99,
      "latitudeE7": 5.370101,
      "longitudeE7": -71.830795,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 26,
      "punto": 100,
      "latitudeE7": 5.370095,
      "longitudeE7": -71.830758,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 26,
      "punto": 101,
      "latitudeE7": 5.370089,
      "longitudeE7": -71.83072,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 26,
      "punto": 102,
      "latitudeE7": 5.370083,
      "longitudeE7": -71.830682,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 26,
      "punto": 103,
      "latitudeE7": 5.370077,
      "longitudeE7": -71.830645,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 26,
      "punto": 104,
      "latitudeE7": 5.370071,
      "longitudeE7": -71.830607,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 26,
      "punto": 105,
      "latitudeE7": 5.370065,
      "longitudeE7": -71.830569,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 26,
      "punto": 106,
      "latitudeE7": 5.370059,
      "longitudeE7": -71.830531,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 26,
      "punto": 107,
      "latitudeE7": 5.370053,
      "longitudeE7": -71.830494,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 26,
      "punto": 108,
      "latitudeE7": 5.370047,
      "longitudeE7": -71.830456,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 26,
      "punto": 109,
      "latitudeE7": 5.370041,
      "longitudeE7": -71.830418,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 26,
      "punto": 110,
      "latitudeE7": 5.370035,
      "longitudeE7": -71.830381,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 26,
      "punto": 111,
      "latitudeE7": 5.370029,
      "longitudeE7": -71.830343,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 26,
      "punto": 112,
      "latitudeE7": 5.370023,
      "longitudeE7": -71.830305,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 26,
      "punto": 113,
      "latitudeE7": 5.370017,
      "longitudeE7": -71.830267,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 26,
      "punto": 114,
      "latitudeE7": 5.370011,
      "longitudeE7": -71.83023,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 27,
      "punto": 1,
      "latitudeE7": 5.370649,
      "longitudeE7": -71.834517,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 27,
      "punto": 2,
      "latitudeE7": 5.370643,
      "longitudeE7": -71.834479,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 27,
      "punto": 3,
      "latitudeE7": 5.370637,
      "longitudeE7": -71.834442,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 27,
      "punto": 4,
      "latitudeE7": 5.370631,
      "longitudeE7": -71.834404,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 27,
      "punto": 5,
      "latitudeE7": 5.370625,
      "longitudeE7": -71.834366,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 27,
      "punto": 6,
      "latitudeE7": 5.370619,
      "longitudeE7": -71.834328,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 27,
      "punto": 7,
      "latitudeE7": 5.370613,
      "longitudeE7": -71.834291,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 27,
      "punto": 8,
      "latitudeE7": 5.370607,
      "longitudeE7": -71.834253,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 27,
      "punto": 9,
      "latitudeE7": 5.370601,
      "longitudeE7": -71.834215,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 27,
      "punto": 10,
      "latitudeE7": 5.370595,
      "longitudeE7": -71.834177,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 27,
      "punto": 11,
      "latitudeE7": 5.370589,
      "longitudeE7": -71.83414,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 27,
      "punto": 12,
      "latitudeE7": 5.370583,
      "longitudeE7": -71.834102,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 27,
      "punto": 13,
      "latitudeE7": 5.370577,
      "longitudeE7": -71.834064,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 27,
      "punto": 14,
      "latitudeE7": 5.370571,
      "longitudeE7": -71.834027,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 27,
      "punto": 15,
      "latitudeE7": 5.370565,
      "longitudeE7": -71.833989,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 27,
      "punto": 16,
      "latitudeE7": 5.370559,
      "longitudeE7": -71.833951,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 27,
      "punto": 17,
      "latitudeE7": 5.370553,
      "longitudeE7": -71.833913,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 27,
      "punto": 18,
      "latitudeE7": 5.370547,
      "longitudeE7": -71.833876,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 27,
      "punto": 19,
      "latitudeE7": 5.370541,
      "longitudeE7": -71.833838,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 27,
      "punto": 20,
      "latitudeE7": 5.370535,
      "longitudeE7": -71.8338,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 27,
      "punto": 21,
      "latitudeE7": 5.370529,
      "longitudeE7": -71.833763,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 27,
      "punto": 22,
      "latitudeE7": 5.370523,
      "longitudeE7": -71.833725,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 27,
      "punto": 23,
      "latitudeE7": 5.370517,
      "longitudeE7": -71.833687,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 27,
      "punto": 24,
      "latitudeE7": 5.370511,
      "longitudeE7": -71.833649,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 27,
      "punto": 25,
      "latitudeE7": 5.370505,
      "longitudeE7": -71.833612,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 27,
      "punto": 26,
      "latitudeE7": 5.370499,
      "longitudeE7": -71.833574,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 27,
      "punto": 27,
      "latitudeE7": 5.370493,
      "longitudeE7": -71.833536,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 27,
      "punto": 28,
      "latitudeE7": 5.370487,
      "longitudeE7": -71.833499,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 27,
      "punto": 29,
      "latitudeE7": 5.370481,
      "longitudeE7": -71.833461,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 27,
      "punto": 30,
      "latitudeE7": 5.370475,
      "longitudeE7": -71.833423,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 27,
      "punto": 31,
      "latitudeE7": 5.370469,
      "longitudeE7": -71.833385,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 27,
      "punto": 32,
      "latitudeE7": 5.370463,
      "longitudeE7": -71.833348,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 27,
      "punto": 33,
      "latitudeE7": 5.370457,
      "longitudeE7": -71.83331,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 27,
      "punto": 34,
      "latitudeE7": 5.370451,
      "longitudeE7": -71.833272,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 27,
      "punto": 35,
      "latitudeE7": 5.370445,
      "longitudeE7": -71.833234,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 27,
      "punto": 36,
      "latitudeE7": 5.370439,
      "longitudeE7": -71.833197,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 27,
      "punto": 37,
      "latitudeE7": 5.370433,
      "longitudeE7": -71.833159,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 27,
      "punto": 38,
      "latitudeE7": 5.370427,
      "longitudeE7": -71.833121,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 27,
      "punto": 39,
      "latitudeE7": 5.370421,
      "longitudeE7": -71.833084,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 27,
      "punto": 40,
      "latitudeE7": 5.370415,
      "longitudeE7": -71.833046,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 27,
      "punto": 41,
      "latitudeE7": 5.370409,
      "longitudeE7": -71.833008,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 27,
      "punto": 42,
      "latitudeE7": 5.370403,
      "longitudeE7": -71.83297,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 27,
      "punto": 43,
      "latitudeE7": 5.370397,
      "longitudeE7": -71.832933,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 27,
      "punto": 44,
      "latitudeE7": 5.370391,
      "longitudeE7": -71.832895,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 27,
      "punto": 45,
      "latitudeE7": 5.370385,
      "longitudeE7": -71.832857,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 27,
      "punto": 46,
      "latitudeE7": 5.370379,
      "longitudeE7": -71.83282,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 27,
      "punto": 47,
      "latitudeE7": 5.370373,
      "longitudeE7": -71.832782,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 27,
      "punto": 48,
      "latitudeE7": 5.370367,
      "longitudeE7": -71.832744,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 27,
      "punto": 49,
      "latitudeE7": 5.370361,
      "longitudeE7": -71.832706,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 27,
      "punto": 50,
      "latitudeE7": 5.370355,
      "longitudeE7": -71.832669,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 27,
      "punto": 51,
      "latitudeE7": 5.370349,
      "longitudeE7": -71.832631,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 27,
      "punto": 52,
      "latitudeE7": 5.370343,
      "longitudeE7": -71.832593,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 27,
      "punto": 53,
      "latitudeE7": 5.370337,
      "longitudeE7": -71.832556,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 27,
      "punto": 54,
      "latitudeE7": 5.370331,
      "longitudeE7": -71.832518,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 27,
      "punto": 55,
      "latitudeE7": 5.370325,
      "longitudeE7": -71.83248,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 27,
      "punto": 56,
      "latitudeE7": 5.370319,
      "longitudeE7": -71.832442,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 27,
      "punto": 57,
      "latitudeE7": 5.370313,
      "longitudeE7": -71.832405,
      "accuracy": 15,
      "porcentaje": 0.08
    },
    {
      "linea": 27,
      "punto": 58,
      "latitudeE7": 5.370307,
      "longitudeE7": -71.832367,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 27,
      "punto": 59,
      "latitudeE7": 5.370301,
      "longitudeE7": -71.832329,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 27,
      "punto": 60,
      "latitudeE7": 5.370295,
      "longitudeE7": -71.832291,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 27,
      "punto": 61,
      "latitudeE7": 5.370289,
      "longitudeE7": -71.832254,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 27,
      "punto": 62,
      "latitudeE7": 5.370283,
      "longitudeE7": -71.832216,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 27,
      "punto": 63,
      "latitudeE7": 5.370277,
      "longitudeE7": -71.832178,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 27,
      "punto": 64,
      "latitudeE7": 5.370271,
      "longitudeE7": -71.832141,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 27,
      "punto": 65,
      "latitudeE7": 5.370265,
      "longitudeE7": -71.832103,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 27,
      "punto": 66,
      "latitudeE7": 5.370259,
      "longitudeE7": -71.832065,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 27,
      "punto": 67,
      "latitudeE7": 5.370253,
      "longitudeE7": -71.832027,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 27,
      "punto": 68,
      "latitudeE7": 5.370247,
      "longitudeE7": -71.83199,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 27,
      "punto": 69,
      "latitudeE7": 5.370241,
      "longitudeE7": -71.831952,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 27,
      "punto": 70,
      "latitudeE7": 5.370235,
      "longitudeE7": -71.831914,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 27,
      "punto": 71,
      "latitudeE7": 5.370229,
      "longitudeE7": -71.831877,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 27,
      "punto": 72,
      "latitudeE7": 5.370223,
      "longitudeE7": -71.831839,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 27,
      "punto": 73,
      "latitudeE7": 5.370217,
      "longitudeE7": -71.831801,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 27,
      "punto": 74,
      "latitudeE7": 5.370211,
      "longitudeE7": -71.831763,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 27,
      "punto": 75,
      "latitudeE7": 5.370205,
      "longitudeE7": -71.831726,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 27,
      "punto": 76,
      "latitudeE7": 5.370199,
      "longitudeE7": -71.831688,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 27,
      "punto": 77,
      "latitudeE7": 5.370193,
      "longitudeE7": -71.83165,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 27,
      "punto": 78,
      "latitudeE7": 5.370187,
      "longitudeE7": -71.831613,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 27,
      "punto": 79,
      "latitudeE7": 5.370181,
      "longitudeE7": -71.831575,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 27,
      "punto": 80,
      "latitudeE7": 5.370175,
      "longitudeE7": -71.831537,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 27,
      "punto": 81,
      "latitudeE7": 5.370169,
      "longitudeE7": -71.831499,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 27,
      "punto": 82,
      "latitudeE7": 5.370163,
      "longitudeE7": -71.831462,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 27,
      "punto": 83,
      "latitudeE7": 5.370157,
      "longitudeE7": -71.831424,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 27,
      "punto": 84,
      "latitudeE7": 5.370151,
      "longitudeE7": -71.831386,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 27,
      "punto": 85,
      "latitudeE7": 5.370145,
      "longitudeE7": -71.831348,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 27,
      "punto": 86,
      "latitudeE7": 5.370139,
      "longitudeE7": -71.831311,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 27,
      "punto": 87,
      "latitudeE7": 5.370133,
      "longitudeE7": -71.831273,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 27,
      "punto": 88,
      "latitudeE7": 5.370127,
      "longitudeE7": -71.831235,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 27,
      "punto": 89,
      "latitudeE7": 5.370121,
      "longitudeE7": -71.831198,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 27,
      "punto": 90,
      "latitudeE7": 5.370115,
      "longitudeE7": -71.83116,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 27,
      "punto": 91,
      "latitudeE7": 5.370109,
      "longitudeE7": -71.831122,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 27,
      "punto": 92,
      "latitudeE7": 5.370103,
      "longitudeE7": -71.831084,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 27,
      "punto": 93,
      "latitudeE7": 5.370097,
      "longitudeE7": -71.831047,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 27,
      "punto": 94,
      "latitudeE7": 5.370091,
      "longitudeE7": -71.831009,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 27,
      "punto": 95,
      "latitudeE7": 5.370085,
      "longitudeE7": -71.830971,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 27,
      "punto": 96,
      "latitudeE7": 5.370079,
      "longitudeE7": -71.830934,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 27,
      "punto": 97,
      "latitudeE7": 5.370073,
      "longitudeE7": -71.830896,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 27,
      "punto": 98,
      "latitudeE7": 5.370067,
      "longitudeE7": -71.830858,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 27,
      "punto": 99,
      "latitudeE7": 5.370061,
      "longitudeE7": -71.83082,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 27,
      "punto": 100,
      "latitudeE7": 5.370055,
      "longitudeE7": -71.830783,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 27,
      "punto": 101,
      "latitudeE7": 5.370049,
      "longitudeE7": -71.830745,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 27,
      "punto": 102,
      "latitudeE7": 5.370043,
      "longitudeE7": -71.830707,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 27,
      "punto": 103,
      "latitudeE7": 5.370037,
      "longitudeE7": -71.83067,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 27,
      "punto": 104,
      "latitudeE7": 5.370031,
      "longitudeE7": -71.830632,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 27,
      "punto": 105,
      "latitudeE7": 5.370025,
      "longitudeE7": -71.830594,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 27,
      "punto": 106,
      "latitudeE7": 5.370019,
      "longitudeE7": -71.830556,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 27,
      "punto": 107,
      "latitudeE7": 5.370013,
      "longitudeE7": -71.830519,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 27,
      "punto": 108,
      "latitudeE7": 5.370007,
      "longitudeE7": -71.830481,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 27,
      "punto": 109,
      "latitudeE7": 5.370001,
      "longitudeE7": -71.830443,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 27,
      "punto": 110,
      "latitudeE7": 5.369995,
      "longitudeE7": -71.830405,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 27,
      "punto": 111,
      "latitudeE7": 5.369989,
      "longitudeE7": -71.830368,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 27,
      "punto": 112,
      "latitudeE7": 5.369983,
      "longitudeE7": -71.83033,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 27,
      "punto": 113,
      "latitudeE7": 5.369977,
      "longitudeE7": -71.830292,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 27,
      "punto": 114,
      "latitudeE7": 5.369971,
      "longitudeE7": -71.830255,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 28,
      "punto": 1,
      "latitudeE7": 5.370609,
      "longitudeE7": -71.834542,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 28,
      "punto": 2,
      "latitudeE7": 5.370603,
      "longitudeE7": -71.834504,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 28,
      "punto": 3,
      "latitudeE7": 5.370597,
      "longitudeE7": -71.834466,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 28,
      "punto": 4,
      "latitudeE7": 5.370591,
      "longitudeE7": -71.834429,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 28,
      "punto": 5,
      "latitudeE7": 5.370585,
      "longitudeE7": -71.834391,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 28,
      "punto": 6,
      "latitudeE7": 5.370579,
      "longitudeE7": -71.834353,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 28,
      "punto": 7,
      "latitudeE7": 5.370573,
      "longitudeE7": -71.834316,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 28,
      "punto": 8,
      "latitudeE7": 5.370567,
      "longitudeE7": -71.834278,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 28,
      "punto": 9,
      "latitudeE7": 5.370561,
      "longitudeE7": -71.83424,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 28,
      "punto": 10,
      "latitudeE7": 5.370555,
      "longitudeE7": -71.834202,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 28,
      "punto": 11,
      "latitudeE7": 5.370549,
      "longitudeE7": -71.834165,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 28,
      "punto": 12,
      "latitudeE7": 5.370543,
      "longitudeE7": -71.834127,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 28,
      "punto": 13,
      "latitudeE7": 5.370537,
      "longitudeE7": -71.834089,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 28,
      "punto": 14,
      "latitudeE7": 5.370531,
      "longitudeE7": -71.834052,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 28,
      "punto": 15,
      "latitudeE7": 5.370525,
      "longitudeE7": -71.834014,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 28,
      "punto": 16,
      "latitudeE7": 5.370519,
      "longitudeE7": -71.833976,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 28,
      "punto": 17,
      "latitudeE7": 5.370513,
      "longitudeE7": -71.833938,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 28,
      "punto": 18,
      "latitudeE7": 5.370507,
      "longitudeE7": -71.833901,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 28,
      "punto": 19,
      "latitudeE7": 5.370501,
      "longitudeE7": -71.833863,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 28,
      "punto": 20,
      "latitudeE7": 5.370495,
      "longitudeE7": -71.833825,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 28,
      "punto": 21,
      "latitudeE7": 5.370489,
      "longitudeE7": -71.833788,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 28,
      "punto": 22,
      "latitudeE7": 5.370483,
      "longitudeE7": -71.83375,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 28,
      "punto": 23,
      "latitudeE7": 5.370477,
      "longitudeE7": -71.833712,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 28,
      "punto": 24,
      "latitudeE7": 5.370471,
      "longitudeE7": -71.833674,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 28,
      "punto": 25,
      "latitudeE7": 5.370465,
      "longitudeE7": -71.833637,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 28,
      "punto": 26,
      "latitudeE7": 5.370459,
      "longitudeE7": -71.833599,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 28,
      "punto": 27,
      "latitudeE7": 5.370453,
      "longitudeE7": -71.833561,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 28,
      "punto": 28,
      "latitudeE7": 5.370447,
      "longitudeE7": -71.833523,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 28,
      "punto": 29,
      "latitudeE7": 5.370441,
      "longitudeE7": -71.833486,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 28,
      "punto": 30,
      "latitudeE7": 5.370435,
      "longitudeE7": -71.833448,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 28,
      "punto": 31,
      "latitudeE7": 5.370429,
      "longitudeE7": -71.83341,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 28,
      "punto": 32,
      "latitudeE7": 5.370423,
      "longitudeE7": -71.833373,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 28,
      "punto": 33,
      "latitudeE7": 5.370417,
      "longitudeE7": -71.833335,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 28,
      "punto": 34,
      "latitudeE7": 5.370411,
      "longitudeE7": -71.833297,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 28,
      "punto": 35,
      "latitudeE7": 5.370405,
      "longitudeE7": -71.833259,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 28,
      "punto": 36,
      "latitudeE7": 5.370399,
      "longitudeE7": -71.833222,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 28,
      "punto": 37,
      "latitudeE7": 5.370393,
      "longitudeE7": -71.833184,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 28,
      "punto": 38,
      "latitudeE7": 5.370387,
      "longitudeE7": -71.833146,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 28,
      "punto": 39,
      "latitudeE7": 5.370381,
      "longitudeE7": -71.833109,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 28,
      "punto": 40,
      "latitudeE7": 5.370375,
      "longitudeE7": -71.833071,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 28,
      "punto": 41,
      "latitudeE7": 5.370369,
      "longitudeE7": -71.833033,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 28,
      "punto": 42,
      "latitudeE7": 5.370363,
      "longitudeE7": -71.832995,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 28,
      "punto": 43,
      "latitudeE7": 5.370357,
      "longitudeE7": -71.832958,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 28,
      "punto": 44,
      "latitudeE7": 5.370351,
      "longitudeE7": -71.83292,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 28,
      "punto": 45,
      "latitudeE7": 5.370345,
      "longitudeE7": -71.832882,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 28,
      "punto": 46,
      "latitudeE7": 5.370339,
      "longitudeE7": -71.832845,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 28,
      "punto": 47,
      "latitudeE7": 5.370333,
      "longitudeE7": -71.832807,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 28,
      "punto": 48,
      "latitudeE7": 5.370327,
      "longitudeE7": -71.832769,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 28,
      "punto": 49,
      "latitudeE7": 5.370321,
      "longitudeE7": -71.832731,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 28,
      "punto": 50,
      "latitudeE7": 5.370315,
      "longitudeE7": -71.832694,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 28,
      "punto": 51,
      "latitudeE7": 5.370309,
      "longitudeE7": -71.832656,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 28,
      "punto": 52,
      "latitudeE7": 5.370303,
      "longitudeE7": -71.832618,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 28,
      "punto": 53,
      "latitudeE7": 5.370297,
      "longitudeE7": -71.83258,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 28,
      "punto": 54,
      "latitudeE7": 5.370291,
      "longitudeE7": -71.832543,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 28,
      "punto": 55,
      "latitudeE7": 5.370285,
      "longitudeE7": -71.832505,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 28,
      "punto": 56,
      "latitudeE7": 5.370279,
      "longitudeE7": -71.832467,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 28,
      "punto": 57,
      "latitudeE7": 5.370273,
      "longitudeE7": -71.83243,
      "accuracy": 15,
      "porcentaje": 0.36
    },
    {
      "linea": 28,
      "punto": 58,
      "latitudeE7": 5.370267,
      "longitudeE7": -71.832392,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 28,
      "punto": 59,
      "latitudeE7": 5.370261,
      "longitudeE7": -71.832354,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 28,
      "punto": 60,
      "latitudeE7": 5.370255,
      "longitudeE7": -71.832316,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 28,
      "punto": 61,
      "latitudeE7": 5.370249,
      "longitudeE7": -71.832279,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 28,
      "punto": 62,
      "latitudeE7": 5.370243,
      "longitudeE7": -71.832241,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 28,
      "punto": 63,
      "latitudeE7": 5.370237,
      "longitudeE7": -71.832203,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 28,
      "punto": 64,
      "latitudeE7": 5.370231,
      "longitudeE7": -71.832166,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 28,
      "punto": 65,
      "latitudeE7": 5.370225,
      "longitudeE7": -71.832128,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 28,
      "punto": 66,
      "latitudeE7": 5.370219,
      "longitudeE7": -71.83209,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 28,
      "punto": 67,
      "latitudeE7": 5.370213,
      "longitudeE7": -71.832052,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 28,
      "punto": 68,
      "latitudeE7": 5.370207,
      "longitudeE7": -71.832015,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 28,
      "punto": 69,
      "latitudeE7": 5.370201,
      "longitudeE7": -71.831977,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 28,
      "punto": 70,
      "latitudeE7": 5.370195,
      "longitudeE7": -71.831939,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 28,
      "punto": 71,
      "latitudeE7": 5.370189,
      "longitudeE7": -71.831902,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 28,
      "punto": 72,
      "latitudeE7": 5.370183,
      "longitudeE7": -71.831864,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 28,
      "punto": 73,
      "latitudeE7": 5.370177,
      "longitudeE7": -71.831826,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 28,
      "punto": 74,
      "latitudeE7": 5.370171,
      "longitudeE7": -71.831788,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 28,
      "punto": 75,
      "latitudeE7": 5.370165,
      "longitudeE7": -71.831751,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 28,
      "punto": 76,
      "latitudeE7": 5.370159,
      "longitudeE7": -71.831713,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 28,
      "punto": 77,
      "latitudeE7": 5.370153,
      "longitudeE7": -71.831675,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 28,
      "punto": 78,
      "latitudeE7": 5.370147,
      "longitudeE7": -71.831637,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 28,
      "punto": 79,
      "latitudeE7": 5.370141,
      "longitudeE7": -71.8316,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 28,
      "punto": 80,
      "latitudeE7": 5.370135,
      "longitudeE7": -71.831562,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 28,
      "punto": 81,
      "latitudeE7": 5.370129,
      "longitudeE7": -71.831524,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 28,
      "punto": 82,
      "latitudeE7": 5.370123,
      "longitudeE7": -71.831487,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 28,
      "punto": 83,
      "latitudeE7": 5.370117,
      "longitudeE7": -71.831449,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 28,
      "punto": 84,
      "latitudeE7": 5.370111,
      "longitudeE7": -71.831411,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 28,
      "punto": 85,
      "latitudeE7": 5.370105,
      "longitudeE7": -71.831373,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 28,
      "punto": 86,
      "latitudeE7": 5.370099,
      "longitudeE7": -71.831336,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 28,
      "punto": 87,
      "latitudeE7": 5.370093,
      "longitudeE7": -71.831298,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 28,
      "punto": 88,
      "latitudeE7": 5.370087,
      "longitudeE7": -71.83126,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 28,
      "punto": 89,
      "latitudeE7": 5.370081,
      "longitudeE7": -71.831223,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 28,
      "punto": 90,
      "latitudeE7": 5.370075,
      "longitudeE7": -71.831185,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 28,
      "punto": 91,
      "latitudeE7": 5.370069,
      "longitudeE7": -71.831147,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 28,
      "punto": 92,
      "latitudeE7": 5.370063,
      "longitudeE7": -71.831109,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 28,
      "punto": 93,
      "latitudeE7": 5.370057,
      "longitudeE7": -71.831072,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 28,
      "punto": 94,
      "latitudeE7": 5.370051,
      "longitudeE7": -71.831034,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 28,
      "punto": 95,
      "latitudeE7": 5.370045,
      "longitudeE7": -71.830996,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 28,
      "punto": 96,
      "latitudeE7": 5.370039,
      "longitudeE7": -71.830959,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 28,
      "punto": 97,
      "latitudeE7": 5.370033,
      "longitudeE7": -71.830921,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 28,
      "punto": 98,
      "latitudeE7": 5.370027,
      "longitudeE7": -71.830883,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 28,
      "punto": 99,
      "latitudeE7": 5.370021,
      "longitudeE7": -71.830845,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 28,
      "punto": 100,
      "latitudeE7": 5.370015,
      "longitudeE7": -71.830808,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 28,
      "punto": 101,
      "latitudeE7": 5.370009,
      "longitudeE7": -71.83077,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 28,
      "punto": 102,
      "latitudeE7": 5.370003,
      "longitudeE7": -71.830732,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 28,
      "punto": 103,
      "latitudeE7": 5.369997,
      "longitudeE7": -71.830694,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 28,
      "punto": 104,
      "latitudeE7": 5.369991,
      "longitudeE7": -71.830657,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 28,
      "punto": 105,
      "latitudeE7": 5.369985,
      "longitudeE7": -71.830619,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 28,
      "punto": 106,
      "latitudeE7": 5.369979,
      "longitudeE7": -71.830581,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 28,
      "punto": 107,
      "latitudeE7": 5.369973,
      "longitudeE7": -71.830544,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 28,
      "punto": 108,
      "latitudeE7": 5.369967,
      "longitudeE7": -71.830506,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 28,
      "punto": 109,
      "latitudeE7": 5.369961,
      "longitudeE7": -71.830468,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 28,
      "punto": 110,
      "latitudeE7": 5.369955,
      "longitudeE7": -71.83043,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 28,
      "punto": 111,
      "latitudeE7": 5.369949,
      "longitudeE7": -71.830393,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 28,
      "punto": 112,
      "latitudeE7": 5.369943,
      "longitudeE7": -71.830355,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 28,
      "punto": 113,
      "latitudeE7": 5.369937,
      "longitudeE7": -71.830317,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 28,
      "punto": 114,
      "latitudeE7": 5.369931,
      "longitudeE7": -71.83028,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 29,
      "punto": 1,
      "latitudeE7": 5.370569,
      "longitudeE7": -71.834567,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 29,
      "punto": 2,
      "latitudeE7": 5.370563,
      "longitudeE7": -71.834529,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 29,
      "punto": 3,
      "latitudeE7": 5.370557,
      "longitudeE7": -71.834491,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 29,
      "punto": 4,
      "latitudeE7": 5.370551,
      "longitudeE7": -71.834454,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 29,
      "punto": 5,
      "latitudeE7": 5.370545,
      "longitudeE7": -71.834416,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 29,
      "punto": 6,
      "latitudeE7": 5.370539,
      "longitudeE7": -71.834378,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 29,
      "punto": 7,
      "latitudeE7": 5.370533,
      "longitudeE7": -71.834341,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 29,
      "punto": 8,
      "latitudeE7": 5.370527,
      "longitudeE7": -71.834303,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 29,
      "punto": 9,
      "latitudeE7": 5.370521,
      "longitudeE7": -71.834265,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 29,
      "punto": 10,
      "latitudeE7": 5.370515,
      "longitudeE7": -71.834227,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 29,
      "punto": 11,
      "latitudeE7": 5.370509,
      "longitudeE7": -71.83419,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 29,
      "punto": 12,
      "latitudeE7": 5.370503,
      "longitudeE7": -71.834152,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 29,
      "punto": 13,
      "latitudeE7": 5.370497,
      "longitudeE7": -71.834114,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 29,
      "punto": 14,
      "latitudeE7": 5.370491,
      "longitudeE7": -71.834077,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 29,
      "punto": 15,
      "latitudeE7": 5.370485,
      "longitudeE7": -71.834039,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 29,
      "punto": 16,
      "latitudeE7": 5.370479,
      "longitudeE7": -71.834001,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 29,
      "punto": 17,
      "latitudeE7": 5.370473,
      "longitudeE7": -71.833963,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 29,
      "punto": 18,
      "latitudeE7": 5.370467,
      "longitudeE7": -71.833926,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 29,
      "punto": 19,
      "latitudeE7": 5.370461,
      "longitudeE7": -71.833888,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 29,
      "punto": 20,
      "latitudeE7": 5.370455,
      "longitudeE7": -71.83385,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 29,
      "punto": 21,
      "latitudeE7": 5.370449,
      "longitudeE7": -71.833812,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 29,
      "punto": 22,
      "latitudeE7": 5.370443,
      "longitudeE7": -71.833775,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 29,
      "punto": 23,
      "latitudeE7": 5.370437,
      "longitudeE7": -71.833737,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 29,
      "punto": 24,
      "latitudeE7": 5.370431,
      "longitudeE7": -71.833699,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 29,
      "punto": 25,
      "latitudeE7": 5.370425,
      "longitudeE7": -71.833662,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 29,
      "punto": 26,
      "latitudeE7": 5.370419,
      "longitudeE7": -71.833624,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 29,
      "punto": 27,
      "latitudeE7": 5.370413,
      "longitudeE7": -71.833586,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 29,
      "punto": 28,
      "latitudeE7": 5.370407,
      "longitudeE7": -71.833548,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 29,
      "punto": 29,
      "latitudeE7": 5.370401,
      "longitudeE7": -71.833511,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 29,
      "punto": 30,
      "latitudeE7": 5.370395,
      "longitudeE7": -71.833473,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 29,
      "punto": 31,
      "latitudeE7": 5.370389,
      "longitudeE7": -71.833435,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 29,
      "punto": 32,
      "latitudeE7": 5.370383,
      "longitudeE7": -71.833398,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 29,
      "punto": 33,
      "latitudeE7": 5.370377,
      "longitudeE7": -71.83336,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 29,
      "punto": 34,
      "latitudeE7": 5.370371,
      "longitudeE7": -71.833322,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 29,
      "punto": 35,
      "latitudeE7": 5.370365,
      "longitudeE7": -71.833284,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 29,
      "punto": 36,
      "latitudeE7": 5.370359,
      "longitudeE7": -71.833247,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 29,
      "punto": 37,
      "latitudeE7": 5.370353,
      "longitudeE7": -71.833209,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 29,
      "punto": 38,
      "latitudeE7": 5.370347,
      "longitudeE7": -71.833171,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 29,
      "punto": 39,
      "latitudeE7": 5.370341,
      "longitudeE7": -71.833134,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 29,
      "punto": 40,
      "latitudeE7": 5.370335,
      "longitudeE7": -71.833096,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 29,
      "punto": 41,
      "latitudeE7": 5.370329,
      "longitudeE7": -71.833058,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 29,
      "punto": 42,
      "latitudeE7": 5.370323,
      "longitudeE7": -71.83302,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 29,
      "punto": 43,
      "latitudeE7": 5.370317,
      "longitudeE7": -71.832983,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 29,
      "punto": 44,
      "latitudeE7": 5.370311,
      "longitudeE7": -71.832945,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 29,
      "punto": 45,
      "latitudeE7": 5.370305,
      "longitudeE7": -71.832907,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 29,
      "punto": 46,
      "latitudeE7": 5.370299,
      "longitudeE7": -71.832869,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 29,
      "punto": 47,
      "latitudeE7": 5.370293,
      "longitudeE7": -71.832832,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 29,
      "punto": 48,
      "latitudeE7": 5.370287,
      "longitudeE7": -71.832794,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 29,
      "punto": 49,
      "latitudeE7": 5.370281,
      "longitudeE7": -71.832756,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 29,
      "punto": 50,
      "latitudeE7": 5.370275,
      "longitudeE7": -71.832719,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 29,
      "punto": 51,
      "latitudeE7": 5.370269,
      "longitudeE7": -71.832681,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 29,
      "punto": 52,
      "latitudeE7": 5.370263,
      "longitudeE7": -71.832643,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 29,
      "punto": 53,
      "latitudeE7": 5.370257,
      "longitudeE7": -71.832605,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 29,
      "punto": 54,
      "latitudeE7": 5.370251,
      "longitudeE7": -71.832568,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 29,
      "punto": 55,
      "latitudeE7": 5.370245,
      "longitudeE7": -71.83253,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 29,
      "punto": 56,
      "latitudeE7": 5.370239,
      "longitudeE7": -71.832492,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 29,
      "punto": 57,
      "latitudeE7": 5.370233,
      "longitudeE7": -71.832455,
      "accuracy": 15,
      "porcentaje": 0.12
    },
    {
      "linea": 29,
      "punto": 58,
      "latitudeE7": 5.370227,
      "longitudeE7": -71.832417,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 29,
      "punto": 59,
      "latitudeE7": 5.370221,
      "longitudeE7": -71.832379,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 29,
      "punto": 60,
      "latitudeE7": 5.370215,
      "longitudeE7": -71.832341,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 29,
      "punto": 61,
      "latitudeE7": 5.370209,
      "longitudeE7": -71.832304,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 29,
      "punto": 62,
      "latitudeE7": 5.370203,
      "longitudeE7": -71.832266,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 29,
      "punto": 63,
      "latitudeE7": 5.370197,
      "longitudeE7": -71.832228,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 29,
      "punto": 64,
      "latitudeE7": 5.370191,
      "longitudeE7": -71.832191,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 29,
      "punto": 65,
      "latitudeE7": 5.370185,
      "longitudeE7": -71.832153,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 29,
      "punto": 66,
      "latitudeE7": 5.370179,
      "longitudeE7": -71.832115,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 29,
      "punto": 67,
      "latitudeE7": 5.370173,
      "longitudeE7": -71.832077,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 29,
      "punto": 68,
      "latitudeE7": 5.370167,
      "longitudeE7": -71.83204,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 29,
      "punto": 69,
      "latitudeE7": 5.370161,
      "longitudeE7": -71.832002,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 29,
      "punto": 70,
      "latitudeE7": 5.370155,
      "longitudeE7": -71.831964,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 29,
      "punto": 71,
      "latitudeE7": 5.370149,
      "longitudeE7": -71.831926,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 29,
      "punto": 72,
      "latitudeE7": 5.370143,
      "longitudeE7": -71.831889,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 29,
      "punto": 73,
      "latitudeE7": 5.370137,
      "longitudeE7": -71.831851,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 29,
      "punto": 74,
      "latitudeE7": 5.370131,
      "longitudeE7": -71.831813,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 29,
      "punto": 75,
      "latitudeE7": 5.370125,
      "longitudeE7": -71.831776,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 29,
      "punto": 76,
      "latitudeE7": 5.370119,
      "longitudeE7": -71.831738,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 29,
      "punto": 77,
      "latitudeE7": 5.370113,
      "longitudeE7": -71.8317,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 29,
      "punto": 78,
      "latitudeE7": 5.370107,
      "longitudeE7": -71.831662,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 29,
      "punto": 79,
      "latitudeE7": 5.370101,
      "longitudeE7": -71.831625,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 29,
      "punto": 80,
      "latitudeE7": 5.370095,
      "longitudeE7": -71.831587,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 29,
      "punto": 81,
      "latitudeE7": 5.370089,
      "longitudeE7": -71.831549,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 29,
      "punto": 82,
      "latitudeE7": 5.370083,
      "longitudeE7": -71.831512,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 29,
      "punto": 83,
      "latitudeE7": 5.370077,
      "longitudeE7": -71.831474,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 29,
      "punto": 84,
      "latitudeE7": 5.370071,
      "longitudeE7": -71.831436,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 29,
      "punto": 85,
      "latitudeE7": 5.370065,
      "longitudeE7": -71.831398,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 29,
      "punto": 86,
      "latitudeE7": 5.370059,
      "longitudeE7": -71.831361,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 29,
      "punto": 87,
      "latitudeE7": 5.370053,
      "longitudeE7": -71.831323,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 29,
      "punto": 88,
      "latitudeE7": 5.370047,
      "longitudeE7": -71.831285,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 29,
      "punto": 89,
      "latitudeE7": 5.370041,
      "longitudeE7": -71.831248,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 29,
      "punto": 90,
      "latitudeE7": 5.370035,
      "longitudeE7": -71.83121,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 29,
      "punto": 91,
      "latitudeE7": 5.370029,
      "longitudeE7": -71.831172,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 29,
      "punto": 92,
      "latitudeE7": 5.370023,
      "longitudeE7": -71.831134,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 29,
      "punto": 93,
      "latitudeE7": 5.370017,
      "longitudeE7": -71.831097,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 29,
      "punto": 94,
      "latitudeE7": 5.370011,
      "longitudeE7": -71.831059,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 29,
      "punto": 95,
      "latitudeE7": 5.370005,
      "longitudeE7": -71.831021,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 29,
      "punto": 96,
      "latitudeE7": 5.369999,
      "longitudeE7": -71.830983,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 29,
      "punto": 97,
      "latitudeE7": 5.369993,
      "longitudeE7": -71.830946,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 29,
      "punto": 98,
      "latitudeE7": 5.369987,
      "longitudeE7": -71.830908,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 29,
      "punto": 99,
      "latitudeE7": 5.369981,
      "longitudeE7": -71.83087,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 29,
      "punto": 100,
      "latitudeE7": 5.369975,
      "longitudeE7": -71.830833,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 29,
      "punto": 101,
      "latitudeE7": 5.369969,
      "longitudeE7": -71.830795,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 29,
      "punto": 102,
      "latitudeE7": 5.369963,
      "longitudeE7": -71.830757,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 29,
      "punto": 103,
      "latitudeE7": 5.369957,
      "longitudeE7": -71.830719,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 29,
      "punto": 104,
      "latitudeE7": 5.369951,
      "longitudeE7": -71.830682,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 29,
      "punto": 105,
      "latitudeE7": 5.369945,
      "longitudeE7": -71.830644,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 29,
      "punto": 106,
      "latitudeE7": 5.369939,
      "longitudeE7": -71.830606,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 29,
      "punto": 107,
      "latitudeE7": 5.369933,
      "longitudeE7": -71.830569,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 29,
      "punto": 108,
      "latitudeE7": 5.369927,
      "longitudeE7": -71.830531,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 29,
      "punto": 109,
      "latitudeE7": 5.369921,
      "longitudeE7": -71.830493,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 29,
      "punto": 110,
      "latitudeE7": 5.369915,
      "longitudeE7": -71.830455,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 29,
      "punto": 111,
      "latitudeE7": 5.369909,
      "longitudeE7": -71.830418,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 29,
      "punto": 112,
      "latitudeE7": 5.369903,
      "longitudeE7": -71.83038,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 29,
      "punto": 113,
      "latitudeE7": 5.369897,
      "longitudeE7": -71.830342,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 29,
      "punto": 114,
      "latitudeE7": 5.369891,
      "longitudeE7": -71.830305,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 30,
      "punto": 1,
      "latitudeE7": 5.370529,
      "longitudeE7": -71.834592,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 30,
      "punto": 2,
      "latitudeE7": 5.370523,
      "longitudeE7": -71.834554,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 30,
      "punto": 3,
      "latitudeE7": 5.370517,
      "longitudeE7": -71.834516,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 30,
      "punto": 4,
      "latitudeE7": 5.370511,
      "longitudeE7": -71.834479,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 30,
      "punto": 5,
      "latitudeE7": 5.370505,
      "longitudeE7": -71.834441,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 30,
      "punto": 6,
      "latitudeE7": 5.370499,
      "longitudeE7": -71.834403,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 30,
      "punto": 7,
      "latitudeE7": 5.370493,
      "longitudeE7": -71.834366,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 30,
      "punto": 8,
      "latitudeE7": 5.370487,
      "longitudeE7": -71.834328,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 30,
      "punto": 9,
      "latitudeE7": 5.370481,
      "longitudeE7": -71.83429,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 30,
      "punto": 10,
      "latitudeE7": 5.370475,
      "longitudeE7": -71.834252,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 30,
      "punto": 11,
      "latitudeE7": 5.370469,
      "longitudeE7": -71.834215,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 30,
      "punto": 12,
      "latitudeE7": 5.370463,
      "longitudeE7": -71.834177,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 30,
      "punto": 13,
      "latitudeE7": 5.370457,
      "longitudeE7": -71.834139,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 30,
      "punto": 14,
      "latitudeE7": 5.370451,
      "longitudeE7": -71.834101,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 30,
      "punto": 15,
      "latitudeE7": 5.370445,
      "longitudeE7": -71.834064,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 30,
      "punto": 16,
      "latitudeE7": 5.370439,
      "longitudeE7": -71.834026,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 30,
      "punto": 17,
      "latitudeE7": 5.370433,
      "longitudeE7": -71.833988,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 30,
      "punto": 18,
      "latitudeE7": 5.370427,
      "longitudeE7": -71.833951,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 30,
      "punto": 19,
      "latitudeE7": 5.370421,
      "longitudeE7": -71.833913,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 30,
      "punto": 20,
      "latitudeE7": 5.370415,
      "longitudeE7": -71.833875,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 30,
      "punto": 21,
      "latitudeE7": 5.370409,
      "longitudeE7": -71.833837,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 30,
      "punto": 22,
      "latitudeE7": 5.370403,
      "longitudeE7": -71.8338,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 30,
      "punto": 23,
      "latitudeE7": 5.370397,
      "longitudeE7": -71.833762,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 30,
      "punto": 24,
      "latitudeE7": 5.370391,
      "longitudeE7": -71.833724,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 30,
      "punto": 25,
      "latitudeE7": 5.370385,
      "longitudeE7": -71.833687,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 30,
      "punto": 26,
      "latitudeE7": 5.370379,
      "longitudeE7": -71.833649,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 30,
      "punto": 27,
      "latitudeE7": 5.370373,
      "longitudeE7": -71.833611,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 30,
      "punto": 28,
      "latitudeE7": 5.370367,
      "longitudeE7": -71.833573,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 30,
      "punto": 29,
      "latitudeE7": 5.370361,
      "longitudeE7": -71.833536,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 30,
      "punto": 30,
      "latitudeE7": 5.370355,
      "longitudeE7": -71.833498,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 30,
      "punto": 31,
      "latitudeE7": 5.370349,
      "longitudeE7": -71.83346,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 30,
      "punto": 32,
      "latitudeE7": 5.370343,
      "longitudeE7": -71.833423,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 30,
      "punto": 33,
      "latitudeE7": 5.370337,
      "longitudeE7": -71.833385,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 30,
      "punto": 34,
      "latitudeE7": 5.370331,
      "longitudeE7": -71.833347,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 30,
      "punto": 35,
      "latitudeE7": 5.370325,
      "longitudeE7": -71.833309,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 30,
      "punto": 36,
      "latitudeE7": 5.370319,
      "longitudeE7": -71.833272,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 30,
      "punto": 37,
      "latitudeE7": 5.370313,
      "longitudeE7": -71.833234,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 30,
      "punto": 38,
      "latitudeE7": 5.370307,
      "longitudeE7": -71.833196,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 30,
      "punto": 39,
      "latitudeE7": 5.370301,
      "longitudeE7": -71.833158,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 30,
      "punto": 40,
      "latitudeE7": 5.370295,
      "longitudeE7": -71.833121,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 30,
      "punto": 41,
      "latitudeE7": 5.370289,
      "longitudeE7": -71.833083,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 30,
      "punto": 42,
      "latitudeE7": 5.370283,
      "longitudeE7": -71.833045,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 30,
      "punto": 43,
      "latitudeE7": 5.370277,
      "longitudeE7": -71.833008,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 30,
      "punto": 44,
      "latitudeE7": 5.370271,
      "longitudeE7": -71.83297,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 30,
      "punto": 45,
      "latitudeE7": 5.370265,
      "longitudeE7": -71.832932,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 30,
      "punto": 46,
      "latitudeE7": 5.370259,
      "longitudeE7": -71.832894,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 30,
      "punto": 47,
      "latitudeE7": 5.370253,
      "longitudeE7": -71.832857,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 30,
      "punto": 48,
      "latitudeE7": 5.370247,
      "longitudeE7": -71.832819,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 30,
      "punto": 49,
      "latitudeE7": 5.370241,
      "longitudeE7": -71.832781,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 30,
      "punto": 50,
      "latitudeE7": 5.370235,
      "longitudeE7": -71.832744,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 30,
      "punto": 51,
      "latitudeE7": 5.370229,
      "longitudeE7": -71.832706,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 30,
      "punto": 52,
      "latitudeE7": 5.370223,
      "longitudeE7": -71.832668,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 30,
      "punto": 53,
      "latitudeE7": 5.370217,
      "longitudeE7": -71.83263,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 30,
      "punto": 54,
      "latitudeE7": 5.370211,
      "longitudeE7": -71.832593,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 30,
      "punto": 55,
      "latitudeE7": 5.370205,
      "longitudeE7": -71.832555,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 30,
      "punto": 56,
      "latitudeE7": 5.370199,
      "longitudeE7": -71.832517,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 30,
      "punto": 57,
      "latitudeE7": 5.370193,
      "longitudeE7": -71.83248,
      "accuracy": 15,
      "porcentaje": 0.24
    },
    {
      "linea": 30,
      "punto": 58,
      "latitudeE7": 5.370187,
      "longitudeE7": -71.832442,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 30,
      "punto": 59,
      "latitudeE7": 5.370181,
      "longitudeE7": -71.832404,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 30,
      "punto": 60,
      "latitudeE7": 5.370175,
      "longitudeE7": -71.832366,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 30,
      "punto": 61,
      "latitudeE7": 5.370169,
      "longitudeE7": -71.832329,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 30,
      "punto": 62,
      "latitudeE7": 5.370163,
      "longitudeE7": -71.832291,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 30,
      "punto": 63,
      "latitudeE7": 5.370157,
      "longitudeE7": -71.832253,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 30,
      "punto": 64,
      "latitudeE7": 5.370151,
      "longitudeE7": -71.832215,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 30,
      "punto": 65,
      "latitudeE7": 5.370145,
      "longitudeE7": -71.832178,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 30,
      "punto": 66,
      "latitudeE7": 5.370139,
      "longitudeE7": -71.83214,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 30,
      "punto": 67,
      "latitudeE7": 5.370133,
      "longitudeE7": -71.832102,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 30,
      "punto": 68,
      "latitudeE7": 5.370127,
      "longitudeE7": -71.832065,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 30,
      "punto": 69,
      "latitudeE7": 5.370121,
      "longitudeE7": -71.832027,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 30,
      "punto": 70,
      "latitudeE7": 5.370115,
      "longitudeE7": -71.831989,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 30,
      "punto": 71,
      "latitudeE7": 5.370109,
      "longitudeE7": -71.831951,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 30,
      "punto": 72,
      "latitudeE7": 5.370103,
      "longitudeE7": -71.831914,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 30,
      "punto": 73,
      "latitudeE7": 5.370097,
      "longitudeE7": -71.831876,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 30,
      "punto": 74,
      "latitudeE7": 5.370091,
      "longitudeE7": -71.831838,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 30,
      "punto": 75,
      "latitudeE7": 5.370085,
      "longitudeE7": -71.831801,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 30,
      "punto": 76,
      "latitudeE7": 5.370079,
      "longitudeE7": -71.831763,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 30,
      "punto": 77,
      "latitudeE7": 5.370073,
      "longitudeE7": -71.831725,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 30,
      "punto": 78,
      "latitudeE7": 5.370067,
      "longitudeE7": -71.831687,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 30,
      "punto": 79,
      "latitudeE7": 5.370061,
      "longitudeE7": -71.83165,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 30,
      "punto": 80,
      "latitudeE7": 5.370055,
      "longitudeE7": -71.831612,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 30,
      "punto": 81,
      "latitudeE7": 5.370049,
      "longitudeE7": -71.831574,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 30,
      "punto": 82,
      "latitudeE7": 5.370043,
      "longitudeE7": -71.831537,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 30,
      "punto": 83,
      "latitudeE7": 5.370037,
      "longitudeE7": -71.831499,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 30,
      "punto": 84,
      "latitudeE7": 5.370031,
      "longitudeE7": -71.831461,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 30,
      "punto": 85,
      "latitudeE7": 5.370025,
      "longitudeE7": -71.831423,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 30,
      "punto": 86,
      "latitudeE7": 5.370019,
      "longitudeE7": -71.831386,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 30,
      "punto": 87,
      "latitudeE7": 5.370013,
      "longitudeE7": -71.831348,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 30,
      "punto": 88,
      "latitudeE7": 5.370007,
      "longitudeE7": -71.83131,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 30,
      "punto": 89,
      "latitudeE7": 5.370001,
      "longitudeE7": -71.831272,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 30,
      "punto": 90,
      "latitudeE7": 5.369995,
      "longitudeE7": -71.831235,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 30,
      "punto": 91,
      "latitudeE7": 5.369989,
      "longitudeE7": -71.831197,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 30,
      "punto": 92,
      "latitudeE7": 5.369983,
      "longitudeE7": -71.831159,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 30,
      "punto": 93,
      "latitudeE7": 5.369977,
      "longitudeE7": -71.831122,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 30,
      "punto": 94,
      "latitudeE7": 5.369971,
      "longitudeE7": -71.831084,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 30,
      "punto": 95,
      "latitudeE7": 5.369965,
      "longitudeE7": -71.831046,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 30,
      "punto": 96,
      "latitudeE7": 5.369959,
      "longitudeE7": -71.831008,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 30,
      "punto": 97,
      "latitudeE7": 5.369953,
      "longitudeE7": -71.830971,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 30,
      "punto": 98,
      "latitudeE7": 5.369947,
      "longitudeE7": -71.830933,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 30,
      "punto": 99,
      "latitudeE7": 5.369941,
      "longitudeE7": -71.830895,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 30,
      "punto": 100,
      "latitudeE7": 5.369935,
      "longitudeE7": -71.830858,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 30,
      "punto": 101,
      "latitudeE7": 5.369929,
      "longitudeE7": -71.83082,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 30,
      "punto": 102,
      "latitudeE7": 5.369923,
      "longitudeE7": -71.830782,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 30,
      "punto": 103,
      "latitudeE7": 5.369917,
      "longitudeE7": -71.830744,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 30,
      "punto": 104,
      "latitudeE7": 5.369911,
      "longitudeE7": -71.830707,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 30,
      "punto": 105,
      "latitudeE7": 5.369905,
      "longitudeE7": -71.830669,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 30,
      "punto": 106,
      "latitudeE7": 5.369899,
      "longitudeE7": -71.830631,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 30,
      "punto": 107,
      "latitudeE7": 5.369893,
      "longitudeE7": -71.830594,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 30,
      "punto": 108,
      "latitudeE7": 5.369887,
      "longitudeE7": -71.830556,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 30,
      "punto": 109,
      "latitudeE7": 5.369881,
      "longitudeE7": -71.830518,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 30,
      "punto": 110,
      "latitudeE7": 5.369875,
      "longitudeE7": -71.83048,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 30,
      "punto": 111,
      "latitudeE7": 5.369869,
      "longitudeE7": -71.830443,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 30,
      "punto": 112,
      "latitudeE7": 5.369863,
      "longitudeE7": -71.830405,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 30,
      "punto": 113,
      "latitudeE7": 5.369857,
      "longitudeE7": -71.830367,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 30,
      "punto": 114,
      "latitudeE7": 5.369851,
      "longitudeE7": -71.830329,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 31,
      "punto": 1,
      "latitudeE7": 5.370489,
      "longitudeE7": -71.834617,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 31,
      "punto": 2,
      "latitudeE7": 5.370483,
      "longitudeE7": -71.834579,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 31,
      "punto": 3,
      "latitudeE7": 5.370477,
      "longitudeE7": -71.834541,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 31,
      "punto": 4,
      "latitudeE7": 5.370471,
      "longitudeE7": -71.834504,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 31,
      "punto": 5,
      "latitudeE7": 5.370465,
      "longitudeE7": -71.834466,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 31,
      "punto": 6,
      "latitudeE7": 5.370459,
      "longitudeE7": -71.834428,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 31,
      "punto": 7,
      "latitudeE7": 5.370453,
      "longitudeE7": -71.83439,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 31,
      "punto": 8,
      "latitudeE7": 5.370447,
      "longitudeE7": -71.834353,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 31,
      "punto": 9,
      "latitudeE7": 5.370441,
      "longitudeE7": -71.834315,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 31,
      "punto": 10,
      "latitudeE7": 5.370435,
      "longitudeE7": -71.834277,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 31,
      "punto": 11,
      "latitudeE7": 5.370429,
      "longitudeE7": -71.83424,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 31,
      "punto": 12,
      "latitudeE7": 5.370423,
      "longitudeE7": -71.834202,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 31,
      "punto": 13,
      "latitudeE7": 5.370417,
      "longitudeE7": -71.834164,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 31,
      "punto": 14,
      "latitudeE7": 5.370411,
      "longitudeE7": -71.834126,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 31,
      "punto": 15,
      "latitudeE7": 5.370405,
      "longitudeE7": -71.834089,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 31,
      "punto": 16,
      "latitudeE7": 5.370399,
      "longitudeE7": -71.834051,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 31,
      "punto": 17,
      "latitudeE7": 5.370393,
      "longitudeE7": -71.834013,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 31,
      "punto": 18,
      "latitudeE7": 5.370387,
      "longitudeE7": -71.833976,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 31,
      "punto": 19,
      "latitudeE7": 5.370381,
      "longitudeE7": -71.833938,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 31,
      "punto": 20,
      "latitudeE7": 5.370375,
      "longitudeE7": -71.8339,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 31,
      "punto": 21,
      "latitudeE7": 5.370369,
      "longitudeE7": -71.833862,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 31,
      "punto": 22,
      "latitudeE7": 5.370363,
      "longitudeE7": -71.833825,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 31,
      "punto": 23,
      "latitudeE7": 5.370357,
      "longitudeE7": -71.833787,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 31,
      "punto": 24,
      "latitudeE7": 5.370351,
      "longitudeE7": -71.833749,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 31,
      "punto": 25,
      "latitudeE7": 5.370345,
      "longitudeE7": -71.833712,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 31,
      "punto": 26,
      "latitudeE7": 5.370339,
      "longitudeE7": -71.833674,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 31,
      "punto": 27,
      "latitudeE7": 5.370333,
      "longitudeE7": -71.833636,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 31,
      "punto": 28,
      "latitudeE7": 5.370327,
      "longitudeE7": -71.833598,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 31,
      "punto": 29,
      "latitudeE7": 5.370321,
      "longitudeE7": -71.833561,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 31,
      "punto": 30,
      "latitudeE7": 5.370315,
      "longitudeE7": -71.833523,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 31,
      "punto": 31,
      "latitudeE7": 5.370309,
      "longitudeE7": -71.833485,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 31,
      "punto": 32,
      "latitudeE7": 5.370303,
      "longitudeE7": -71.833447,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 31,
      "punto": 33,
      "latitudeE7": 5.370297,
      "longitudeE7": -71.83341,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 31,
      "punto": 34,
      "latitudeE7": 5.370291,
      "longitudeE7": -71.833372,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 31,
      "punto": 35,
      "latitudeE7": 5.370285,
      "longitudeE7": -71.833334,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 31,
      "punto": 36,
      "latitudeE7": 5.370279,
      "longitudeE7": -71.833297,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 31,
      "punto": 37,
      "latitudeE7": 5.370273,
      "longitudeE7": -71.833259,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 31,
      "punto": 38,
      "latitudeE7": 5.370267,
      "longitudeE7": -71.833221,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 31,
      "punto": 39,
      "latitudeE7": 5.370261,
      "longitudeE7": -71.833183,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 31,
      "punto": 40,
      "latitudeE7": 5.370255,
      "longitudeE7": -71.833146,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 31,
      "punto": 41,
      "latitudeE7": 5.370249,
      "longitudeE7": -71.833108,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 31,
      "punto": 42,
      "latitudeE7": 5.370243,
      "longitudeE7": -71.83307,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 31,
      "punto": 43,
      "latitudeE7": 5.370237,
      "longitudeE7": -71.833033,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 31,
      "punto": 44,
      "latitudeE7": 5.370231,
      "longitudeE7": -71.832995,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 31,
      "punto": 45,
      "latitudeE7": 5.370225,
      "longitudeE7": -71.832957,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 31,
      "punto": 46,
      "latitudeE7": 5.370219,
      "longitudeE7": -71.832919,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 31,
      "punto": 47,
      "latitudeE7": 5.370213,
      "longitudeE7": -71.832882,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 31,
      "punto": 48,
      "latitudeE7": 5.370207,
      "longitudeE7": -71.832844,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 31,
      "punto": 49,
      "latitudeE7": 5.370201,
      "longitudeE7": -71.832806,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 31,
      "punto": 50,
      "latitudeE7": 5.370195,
      "longitudeE7": -71.832769,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 31,
      "punto": 51,
      "latitudeE7": 5.370189,
      "longitudeE7": -71.832731,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 31,
      "punto": 52,
      "latitudeE7": 5.370183,
      "longitudeE7": -71.832693,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 31,
      "punto": 53,
      "latitudeE7": 5.370177,
      "longitudeE7": -71.832655,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 31,
      "punto": 54,
      "latitudeE7": 5.370171,
      "longitudeE7": -71.832618,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 31,
      "punto": 55,
      "latitudeE7": 5.370165,
      "longitudeE7": -71.83258,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 31,
      "punto": 56,
      "latitudeE7": 5.370159,
      "longitudeE7": -71.832542,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 31,
      "punto": 57,
      "latitudeE7": 5.370153,
      "longitudeE7": -71.832504,
      "accuracy": 15,
      "porcentaje": 0.52
    },
    {
      "linea": 31,
      "punto": 58,
      "latitudeE7": 5.370147,
      "longitudeE7": -71.832467,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 31,
      "punto": 59,
      "latitudeE7": 5.370141,
      "longitudeE7": -71.832429,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 31,
      "punto": 60,
      "latitudeE7": 5.370135,
      "longitudeE7": -71.832391,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 31,
      "punto": 61,
      "latitudeE7": 5.370129,
      "longitudeE7": -71.832354,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 31,
      "punto": 62,
      "latitudeE7": 5.370123,
      "longitudeE7": -71.832316,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 31,
      "punto": 63,
      "latitudeE7": 5.370117,
      "longitudeE7": -71.832278,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 31,
      "punto": 64,
      "latitudeE7": 5.370111,
      "longitudeE7": -71.83224,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 31,
      "punto": 65,
      "latitudeE7": 5.370105,
      "longitudeE7": -71.832203,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 31,
      "punto": 66,
      "latitudeE7": 5.370099,
      "longitudeE7": -71.832165,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 31,
      "punto": 67,
      "latitudeE7": 5.370093,
      "longitudeE7": -71.832127,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 31,
      "punto": 68,
      "latitudeE7": 5.370087,
      "longitudeE7": -71.83209,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 31,
      "punto": 69,
      "latitudeE7": 5.370081,
      "longitudeE7": -71.832052,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 31,
      "punto": 70,
      "latitudeE7": 5.370075,
      "longitudeE7": -71.832014,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 31,
      "punto": 71,
      "latitudeE7": 5.370069,
      "longitudeE7": -71.831976,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 31,
      "punto": 72,
      "latitudeE7": 5.370063,
      "longitudeE7": -71.831939,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 31,
      "punto": 73,
      "latitudeE7": 5.370057,
      "longitudeE7": -71.831901,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 31,
      "punto": 74,
      "latitudeE7": 5.370051,
      "longitudeE7": -71.831863,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 31,
      "punto": 75,
      "latitudeE7": 5.370045,
      "longitudeE7": -71.831826,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 31,
      "punto": 76,
      "latitudeE7": 5.370039,
      "longitudeE7": -71.831788,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 31,
      "punto": 77,
      "latitudeE7": 5.370033,
      "longitudeE7": -71.83175,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 31,
      "punto": 78,
      "latitudeE7": 5.370027,
      "longitudeE7": -71.831712,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 31,
      "punto": 79,
      "latitudeE7": 5.370021,
      "longitudeE7": -71.831675,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 31,
      "punto": 80,
      "latitudeE7": 5.370015,
      "longitudeE7": -71.831637,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 31,
      "punto": 81,
      "latitudeE7": 5.370009,
      "longitudeE7": -71.831599,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 31,
      "punto": 82,
      "latitudeE7": 5.370003,
      "longitudeE7": -71.831561,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 31,
      "punto": 83,
      "latitudeE7": 5.369997,
      "longitudeE7": -71.831524,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 31,
      "punto": 84,
      "latitudeE7": 5.369991,
      "longitudeE7": -71.831486,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 31,
      "punto": 85,
      "latitudeE7": 5.369985,
      "longitudeE7": -71.831448,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 31,
      "punto": 86,
      "latitudeE7": 5.369979,
      "longitudeE7": -71.831411,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 31,
      "punto": 87,
      "latitudeE7": 5.369973,
      "longitudeE7": -71.831373,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 31,
      "punto": 88,
      "latitudeE7": 5.369967,
      "longitudeE7": -71.831335,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 31,
      "punto": 89,
      "latitudeE7": 5.369961,
      "longitudeE7": -71.831297,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 31,
      "punto": 90,
      "latitudeE7": 5.369955,
      "longitudeE7": -71.83126,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 31,
      "punto": 91,
      "latitudeE7": 5.369949,
      "longitudeE7": -71.831222,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 31,
      "punto": 92,
      "latitudeE7": 5.369943,
      "longitudeE7": -71.831184,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 31,
      "punto": 93,
      "latitudeE7": 5.369937,
      "longitudeE7": -71.831147,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 31,
      "punto": 94,
      "latitudeE7": 5.369931,
      "longitudeE7": -71.831109,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 31,
      "punto": 95,
      "latitudeE7": 5.369925,
      "longitudeE7": -71.831071,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 31,
      "punto": 96,
      "latitudeE7": 5.369919,
      "longitudeE7": -71.831033,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 31,
      "punto": 97,
      "latitudeE7": 5.369913,
      "longitudeE7": -71.830996,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 31,
      "punto": 98,
      "latitudeE7": 5.369907,
      "longitudeE7": -71.830958,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 31,
      "punto": 99,
      "latitudeE7": 5.369901,
      "longitudeE7": -71.83092,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 31,
      "punto": 100,
      "latitudeE7": 5.369895,
      "longitudeE7": -71.830883,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 31,
      "punto": 101,
      "latitudeE7": 5.369889,
      "longitudeE7": -71.830845,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 31,
      "punto": 102,
      "latitudeE7": 5.369883,
      "longitudeE7": -71.830807,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 31,
      "punto": 103,
      "latitudeE7": 5.369877,
      "longitudeE7": -71.830769,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 31,
      "punto": 104,
      "latitudeE7": 5.369871,
      "longitudeE7": -71.830732,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 31,
      "punto": 105,
      "latitudeE7": 5.369865,
      "longitudeE7": -71.830694,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 31,
      "punto": 106,
      "latitudeE7": 5.369859,
      "longitudeE7": -71.830656,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 31,
      "punto": 107,
      "latitudeE7": 5.369853,
      "longitudeE7": -71.830618,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 31,
      "punto": 108,
      "latitudeE7": 5.369847,
      "longitudeE7": -71.830581,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 31,
      "punto": 109,
      "latitudeE7": 5.369841,
      "longitudeE7": -71.830543,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 31,
      "punto": 110,
      "latitudeE7": 5.369835,
      "longitudeE7": -71.830505,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 31,
      "punto": 111,
      "latitudeE7": 5.369829,
      "longitudeE7": -71.830468,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 31,
      "punto": 112,
      "latitudeE7": 5.369823,
      "longitudeE7": -71.83043,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 31,
      "punto": 113,
      "latitudeE7": 5.369817,
      "longitudeE7": -71.830392,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 31,
      "punto": 114,
      "latitudeE7": 5.369811,
      "longitudeE7": -71.830354,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 32,
      "punto": 1,
      "latitudeE7": 5.370449,
      "longitudeE7": -71.834642,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 32,
      "punto": 2,
      "latitudeE7": 5.370443,
      "longitudeE7": -71.834604,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 32,
      "punto": 3,
      "latitudeE7": 5.370437,
      "longitudeE7": -71.834566,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 32,
      "punto": 4,
      "latitudeE7": 5.370431,
      "longitudeE7": -71.834529,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 32,
      "punto": 5,
      "latitudeE7": 5.370425,
      "longitudeE7": -71.834491,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 32,
      "punto": 6,
      "latitudeE7": 5.370419,
      "longitudeE7": -71.834453,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 32,
      "punto": 7,
      "latitudeE7": 5.370413,
      "longitudeE7": -71.834415,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 32,
      "punto": 8,
      "latitudeE7": 5.370407,
      "longitudeE7": -71.834378,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 32,
      "punto": 9,
      "latitudeE7": 5.370401,
      "longitudeE7": -71.83434,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 32,
      "punto": 10,
      "latitudeE7": 5.370395,
      "longitudeE7": -71.834302,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 32,
      "punto": 11,
      "latitudeE7": 5.370389,
      "longitudeE7": -71.834265,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 32,
      "punto": 12,
      "latitudeE7": 5.370383,
      "longitudeE7": -71.834227,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 32,
      "punto": 13,
      "latitudeE7": 5.370377,
      "longitudeE7": -71.834189,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 32,
      "punto": 14,
      "latitudeE7": 5.370371,
      "longitudeE7": -71.834151,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 32,
      "punto": 15,
      "latitudeE7": 5.370365,
      "longitudeE7": -71.834114,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 32,
      "punto": 16,
      "latitudeE7": 5.370359,
      "longitudeE7": -71.834076,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 32,
      "punto": 17,
      "latitudeE7": 5.370353,
      "longitudeE7": -71.834038,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 32,
      "punto": 18,
      "latitudeE7": 5.370347,
      "longitudeE7": -71.834001,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 32,
      "punto": 19,
      "latitudeE7": 5.370341,
      "longitudeE7": -71.833963,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 32,
      "punto": 20,
      "latitudeE7": 5.370335,
      "longitudeE7": -71.833925,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 32,
      "punto": 21,
      "latitudeE7": 5.370329,
      "longitudeE7": -71.833887,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 32,
      "punto": 22,
      "latitudeE7": 5.370323,
      "longitudeE7": -71.83385,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 32,
      "punto": 23,
      "latitudeE7": 5.370317,
      "longitudeE7": -71.833812,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 32,
      "punto": 24,
      "latitudeE7": 5.370311,
      "longitudeE7": -71.833774,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 32,
      "punto": 25,
      "latitudeE7": 5.370305,
      "longitudeE7": -71.833736,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 32,
      "punto": 26,
      "latitudeE7": 5.370299,
      "longitudeE7": -71.833699,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 32,
      "punto": 27,
      "latitudeE7": 5.370293,
      "longitudeE7": -71.833661,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 32,
      "punto": 28,
      "latitudeE7": 5.370287,
      "longitudeE7": -71.833623,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 32,
      "punto": 29,
      "latitudeE7": 5.370281,
      "longitudeE7": -71.833586,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 32,
      "punto": 30,
      "latitudeE7": 5.370275,
      "longitudeE7": -71.833548,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 32,
      "punto": 31,
      "latitudeE7": 5.370269,
      "longitudeE7": -71.83351,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 32,
      "punto": 32,
      "latitudeE7": 5.370263,
      "longitudeE7": -71.833472,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 32,
      "punto": 33,
      "latitudeE7": 5.370257,
      "longitudeE7": -71.833435,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 32,
      "punto": 34,
      "latitudeE7": 5.370251,
      "longitudeE7": -71.833397,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 32,
      "punto": 35,
      "latitudeE7": 5.370245,
      "longitudeE7": -71.833359,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 32,
      "punto": 36,
      "latitudeE7": 5.370239,
      "longitudeE7": -71.833322,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 32,
      "punto": 37,
      "latitudeE7": 5.370233,
      "longitudeE7": -71.833284,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 32,
      "punto": 38,
      "latitudeE7": 5.370227,
      "longitudeE7": -71.833246,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 32,
      "punto": 39,
      "latitudeE7": 5.370221,
      "longitudeE7": -71.833208,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 32,
      "punto": 40,
      "latitudeE7": 5.370215,
      "longitudeE7": -71.833171,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 32,
      "punto": 41,
      "latitudeE7": 5.370209,
      "longitudeE7": -71.833133,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 32,
      "punto": 42,
      "latitudeE7": 5.370203,
      "longitudeE7": -71.833095,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 32,
      "punto": 43,
      "latitudeE7": 5.370197,
      "longitudeE7": -71.833058,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 32,
      "punto": 44,
      "latitudeE7": 5.370191,
      "longitudeE7": -71.83302,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 32,
      "punto": 45,
      "latitudeE7": 5.370185,
      "longitudeE7": -71.832982,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 32,
      "punto": 46,
      "latitudeE7": 5.370179,
      "longitudeE7": -71.832944,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 32,
      "punto": 47,
      "latitudeE7": 5.370173,
      "longitudeE7": -71.832907,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 32,
      "punto": 48,
      "latitudeE7": 5.370167,
      "longitudeE7": -71.832869,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 32,
      "punto": 49,
      "latitudeE7": 5.370161,
      "longitudeE7": -71.832831,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 32,
      "punto": 50,
      "latitudeE7": 5.370155,
      "longitudeE7": -71.832793,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 32,
      "punto": 51,
      "latitudeE7": 5.370149,
      "longitudeE7": -71.832756,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 32,
      "punto": 52,
      "latitudeE7": 5.370143,
      "longitudeE7": -71.832718,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 32,
      "punto": 53,
      "latitudeE7": 5.370137,
      "longitudeE7": -71.83268,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 32,
      "punto": 54,
      "latitudeE7": 5.370131,
      "longitudeE7": -71.832643,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 32,
      "punto": 55,
      "latitudeE7": 5.370125,
      "longitudeE7": -71.832605,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 32,
      "punto": 56,
      "latitudeE7": 5.370119,
      "longitudeE7": -71.832567,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 32,
      "punto": 57,
      "latitudeE7": 5.370113,
      "longitudeE7": -71.832529,
      "accuracy": 15,
      "porcentaje": 0.04
    },
    {
      "linea": 32,
      "punto": 58,
      "latitudeE7": 5.370107,
      "longitudeE7": -71.832492,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 32,
      "punto": 59,
      "latitudeE7": 5.370101,
      "longitudeE7": -71.832454,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 32,
      "punto": 60,
      "latitudeE7": 5.370095,
      "longitudeE7": -71.832416,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 32,
      "punto": 61,
      "latitudeE7": 5.370089,
      "longitudeE7": -71.832379,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 32,
      "punto": 62,
      "latitudeE7": 5.370083,
      "longitudeE7": -71.832341,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 32,
      "punto": 63,
      "latitudeE7": 5.370077,
      "longitudeE7": -71.832303,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 32,
      "punto": 64,
      "latitudeE7": 5.370071,
      "longitudeE7": -71.832265,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 32,
      "punto": 65,
      "latitudeE7": 5.370065,
      "longitudeE7": -71.832228,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 32,
      "punto": 66,
      "latitudeE7": 5.370059,
      "longitudeE7": -71.83219,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 32,
      "punto": 67,
      "latitudeE7": 5.370053,
      "longitudeE7": -71.832152,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 32,
      "punto": 68,
      "latitudeE7": 5.370047,
      "longitudeE7": -71.832115,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 32,
      "punto": 69,
      "latitudeE7": 5.370041,
      "longitudeE7": -71.832077,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 32,
      "punto": 70,
      "latitudeE7": 5.370035,
      "longitudeE7": -71.832039,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 32,
      "punto": 71,
      "latitudeE7": 5.370029,
      "longitudeE7": -71.832001,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 32,
      "punto": 72,
      "latitudeE7": 5.370023,
      "longitudeE7": -71.831964,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 32,
      "punto": 73,
      "latitudeE7": 5.370017,
      "longitudeE7": -71.831926,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 32,
      "punto": 74,
      "latitudeE7": 5.370011,
      "longitudeE7": -71.831888,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 32,
      "punto": 75,
      "latitudeE7": 5.370005,
      "longitudeE7": -71.83185,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 32,
      "punto": 76,
      "latitudeE7": 5.369999,
      "longitudeE7": -71.831813,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 32,
      "punto": 77,
      "latitudeE7": 5.369993,
      "longitudeE7": -71.831775,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 32,
      "punto": 78,
      "latitudeE7": 5.369987,
      "longitudeE7": -71.831737,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 32,
      "punto": 79,
      "latitudeE7": 5.369981,
      "longitudeE7": -71.8317,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 32,
      "punto": 80,
      "latitudeE7": 5.369975,
      "longitudeE7": -71.831662,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 32,
      "punto": 81,
      "latitudeE7": 5.369969,
      "longitudeE7": -71.831624,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 32,
      "punto": 82,
      "latitudeE7": 5.369963,
      "longitudeE7": -71.831586,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 32,
      "punto": 83,
      "latitudeE7": 5.369957,
      "longitudeE7": -71.831549,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 32,
      "punto": 84,
      "latitudeE7": 5.369951,
      "longitudeE7": -71.831511,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 32,
      "punto": 85,
      "latitudeE7": 5.369945,
      "longitudeE7": -71.831473,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 32,
      "punto": 86,
      "latitudeE7": 5.369939,
      "longitudeE7": -71.831436,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 32,
      "punto": 87,
      "latitudeE7": 5.369933,
      "longitudeE7": -71.831398,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 32,
      "punto": 88,
      "latitudeE7": 5.369927,
      "longitudeE7": -71.83136,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 32,
      "punto": 89,
      "latitudeE7": 5.369921,
      "longitudeE7": -71.831322,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 32,
      "punto": 90,
      "latitudeE7": 5.369915,
      "longitudeE7": -71.831285,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 32,
      "punto": 91,
      "latitudeE7": 5.369909,
      "longitudeE7": -71.831247,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 32,
      "punto": 92,
      "latitudeE7": 5.369903,
      "longitudeE7": -71.831209,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 32,
      "punto": 93,
      "latitudeE7": 5.369897,
      "longitudeE7": -71.831172,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 32,
      "punto": 94,
      "latitudeE7": 5.369891,
      "longitudeE7": -71.831134,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 32,
      "punto": 95,
      "latitudeE7": 5.369885,
      "longitudeE7": -71.831096,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 32,
      "punto": 96,
      "latitudeE7": 5.369879,
      "longitudeE7": -71.831058,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 32,
      "punto": 97,
      "latitudeE7": 5.369873,
      "longitudeE7": -71.831021,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 32,
      "punto": 98,
      "latitudeE7": 5.369867,
      "longitudeE7": -71.830983,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 32,
      "punto": 99,
      "latitudeE7": 5.369861,
      "longitudeE7": -71.830945,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 32,
      "punto": 100,
      "latitudeE7": 5.369855,
      "longitudeE7": -71.830907,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 32,
      "punto": 101,
      "latitudeE7": 5.369849,
      "longitudeE7": -71.83087,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 32,
      "punto": 102,
      "latitudeE7": 5.369843,
      "longitudeE7": -71.830832,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 32,
      "punto": 103,
      "latitudeE7": 5.369837,
      "longitudeE7": -71.830794,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 32,
      "punto": 104,
      "latitudeE7": 5.369831,
      "longitudeE7": -71.830757,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 32,
      "punto": 105,
      "latitudeE7": 5.369825,
      "longitudeE7": -71.830719,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 32,
      "punto": 106,
      "latitudeE7": 5.369819,
      "longitudeE7": -71.830681,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 32,
      "punto": 107,
      "latitudeE7": 5.369813,
      "longitudeE7": -71.830643,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 32,
      "punto": 108,
      "latitudeE7": 5.369807,
      "longitudeE7": -71.830606,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 32,
      "punto": 109,
      "latitudeE7": 5.369801,
      "longitudeE7": -71.830568,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 32,
      "punto": 110,
      "latitudeE7": 5.369795,
      "longitudeE7": -71.83053,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 32,
      "punto": 111,
      "latitudeE7": 5.369789,
      "longitudeE7": -71.830493,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 32,
      "punto": 112,
      "latitudeE7": 5.369783,
      "longitudeE7": -71.830455,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 32,
      "punto": 113,
      "latitudeE7": 5.369777,
      "longitudeE7": -71.830417,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 32,
      "punto": 114,
      "latitudeE7": 5.369771,
      "longitudeE7": -71.830379,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 33,
      "punto": 1,
      "latitudeE7": 5.370409,
      "longitudeE7": -71.834667,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 33,
      "punto": 2,
      "latitudeE7": 5.370403,
      "longitudeE7": -71.834629,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 33,
      "punto": 3,
      "latitudeE7": 5.370397,
      "longitudeE7": -71.834591,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 33,
      "punto": 4,
      "latitudeE7": 5.370391,
      "longitudeE7": -71.834554,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 33,
      "punto": 5,
      "latitudeE7": 5.370385,
      "longitudeE7": -71.834516,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 33,
      "punto": 6,
      "latitudeE7": 5.370379,
      "longitudeE7": -71.834478,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 33,
      "punto": 7,
      "latitudeE7": 5.370373,
      "longitudeE7": -71.83444,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 33,
      "punto": 8,
      "latitudeE7": 5.370367,
      "longitudeE7": -71.834403,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 33,
      "punto": 9,
      "latitudeE7": 5.370361,
      "longitudeE7": -71.834365,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 33,
      "punto": 10,
      "latitudeE7": 5.370355,
      "longitudeE7": -71.834327,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 33,
      "punto": 11,
      "latitudeE7": 5.370349,
      "longitudeE7": -71.83429,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 33,
      "punto": 12,
      "latitudeE7": 5.370343,
      "longitudeE7": -71.834252,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 33,
      "punto": 13,
      "latitudeE7": 5.370337,
      "longitudeE7": -71.834214,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 33,
      "punto": 14,
      "latitudeE7": 5.370331,
      "longitudeE7": -71.834176,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 33,
      "punto": 15,
      "latitudeE7": 5.370325,
      "longitudeE7": -71.834139,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 33,
      "punto": 16,
      "latitudeE7": 5.370319,
      "longitudeE7": -71.834101,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 33,
      "punto": 17,
      "latitudeE7": 5.370313,
      "longitudeE7": -71.834063,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 33,
      "punto": 18,
      "latitudeE7": 5.370307,
      "longitudeE7": -71.834025,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 33,
      "punto": 19,
      "latitudeE7": 5.370301,
      "longitudeE7": -71.833988,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 33,
      "punto": 20,
      "latitudeE7": 5.370295,
      "longitudeE7": -71.83395,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 33,
      "punto": 21,
      "latitudeE7": 5.370289,
      "longitudeE7": -71.833912,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 33,
      "punto": 22,
      "latitudeE7": 5.370283,
      "longitudeE7": -71.833875,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 33,
      "punto": 23,
      "latitudeE7": 5.370277,
      "longitudeE7": -71.833837,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 33,
      "punto": 24,
      "latitudeE7": 5.370271,
      "longitudeE7": -71.833799,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 33,
      "punto": 25,
      "latitudeE7": 5.370265,
      "longitudeE7": -71.833761,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 33,
      "punto": 26,
      "latitudeE7": 5.370259,
      "longitudeE7": -71.833724,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 33,
      "punto": 27,
      "latitudeE7": 5.370253,
      "longitudeE7": -71.833686,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 33,
      "punto": 28,
      "latitudeE7": 5.370247,
      "longitudeE7": -71.833648,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 33,
      "punto": 29,
      "latitudeE7": 5.370241,
      "longitudeE7": -71.833611,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 33,
      "punto": 30,
      "latitudeE7": 5.370235,
      "longitudeE7": -71.833573,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 33,
      "punto": 31,
      "latitudeE7": 5.370229,
      "longitudeE7": -71.833535,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 33,
      "punto": 32,
      "latitudeE7": 5.370223,
      "longitudeE7": -71.833497,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 33,
      "punto": 33,
      "latitudeE7": 5.370217,
      "longitudeE7": -71.83346,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 33,
      "punto": 34,
      "latitudeE7": 5.370211,
      "longitudeE7": -71.833422,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 33,
      "punto": 35,
      "latitudeE7": 5.370205,
      "longitudeE7": -71.833384,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 33,
      "punto": 36,
      "latitudeE7": 5.370199,
      "longitudeE7": -71.833347,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 33,
      "punto": 37,
      "latitudeE7": 5.370193,
      "longitudeE7": -71.833309,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 33,
      "punto": 38,
      "latitudeE7": 5.370187,
      "longitudeE7": -71.833271,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 33,
      "punto": 39,
      "latitudeE7": 5.370181,
      "longitudeE7": -71.833233,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 33,
      "punto": 40,
      "latitudeE7": 5.370175,
      "longitudeE7": -71.833196,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 33,
      "punto": 41,
      "latitudeE7": 5.370169,
      "longitudeE7": -71.833158,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 33,
      "punto": 42,
      "latitudeE7": 5.370163,
      "longitudeE7": -71.83312,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 33,
      "punto": 43,
      "latitudeE7": 5.370157,
      "longitudeE7": -71.833082,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 33,
      "punto": 44,
      "latitudeE7": 5.370151,
      "longitudeE7": -71.833045,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 33,
      "punto": 45,
      "latitudeE7": 5.370145,
      "longitudeE7": -71.833007,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 33,
      "punto": 46,
      "latitudeE7": 5.370139,
      "longitudeE7": -71.832969,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 33,
      "punto": 47,
      "latitudeE7": 5.370133,
      "longitudeE7": -71.832932,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 33,
      "punto": 48,
      "latitudeE7": 5.370127,
      "longitudeE7": -71.832894,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 33,
      "punto": 49,
      "latitudeE7": 5.370121,
      "longitudeE7": -71.832856,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 33,
      "punto": 50,
      "latitudeE7": 5.370115,
      "longitudeE7": -71.832818,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 33,
      "punto": 51,
      "latitudeE7": 5.370109,
      "longitudeE7": -71.832781,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 33,
      "punto": 52,
      "latitudeE7": 5.370103,
      "longitudeE7": -71.832743,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 33,
      "punto": 53,
      "latitudeE7": 5.370097,
      "longitudeE7": -71.832705,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 33,
      "punto": 54,
      "latitudeE7": 5.370091,
      "longitudeE7": -71.832668,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 33,
      "punto": 55,
      "latitudeE7": 5.370085,
      "longitudeE7": -71.83263,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 33,
      "punto": 56,
      "latitudeE7": 5.370079,
      "longitudeE7": -71.832592,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 33,
      "punto": 57,
      "latitudeE7": 5.370073,
      "longitudeE7": -71.832554,
      "accuracy": 15,
      "porcentaje": 0.72
    },
    {
      "linea": 33,
      "punto": 58,
      "latitudeE7": 5.370067,
      "longitudeE7": -71.832517,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 33,
      "punto": 59,
      "latitudeE7": 5.370061,
      "longitudeE7": -71.832479,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 33,
      "punto": 60,
      "latitudeE7": 5.370055,
      "longitudeE7": -71.832441,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 33,
      "punto": 61,
      "latitudeE7": 5.370049,
      "longitudeE7": -71.832404,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 33,
      "punto": 62,
      "latitudeE7": 5.370043,
      "longitudeE7": -71.832366,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 33,
      "punto": 63,
      "latitudeE7": 5.370037,
      "longitudeE7": -71.832328,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 33,
      "punto": 64,
      "latitudeE7": 5.370031,
      "longitudeE7": -71.83229,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 33,
      "punto": 65,
      "latitudeE7": 5.370025,
      "longitudeE7": -71.832253,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 33,
      "punto": 66,
      "latitudeE7": 5.370019,
      "longitudeE7": -71.832215,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 33,
      "punto": 67,
      "latitudeE7": 5.370013,
      "longitudeE7": -71.832177,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 33,
      "punto": 68,
      "latitudeE7": 5.370007,
      "longitudeE7": -71.832139,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 33,
      "punto": 69,
      "latitudeE7": 5.370001,
      "longitudeE7": -71.832102,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 33,
      "punto": 70,
      "latitudeE7": 5.369995,
      "longitudeE7": -71.832064,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 33,
      "punto": 71,
      "latitudeE7": 5.369989,
      "longitudeE7": -71.832026,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 33,
      "punto": 72,
      "latitudeE7": 5.369983,
      "longitudeE7": -71.831989,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 33,
      "punto": 73,
      "latitudeE7": 5.369977,
      "longitudeE7": -71.831951,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 33,
      "punto": 74,
      "latitudeE7": 5.369971,
      "longitudeE7": -71.831913,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 33,
      "punto": 75,
      "latitudeE7": 5.369965,
      "longitudeE7": -71.831875,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 33,
      "punto": 76,
      "latitudeE7": 5.369959,
      "longitudeE7": -71.831838,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 33,
      "punto": 77,
      "latitudeE7": 5.369953,
      "longitudeE7": -71.8318,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 33,
      "punto": 78,
      "latitudeE7": 5.369947,
      "longitudeE7": -71.831762,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 33,
      "punto": 79,
      "latitudeE7": 5.369941,
      "longitudeE7": -71.831725,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 33,
      "punto": 80,
      "latitudeE7": 5.369935,
      "longitudeE7": -71.831687,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 33,
      "punto": 81,
      "latitudeE7": 5.369929,
      "longitudeE7": -71.831649,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 33,
      "punto": 82,
      "latitudeE7": 5.369923,
      "longitudeE7": -71.831611,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 33,
      "punto": 83,
      "latitudeE7": 5.369917,
      "longitudeE7": -71.831574,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 33,
      "punto": 84,
      "latitudeE7": 5.369911,
      "longitudeE7": -71.831536,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 33,
      "punto": 85,
      "latitudeE7": 5.369905,
      "longitudeE7": -71.831498,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 33,
      "punto": 86,
      "latitudeE7": 5.369899,
      "longitudeE7": -71.831461,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 33,
      "punto": 87,
      "latitudeE7": 5.369893,
      "longitudeE7": -71.831423,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 33,
      "punto": 88,
      "latitudeE7": 5.369887,
      "longitudeE7": -71.831385,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 33,
      "punto": 89,
      "latitudeE7": 5.369881,
      "longitudeE7": -71.831347,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 33,
      "punto": 90,
      "latitudeE7": 5.369875,
      "longitudeE7": -71.83131,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 33,
      "punto": 91,
      "latitudeE7": 5.369869,
      "longitudeE7": -71.831272,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 33,
      "punto": 92,
      "latitudeE7": 5.369863,
      "longitudeE7": -71.831234,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 33,
      "punto": 93,
      "latitudeE7": 5.369857,
      "longitudeE7": -71.831196,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 33,
      "punto": 94,
      "latitudeE7": 5.369851,
      "longitudeE7": -71.831159,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 33,
      "punto": 95,
      "latitudeE7": 5.369845,
      "longitudeE7": -71.831121,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 33,
      "punto": 96,
      "latitudeE7": 5.369839,
      "longitudeE7": -71.831083,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 33,
      "punto": 97,
      "latitudeE7": 5.369833,
      "longitudeE7": -71.831046,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 33,
      "punto": 98,
      "latitudeE7": 5.369827,
      "longitudeE7": -71.831008,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 33,
      "punto": 99,
      "latitudeE7": 5.369821,
      "longitudeE7": -71.83097,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 33,
      "punto": 100,
      "latitudeE7": 5.369815,
      "longitudeE7": -71.830932,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 33,
      "punto": 101,
      "latitudeE7": 5.369809,
      "longitudeE7": -71.830895,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 33,
      "punto": 102,
      "latitudeE7": 5.369803,
      "longitudeE7": -71.830857,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 33,
      "punto": 103,
      "latitudeE7": 5.369797,
      "longitudeE7": -71.830819,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 33,
      "punto": 104,
      "latitudeE7": 5.369791,
      "longitudeE7": -71.830782,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 33,
      "punto": 105,
      "latitudeE7": 5.369785,
      "longitudeE7": -71.830744,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 33,
      "punto": 106,
      "latitudeE7": 5.369779,
      "longitudeE7": -71.830706,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 33,
      "punto": 107,
      "latitudeE7": 5.369773,
      "longitudeE7": -71.830668,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 33,
      "punto": 108,
      "latitudeE7": 5.369767,
      "longitudeE7": -71.830631,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 33,
      "punto": 109,
      "latitudeE7": 5.369761,
      "longitudeE7": -71.830593,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 33,
      "punto": 110,
      "latitudeE7": 5.369755,
      "longitudeE7": -71.830555,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 33,
      "punto": 111,
      "latitudeE7": 5.369749,
      "longitudeE7": -71.830518,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 33,
      "punto": 112,
      "latitudeE7": 5.369743,
      "longitudeE7": -71.83048,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 33,
      "punto": 113,
      "latitudeE7": 5.369737,
      "longitudeE7": -71.830442,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 33,
      "punto": 114,
      "latitudeE7": 5.369731,
      "longitudeE7": -71.830404,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 34,
      "punto": 1,
      "latitudeE7": 5.370369,
      "longitudeE7": -71.834692,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 34,
      "punto": 2,
      "latitudeE7": 5.370363,
      "longitudeE7": -71.834654,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 34,
      "punto": 3,
      "latitudeE7": 5.370357,
      "longitudeE7": -71.834616,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 34,
      "punto": 4,
      "latitudeE7": 5.370351,
      "longitudeE7": -71.834579,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 34,
      "punto": 5,
      "latitudeE7": 5.370345,
      "longitudeE7": -71.834541,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 34,
      "punto": 6,
      "latitudeE7": 5.370339,
      "longitudeE7": -71.834503,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 34,
      "punto": 7,
      "latitudeE7": 5.370333,
      "longitudeE7": -71.834465,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 34,
      "punto": 8,
      "latitudeE7": 5.370327,
      "longitudeE7": -71.834428,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 34,
      "punto": 9,
      "latitudeE7": 5.370321,
      "longitudeE7": -71.83439,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 34,
      "punto": 10,
      "latitudeE7": 5.370315,
      "longitudeE7": -71.834352,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 34,
      "punto": 11,
      "latitudeE7": 5.370309,
      "longitudeE7": -71.834314,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 34,
      "punto": 12,
      "latitudeE7": 5.370303,
      "longitudeE7": -71.834277,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 34,
      "punto": 13,
      "latitudeE7": 5.370297,
      "longitudeE7": -71.834239,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 34,
      "punto": 14,
      "latitudeE7": 5.370291,
      "longitudeE7": -71.834201,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 34,
      "punto": 15,
      "latitudeE7": 5.370285,
      "longitudeE7": -71.834164,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 34,
      "punto": 16,
      "latitudeE7": 5.370279,
      "longitudeE7": -71.834126,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 34,
      "punto": 17,
      "latitudeE7": 5.370273,
      "longitudeE7": -71.834088,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 34,
      "punto": 18,
      "latitudeE7": 5.370267,
      "longitudeE7": -71.83405,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 34,
      "punto": 19,
      "latitudeE7": 5.370261,
      "longitudeE7": -71.834013,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 34,
      "punto": 20,
      "latitudeE7": 5.370255,
      "longitudeE7": -71.833975,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 34,
      "punto": 21,
      "latitudeE7": 5.370249,
      "longitudeE7": -71.833937,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 34,
      "punto": 22,
      "latitudeE7": 5.370243,
      "longitudeE7": -71.8339,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 34,
      "punto": 23,
      "latitudeE7": 5.370237,
      "longitudeE7": -71.833862,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 34,
      "punto": 24,
      "latitudeE7": 5.370231,
      "longitudeE7": -71.833824,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 34,
      "punto": 25,
      "latitudeE7": 5.370225,
      "longitudeE7": -71.833786,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 34,
      "punto": 26,
      "latitudeE7": 5.370219,
      "longitudeE7": -71.833749,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 34,
      "punto": 27,
      "latitudeE7": 5.370213,
      "longitudeE7": -71.833711,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 34,
      "punto": 28,
      "latitudeE7": 5.370207,
      "longitudeE7": -71.833673,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 34,
      "punto": 29,
      "latitudeE7": 5.370201,
      "longitudeE7": -71.833636,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 34,
      "punto": 30,
      "latitudeE7": 5.370195,
      "longitudeE7": -71.833598,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 34,
      "punto": 31,
      "latitudeE7": 5.370189,
      "longitudeE7": -71.83356,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 34,
      "punto": 32,
      "latitudeE7": 5.370183,
      "longitudeE7": -71.833522,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 34,
      "punto": 33,
      "latitudeE7": 5.370177,
      "longitudeE7": -71.833485,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 34,
      "punto": 34,
      "latitudeE7": 5.370171,
      "longitudeE7": -71.833447,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 34,
      "punto": 35,
      "latitudeE7": 5.370165,
      "longitudeE7": -71.833409,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 34,
      "punto": 36,
      "latitudeE7": 5.370159,
      "longitudeE7": -71.833371,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 34,
      "punto": 37,
      "latitudeE7": 5.370153,
      "longitudeE7": -71.833334,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 34,
      "punto": 38,
      "latitudeE7": 5.370147,
      "longitudeE7": -71.833296,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 34,
      "punto": 39,
      "latitudeE7": 5.370141,
      "longitudeE7": -71.833258,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 34,
      "punto": 40,
      "latitudeE7": 5.370135,
      "longitudeE7": -71.833221,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 34,
      "punto": 41,
      "latitudeE7": 5.370129,
      "longitudeE7": -71.833183,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 34,
      "punto": 42,
      "latitudeE7": 5.370123,
      "longitudeE7": -71.833145,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 34,
      "punto": 43,
      "latitudeE7": 5.370117,
      "longitudeE7": -71.833107,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 34,
      "punto": 44,
      "latitudeE7": 5.370111,
      "longitudeE7": -71.83307,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 34,
      "punto": 45,
      "latitudeE7": 5.370105,
      "longitudeE7": -71.833032,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 34,
      "punto": 46,
      "latitudeE7": 5.370099,
      "longitudeE7": -71.832994,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 34,
      "punto": 47,
      "latitudeE7": 5.370093,
      "longitudeE7": -71.832957,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 34,
      "punto": 48,
      "latitudeE7": 5.370087,
      "longitudeE7": -71.832919,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 34,
      "punto": 49,
      "latitudeE7": 5.370081,
      "longitudeE7": -71.832881,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 34,
      "punto": 50,
      "latitudeE7": 5.370075,
      "longitudeE7": -71.832843,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 34,
      "punto": 51,
      "latitudeE7": 5.370069,
      "longitudeE7": -71.832806,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 34,
      "punto": 52,
      "latitudeE7": 5.370063,
      "longitudeE7": -71.832768,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 34,
      "punto": 53,
      "latitudeE7": 5.370057,
      "longitudeE7": -71.83273,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 34,
      "punto": 54,
      "latitudeE7": 5.370051,
      "longitudeE7": -71.832693,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 34,
      "punto": 55,
      "latitudeE7": 5.370045,
      "longitudeE7": -71.832655,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 34,
      "punto": 56,
      "latitudeE7": 5.370039,
      "longitudeE7": -71.832617,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 34,
      "punto": 57,
      "latitudeE7": 5.370033,
      "longitudeE7": -71.832579,
      "accuracy": 15,
      "porcentaje": 0.6
    },
    {
      "linea": 34,
      "punto": 58,
      "latitudeE7": 5.370027,
      "longitudeE7": -71.832542,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 34,
      "punto": 59,
      "latitudeE7": 5.370021,
      "longitudeE7": -71.832504,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 34,
      "punto": 60,
      "latitudeE7": 5.370015,
      "longitudeE7": -71.832466,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 34,
      "punto": 61,
      "latitudeE7": 5.370009,
      "longitudeE7": -71.832428,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 34,
      "punto": 62,
      "latitudeE7": 5.370003,
      "longitudeE7": -71.832391,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 34,
      "punto": 63,
      "latitudeE7": 5.369997,
      "longitudeE7": -71.832353,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 34,
      "punto": 64,
      "latitudeE7": 5.369991,
      "longitudeE7": -71.832315,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 34,
      "punto": 65,
      "latitudeE7": 5.369985,
      "longitudeE7": -71.832278,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 34,
      "punto": 66,
      "latitudeE7": 5.369979,
      "longitudeE7": -71.83224,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 34,
      "punto": 67,
      "latitudeE7": 5.369973,
      "longitudeE7": -71.832202,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 34,
      "punto": 68,
      "latitudeE7": 5.369967,
      "longitudeE7": -71.832164,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 34,
      "punto": 69,
      "latitudeE7": 5.369961,
      "longitudeE7": -71.832127,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 34,
      "punto": 70,
      "latitudeE7": 5.369955,
      "longitudeE7": -71.832089,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 34,
      "punto": 71,
      "latitudeE7": 5.369949,
      "longitudeE7": -71.832051,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 34,
      "punto": 72,
      "latitudeE7": 5.369943,
      "longitudeE7": -71.832014,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 34,
      "punto": 73,
      "latitudeE7": 5.369937,
      "longitudeE7": -71.831976,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 34,
      "punto": 74,
      "latitudeE7": 5.369931,
      "longitudeE7": -71.831938,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 34,
      "punto": 75,
      "latitudeE7": 5.369925,
      "longitudeE7": -71.8319,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 34,
      "punto": 76,
      "latitudeE7": 5.369919,
      "longitudeE7": -71.831863,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 34,
      "punto": 77,
      "latitudeE7": 5.369913,
      "longitudeE7": -71.831825,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 34,
      "punto": 78,
      "latitudeE7": 5.369907,
      "longitudeE7": -71.831787,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 34,
      "punto": 79,
      "latitudeE7": 5.369901,
      "longitudeE7": -71.83175,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 34,
      "punto": 80,
      "latitudeE7": 5.369895,
      "longitudeE7": -71.831712,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 34,
      "punto": 81,
      "latitudeE7": 5.369889,
      "longitudeE7": -71.831674,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 34,
      "punto": 82,
      "latitudeE7": 5.369883,
      "longitudeE7": -71.831636,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 34,
      "punto": 83,
      "latitudeE7": 5.369877,
      "longitudeE7": -71.831599,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 34,
      "punto": 84,
      "latitudeE7": 5.369871,
      "longitudeE7": -71.831561,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 34,
      "punto": 85,
      "latitudeE7": 5.369865,
      "longitudeE7": -71.831523,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 34,
      "punto": 86,
      "latitudeE7": 5.369859,
      "longitudeE7": -71.831485,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 34,
      "punto": 87,
      "latitudeE7": 5.369853,
      "longitudeE7": -71.831448,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 34,
      "punto": 88,
      "latitudeE7": 5.369847,
      "longitudeE7": -71.83141,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 34,
      "punto": 89,
      "latitudeE7": 5.369841,
      "longitudeE7": -71.831372,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 34,
      "punto": 90,
      "latitudeE7": 5.369835,
      "longitudeE7": -71.831335,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 34,
      "punto": 91,
      "latitudeE7": 5.369829,
      "longitudeE7": -71.831297,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 34,
      "punto": 92,
      "latitudeE7": 5.369823,
      "longitudeE7": -71.831259,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 34,
      "punto": 93,
      "latitudeE7": 5.369817,
      "longitudeE7": -71.831221,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 34,
      "punto": 94,
      "latitudeE7": 5.369811,
      "longitudeE7": -71.831184,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 34,
      "punto": 95,
      "latitudeE7": 5.369805,
      "longitudeE7": -71.831146,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 34,
      "punto": 96,
      "latitudeE7": 5.369799,
      "longitudeE7": -71.831108,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 34,
      "punto": 97,
      "latitudeE7": 5.369793,
      "longitudeE7": -71.831071,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 34,
      "punto": 98,
      "latitudeE7": 5.369787,
      "longitudeE7": -71.831033,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 34,
      "punto": 99,
      "latitudeE7": 5.369781,
      "longitudeE7": -71.830995,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 34,
      "punto": 100,
      "latitudeE7": 5.369775,
      "longitudeE7": -71.830957,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 34,
      "punto": 101,
      "latitudeE7": 5.369769,
      "longitudeE7": -71.83092,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 34,
      "punto": 102,
      "latitudeE7": 5.369763,
      "longitudeE7": -71.830882,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 34,
      "punto": 103,
      "latitudeE7": 5.369757,
      "longitudeE7": -71.830844,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 34,
      "punto": 104,
      "latitudeE7": 5.369751,
      "longitudeE7": -71.830807,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 34,
      "punto": 105,
      "latitudeE7": 5.369745,
      "longitudeE7": -71.830769,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 34,
      "punto": 106,
      "latitudeE7": 5.369739,
      "longitudeE7": -71.830731,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 34,
      "punto": 107,
      "latitudeE7": 5.369733,
      "longitudeE7": -71.830693,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 34,
      "punto": 108,
      "latitudeE7": 5.369727,
      "longitudeE7": -71.830656,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 34,
      "punto": 109,
      "latitudeE7": 5.369721,
      "longitudeE7": -71.830618,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 34,
      "punto": 110,
      "latitudeE7": 5.369715,
      "longitudeE7": -71.83058,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 34,
      "punto": 111,
      "latitudeE7": 5.369709,
      "longitudeE7": -71.830542,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 34,
      "punto": 112,
      "latitudeE7": 5.369703,
      "longitudeE7": -71.830505,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 34,
      "punto": 113,
      "latitudeE7": 5.369697,
      "longitudeE7": -71.830467,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 34,
      "punto": 114,
      "latitudeE7": 5.369691,
      "longitudeE7": -71.830429,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 35,
      "punto": 1,
      "latitudeE7": 5.370329,
      "longitudeE7": -71.834717,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 35,
      "punto": 2,
      "latitudeE7": 5.370323,
      "longitudeE7": -71.834679,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 35,
      "punto": 3,
      "latitudeE7": 5.370317,
      "longitudeE7": -71.834641,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 35,
      "punto": 4,
      "latitudeE7": 5.370311,
      "longitudeE7": -71.834603,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 35,
      "punto": 5,
      "latitudeE7": 5.370305,
      "longitudeE7": -71.834566,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 35,
      "punto": 6,
      "latitudeE7": 5.370299,
      "longitudeE7": -71.834528,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 35,
      "punto": 7,
      "latitudeE7": 5.370293,
      "longitudeE7": -71.83449,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 35,
      "punto": 8,
      "latitudeE7": 5.370287,
      "longitudeE7": -71.834453,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 35,
      "punto": 9,
      "latitudeE7": 5.370281,
      "longitudeE7": -71.834415,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 35,
      "punto": 10,
      "latitudeE7": 5.370275,
      "longitudeE7": -71.834377,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 35,
      "punto": 11,
      "latitudeE7": 5.370269,
      "longitudeE7": -71.834339,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 35,
      "punto": 12,
      "latitudeE7": 5.370263,
      "longitudeE7": -71.834302,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 35,
      "punto": 13,
      "latitudeE7": 5.370257,
      "longitudeE7": -71.834264,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 35,
      "punto": 14,
      "latitudeE7": 5.370251,
      "longitudeE7": -71.834226,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 35,
      "punto": 15,
      "latitudeE7": 5.370245,
      "longitudeE7": -71.834189,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 35,
      "punto": 16,
      "latitudeE7": 5.370239,
      "longitudeE7": -71.834151,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 35,
      "punto": 17,
      "latitudeE7": 5.370233,
      "longitudeE7": -71.834113,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 35,
      "punto": 18,
      "latitudeE7": 5.370227,
      "longitudeE7": -71.834075,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 35,
      "punto": 19,
      "latitudeE7": 5.370221,
      "longitudeE7": -71.834038,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 35,
      "punto": 20,
      "latitudeE7": 5.370215,
      "longitudeE7": -71.834,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 35,
      "punto": 21,
      "latitudeE7": 5.370209,
      "longitudeE7": -71.833962,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 35,
      "punto": 22,
      "latitudeE7": 5.370203,
      "longitudeE7": -71.833925,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 35,
      "punto": 23,
      "latitudeE7": 5.370197,
      "longitudeE7": -71.833887,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 35,
      "punto": 24,
      "latitudeE7": 5.370191,
      "longitudeE7": -71.833849,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 35,
      "punto": 25,
      "latitudeE7": 5.370185,
      "longitudeE7": -71.833811,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 35,
      "punto": 26,
      "latitudeE7": 5.370179,
      "longitudeE7": -71.833774,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 35,
      "punto": 27,
      "latitudeE7": 5.370173,
      "longitudeE7": -71.833736,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 35,
      "punto": 28,
      "latitudeE7": 5.370167,
      "longitudeE7": -71.833698,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 35,
      "punto": 29,
      "latitudeE7": 5.370161,
      "longitudeE7": -71.83366,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 35,
      "punto": 30,
      "latitudeE7": 5.370155,
      "longitudeE7": -71.833623,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 35,
      "punto": 31,
      "latitudeE7": 5.370149,
      "longitudeE7": -71.833585,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 35,
      "punto": 32,
      "latitudeE7": 5.370143,
      "longitudeE7": -71.833547,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 35,
      "punto": 33,
      "latitudeE7": 5.370137,
      "longitudeE7": -71.83351,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 35,
      "punto": 34,
      "latitudeE7": 5.370131,
      "longitudeE7": -71.833472,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 35,
      "punto": 35,
      "latitudeE7": 5.370125,
      "longitudeE7": -71.833434,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 35,
      "punto": 36,
      "latitudeE7": 5.370119,
      "longitudeE7": -71.833396,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 35,
      "punto": 37,
      "latitudeE7": 5.370113,
      "longitudeE7": -71.833359,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 35,
      "punto": 38,
      "latitudeE7": 5.370107,
      "longitudeE7": -71.833321,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 35,
      "punto": 39,
      "latitudeE7": 5.370101,
      "longitudeE7": -71.833283,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 35,
      "punto": 40,
      "latitudeE7": 5.370095,
      "longitudeE7": -71.833246,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 35,
      "punto": 41,
      "latitudeE7": 5.370089,
      "longitudeE7": -71.833208,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 35,
      "punto": 42,
      "latitudeE7": 5.370083,
      "longitudeE7": -71.83317,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 35,
      "punto": 43,
      "latitudeE7": 5.370077,
      "longitudeE7": -71.833132,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 35,
      "punto": 44,
      "latitudeE7": 5.370071,
      "longitudeE7": -71.833095,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 35,
      "punto": 45,
      "latitudeE7": 5.370065,
      "longitudeE7": -71.833057,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 35,
      "punto": 46,
      "latitudeE7": 5.370059,
      "longitudeE7": -71.833019,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 35,
      "punto": 47,
      "latitudeE7": 5.370053,
      "longitudeE7": -71.832982,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 35,
      "punto": 48,
      "latitudeE7": 5.370047,
      "longitudeE7": -71.832944,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 35,
      "punto": 49,
      "latitudeE7": 5.370041,
      "longitudeE7": -71.832906,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 35,
      "punto": 50,
      "latitudeE7": 5.370035,
      "longitudeE7": -71.832868,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 35,
      "punto": 51,
      "latitudeE7": 5.370029,
      "longitudeE7": -71.832831,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 35,
      "punto": 52,
      "latitudeE7": 5.370023,
      "longitudeE7": -71.832793,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 35,
      "punto": 53,
      "latitudeE7": 5.370017,
      "longitudeE7": -71.832755,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 35,
      "punto": 54,
      "latitudeE7": 5.370011,
      "longitudeE7": -71.832717,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 35,
      "punto": 55,
      "latitudeE7": 5.370005,
      "longitudeE7": -71.83268,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 35,
      "punto": 56,
      "latitudeE7": 5.369999,
      "longitudeE7": -71.832642,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 35,
      "punto": 57,
      "latitudeE7": 5.369993,
      "longitudeE7": -71.832604,
      "accuracy": 15,
      "porcentaje": 0.48
    },
    {
      "linea": 35,
      "punto": 58,
      "latitudeE7": 5.369987,
      "longitudeE7": -71.832567,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 35,
      "punto": 59,
      "latitudeE7": 5.369981,
      "longitudeE7": -71.832529,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 35,
      "punto": 60,
      "latitudeE7": 5.369975,
      "longitudeE7": -71.832491,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 35,
      "punto": 61,
      "latitudeE7": 5.369969,
      "longitudeE7": -71.832453,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 35,
      "punto": 62,
      "latitudeE7": 5.369963,
      "longitudeE7": -71.832416,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 35,
      "punto": 63,
      "latitudeE7": 5.369957,
      "longitudeE7": -71.832378,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 35,
      "punto": 64,
      "latitudeE7": 5.369951,
      "longitudeE7": -71.83234,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 35,
      "punto": 65,
      "latitudeE7": 5.369945,
      "longitudeE7": -71.832303,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 35,
      "punto": 66,
      "latitudeE7": 5.369939,
      "longitudeE7": -71.832265,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 35,
      "punto": 67,
      "latitudeE7": 5.369933,
      "longitudeE7": -71.832227,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 35,
      "punto": 68,
      "latitudeE7": 5.369927,
      "longitudeE7": -71.832189,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 35,
      "punto": 69,
      "latitudeE7": 5.369921,
      "longitudeE7": -71.832152,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 35,
      "punto": 70,
      "latitudeE7": 5.369915,
      "longitudeE7": -71.832114,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 35,
      "punto": 71,
      "latitudeE7": 5.369909,
      "longitudeE7": -71.832076,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 35,
      "punto": 72,
      "latitudeE7": 5.369903,
      "longitudeE7": -71.832039,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 35,
      "punto": 73,
      "latitudeE7": 5.369897,
      "longitudeE7": -71.832001,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 35,
      "punto": 74,
      "latitudeE7": 5.369891,
      "longitudeE7": -71.831963,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 35,
      "punto": 75,
      "latitudeE7": 5.369885,
      "longitudeE7": -71.831925,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 35,
      "punto": 76,
      "latitudeE7": 5.369879,
      "longitudeE7": -71.831888,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 35,
      "punto": 77,
      "latitudeE7": 5.369873,
      "longitudeE7": -71.83185,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 35,
      "punto": 78,
      "latitudeE7": 5.369867,
      "longitudeE7": -71.831812,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 35,
      "punto": 79,
      "latitudeE7": 5.369861,
      "longitudeE7": -71.831774,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 35,
      "punto": 80,
      "latitudeE7": 5.369855,
      "longitudeE7": -71.831737,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 35,
      "punto": 81,
      "latitudeE7": 5.369849,
      "longitudeE7": -71.831699,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 35,
      "punto": 82,
      "latitudeE7": 5.369843,
      "longitudeE7": -71.831661,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 35,
      "punto": 83,
      "latitudeE7": 5.369837,
      "longitudeE7": -71.831624,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 35,
      "punto": 84,
      "latitudeE7": 5.369831,
      "longitudeE7": -71.831586,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 35,
      "punto": 85,
      "latitudeE7": 5.369825,
      "longitudeE7": -71.831548,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 35,
      "punto": 86,
      "latitudeE7": 5.369819,
      "longitudeE7": -71.83151,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 35,
      "punto": 87,
      "latitudeE7": 5.369813,
      "longitudeE7": -71.831473,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 35,
      "punto": 88,
      "latitudeE7": 5.369807,
      "longitudeE7": -71.831435,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 35,
      "punto": 89,
      "latitudeE7": 5.369801,
      "longitudeE7": -71.831397,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 35,
      "punto": 90,
      "latitudeE7": 5.369795,
      "longitudeE7": -71.83136,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 35,
      "punto": 91,
      "latitudeE7": 5.369789,
      "longitudeE7": -71.831322,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 35,
      "punto": 92,
      "latitudeE7": 5.369783,
      "longitudeE7": -71.831284,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 35,
      "punto": 93,
      "latitudeE7": 5.369777,
      "longitudeE7": -71.831246,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 35,
      "punto": 94,
      "latitudeE7": 5.369771,
      "longitudeE7": -71.831209,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 35,
      "punto": 95,
      "latitudeE7": 5.369765,
      "longitudeE7": -71.831171,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 35,
      "punto": 96,
      "latitudeE7": 5.369759,
      "longitudeE7": -71.831133,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 35,
      "punto": 97,
      "latitudeE7": 5.369753,
      "longitudeE7": -71.831096,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 35,
      "punto": 98,
      "latitudeE7": 5.369747,
      "longitudeE7": -71.831058,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 35,
      "punto": 99,
      "latitudeE7": 5.369741,
      "longitudeE7": -71.83102,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 35,
      "punto": 100,
      "latitudeE7": 5.369735,
      "longitudeE7": -71.830982,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 35,
      "punto": 101,
      "latitudeE7": 5.369729,
      "longitudeE7": -71.830945,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 35,
      "punto": 102,
      "latitudeE7": 5.369723,
      "longitudeE7": -71.830907,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 35,
      "punto": 103,
      "latitudeE7": 5.369717,
      "longitudeE7": -71.830869,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 35,
      "punto": 104,
      "latitudeE7": 5.369711,
      "longitudeE7": -71.830831,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 35,
      "punto": 105,
      "latitudeE7": 5.369705,
      "longitudeE7": -71.830794,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 35,
      "punto": 106,
      "latitudeE7": 5.369699,
      "longitudeE7": -71.830756,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 35,
      "punto": 107,
      "latitudeE7": 5.369693,
      "longitudeE7": -71.830718,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 35,
      "punto": 108,
      "latitudeE7": 5.369687,
      "longitudeE7": -71.830681,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 35,
      "punto": 109,
      "latitudeE7": 5.369681,
      "longitudeE7": -71.830643,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 35,
      "punto": 110,
      "latitudeE7": 5.369675,
      "longitudeE7": -71.830605,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 35,
      "punto": 111,
      "latitudeE7": 5.369669,
      "longitudeE7": -71.830567,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 35,
      "punto": 112,
      "latitudeE7": 5.369663,
      "longitudeE7": -71.83053,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 35,
      "punto": 113,
      "latitudeE7": 5.369657,
      "longitudeE7": -71.830492,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 35,
      "punto": 114,
      "latitudeE7": 5.369651,
      "longitudeE7": -71.830454,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 36,
      "punto": 1,
      "latitudeE7": 5.370289,
      "longitudeE7": -71.834742,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 36,
      "punto": 2,
      "latitudeE7": 5.370283,
      "longitudeE7": -71.834704,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 36,
      "punto": 3,
      "latitudeE7": 5.370277,
      "longitudeE7": -71.834666,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 36,
      "punto": 4,
      "latitudeE7": 5.370271,
      "longitudeE7": -71.834628,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 36,
      "punto": 5,
      "latitudeE7": 5.370265,
      "longitudeE7": -71.834591,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 36,
      "punto": 6,
      "latitudeE7": 5.370259,
      "longitudeE7": -71.834553,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 36,
      "punto": 7,
      "latitudeE7": 5.370253,
      "longitudeE7": -71.834515,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 36,
      "punto": 8,
      "latitudeE7": 5.370247,
      "longitudeE7": -71.834478,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 36,
      "punto": 9,
      "latitudeE7": 5.370241,
      "longitudeE7": -71.83444,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 36,
      "punto": 10,
      "latitudeE7": 5.370235,
      "longitudeE7": -71.834402,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 36,
      "punto": 11,
      "latitudeE7": 5.370229,
      "longitudeE7": -71.834364,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 36,
      "punto": 12,
      "latitudeE7": 5.370223,
      "longitudeE7": -71.834327,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 36,
      "punto": 13,
      "latitudeE7": 5.370217,
      "longitudeE7": -71.834289,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 36,
      "punto": 14,
      "latitudeE7": 5.370211,
      "longitudeE7": -71.834251,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 36,
      "punto": 15,
      "latitudeE7": 5.370205,
      "longitudeE7": -71.834214,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 36,
      "punto": 16,
      "latitudeE7": 5.370199,
      "longitudeE7": -71.834176,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 36,
      "punto": 17,
      "latitudeE7": 5.370193,
      "longitudeE7": -71.834138,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 36,
      "punto": 18,
      "latitudeE7": 5.370187,
      "longitudeE7": -71.8341,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 36,
      "punto": 19,
      "latitudeE7": 5.370181,
      "longitudeE7": -71.834063,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 36,
      "punto": 20,
      "latitudeE7": 5.370175,
      "longitudeE7": -71.834025,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 36,
      "punto": 21,
      "latitudeE7": 5.370169,
      "longitudeE7": -71.833987,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 36,
      "punto": 22,
      "latitudeE7": 5.370163,
      "longitudeE7": -71.833949,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 36,
      "punto": 23,
      "latitudeE7": 5.370157,
      "longitudeE7": -71.833912,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 36,
      "punto": 24,
      "latitudeE7": 5.370151,
      "longitudeE7": -71.833874,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 36,
      "punto": 25,
      "latitudeE7": 5.370145,
      "longitudeE7": -71.833836,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 36,
      "punto": 26,
      "latitudeE7": 5.370139,
      "longitudeE7": -71.833799,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 36,
      "punto": 27,
      "latitudeE7": 5.370133,
      "longitudeE7": -71.833761,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 36,
      "punto": 28,
      "latitudeE7": 5.370127,
      "longitudeE7": -71.833723,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 36,
      "punto": 29,
      "latitudeE7": 5.370121,
      "longitudeE7": -71.833685,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 36,
      "punto": 30,
      "latitudeE7": 5.370115,
      "longitudeE7": -71.833648,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 36,
      "punto": 31,
      "latitudeE7": 5.370109,
      "longitudeE7": -71.83361,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 36,
      "punto": 32,
      "latitudeE7": 5.370103,
      "longitudeE7": -71.833572,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 36,
      "punto": 33,
      "latitudeE7": 5.370097,
      "longitudeE7": -71.833535,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 36,
      "punto": 34,
      "latitudeE7": 5.370091,
      "longitudeE7": -71.833497,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 36,
      "punto": 35,
      "latitudeE7": 5.370085,
      "longitudeE7": -71.833459,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 36,
      "punto": 36,
      "latitudeE7": 5.370079,
      "longitudeE7": -71.833421,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 36,
      "punto": 37,
      "latitudeE7": 5.370073,
      "longitudeE7": -71.833384,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 36,
      "punto": 38,
      "latitudeE7": 5.370067,
      "longitudeE7": -71.833346,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 36,
      "punto": 39,
      "latitudeE7": 5.370061,
      "longitudeE7": -71.833308,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 36,
      "punto": 40,
      "latitudeE7": 5.370055,
      "longitudeE7": -71.833271,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 36,
      "punto": 41,
      "latitudeE7": 5.370049,
      "longitudeE7": -71.833233,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 36,
      "punto": 42,
      "latitudeE7": 5.370043,
      "longitudeE7": -71.833195,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 36,
      "punto": 43,
      "latitudeE7": 5.370037,
      "longitudeE7": -71.833157,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 36,
      "punto": 44,
      "latitudeE7": 5.370031,
      "longitudeE7": -71.83312,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 36,
      "punto": 45,
      "latitudeE7": 5.370025,
      "longitudeE7": -71.833082,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 36,
      "punto": 46,
      "latitudeE7": 5.370019,
      "longitudeE7": -71.833044,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 36,
      "punto": 47,
      "latitudeE7": 5.370013,
      "longitudeE7": -71.833006,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 36,
      "punto": 48,
      "latitudeE7": 5.370007,
      "longitudeE7": -71.832969,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 36,
      "punto": 49,
      "latitudeE7": 5.370001,
      "longitudeE7": -71.832931,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 36,
      "punto": 50,
      "latitudeE7": 5.369995,
      "longitudeE7": -71.832893,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 36,
      "punto": 51,
      "latitudeE7": 5.369989,
      "longitudeE7": -71.832856,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 36,
      "punto": 52,
      "latitudeE7": 5.369983,
      "longitudeE7": -71.832818,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 36,
      "punto": 53,
      "latitudeE7": 5.369977,
      "longitudeE7": -71.83278,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 36,
      "punto": 54,
      "latitudeE7": 5.369971,
      "longitudeE7": -71.832742,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 36,
      "punto": 55,
      "latitudeE7": 5.369965,
      "longitudeE7": -71.832705,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 36,
      "punto": 56,
      "latitudeE7": 5.369959,
      "longitudeE7": -71.832667,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 36,
      "punto": 57,
      "latitudeE7": 5.369953,
      "longitudeE7": -71.832629,
      "accuracy": 15,
      "porcentaje": 0.08
    },
    {
      "linea": 36,
      "punto": 58,
      "latitudeE7": 5.369947,
      "longitudeE7": -71.832592,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 36,
      "punto": 59,
      "latitudeE7": 5.369941,
      "longitudeE7": -71.832554,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 36,
      "punto": 60,
      "latitudeE7": 5.369935,
      "longitudeE7": -71.832516,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 36,
      "punto": 61,
      "latitudeE7": 5.369929,
      "longitudeE7": -71.832478,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 36,
      "punto": 62,
      "latitudeE7": 5.369923,
      "longitudeE7": -71.832441,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 36,
      "punto": 63,
      "latitudeE7": 5.369917,
      "longitudeE7": -71.832403,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 36,
      "punto": 64,
      "latitudeE7": 5.369911,
      "longitudeE7": -71.832365,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 36,
      "punto": 65,
      "latitudeE7": 5.369905,
      "longitudeE7": -71.832328,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 36,
      "punto": 66,
      "latitudeE7": 5.369899,
      "longitudeE7": -71.83229,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 36,
      "punto": 67,
      "latitudeE7": 5.369893,
      "longitudeE7": -71.832252,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 36,
      "punto": 68,
      "latitudeE7": 5.369887,
      "longitudeE7": -71.832214,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 36,
      "punto": 69,
      "latitudeE7": 5.369881,
      "longitudeE7": -71.832177,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 36,
      "punto": 70,
      "latitudeE7": 5.369875,
      "longitudeE7": -71.832139,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 36,
      "punto": 71,
      "latitudeE7": 5.369869,
      "longitudeE7": -71.832101,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 36,
      "punto": 72,
      "latitudeE7": 5.369863,
      "longitudeE7": -71.832063,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 36,
      "punto": 73,
      "latitudeE7": 5.369857,
      "longitudeE7": -71.832026,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 36,
      "punto": 74,
      "latitudeE7": 5.369851,
      "longitudeE7": -71.831988,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 36,
      "punto": 75,
      "latitudeE7": 5.369845,
      "longitudeE7": -71.83195,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 36,
      "punto": 76,
      "latitudeE7": 5.369839,
      "longitudeE7": -71.831913,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 36,
      "punto": 77,
      "latitudeE7": 5.369833,
      "longitudeE7": -71.831875,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 36,
      "punto": 78,
      "latitudeE7": 5.369827,
      "longitudeE7": -71.831837,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 36,
      "punto": 79,
      "latitudeE7": 5.369821,
      "longitudeE7": -71.831799,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 36,
      "punto": 80,
      "latitudeE7": 5.369815,
      "longitudeE7": -71.831762,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 36,
      "punto": 81,
      "latitudeE7": 5.369809,
      "longitudeE7": -71.831724,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 36,
      "punto": 82,
      "latitudeE7": 5.369803,
      "longitudeE7": -71.831686,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 36,
      "punto": 83,
      "latitudeE7": 5.369797,
      "longitudeE7": -71.831649,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 36,
      "punto": 84,
      "latitudeE7": 5.369791,
      "longitudeE7": -71.831611,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 36,
      "punto": 85,
      "latitudeE7": 5.369785,
      "longitudeE7": -71.831573,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 36,
      "punto": 86,
      "latitudeE7": 5.369779,
      "longitudeE7": -71.831535,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 36,
      "punto": 87,
      "latitudeE7": 5.369773,
      "longitudeE7": -71.831498,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 36,
      "punto": 88,
      "latitudeE7": 5.369767,
      "longitudeE7": -71.83146,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 36,
      "punto": 89,
      "latitudeE7": 5.369761,
      "longitudeE7": -71.831422,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 36,
      "punto": 90,
      "latitudeE7": 5.369755,
      "longitudeE7": -71.831385,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 36,
      "punto": 91,
      "latitudeE7": 5.369749,
      "longitudeE7": -71.831347,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 36,
      "punto": 92,
      "latitudeE7": 5.369743,
      "longitudeE7": -71.831309,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 36,
      "punto": 93,
      "latitudeE7": 5.369737,
      "longitudeE7": -71.831271,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 36,
      "punto": 94,
      "latitudeE7": 5.369731,
      "longitudeE7": -71.831234,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 36,
      "punto": 95,
      "latitudeE7": 5.369725,
      "longitudeE7": -71.831196,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 36,
      "punto": 96,
      "latitudeE7": 5.369719,
      "longitudeE7": -71.831158,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 36,
      "punto": 97,
      "latitudeE7": 5.369713,
      "longitudeE7": -71.83112,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 36,
      "punto": 98,
      "latitudeE7": 5.369707,
      "longitudeE7": -71.831083,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 36,
      "punto": 99,
      "latitudeE7": 5.369701,
      "longitudeE7": -71.831045,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 36,
      "punto": 100,
      "latitudeE7": 5.369695,
      "longitudeE7": -71.831007,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 36,
      "punto": 101,
      "latitudeE7": 5.369689,
      "longitudeE7": -71.83097,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 36,
      "punto": 102,
      "latitudeE7": 5.369683,
      "longitudeE7": -71.830932,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 36,
      "punto": 103,
      "latitudeE7": 5.369677,
      "longitudeE7": -71.830894,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 36,
      "punto": 104,
      "latitudeE7": 5.369671,
      "longitudeE7": -71.830856,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 36,
      "punto": 105,
      "latitudeE7": 5.369665,
      "longitudeE7": -71.830819,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 36,
      "punto": 106,
      "latitudeE7": 5.369659,
      "longitudeE7": -71.830781,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 36,
      "punto": 107,
      "latitudeE7": 5.369653,
      "longitudeE7": -71.830743,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 36,
      "punto": 108,
      "latitudeE7": 5.369647,
      "longitudeE7": -71.830706,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 36,
      "punto": 109,
      "latitudeE7": 5.369641,
      "longitudeE7": -71.830668,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 36,
      "punto": 110,
      "latitudeE7": 5.369635,
      "longitudeE7": -71.83063,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 36,
      "punto": 111,
      "latitudeE7": 5.369629,
      "longitudeE7": -71.830592,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 36,
      "punto": 112,
      "latitudeE7": 5.369623,
      "longitudeE7": -71.830555,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 36,
      "punto": 113,
      "latitudeE7": 5.369617,
      "longitudeE7": -71.830517,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 36,
      "punto": 114,
      "latitudeE7": 5.369611,
      "longitudeE7": -71.830479,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 37,
      "punto": 1,
      "latitudeE7": 5.370249,
      "longitudeE7": -71.834767,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 37,
      "punto": 2,
      "latitudeE7": 5.370243,
      "longitudeE7": -71.834729,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 37,
      "punto": 3,
      "latitudeE7": 5.370237,
      "longitudeE7": -71.834691,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 37,
      "punto": 4,
      "latitudeE7": 5.370231,
      "longitudeE7": -71.834653,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 37,
      "punto": 5,
      "latitudeE7": 5.370225,
      "longitudeE7": -71.834616,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 37,
      "punto": 6,
      "latitudeE7": 5.370219,
      "longitudeE7": -71.834578,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 37,
      "punto": 7,
      "latitudeE7": 5.370213,
      "longitudeE7": -71.83454,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 37,
      "punto": 8,
      "latitudeE7": 5.370207,
      "longitudeE7": -71.834503,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 37,
      "punto": 9,
      "latitudeE7": 5.370201,
      "longitudeE7": -71.834465,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 37,
      "punto": 10,
      "latitudeE7": 5.370195,
      "longitudeE7": -71.834427,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 37,
      "punto": 11,
      "latitudeE7": 5.370189,
      "longitudeE7": -71.834389,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 37,
      "punto": 12,
      "latitudeE7": 5.370183,
      "longitudeE7": -71.834352,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 37,
      "punto": 13,
      "latitudeE7": 5.370177,
      "longitudeE7": -71.834314,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 37,
      "punto": 14,
      "latitudeE7": 5.370171,
      "longitudeE7": -71.834276,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 37,
      "punto": 15,
      "latitudeE7": 5.370165,
      "longitudeE7": -71.834238,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 37,
      "punto": 16,
      "latitudeE7": 5.370159,
      "longitudeE7": -71.834201,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 37,
      "punto": 17,
      "latitudeE7": 5.370153,
      "longitudeE7": -71.834163,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 37,
      "punto": 18,
      "latitudeE7": 5.370147,
      "longitudeE7": -71.834125,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 37,
      "punto": 19,
      "latitudeE7": 5.370141,
      "longitudeE7": -71.834088,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 37,
      "punto": 20,
      "latitudeE7": 5.370135,
      "longitudeE7": -71.83405,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 37,
      "punto": 21,
      "latitudeE7": 5.370129,
      "longitudeE7": -71.834012,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 37,
      "punto": 22,
      "latitudeE7": 5.370123,
      "longitudeE7": -71.833974,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 37,
      "punto": 23,
      "latitudeE7": 5.370117,
      "longitudeE7": -71.833937,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 37,
      "punto": 24,
      "latitudeE7": 5.370111,
      "longitudeE7": -71.833899,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 37,
      "punto": 25,
      "latitudeE7": 5.370105,
      "longitudeE7": -71.833861,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 37,
      "punto": 26,
      "latitudeE7": 5.370099,
      "longitudeE7": -71.833824,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 37,
      "punto": 27,
      "latitudeE7": 5.370093,
      "longitudeE7": -71.833786,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 37,
      "punto": 28,
      "latitudeE7": 5.370087,
      "longitudeE7": -71.833748,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 37,
      "punto": 29,
      "latitudeE7": 5.370081,
      "longitudeE7": -71.83371,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 37,
      "punto": 30,
      "latitudeE7": 5.370075,
      "longitudeE7": -71.833673,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 37,
      "punto": 31,
      "latitudeE7": 5.370069,
      "longitudeE7": -71.833635,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 37,
      "punto": 32,
      "latitudeE7": 5.370063,
      "longitudeE7": -71.833597,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 37,
      "punto": 33,
      "latitudeE7": 5.370057,
      "longitudeE7": -71.83356,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 37,
      "punto": 34,
      "latitudeE7": 5.370051,
      "longitudeE7": -71.833522,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 37,
      "punto": 35,
      "latitudeE7": 5.370045,
      "longitudeE7": -71.833484,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 37,
      "punto": 36,
      "latitudeE7": 5.370039,
      "longitudeE7": -71.833446,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 37,
      "punto": 37,
      "latitudeE7": 5.370033,
      "longitudeE7": -71.833409,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 37,
      "punto": 38,
      "latitudeE7": 5.370027,
      "longitudeE7": -71.833371,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 37,
      "punto": 39,
      "latitudeE7": 5.370021,
      "longitudeE7": -71.833333,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 37,
      "punto": 40,
      "latitudeE7": 5.370015,
      "longitudeE7": -71.833295,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 37,
      "punto": 41,
      "latitudeE7": 5.370009,
      "longitudeE7": -71.833258,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 37,
      "punto": 42,
      "latitudeE7": 5.370003,
      "longitudeE7": -71.83322,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 37,
      "punto": 43,
      "latitudeE7": 5.369997,
      "longitudeE7": -71.833182,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 37,
      "punto": 44,
      "latitudeE7": 5.369991,
      "longitudeE7": -71.833145,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 37,
      "punto": 45,
      "latitudeE7": 5.369985,
      "longitudeE7": -71.833107,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 37,
      "punto": 46,
      "latitudeE7": 5.369979,
      "longitudeE7": -71.833069,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 37,
      "punto": 47,
      "latitudeE7": 5.369973,
      "longitudeE7": -71.833031,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 37,
      "punto": 48,
      "latitudeE7": 5.369967,
      "longitudeE7": -71.832994,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 37,
      "punto": 49,
      "latitudeE7": 5.369961,
      "longitudeE7": -71.832956,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 37,
      "punto": 50,
      "latitudeE7": 5.369955,
      "longitudeE7": -71.832918,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 37,
      "punto": 51,
      "latitudeE7": 5.369949,
      "longitudeE7": -71.832881,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 37,
      "punto": 52,
      "latitudeE7": 5.369943,
      "longitudeE7": -71.832843,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 37,
      "punto": 53,
      "latitudeE7": 5.369937,
      "longitudeE7": -71.832805,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 37,
      "punto": 54,
      "latitudeE7": 5.369931,
      "longitudeE7": -71.832767,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 37,
      "punto": 55,
      "latitudeE7": 5.369925,
      "longitudeE7": -71.83273,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 37,
      "punto": 56,
      "latitudeE7": 5.369919,
      "longitudeE7": -71.832692,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 37,
      "punto": 57,
      "latitudeE7": 5.369913,
      "longitudeE7": -71.832654,
      "accuracy": 15,
      "porcentaje": 0.68
    },
    {
      "linea": 37,
      "punto": 58,
      "latitudeE7": 5.369907,
      "longitudeE7": -71.832617,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 37,
      "punto": 59,
      "latitudeE7": 5.369901,
      "longitudeE7": -71.832579,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 37,
      "punto": 60,
      "latitudeE7": 5.369895,
      "longitudeE7": -71.832541,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 37,
      "punto": 61,
      "latitudeE7": 5.369889,
      "longitudeE7": -71.832503,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 37,
      "punto": 62,
      "latitudeE7": 5.369883,
      "longitudeE7": -71.832466,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 37,
      "punto": 63,
      "latitudeE7": 5.369877,
      "longitudeE7": -71.832428,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 37,
      "punto": 64,
      "latitudeE7": 5.369871,
      "longitudeE7": -71.83239,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 37,
      "punto": 65,
      "latitudeE7": 5.369865,
      "longitudeE7": -71.832352,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 37,
      "punto": 66,
      "latitudeE7": 5.369859,
      "longitudeE7": -71.832315,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 37,
      "punto": 67,
      "latitudeE7": 5.369853,
      "longitudeE7": -71.832277,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 37,
      "punto": 68,
      "latitudeE7": 5.369847,
      "longitudeE7": -71.832239,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 37,
      "punto": 69,
      "latitudeE7": 5.369841,
      "longitudeE7": -71.832202,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 37,
      "punto": 70,
      "latitudeE7": 5.369835,
      "longitudeE7": -71.832164,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 37,
      "punto": 71,
      "latitudeE7": 5.369829,
      "longitudeE7": -71.832126,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 37,
      "punto": 72,
      "latitudeE7": 5.369823,
      "longitudeE7": -71.832088,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 37,
      "punto": 73,
      "latitudeE7": 5.369817,
      "longitudeE7": -71.832051,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 37,
      "punto": 74,
      "latitudeE7": 5.369811,
      "longitudeE7": -71.832013,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 37,
      "punto": 75,
      "latitudeE7": 5.369805,
      "longitudeE7": -71.831975,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 37,
      "punto": 76,
      "latitudeE7": 5.369799,
      "longitudeE7": -71.831938,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 37,
      "punto": 77,
      "latitudeE7": 5.369793,
      "longitudeE7": -71.8319,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 37,
      "punto": 78,
      "latitudeE7": 5.369787,
      "longitudeE7": -71.831862,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 37,
      "punto": 79,
      "latitudeE7": 5.369781,
      "longitudeE7": -71.831824,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 37,
      "punto": 80,
      "latitudeE7": 5.369775,
      "longitudeE7": -71.831787,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 37,
      "punto": 81,
      "latitudeE7": 5.369769,
      "longitudeE7": -71.831749,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 37,
      "punto": 82,
      "latitudeE7": 5.369763,
      "longitudeE7": -71.831711,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 37,
      "punto": 83,
      "latitudeE7": 5.369757,
      "longitudeE7": -71.831674,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 37,
      "punto": 84,
      "latitudeE7": 5.369751,
      "longitudeE7": -71.831636,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 37,
      "punto": 85,
      "latitudeE7": 5.369745,
      "longitudeE7": -71.831598,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 37,
      "punto": 86,
      "latitudeE7": 5.369739,
      "longitudeE7": -71.83156,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 37,
      "punto": 87,
      "latitudeE7": 5.369733,
      "longitudeE7": -71.831523,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 37,
      "punto": 88,
      "latitudeE7": 5.369727,
      "longitudeE7": -71.831485,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 37,
      "punto": 89,
      "latitudeE7": 5.369721,
      "longitudeE7": -71.831447,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 37,
      "punto": 90,
      "latitudeE7": 5.369715,
      "longitudeE7": -71.831409,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 37,
      "punto": 91,
      "latitudeE7": 5.369709,
      "longitudeE7": -71.831372,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 37,
      "punto": 92,
      "latitudeE7": 5.369703,
      "longitudeE7": -71.831334,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 37,
      "punto": 93,
      "latitudeE7": 5.369697,
      "longitudeE7": -71.831296,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 37,
      "punto": 94,
      "latitudeE7": 5.369691,
      "longitudeE7": -71.831259,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 37,
      "punto": 95,
      "latitudeE7": 5.369685,
      "longitudeE7": -71.831221,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 37,
      "punto": 96,
      "latitudeE7": 5.369679,
      "longitudeE7": -71.831183,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 37,
      "punto": 97,
      "latitudeE7": 5.369673,
      "longitudeE7": -71.831145,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 37,
      "punto": 98,
      "latitudeE7": 5.369667,
      "longitudeE7": -71.831108,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 37,
      "punto": 99,
      "latitudeE7": 5.369661,
      "longitudeE7": -71.83107,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 37,
      "punto": 100,
      "latitudeE7": 5.369655,
      "longitudeE7": -71.831032,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 37,
      "punto": 101,
      "latitudeE7": 5.369649,
      "longitudeE7": -71.830995,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 37,
      "punto": 102,
      "latitudeE7": 5.369643,
      "longitudeE7": -71.830957,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 37,
      "punto": 103,
      "latitudeE7": 5.369637,
      "longitudeE7": -71.830919,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 37,
      "punto": 104,
      "latitudeE7": 5.369631,
      "longitudeE7": -71.830881,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 37,
      "punto": 105,
      "latitudeE7": 5.369625,
      "longitudeE7": -71.830844,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 37,
      "punto": 106,
      "latitudeE7": 5.369619,
      "longitudeE7": -71.830806,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 37,
      "punto": 107,
      "latitudeE7": 5.369613,
      "longitudeE7": -71.830768,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 37,
      "punto": 108,
      "latitudeE7": 5.369607,
      "longitudeE7": -71.830731,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 37,
      "punto": 109,
      "latitudeE7": 5.369601,
      "longitudeE7": -71.830693,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 37,
      "punto": 110,
      "latitudeE7": 5.369595,
      "longitudeE7": -71.830655,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 37,
      "punto": 111,
      "latitudeE7": 5.369589,
      "longitudeE7": -71.830617,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 37,
      "punto": 112,
      "latitudeE7": 5.369583,
      "longitudeE7": -71.83058,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 37,
      "punto": 113,
      "latitudeE7": 5.369577,
      "longitudeE7": -71.830542,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 37,
      "punto": 114,
      "latitudeE7": 5.369571,
      "longitudeE7": -71.830504,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 38,
      "punto": 1,
      "latitudeE7": 5.370209,
      "longitudeE7": -71.834792,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 38,
      "punto": 2,
      "latitudeE7": 5.370203,
      "longitudeE7": -71.834754,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 38,
      "punto": 3,
      "latitudeE7": 5.370197,
      "longitudeE7": -71.834716,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 38,
      "punto": 4,
      "latitudeE7": 5.370191,
      "longitudeE7": -71.834678,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 38,
      "punto": 5,
      "latitudeE7": 5.370185,
      "longitudeE7": -71.834641,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 38,
      "punto": 6,
      "latitudeE7": 5.370179,
      "longitudeE7": -71.834603,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 38,
      "punto": 7,
      "latitudeE7": 5.370173,
      "longitudeE7": -71.834565,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 38,
      "punto": 8,
      "latitudeE7": 5.370167,
      "longitudeE7": -71.834527,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 38,
      "punto": 9,
      "latitudeE7": 5.370161,
      "longitudeE7": -71.83449,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 38,
      "punto": 10,
      "latitudeE7": 5.370155,
      "longitudeE7": -71.834452,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 38,
      "punto": 11,
      "latitudeE7": 5.370149,
      "longitudeE7": -71.834414,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 38,
      "punto": 12,
      "latitudeE7": 5.370143,
      "longitudeE7": -71.834377,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 38,
      "punto": 13,
      "latitudeE7": 5.370137,
      "longitudeE7": -71.834339,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 38,
      "punto": 14,
      "latitudeE7": 5.370131,
      "longitudeE7": -71.834301,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 38,
      "punto": 15,
      "latitudeE7": 5.370125,
      "longitudeE7": -71.834263,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 38,
      "punto": 16,
      "latitudeE7": 5.370119,
      "longitudeE7": -71.834226,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 38,
      "punto": 17,
      "latitudeE7": 5.370113,
      "longitudeE7": -71.834188,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 38,
      "punto": 18,
      "latitudeE7": 5.370107,
      "longitudeE7": -71.83415,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 38,
      "punto": 19,
      "latitudeE7": 5.370101,
      "longitudeE7": -71.834113,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 38,
      "punto": 20,
      "latitudeE7": 5.370095,
      "longitudeE7": -71.834075,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 38,
      "punto": 21,
      "latitudeE7": 5.370089,
      "longitudeE7": -71.834037,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 38,
      "punto": 22,
      "latitudeE7": 5.370083,
      "longitudeE7": -71.833999,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 38,
      "punto": 23,
      "latitudeE7": 5.370077,
      "longitudeE7": -71.833962,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 38,
      "punto": 24,
      "latitudeE7": 5.370071,
      "longitudeE7": -71.833924,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 38,
      "punto": 25,
      "latitudeE7": 5.370065,
      "longitudeE7": -71.833886,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 38,
      "punto": 26,
      "latitudeE7": 5.370059,
      "longitudeE7": -71.833849,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 38,
      "punto": 27,
      "latitudeE7": 5.370053,
      "longitudeE7": -71.833811,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 38,
      "punto": 28,
      "latitudeE7": 5.370047,
      "longitudeE7": -71.833773,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 38,
      "punto": 29,
      "latitudeE7": 5.370041,
      "longitudeE7": -71.833735,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 38,
      "punto": 30,
      "latitudeE7": 5.370035,
      "longitudeE7": -71.833698,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 38,
      "punto": 31,
      "latitudeE7": 5.370029,
      "longitudeE7": -71.83366,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 38,
      "punto": 32,
      "latitudeE7": 5.370023,
      "longitudeE7": -71.833622,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 38,
      "punto": 33,
      "latitudeE7": 5.370017,
      "longitudeE7": -71.833584,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 38,
      "punto": 34,
      "latitudeE7": 5.370011,
      "longitudeE7": -71.833547,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 38,
      "punto": 35,
      "latitudeE7": 5.370005,
      "longitudeE7": -71.833509,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 38,
      "punto": 36,
      "latitudeE7": 5.369999,
      "longitudeE7": -71.833471,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 38,
      "punto": 37,
      "latitudeE7": 5.369993,
      "longitudeE7": -71.833434,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 38,
      "punto": 38,
      "latitudeE7": 5.369987,
      "longitudeE7": -71.833396,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 38,
      "punto": 39,
      "latitudeE7": 5.369981,
      "longitudeE7": -71.833358,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 38,
      "punto": 40,
      "latitudeE7": 5.369975,
      "longitudeE7": -71.83332,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 38,
      "punto": 41,
      "latitudeE7": 5.369969,
      "longitudeE7": -71.833283,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 38,
      "punto": 42,
      "latitudeE7": 5.369963,
      "longitudeE7": -71.833245,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 38,
      "punto": 43,
      "latitudeE7": 5.369957,
      "longitudeE7": -71.833207,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 38,
      "punto": 44,
      "latitudeE7": 5.369951,
      "longitudeE7": -71.83317,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 38,
      "punto": 45,
      "latitudeE7": 5.369945,
      "longitudeE7": -71.833132,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 38,
      "punto": 46,
      "latitudeE7": 5.369939,
      "longitudeE7": -71.833094,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 38,
      "punto": 47,
      "latitudeE7": 5.369933,
      "longitudeE7": -71.833056,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 38,
      "punto": 48,
      "latitudeE7": 5.369927,
      "longitudeE7": -71.833019,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 38,
      "punto": 49,
      "latitudeE7": 5.369921,
      "longitudeE7": -71.832981,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 38,
      "punto": 50,
      "latitudeE7": 5.369915,
      "longitudeE7": -71.832943,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 38,
      "punto": 51,
      "latitudeE7": 5.369909,
      "longitudeE7": -71.832906,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 38,
      "punto": 52,
      "latitudeE7": 5.369903,
      "longitudeE7": -71.832868,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 38,
      "punto": 53,
      "latitudeE7": 5.369897,
      "longitudeE7": -71.83283,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 38,
      "punto": 54,
      "latitudeE7": 5.369891,
      "longitudeE7": -71.832792,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 38,
      "punto": 55,
      "latitudeE7": 5.369885,
      "longitudeE7": -71.832755,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 38,
      "punto": 56,
      "latitudeE7": 5.369879,
      "longitudeE7": -71.832717,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 38,
      "punto": 57,
      "latitudeE7": 5.369873,
      "longitudeE7": -71.832679,
      "accuracy": 15,
      "porcentaje": 0.08
    },
    {
      "linea": 38,
      "punto": 58,
      "latitudeE7": 5.369867,
      "longitudeE7": -71.832641,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 38,
      "punto": 59,
      "latitudeE7": 5.369861,
      "longitudeE7": -71.832604,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 38,
      "punto": 60,
      "latitudeE7": 5.369855,
      "longitudeE7": -71.832566,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 38,
      "punto": 61,
      "latitudeE7": 5.369849,
      "longitudeE7": -71.832528,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 38,
      "punto": 62,
      "latitudeE7": 5.369843,
      "longitudeE7": -71.832491,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 38,
      "punto": 63,
      "latitudeE7": 5.369837,
      "longitudeE7": -71.832453,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 38,
      "punto": 64,
      "latitudeE7": 5.369831,
      "longitudeE7": -71.832415,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 38,
      "punto": 65,
      "latitudeE7": 5.369825,
      "longitudeE7": -71.832377,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 38,
      "punto": 66,
      "latitudeE7": 5.369819,
      "longitudeE7": -71.83234,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 38,
      "punto": 67,
      "latitudeE7": 5.369813,
      "longitudeE7": -71.832302,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 38,
      "punto": 68,
      "latitudeE7": 5.369807,
      "longitudeE7": -71.832264,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 38,
      "punto": 69,
      "latitudeE7": 5.369801,
      "longitudeE7": -71.832227,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 38,
      "punto": 70,
      "latitudeE7": 5.369795,
      "longitudeE7": -71.832189,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 38,
      "punto": 71,
      "latitudeE7": 5.369789,
      "longitudeE7": -71.832151,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 38,
      "punto": 72,
      "latitudeE7": 5.369783,
      "longitudeE7": -71.832113,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 38,
      "punto": 73,
      "latitudeE7": 5.369777,
      "longitudeE7": -71.832076,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 38,
      "punto": 74,
      "latitudeE7": 5.369771,
      "longitudeE7": -71.832038,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 38,
      "punto": 75,
      "latitudeE7": 5.369765,
      "longitudeE7": -71.832,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 38,
      "punto": 76,
      "latitudeE7": 5.369759,
      "longitudeE7": -71.831963,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 38,
      "punto": 77,
      "latitudeE7": 5.369753,
      "longitudeE7": -71.831925,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 38,
      "punto": 78,
      "latitudeE7": 5.369747,
      "longitudeE7": -71.831887,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 38,
      "punto": 79,
      "latitudeE7": 5.369741,
      "longitudeE7": -71.831849,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 38,
      "punto": 80,
      "latitudeE7": 5.369735,
      "longitudeE7": -71.831812,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 38,
      "punto": 81,
      "latitudeE7": 5.369729,
      "longitudeE7": -71.831774,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 38,
      "punto": 82,
      "latitudeE7": 5.369723,
      "longitudeE7": -71.831736,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 38,
      "punto": 83,
      "latitudeE7": 5.369717,
      "longitudeE7": -71.831698,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 38,
      "punto": 84,
      "latitudeE7": 5.369711,
      "longitudeE7": -71.831661,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 38,
      "punto": 85,
      "latitudeE7": 5.369705,
      "longitudeE7": -71.831623,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 38,
      "punto": 86,
      "latitudeE7": 5.369699,
      "longitudeE7": -71.831585,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 38,
      "punto": 87,
      "latitudeE7": 5.369693,
      "longitudeE7": -71.831548,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 38,
      "punto": 88,
      "latitudeE7": 5.369687,
      "longitudeE7": -71.83151,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 38,
      "punto": 89,
      "latitudeE7": 5.369681,
      "longitudeE7": -71.831472,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 38,
      "punto": 90,
      "latitudeE7": 5.369675,
      "longitudeE7": -71.831434,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 38,
      "punto": 91,
      "latitudeE7": 5.369669,
      "longitudeE7": -71.831397,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 38,
      "punto": 92,
      "latitudeE7": 5.369663,
      "longitudeE7": -71.831359,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 38,
      "punto": 93,
      "latitudeE7": 5.369657,
      "longitudeE7": -71.831321,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 38,
      "punto": 94,
      "latitudeE7": 5.369651,
      "longitudeE7": -71.831284,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 38,
      "punto": 95,
      "latitudeE7": 5.369645,
      "longitudeE7": -71.831246,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 38,
      "punto": 96,
      "latitudeE7": 5.369639,
      "longitudeE7": -71.831208,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 38,
      "punto": 97,
      "latitudeE7": 5.369633,
      "longitudeE7": -71.83117,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 38,
      "punto": 98,
      "latitudeE7": 5.369627,
      "longitudeE7": -71.831133,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 38,
      "punto": 99,
      "latitudeE7": 5.369621,
      "longitudeE7": -71.831095,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 38,
      "punto": 100,
      "latitudeE7": 5.369615,
      "longitudeE7": -71.831057,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 38,
      "punto": 101,
      "latitudeE7": 5.369609,
      "longitudeE7": -71.83102,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 38,
      "punto": 102,
      "latitudeE7": 5.369603,
      "longitudeE7": -71.830982,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 38,
      "punto": 103,
      "latitudeE7": 5.369597,
      "longitudeE7": -71.830944,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 38,
      "punto": 104,
      "latitudeE7": 5.369591,
      "longitudeE7": -71.830906,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 38,
      "punto": 105,
      "latitudeE7": 5.369585,
      "longitudeE7": -71.830869,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 38,
      "punto": 106,
      "latitudeE7": 5.369579,
      "longitudeE7": -71.830831,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 38,
      "punto": 107,
      "latitudeE7": 5.369573,
      "longitudeE7": -71.830793,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 38,
      "punto": 108,
      "latitudeE7": 5.369567,
      "longitudeE7": -71.830755,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 38,
      "punto": 109,
      "latitudeE7": 5.369561,
      "longitudeE7": -71.830718,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 38,
      "punto": 110,
      "latitudeE7": 5.369555,
      "longitudeE7": -71.83068,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 38,
      "punto": 111,
      "latitudeE7": 5.369549,
      "longitudeE7": -71.830642,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 38,
      "punto": 112,
      "latitudeE7": 5.369543,
      "longitudeE7": -71.830605,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 38,
      "punto": 113,
      "latitudeE7": 5.369537,
      "longitudeE7": -71.830567,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 38,
      "punto": 114,
      "latitudeE7": 5.369531,
      "longitudeE7": -71.830529,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 39,
      "punto": 1,
      "latitudeE7": 5.370169,
      "longitudeE7": -71.834816,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 39,
      "punto": 2,
      "latitudeE7": 5.370163,
      "longitudeE7": -71.834779,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 39,
      "punto": 3,
      "latitudeE7": 5.370157,
      "longitudeE7": -71.834741,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 39,
      "punto": 4,
      "latitudeE7": 5.370151,
      "longitudeE7": -71.834703,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 39,
      "punto": 5,
      "latitudeE7": 5.370145,
      "longitudeE7": -71.834666,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 39,
      "punto": 6,
      "latitudeE7": 5.370139,
      "longitudeE7": -71.834628,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 39,
      "punto": 7,
      "latitudeE7": 5.370133,
      "longitudeE7": -71.83459,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 39,
      "punto": 8,
      "latitudeE7": 5.370127,
      "longitudeE7": -71.834552,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 39,
      "punto": 9,
      "latitudeE7": 5.370121,
      "longitudeE7": -71.834515,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 39,
      "punto": 10,
      "latitudeE7": 5.370115,
      "longitudeE7": -71.834477,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 39,
      "punto": 11,
      "latitudeE7": 5.370109,
      "longitudeE7": -71.834439,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 39,
      "punto": 12,
      "latitudeE7": 5.370103,
      "longitudeE7": -71.834402,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 39,
      "punto": 13,
      "latitudeE7": 5.370097,
      "longitudeE7": -71.834364,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 39,
      "punto": 14,
      "latitudeE7": 5.370091,
      "longitudeE7": -71.834326,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 39,
      "punto": 15,
      "latitudeE7": 5.370085,
      "longitudeE7": -71.834288,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 39,
      "punto": 16,
      "latitudeE7": 5.370079,
      "longitudeE7": -71.834251,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 39,
      "punto": 17,
      "latitudeE7": 5.370073,
      "longitudeE7": -71.834213,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 39,
      "punto": 18,
      "latitudeE7": 5.370067,
      "longitudeE7": -71.834175,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 39,
      "punto": 19,
      "latitudeE7": 5.370061,
      "longitudeE7": -71.834138,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 39,
      "punto": 20,
      "latitudeE7": 5.370055,
      "longitudeE7": -71.8341,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 39,
      "punto": 21,
      "latitudeE7": 5.370049,
      "longitudeE7": -71.834062,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 39,
      "punto": 22,
      "latitudeE7": 5.370043,
      "longitudeE7": -71.834024,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 39,
      "punto": 23,
      "latitudeE7": 5.370037,
      "longitudeE7": -71.833987,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 39,
      "punto": 24,
      "latitudeE7": 5.370031,
      "longitudeE7": -71.833949,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 39,
      "punto": 25,
      "latitudeE7": 5.370025,
      "longitudeE7": -71.833911,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 39,
      "punto": 26,
      "latitudeE7": 5.370019,
      "longitudeE7": -71.833873,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 39,
      "punto": 27,
      "latitudeE7": 5.370013,
      "longitudeE7": -71.833836,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 39,
      "punto": 28,
      "latitudeE7": 5.370007,
      "longitudeE7": -71.833798,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 39,
      "punto": 29,
      "latitudeE7": 5.370001,
      "longitudeE7": -71.83376,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 39,
      "punto": 30,
      "latitudeE7": 5.369995,
      "longitudeE7": -71.833723,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 39,
      "punto": 31,
      "latitudeE7": 5.369989,
      "longitudeE7": -71.833685,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 39,
      "punto": 32,
      "latitudeE7": 5.369983,
      "longitudeE7": -71.833647,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 39,
      "punto": 33,
      "latitudeE7": 5.369977,
      "longitudeE7": -71.833609,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 39,
      "punto": 34,
      "latitudeE7": 5.369971,
      "longitudeE7": -71.833572,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 39,
      "punto": 35,
      "latitudeE7": 5.369965,
      "longitudeE7": -71.833534,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 39,
      "punto": 36,
      "latitudeE7": 5.369959,
      "longitudeE7": -71.833496,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 39,
      "punto": 37,
      "latitudeE7": 5.369953,
      "longitudeE7": -71.833459,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 39,
      "punto": 38,
      "latitudeE7": 5.369947,
      "longitudeE7": -71.833421,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 39,
      "punto": 39,
      "latitudeE7": 5.369941,
      "longitudeE7": -71.833383,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 39,
      "punto": 40,
      "latitudeE7": 5.369935,
      "longitudeE7": -71.833345,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 39,
      "punto": 41,
      "latitudeE7": 5.369929,
      "longitudeE7": -71.833308,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 39,
      "punto": 42,
      "latitudeE7": 5.369923,
      "longitudeE7": -71.83327,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 39,
      "punto": 43,
      "latitudeE7": 5.369917,
      "longitudeE7": -71.833232,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 39,
      "punto": 44,
      "latitudeE7": 5.369911,
      "longitudeE7": -71.833195,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 39,
      "punto": 45,
      "latitudeE7": 5.369905,
      "longitudeE7": -71.833157,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 39,
      "punto": 46,
      "latitudeE7": 5.369899,
      "longitudeE7": -71.833119,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 39,
      "punto": 47,
      "latitudeE7": 5.369893,
      "longitudeE7": -71.833081,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 39,
      "punto": 48,
      "latitudeE7": 5.369887,
      "longitudeE7": -71.833044,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 39,
      "punto": 49,
      "latitudeE7": 5.369881,
      "longitudeE7": -71.833006,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 39,
      "punto": 50,
      "latitudeE7": 5.369875,
      "longitudeE7": -71.832968,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 39,
      "punto": 51,
      "latitudeE7": 5.369869,
      "longitudeE7": -71.83293,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 39,
      "punto": 52,
      "latitudeE7": 5.369863,
      "longitudeE7": -71.832893,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 39,
      "punto": 53,
      "latitudeE7": 5.369857,
      "longitudeE7": -71.832855,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 39,
      "punto": 54,
      "latitudeE7": 5.369851,
      "longitudeE7": -71.832817,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 39,
      "punto": 55,
      "latitudeE7": 5.369845,
      "longitudeE7": -71.83278,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 39,
      "punto": 56,
      "latitudeE7": 5.369839,
      "longitudeE7": -71.832742,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 39,
      "punto": 57,
      "latitudeE7": 5.369833,
      "longitudeE7": -71.832704,
      "accuracy": 15,
      "porcentaje": 0.08
    },
    {
      "linea": 39,
      "punto": 58,
      "latitudeE7": 5.369827,
      "longitudeE7": -71.832666,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 39,
      "punto": 59,
      "latitudeE7": 5.369821,
      "longitudeE7": -71.832629,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 39,
      "punto": 60,
      "latitudeE7": 5.369815,
      "longitudeE7": -71.832591,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 39,
      "punto": 61,
      "latitudeE7": 5.369809,
      "longitudeE7": -71.832553,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 39,
      "punto": 62,
      "latitudeE7": 5.369803,
      "longitudeE7": -71.832516,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 39,
      "punto": 63,
      "latitudeE7": 5.369797,
      "longitudeE7": -71.832478,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 39,
      "punto": 64,
      "latitudeE7": 5.369791,
      "longitudeE7": -71.83244,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 39,
      "punto": 65,
      "latitudeE7": 5.369785,
      "longitudeE7": -71.832402,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 39,
      "punto": 66,
      "latitudeE7": 5.369779,
      "longitudeE7": -71.832365,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 39,
      "punto": 67,
      "latitudeE7": 5.369773,
      "longitudeE7": -71.832327,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 39,
      "punto": 68,
      "latitudeE7": 5.369767,
      "longitudeE7": -71.832289,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 39,
      "punto": 69,
      "latitudeE7": 5.369761,
      "longitudeE7": -71.832252,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 39,
      "punto": 70,
      "latitudeE7": 5.369755,
      "longitudeE7": -71.832214,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 39,
      "punto": 71,
      "latitudeE7": 5.369749,
      "longitudeE7": -71.832176,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 39,
      "punto": 72,
      "latitudeE7": 5.369743,
      "longitudeE7": -71.832138,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 39,
      "punto": 73,
      "latitudeE7": 5.369737,
      "longitudeE7": -71.832101,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 39,
      "punto": 74,
      "latitudeE7": 5.369731,
      "longitudeE7": -71.832063,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 39,
      "punto": 75,
      "latitudeE7": 5.369725,
      "longitudeE7": -71.832025,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 39,
      "punto": 76,
      "latitudeE7": 5.369719,
      "longitudeE7": -71.831987,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 39,
      "punto": 77,
      "latitudeE7": 5.369713,
      "longitudeE7": -71.83195,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 39,
      "punto": 78,
      "latitudeE7": 5.369707,
      "longitudeE7": -71.831912,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 39,
      "punto": 79,
      "latitudeE7": 5.369701,
      "longitudeE7": -71.831874,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 39,
      "punto": 80,
      "latitudeE7": 5.369695,
      "longitudeE7": -71.831837,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 39,
      "punto": 81,
      "latitudeE7": 5.369689,
      "longitudeE7": -71.831799,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 39,
      "punto": 82,
      "latitudeE7": 5.369683,
      "longitudeE7": -71.831761,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 39,
      "punto": 83,
      "latitudeE7": 5.369677,
      "longitudeE7": -71.831723,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 39,
      "punto": 84,
      "latitudeE7": 5.369671,
      "longitudeE7": -71.831686,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 39,
      "punto": 85,
      "latitudeE7": 5.369665,
      "longitudeE7": -71.831648,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 39,
      "punto": 86,
      "latitudeE7": 5.369659,
      "longitudeE7": -71.83161,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 39,
      "punto": 87,
      "latitudeE7": 5.369653,
      "longitudeE7": -71.831573,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 39,
      "punto": 88,
      "latitudeE7": 5.369647,
      "longitudeE7": -71.831535,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 39,
      "punto": 89,
      "latitudeE7": 5.369641,
      "longitudeE7": -71.831497,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 39,
      "punto": 90,
      "latitudeE7": 5.369635,
      "longitudeE7": -71.831459,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 39,
      "punto": 91,
      "latitudeE7": 5.369629,
      "longitudeE7": -71.831422,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 39,
      "punto": 92,
      "latitudeE7": 5.369623,
      "longitudeE7": -71.831384,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 39,
      "punto": 93,
      "latitudeE7": 5.369617,
      "longitudeE7": -71.831346,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 39,
      "punto": 94,
      "latitudeE7": 5.369611,
      "longitudeE7": -71.831309,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 39,
      "punto": 95,
      "latitudeE7": 5.369605,
      "longitudeE7": -71.831271,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 39,
      "punto": 96,
      "latitudeE7": 5.369599,
      "longitudeE7": -71.831233,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 39,
      "punto": 97,
      "latitudeE7": 5.369593,
      "longitudeE7": -71.831195,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 39,
      "punto": 98,
      "latitudeE7": 5.369587,
      "longitudeE7": -71.831158,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 39,
      "punto": 99,
      "latitudeE7": 5.369581,
      "longitudeE7": -71.83112,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 39,
      "punto": 100,
      "latitudeE7": 5.369575,
      "longitudeE7": -71.831082,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 39,
      "punto": 101,
      "latitudeE7": 5.369569,
      "longitudeE7": -71.831044,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 39,
      "punto": 102,
      "latitudeE7": 5.369563,
      "longitudeE7": -71.831007,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 39,
      "punto": 103,
      "latitudeE7": 5.369557,
      "longitudeE7": -71.830969,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 39,
      "punto": 104,
      "latitudeE7": 5.369551,
      "longitudeE7": -71.830931,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 39,
      "punto": 105,
      "latitudeE7": 5.369545,
      "longitudeE7": -71.830894,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 39,
      "punto": 106,
      "latitudeE7": 5.369539,
      "longitudeE7": -71.830856,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 39,
      "punto": 107,
      "latitudeE7": 5.369533,
      "longitudeE7": -71.830818,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 39,
      "punto": 108,
      "latitudeE7": 5.369527,
      "longitudeE7": -71.83078,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 39,
      "punto": 109,
      "latitudeE7": 5.369521,
      "longitudeE7": -71.830743,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 39,
      "punto": 110,
      "latitudeE7": 5.369515,
      "longitudeE7": -71.830705,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 39,
      "punto": 111,
      "latitudeE7": 5.369509,
      "longitudeE7": -71.830667,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 39,
      "punto": 112,
      "latitudeE7": 5.369503,
      "longitudeE7": -71.83063,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 39,
      "punto": 113,
      "latitudeE7": 5.369497,
      "longitudeE7": -71.830592,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 39,
      "punto": 114,
      "latitudeE7": 5.369491,
      "longitudeE7": -71.830554,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 40,
      "punto": 1,
      "latitudeE7": 5.370129,
      "longitudeE7": -71.834841,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 40,
      "punto": 2,
      "latitudeE7": 5.370123,
      "longitudeE7": -71.834804,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 40,
      "punto": 3,
      "latitudeE7": 5.370117,
      "longitudeE7": -71.834766,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 40,
      "punto": 4,
      "latitudeE7": 5.370111,
      "longitudeE7": -71.834728,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 40,
      "punto": 5,
      "latitudeE7": 5.370105,
      "longitudeE7": -71.834691,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 40,
      "punto": 6,
      "latitudeE7": 5.370099,
      "longitudeE7": -71.834653,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 40,
      "punto": 7,
      "latitudeE7": 5.370093,
      "longitudeE7": -71.834615,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 40,
      "punto": 8,
      "latitudeE7": 5.370087,
      "longitudeE7": -71.834577,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 40,
      "punto": 9,
      "latitudeE7": 5.370081,
      "longitudeE7": -71.83454,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 40,
      "punto": 10,
      "latitudeE7": 5.370075,
      "longitudeE7": -71.834502,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 40,
      "punto": 11,
      "latitudeE7": 5.370069,
      "longitudeE7": -71.834464,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 40,
      "punto": 12,
      "latitudeE7": 5.370063,
      "longitudeE7": -71.834427,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 40,
      "punto": 13,
      "latitudeE7": 5.370057,
      "longitudeE7": -71.834389,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 40,
      "punto": 14,
      "latitudeE7": 5.370051,
      "longitudeE7": -71.834351,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 40,
      "punto": 15,
      "latitudeE7": 5.370045,
      "longitudeE7": -71.834313,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 40,
      "punto": 16,
      "latitudeE7": 5.370039,
      "longitudeE7": -71.834276,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 40,
      "punto": 17,
      "latitudeE7": 5.370033,
      "longitudeE7": -71.834238,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 40,
      "punto": 18,
      "latitudeE7": 5.370027,
      "longitudeE7": -71.8342,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 40,
      "punto": 19,
      "latitudeE7": 5.370021,
      "longitudeE7": -71.834162,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 40,
      "punto": 20,
      "latitudeE7": 5.370015,
      "longitudeE7": -71.834125,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 40,
      "punto": 21,
      "latitudeE7": 5.370009,
      "longitudeE7": -71.834087,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 40,
      "punto": 22,
      "latitudeE7": 5.370003,
      "longitudeE7": -71.834049,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 40,
      "punto": 23,
      "latitudeE7": 5.369997,
      "longitudeE7": -71.834012,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 40,
      "punto": 24,
      "latitudeE7": 5.369991,
      "longitudeE7": -71.833974,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 40,
      "punto": 25,
      "latitudeE7": 5.369985,
      "longitudeE7": -71.833936,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 40,
      "punto": 26,
      "latitudeE7": 5.369979,
      "longitudeE7": -71.833898,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 40,
      "punto": 27,
      "latitudeE7": 5.369973,
      "longitudeE7": -71.833861,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 40,
      "punto": 28,
      "latitudeE7": 5.369967,
      "longitudeE7": -71.833823,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 40,
      "punto": 29,
      "latitudeE7": 5.369961,
      "longitudeE7": -71.833785,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 40,
      "punto": 30,
      "latitudeE7": 5.369955,
      "longitudeE7": -71.833748,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 40,
      "punto": 31,
      "latitudeE7": 5.369949,
      "longitudeE7": -71.83371,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 40,
      "punto": 32,
      "latitudeE7": 5.369943,
      "longitudeE7": -71.833672,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 40,
      "punto": 33,
      "latitudeE7": 5.369937,
      "longitudeE7": -71.833634,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 40,
      "punto": 34,
      "latitudeE7": 5.369931,
      "longitudeE7": -71.833597,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 40,
      "punto": 35,
      "latitudeE7": 5.369925,
      "longitudeE7": -71.833559,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 40,
      "punto": 36,
      "latitudeE7": 5.369919,
      "longitudeE7": -71.833521,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 40,
      "punto": 37,
      "latitudeE7": 5.369913,
      "longitudeE7": -71.833484,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 40,
      "punto": 38,
      "latitudeE7": 5.369907,
      "longitudeE7": -71.833446,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 40,
      "punto": 39,
      "latitudeE7": 5.369901,
      "longitudeE7": -71.833408,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 40,
      "punto": 40,
      "latitudeE7": 5.369895,
      "longitudeE7": -71.83337,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 40,
      "punto": 41,
      "latitudeE7": 5.369889,
      "longitudeE7": -71.833333,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 40,
      "punto": 42,
      "latitudeE7": 5.369883,
      "longitudeE7": -71.833295,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 40,
      "punto": 43,
      "latitudeE7": 5.369877,
      "longitudeE7": -71.833257,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 40,
      "punto": 44,
      "latitudeE7": 5.369871,
      "longitudeE7": -71.833219,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 40,
      "punto": 45,
      "latitudeE7": 5.369865,
      "longitudeE7": -71.833182,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 40,
      "punto": 46,
      "latitudeE7": 5.369859,
      "longitudeE7": -71.833144,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 40,
      "punto": 47,
      "latitudeE7": 5.369853,
      "longitudeE7": -71.833106,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 40,
      "punto": 48,
      "latitudeE7": 5.369847,
      "longitudeE7": -71.833069,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 40,
      "punto": 49,
      "latitudeE7": 5.369841,
      "longitudeE7": -71.833031,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 40,
      "punto": 50,
      "latitudeE7": 5.369835,
      "longitudeE7": -71.832993,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 40,
      "punto": 51,
      "latitudeE7": 5.369829,
      "longitudeE7": -71.832955,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 40,
      "punto": 52,
      "latitudeE7": 5.369823,
      "longitudeE7": -71.832918,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 40,
      "punto": 53,
      "latitudeE7": 5.369817,
      "longitudeE7": -71.83288,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 40,
      "punto": 54,
      "latitudeE7": 5.369811,
      "longitudeE7": -71.832842,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 40,
      "punto": 55,
      "latitudeE7": 5.369805,
      "longitudeE7": -71.832805,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 40,
      "punto": 56,
      "latitudeE7": 5.369799,
      "longitudeE7": -71.832767,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 40,
      "punto": 57,
      "latitudeE7": 5.369793,
      "longitudeE7": -71.832729,
      "accuracy": 15,
      "porcentaje": 0
    },
    {
      "linea": 40,
      "punto": 58,
      "latitudeE7": 5.369787,
      "longitudeE7": -71.832691,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 40,
      "punto": 59,
      "latitudeE7": 5.369781,
      "longitudeE7": -71.832654,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 40,
      "punto": 60,
      "latitudeE7": 5.369775,
      "longitudeE7": -71.832616,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 40,
      "punto": 61,
      "latitudeE7": 5.369769,
      "longitudeE7": -71.832578,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 40,
      "punto": 62,
      "latitudeE7": 5.369763,
      "longitudeE7": -71.832541,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 40,
      "punto": 63,
      "latitudeE7": 5.369757,
      "longitudeE7": -71.832503,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 40,
      "punto": 64,
      "latitudeE7": 5.369751,
      "longitudeE7": -71.832465,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 40,
      "punto": 65,
      "latitudeE7": 5.369745,
      "longitudeE7": -71.832427,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 40,
      "punto": 66,
      "latitudeE7": 5.369739,
      "longitudeE7": -71.83239,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 40,
      "punto": 67,
      "latitudeE7": 5.369733,
      "longitudeE7": -71.832352,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 40,
      "punto": 68,
      "latitudeE7": 5.369727,
      "longitudeE7": -71.832314,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 40,
      "punto": 69,
      "latitudeE7": 5.369721,
      "longitudeE7": -71.832276,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 40,
      "punto": 70,
      "latitudeE7": 5.369715,
      "longitudeE7": -71.832239,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 40,
      "punto": 71,
      "latitudeE7": 5.369709,
      "longitudeE7": -71.832201,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 40,
      "punto": 72,
      "latitudeE7": 5.369703,
      "longitudeE7": -71.832163,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 40,
      "punto": 73,
      "latitudeE7": 5.369697,
      "longitudeE7": -71.832126,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 40,
      "punto": 74,
      "latitudeE7": 5.369691,
      "longitudeE7": -71.832088,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 40,
      "punto": 75,
      "latitudeE7": 5.369685,
      "longitudeE7": -71.83205,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 40,
      "punto": 76,
      "latitudeE7": 5.369679,
      "longitudeE7": -71.832012,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 40,
      "punto": 77,
      "latitudeE7": 5.369673,
      "longitudeE7": -71.831975,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 40,
      "punto": 78,
      "latitudeE7": 5.369667,
      "longitudeE7": -71.831937,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 40,
      "punto": 79,
      "latitudeE7": 5.369661,
      "longitudeE7": -71.831899,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 40,
      "punto": 80,
      "latitudeE7": 5.369655,
      "longitudeE7": -71.831862,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 40,
      "punto": 81,
      "latitudeE7": 5.369649,
      "longitudeE7": -71.831824,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 40,
      "punto": 82,
      "latitudeE7": 5.369643,
      "longitudeE7": -71.831786,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 40,
      "punto": 83,
      "latitudeE7": 5.369637,
      "longitudeE7": -71.831748,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 40,
      "punto": 84,
      "latitudeE7": 5.369631,
      "longitudeE7": -71.831711,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 40,
      "punto": 85,
      "latitudeE7": 5.369625,
      "longitudeE7": -71.831673,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 40,
      "punto": 86,
      "latitudeE7": 5.369619,
      "longitudeE7": -71.831635,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 40,
      "punto": 87,
      "latitudeE7": 5.369613,
      "longitudeE7": -71.831598,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 40,
      "punto": 88,
      "latitudeE7": 5.369607,
      "longitudeE7": -71.83156,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 40,
      "punto": 89,
      "latitudeE7": 5.369601,
      "longitudeE7": -71.831522,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 40,
      "punto": 90,
      "latitudeE7": 5.369595,
      "longitudeE7": -71.831484,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 40,
      "punto": 91,
      "latitudeE7": 5.369589,
      "longitudeE7": -71.831447,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 40,
      "punto": 92,
      "latitudeE7": 5.369583,
      "longitudeE7": -71.831409,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 40,
      "punto": 93,
      "latitudeE7": 5.369577,
      "longitudeE7": -71.831371,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 40,
      "punto": 94,
      "latitudeE7": 5.369571,
      "longitudeE7": -71.831333,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 40,
      "punto": 95,
      "latitudeE7": 5.369565,
      "longitudeE7": -71.831296,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 40,
      "punto": 96,
      "latitudeE7": 5.369559,
      "longitudeE7": -71.831258,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 40,
      "punto": 97,
      "latitudeE7": 5.369553,
      "longitudeE7": -71.83122,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 40,
      "punto": 98,
      "latitudeE7": 5.369547,
      "longitudeE7": -71.831183,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 40,
      "punto": 99,
      "latitudeE7": 5.369541,
      "longitudeE7": -71.831145,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 40,
      "punto": 100,
      "latitudeE7": 5.369535,
      "longitudeE7": -71.831107,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 40,
      "punto": 101,
      "latitudeE7": 5.369529,
      "longitudeE7": -71.831069,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 40,
      "punto": 102,
      "latitudeE7": 5.369523,
      "longitudeE7": -71.831032,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 40,
      "punto": 103,
      "latitudeE7": 5.369517,
      "longitudeE7": -71.830994,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 40,
      "punto": 104,
      "latitudeE7": 5.369511,
      "longitudeE7": -71.830956,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 40,
      "punto": 105,
      "latitudeE7": 5.369505,
      "longitudeE7": -71.830919,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 40,
      "punto": 106,
      "latitudeE7": 5.369499,
      "longitudeE7": -71.830881,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 40,
      "punto": 107,
      "latitudeE7": 5.369493,
      "longitudeE7": -71.830843,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 40,
      "punto": 108,
      "latitudeE7": 5.369487,
      "longitudeE7": -71.830805,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 40,
      "punto": 109,
      "latitudeE7": 5.369481,
      "longitudeE7": -71.830768,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 40,
      "punto": 110,
      "latitudeE7": 5.369475,
      "longitudeE7": -71.83073,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 40,
      "punto": 111,
      "latitudeE7": 5.369469,
      "longitudeE7": -71.830692,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 40,
      "punto": 112,
      "latitudeE7": 5.369463,
      "longitudeE7": -71.830655,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 40,
      "punto": 113,
      "latitudeE7": 5.369457,
      "longitudeE7": -71.830617,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 40,
      "punto": 114,
      "latitudeE7": 5.369451,
      "longitudeE7": -71.830579,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 41,
      "punto": 1,
      "latitudeE7": 5.370089,
      "longitudeE7": -71.834866,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 41,
      "punto": 2,
      "latitudeE7": 5.370083,
      "longitudeE7": -71.834829,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 41,
      "punto": 3,
      "latitudeE7": 5.370077,
      "longitudeE7": -71.834791,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 41,
      "punto": 4,
      "latitudeE7": 5.370071,
      "longitudeE7": -71.834753,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 41,
      "punto": 5,
      "latitudeE7": 5.370065,
      "longitudeE7": -71.834716,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 41,
      "punto": 6,
      "latitudeE7": 5.370059,
      "longitudeE7": -71.834678,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 41,
      "punto": 7,
      "latitudeE7": 5.370053,
      "longitudeE7": -71.83464,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 41,
      "punto": 8,
      "latitudeE7": 5.370047,
      "longitudeE7": -71.834602,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 41,
      "punto": 9,
      "latitudeE7": 5.370041,
      "longitudeE7": -71.834565,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 41,
      "punto": 10,
      "latitudeE7": 5.370035,
      "longitudeE7": -71.834527,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 41,
      "punto": 11,
      "latitudeE7": 5.370029,
      "longitudeE7": -71.834489,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 41,
      "punto": 12,
      "latitudeE7": 5.370023,
      "longitudeE7": -71.834451,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 41,
      "punto": 13,
      "latitudeE7": 5.370017,
      "longitudeE7": -71.834414,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 41,
      "punto": 14,
      "latitudeE7": 5.370011,
      "longitudeE7": -71.834376,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 41,
      "punto": 15,
      "latitudeE7": 5.370005,
      "longitudeE7": -71.834338,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 41,
      "punto": 16,
      "latitudeE7": 5.369999,
      "longitudeE7": -71.834301,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 41,
      "punto": 17,
      "latitudeE7": 5.369993,
      "longitudeE7": -71.834263,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 41,
      "punto": 18,
      "latitudeE7": 5.369987,
      "longitudeE7": -71.834225,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 41,
      "punto": 19,
      "latitudeE7": 5.369981,
      "longitudeE7": -71.834187,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 41,
      "punto": 20,
      "latitudeE7": 5.369975,
      "longitudeE7": -71.83415,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 41,
      "punto": 21,
      "latitudeE7": 5.369969,
      "longitudeE7": -71.834112,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 41,
      "punto": 22,
      "latitudeE7": 5.369963,
      "longitudeE7": -71.834074,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 41,
      "punto": 23,
      "latitudeE7": 5.369957,
      "longitudeE7": -71.834037,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 41,
      "punto": 24,
      "latitudeE7": 5.369951,
      "longitudeE7": -71.833999,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 41,
      "punto": 25,
      "latitudeE7": 5.369945,
      "longitudeE7": -71.833961,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 41,
      "punto": 26,
      "latitudeE7": 5.369939,
      "longitudeE7": -71.833923,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 41,
      "punto": 27,
      "latitudeE7": 5.369933,
      "longitudeE7": -71.833886,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 41,
      "punto": 28,
      "latitudeE7": 5.369927,
      "longitudeE7": -71.833848,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 41,
      "punto": 29,
      "latitudeE7": 5.369921,
      "longitudeE7": -71.83381,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 41,
      "punto": 30,
      "latitudeE7": 5.369915,
      "longitudeE7": -71.833773,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 41,
      "punto": 31,
      "latitudeE7": 5.369909,
      "longitudeE7": -71.833735,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 41,
      "punto": 32,
      "latitudeE7": 5.369903,
      "longitudeE7": -71.833697,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 41,
      "punto": 33,
      "latitudeE7": 5.369897,
      "longitudeE7": -71.833659,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 41,
      "punto": 34,
      "latitudeE7": 5.369891,
      "longitudeE7": -71.833622,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 41,
      "punto": 35,
      "latitudeE7": 5.369885,
      "longitudeE7": -71.833584,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 41,
      "punto": 36,
      "latitudeE7": 5.369879,
      "longitudeE7": -71.833546,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 41,
      "punto": 37,
      "latitudeE7": 5.369873,
      "longitudeE7": -71.833508,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 41,
      "punto": 38,
      "latitudeE7": 5.369867,
      "longitudeE7": -71.833471,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 41,
      "punto": 39,
      "latitudeE7": 5.369861,
      "longitudeE7": -71.833433,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 41,
      "punto": 40,
      "latitudeE7": 5.369855,
      "longitudeE7": -71.833395,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 41,
      "punto": 41,
      "latitudeE7": 5.369849,
      "longitudeE7": -71.833358,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 41,
      "punto": 42,
      "latitudeE7": 5.369843,
      "longitudeE7": -71.83332,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 41,
      "punto": 43,
      "latitudeE7": 5.369837,
      "longitudeE7": -71.833282,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 41,
      "punto": 44,
      "latitudeE7": 5.369831,
      "longitudeE7": -71.833244,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 41,
      "punto": 45,
      "latitudeE7": 5.369825,
      "longitudeE7": -71.833207,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 41,
      "punto": 46,
      "latitudeE7": 5.369819,
      "longitudeE7": -71.833169,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 41,
      "punto": 47,
      "latitudeE7": 5.369813,
      "longitudeE7": -71.833131,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 41,
      "punto": 48,
      "latitudeE7": 5.369807,
      "longitudeE7": -71.833094,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 41,
      "punto": 49,
      "latitudeE7": 5.369801,
      "longitudeE7": -71.833056,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 41,
      "punto": 50,
      "latitudeE7": 5.369795,
      "longitudeE7": -71.833018,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 41,
      "punto": 51,
      "latitudeE7": 5.369789,
      "longitudeE7": -71.83298,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 41,
      "punto": 52,
      "latitudeE7": 5.369783,
      "longitudeE7": -71.832943,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 41,
      "punto": 53,
      "latitudeE7": 5.369777,
      "longitudeE7": -71.832905,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 41,
      "punto": 54,
      "latitudeE7": 5.369771,
      "longitudeE7": -71.832867,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 41,
      "punto": 55,
      "latitudeE7": 5.369765,
      "longitudeE7": -71.83283,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 41,
      "punto": 56,
      "latitudeE7": 5.369759,
      "longitudeE7": -71.832792,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 41,
      "punto": 57,
      "latitudeE7": 5.369753,
      "longitudeE7": -71.832754,
      "accuracy": 15,
      "porcentaje": 0.2
    },
    {
      "linea": 41,
      "punto": 58,
      "latitudeE7": 5.369747,
      "longitudeE7": -71.832716,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 41,
      "punto": 59,
      "latitudeE7": 5.369741,
      "longitudeE7": -71.832679,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 41,
      "punto": 60,
      "latitudeE7": 5.369735,
      "longitudeE7": -71.832641,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 41,
      "punto": 61,
      "latitudeE7": 5.369729,
      "longitudeE7": -71.832603,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 41,
      "punto": 62,
      "latitudeE7": 5.369723,
      "longitudeE7": -71.832565,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 41,
      "punto": 63,
      "latitudeE7": 5.369717,
      "longitudeE7": -71.832528,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 41,
      "punto": 64,
      "latitudeE7": 5.369711,
      "longitudeE7": -71.83249,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 41,
      "punto": 65,
      "latitudeE7": 5.369705,
      "longitudeE7": -71.832452,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 41,
      "punto": 66,
      "latitudeE7": 5.369699,
      "longitudeE7": -71.832415,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 41,
      "punto": 67,
      "latitudeE7": 5.369693,
      "longitudeE7": -71.832377,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 41,
      "punto": 68,
      "latitudeE7": 5.369687,
      "longitudeE7": -71.832339,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 41,
      "punto": 69,
      "latitudeE7": 5.369681,
      "longitudeE7": -71.832301,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 41,
      "punto": 70,
      "latitudeE7": 5.369675,
      "longitudeE7": -71.832264,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 41,
      "punto": 71,
      "latitudeE7": 5.369669,
      "longitudeE7": -71.832226,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 41,
      "punto": 72,
      "latitudeE7": 5.369663,
      "longitudeE7": -71.832188,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 41,
      "punto": 73,
      "latitudeE7": 5.369657,
      "longitudeE7": -71.832151,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 41,
      "punto": 74,
      "latitudeE7": 5.369651,
      "longitudeE7": -71.832113,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 41,
      "punto": 75,
      "latitudeE7": 5.369645,
      "longitudeE7": -71.832075,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 41,
      "punto": 76,
      "latitudeE7": 5.369639,
      "longitudeE7": -71.832037,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 41,
      "punto": 77,
      "latitudeE7": 5.369633,
      "longitudeE7": -71.832,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 41,
      "punto": 78,
      "latitudeE7": 5.369627,
      "longitudeE7": -71.831962,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 41,
      "punto": 79,
      "latitudeE7": 5.369621,
      "longitudeE7": -71.831924,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 41,
      "punto": 80,
      "latitudeE7": 5.369615,
      "longitudeE7": -71.831887,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 41,
      "punto": 81,
      "latitudeE7": 5.369609,
      "longitudeE7": -71.831849,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 41,
      "punto": 82,
      "latitudeE7": 5.369603,
      "longitudeE7": -71.831811,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 41,
      "punto": 83,
      "latitudeE7": 5.369597,
      "longitudeE7": -71.831773,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 41,
      "punto": 84,
      "latitudeE7": 5.369591,
      "longitudeE7": -71.831736,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 41,
      "punto": 85,
      "latitudeE7": 5.369585,
      "longitudeE7": -71.831698,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 41,
      "punto": 86,
      "latitudeE7": 5.369579,
      "longitudeE7": -71.83166,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 41,
      "punto": 87,
      "latitudeE7": 5.369573,
      "longitudeE7": -71.831622,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 41,
      "punto": 88,
      "latitudeE7": 5.369567,
      "longitudeE7": -71.831585,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 41,
      "punto": 89,
      "latitudeE7": 5.369561,
      "longitudeE7": -71.831547,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 41,
      "punto": 90,
      "latitudeE7": 5.369555,
      "longitudeE7": -71.831509,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 41,
      "punto": 91,
      "latitudeE7": 5.369549,
      "longitudeE7": -71.831472,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 41,
      "punto": 92,
      "latitudeE7": 5.369543,
      "longitudeE7": -71.831434,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 41,
      "punto": 93,
      "latitudeE7": 5.369537,
      "longitudeE7": -71.831396,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 41,
      "punto": 94,
      "latitudeE7": 5.369531,
      "longitudeE7": -71.831358,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 41,
      "punto": 95,
      "latitudeE7": 5.369525,
      "longitudeE7": -71.831321,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 41,
      "punto": 96,
      "latitudeE7": 5.369519,
      "longitudeE7": -71.831283,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 41,
      "punto": 97,
      "latitudeE7": 5.369513,
      "longitudeE7": -71.831245,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 41,
      "punto": 98,
      "latitudeE7": 5.369507,
      "longitudeE7": -71.831208,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 41,
      "punto": 99,
      "latitudeE7": 5.369501,
      "longitudeE7": -71.83117,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 41,
      "punto": 100,
      "latitudeE7": 5.369495,
      "longitudeE7": -71.831132,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 41,
      "punto": 101,
      "latitudeE7": 5.369489,
      "longitudeE7": -71.831094,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 41,
      "punto": 102,
      "latitudeE7": 5.369483,
      "longitudeE7": -71.831057,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 41,
      "punto": 103,
      "latitudeE7": 5.369477,
      "longitudeE7": -71.831019,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 41,
      "punto": 104,
      "latitudeE7": 5.369471,
      "longitudeE7": -71.830981,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 41,
      "punto": 105,
      "latitudeE7": 5.369465,
      "longitudeE7": -71.830944,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 41,
      "punto": 106,
      "latitudeE7": 5.369459,
      "longitudeE7": -71.830906,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 41,
      "punto": 107,
      "latitudeE7": 5.369453,
      "longitudeE7": -71.830868,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 41,
      "punto": 108,
      "latitudeE7": 5.369447,
      "longitudeE7": -71.83083,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 41,
      "punto": 109,
      "latitudeE7": 5.369441,
      "longitudeE7": -71.830793,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 41,
      "punto": 110,
      "latitudeE7": 5.369435,
      "longitudeE7": -71.830755,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 41,
      "punto": 111,
      "latitudeE7": 5.369429,
      "longitudeE7": -71.830717,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 41,
      "punto": 112,
      "latitudeE7": 5.369423,
      "longitudeE7": -71.830679,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 41,
      "punto": 113,
      "latitudeE7": 5.369417,
      "longitudeE7": -71.830642,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 41,
      "punto": 114,
      "latitudeE7": 5.369411,
      "longitudeE7": -71.830604,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 42,
      "punto": 1,
      "latitudeE7": 5.370049,
      "longitudeE7": -71.834891,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 42,
      "punto": 2,
      "latitudeE7": 5.370043,
      "longitudeE7": -71.834854,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 42,
      "punto": 3,
      "latitudeE7": 5.370037,
      "longitudeE7": -71.834816,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 42,
      "punto": 4,
      "latitudeE7": 5.370031,
      "longitudeE7": -71.834778,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 42,
      "punto": 5,
      "latitudeE7": 5.370025,
      "longitudeE7": -71.83474,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 42,
      "punto": 6,
      "latitudeE7": 5.370019,
      "longitudeE7": -71.834703,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 42,
      "punto": 7,
      "latitudeE7": 5.370013,
      "longitudeE7": -71.834665,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 42,
      "punto": 8,
      "latitudeE7": 5.370007,
      "longitudeE7": -71.834627,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 42,
      "punto": 9,
      "latitudeE7": 5.370001,
      "longitudeE7": -71.83459,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 42,
      "punto": 10,
      "latitudeE7": 5.369995,
      "longitudeE7": -71.834552,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 42,
      "punto": 11,
      "latitudeE7": 5.369989,
      "longitudeE7": -71.834514,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 42,
      "punto": 12,
      "latitudeE7": 5.369983,
      "longitudeE7": -71.834476,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 42,
      "punto": 13,
      "latitudeE7": 5.369977,
      "longitudeE7": -71.834439,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 42,
      "punto": 14,
      "latitudeE7": 5.369971,
      "longitudeE7": -71.834401,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 42,
      "punto": 15,
      "latitudeE7": 5.369965,
      "longitudeE7": -71.834363,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 42,
      "punto": 16,
      "latitudeE7": 5.369959,
      "longitudeE7": -71.834326,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 42,
      "punto": 17,
      "latitudeE7": 5.369953,
      "longitudeE7": -71.834288,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 42,
      "punto": 18,
      "latitudeE7": 5.369947,
      "longitudeE7": -71.83425,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 42,
      "punto": 19,
      "latitudeE7": 5.369941,
      "longitudeE7": -71.834212,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 42,
      "punto": 20,
      "latitudeE7": 5.369935,
      "longitudeE7": -71.834175,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 42,
      "punto": 21,
      "latitudeE7": 5.369929,
      "longitudeE7": -71.834137,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 42,
      "punto": 22,
      "latitudeE7": 5.369923,
      "longitudeE7": -71.834099,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 42,
      "punto": 23,
      "latitudeE7": 5.369917,
      "longitudeE7": -71.834062,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 42,
      "punto": 24,
      "latitudeE7": 5.369911,
      "longitudeE7": -71.834024,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 42,
      "punto": 25,
      "latitudeE7": 5.369905,
      "longitudeE7": -71.833986,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 42,
      "punto": 26,
      "latitudeE7": 5.369899,
      "longitudeE7": -71.833948,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 42,
      "punto": 27,
      "latitudeE7": 5.369893,
      "longitudeE7": -71.833911,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 42,
      "punto": 28,
      "latitudeE7": 5.369887,
      "longitudeE7": -71.833873,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 42,
      "punto": 29,
      "latitudeE7": 5.369881,
      "longitudeE7": -71.833835,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 42,
      "punto": 30,
      "latitudeE7": 5.369875,
      "longitudeE7": -71.833797,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 42,
      "punto": 31,
      "latitudeE7": 5.369869,
      "longitudeE7": -71.83376,
      "accuracy": 5,
      "porcentaje": 0.48
    },
    {
      "linea": 42,
      "punto": 32,
      "latitudeE7": 5.369863,
      "longitudeE7": -71.833722,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 42,
      "punto": 33,
      "latitudeE7": 5.369857,
      "longitudeE7": -71.833684,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 42,
      "punto": 34,
      "latitudeE7": 5.369851,
      "longitudeE7": -71.833647,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 42,
      "punto": 35,
      "latitudeE7": 5.369845,
      "longitudeE7": -71.833609,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 42,
      "punto": 36,
      "latitudeE7": 5.369839,
      "longitudeE7": -71.833571,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 42,
      "punto": 37,
      "latitudeE7": 5.369833,
      "longitudeE7": -71.833533,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 42,
      "punto": 38,
      "latitudeE7": 5.369827,
      "longitudeE7": -71.833496,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 42,
      "punto": 39,
      "latitudeE7": 5.369821,
      "longitudeE7": -71.833458,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 42,
      "punto": 40,
      "latitudeE7": 5.369815,
      "longitudeE7": -71.83342,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 42,
      "punto": 41,
      "latitudeE7": 5.369809,
      "longitudeE7": -71.833383,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 42,
      "punto": 42,
      "latitudeE7": 5.369803,
      "longitudeE7": -71.833345,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 42,
      "punto": 43,
      "latitudeE7": 5.369797,
      "longitudeE7": -71.833307,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 42,
      "punto": 44,
      "latitudeE7": 5.369791,
      "longitudeE7": -71.833269,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 42,
      "punto": 45,
      "latitudeE7": 5.369785,
      "longitudeE7": -71.833232,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 42,
      "punto": 46,
      "latitudeE7": 5.369779,
      "longitudeE7": -71.833194,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 42,
      "punto": 47,
      "latitudeE7": 5.369773,
      "longitudeE7": -71.833156,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 42,
      "punto": 48,
      "latitudeE7": 5.369767,
      "longitudeE7": -71.833119,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 42,
      "punto": 49,
      "latitudeE7": 5.369761,
      "longitudeE7": -71.833081,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 42,
      "punto": 50,
      "latitudeE7": 5.369755,
      "longitudeE7": -71.833043,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 42,
      "punto": 51,
      "latitudeE7": 5.369749,
      "longitudeE7": -71.833005,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 42,
      "punto": 52,
      "latitudeE7": 5.369743,
      "longitudeE7": -71.832968,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 42,
      "punto": 53,
      "latitudeE7": 5.369737,
      "longitudeE7": -71.83293,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 42,
      "punto": 54,
      "latitudeE7": 5.369731,
      "longitudeE7": -71.832892,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 42,
      "punto": 55,
      "latitudeE7": 5.369725,
      "longitudeE7": -71.832854,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 42,
      "punto": 56,
      "latitudeE7": 5.369719,
      "longitudeE7": -71.832817,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 42,
      "punto": 57,
      "latitudeE7": 5.369713,
      "longitudeE7": -71.832779,
      "accuracy": 15,
      "porcentaje": 0.52
    },
    {
      "linea": 42,
      "punto": 58,
      "latitudeE7": 5.369707,
      "longitudeE7": -71.832741,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 42,
      "punto": 59,
      "latitudeE7": 5.369701,
      "longitudeE7": -71.832704,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 42,
      "punto": 60,
      "latitudeE7": 5.369695,
      "longitudeE7": -71.832666,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 42,
      "punto": 61,
      "latitudeE7": 5.369689,
      "longitudeE7": -71.832628,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 42,
      "punto": 62,
      "latitudeE7": 5.369683,
      "longitudeE7": -71.83259,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 42,
      "punto": 63,
      "latitudeE7": 5.369677,
      "longitudeE7": -71.832553,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 42,
      "punto": 64,
      "latitudeE7": 5.369671,
      "longitudeE7": -71.832515,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 42,
      "punto": 65,
      "latitudeE7": 5.369665,
      "longitudeE7": -71.832477,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 42,
      "punto": 66,
      "latitudeE7": 5.369659,
      "longitudeE7": -71.83244,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 42,
      "punto": 67,
      "latitudeE7": 5.369653,
      "longitudeE7": -71.832402,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 42,
      "punto": 68,
      "latitudeE7": 5.369647,
      "longitudeE7": -71.832364,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 42,
      "punto": 69,
      "latitudeE7": 5.369641,
      "longitudeE7": -71.832326,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 42,
      "punto": 70,
      "latitudeE7": 5.369635,
      "longitudeE7": -71.832289,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 42,
      "punto": 71,
      "latitudeE7": 5.369629,
      "longitudeE7": -71.832251,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 42,
      "punto": 72,
      "latitudeE7": 5.369623,
      "longitudeE7": -71.832213,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 42,
      "punto": 73,
      "latitudeE7": 5.369617,
      "longitudeE7": -71.832176,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 42,
      "punto": 74,
      "latitudeE7": 5.369611,
      "longitudeE7": -71.832138,
      "accuracy": 25,
      "porcentaje": 0.08
    },
    {
      "linea": 42,
      "punto": 75,
      "latitudeE7": 5.369605,
      "longitudeE7": -71.8321,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 42,
      "punto": 76,
      "latitudeE7": 5.369599,
      "longitudeE7": -71.832062,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 42,
      "punto": 77,
      "latitudeE7": 5.369593,
      "longitudeE7": -71.832025,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 42,
      "punto": 78,
      "latitudeE7": 5.369587,
      "longitudeE7": -71.831987,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 42,
      "punto": 79,
      "latitudeE7": 5.369581,
      "longitudeE7": -71.831949,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 42,
      "punto": 80,
      "latitudeE7": 5.369575,
      "longitudeE7": -71.831911,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 42,
      "punto": 81,
      "latitudeE7": 5.369569,
      "longitudeE7": -71.831874,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 42,
      "punto": 82,
      "latitudeE7": 5.369563,
      "longitudeE7": -71.831836,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 42,
      "punto": 83,
      "latitudeE7": 5.369557,
      "longitudeE7": -71.831798,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 42,
      "punto": 84,
      "latitudeE7": 5.369551,
      "longitudeE7": -71.831761,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 42,
      "punto": 85,
      "latitudeE7": 5.369545,
      "longitudeE7": -71.831723,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 42,
      "punto": 86,
      "latitudeE7": 5.369539,
      "longitudeE7": -71.831685,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 42,
      "punto": 87,
      "latitudeE7": 5.369533,
      "longitudeE7": -71.831647,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 42,
      "punto": 88,
      "latitudeE7": 5.369527,
      "longitudeE7": -71.83161,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 42,
      "punto": 89,
      "latitudeE7": 5.369521,
      "longitudeE7": -71.831572,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 42,
      "punto": 90,
      "latitudeE7": 5.369515,
      "longitudeE7": -71.831534,
      "accuracy": 25,
      "porcentaje": 0.28
    },
    {
      "linea": 42,
      "punto": 91,
      "latitudeE7": 5.369509,
      "longitudeE7": -71.831497,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 42,
      "punto": 92,
      "latitudeE7": 5.369503,
      "longitudeE7": -71.831459,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 42,
      "punto": 93,
      "latitudeE7": 5.369497,
      "longitudeE7": -71.831421,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 42,
      "punto": 94,
      "latitudeE7": 5.369491,
      "longitudeE7": -71.831383,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 42,
      "punto": 95,
      "latitudeE7": 5.369485,
      "longitudeE7": -71.831346,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 42,
      "punto": 96,
      "latitudeE7": 5.369479,
      "longitudeE7": -71.831308,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 42,
      "punto": 97,
      "latitudeE7": 5.369473,
      "longitudeE7": -71.83127,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 42,
      "punto": 98,
      "latitudeE7": 5.369467,
      "longitudeE7": -71.831233,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 42,
      "punto": 99,
      "latitudeE7": 5.369461,
      "longitudeE7": -71.831195,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 42,
      "punto": 100,
      "latitudeE7": 5.369455,
      "longitudeE7": -71.831157,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 42,
      "punto": 101,
      "latitudeE7": 5.369449,
      "longitudeE7": -71.831119,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 42,
      "punto": 102,
      "latitudeE7": 5.369443,
      "longitudeE7": -71.831082,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 42,
      "punto": 103,
      "latitudeE7": 5.369437,
      "longitudeE7": -71.831044,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 42,
      "punto": 104,
      "latitudeE7": 5.369431,
      "longitudeE7": -71.831006,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 42,
      "punto": 105,
      "latitudeE7": 5.369425,
      "longitudeE7": -71.830968,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 42,
      "punto": 106,
      "latitudeE7": 5.369419,
      "longitudeE7": -71.830931,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 42,
      "punto": 107,
      "latitudeE7": 5.369413,
      "longitudeE7": -71.830893,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 42,
      "punto": 108,
      "latitudeE7": 5.369407,
      "longitudeE7": -71.830855,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 42,
      "punto": 109,
      "latitudeE7": 5.369401,
      "longitudeE7": -71.830818,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 42,
      "punto": 110,
      "latitudeE7": 5.369395,
      "longitudeE7": -71.83078,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 42,
      "punto": 111,
      "latitudeE7": 5.369389,
      "longitudeE7": -71.830742,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 42,
      "punto": 112,
      "latitudeE7": 5.369383,
      "longitudeE7": -71.830704,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 42,
      "punto": 113,
      "latitudeE7": 5.369377,
      "longitudeE7": -71.830667,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 42,
      "punto": 114,
      "latitudeE7": 5.369371,
      "longitudeE7": -71.830629,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 43,
      "punto": 1,
      "latitudeE7": 5.370009,
      "longitudeE7": -71.834916,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 43,
      "punto": 2,
      "latitudeE7": 5.370003,
      "longitudeE7": -71.834879,
      "accuracy": 5,
      "porcentaje": 0.52
    },
    {
      "linea": 43,
      "punto": 3,
      "latitudeE7": 5.369997,
      "longitudeE7": -71.834841,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 43,
      "punto": 4,
      "latitudeE7": 5.369991,
      "longitudeE7": -71.834803,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 43,
      "punto": 5,
      "latitudeE7": 5.369985,
      "longitudeE7": -71.834765,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 43,
      "punto": 6,
      "latitudeE7": 5.369979,
      "longitudeE7": -71.834728,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 43,
      "punto": 7,
      "latitudeE7": 5.369973,
      "longitudeE7": -71.83469,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 43,
      "punto": 8,
      "latitudeE7": 5.369967,
      "longitudeE7": -71.834652,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 43,
      "punto": 9,
      "latitudeE7": 5.369961,
      "longitudeE7": -71.834615,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 43,
      "punto": 10,
      "latitudeE7": 5.369955,
      "longitudeE7": -71.834577,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 43,
      "punto": 11,
      "latitudeE7": 5.369949,
      "longitudeE7": -71.834539,
      "accuracy": 5,
      "porcentaje": 0.2
    },
    {
      "linea": 43,
      "punto": 12,
      "latitudeE7": 5.369943,
      "longitudeE7": -71.834501,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 43,
      "punto": 13,
      "latitudeE7": 5.369937,
      "longitudeE7": -71.834464,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 43,
      "punto": 14,
      "latitudeE7": 5.369931,
      "longitudeE7": -71.834426,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 43,
      "punto": 15,
      "latitudeE7": 5.369925,
      "longitudeE7": -71.834388,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 43,
      "punto": 16,
      "latitudeE7": 5.369919,
      "longitudeE7": -71.834351,
      "accuracy": 5,
      "porcentaje": 0.12
    },
    {
      "linea": 43,
      "punto": 17,
      "latitudeE7": 5.369913,
      "longitudeE7": -71.834313,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 43,
      "punto": 18,
      "latitudeE7": 5.369907,
      "longitudeE7": -71.834275,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 43,
      "punto": 19,
      "latitudeE7": 5.369901,
      "longitudeE7": -71.834237,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 43,
      "punto": 20,
      "latitudeE7": 5.369895,
      "longitudeE7": -71.8342,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 43,
      "punto": 21,
      "latitudeE7": 5.369889,
      "longitudeE7": -71.834162,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 43,
      "punto": 22,
      "latitudeE7": 5.369883,
      "longitudeE7": -71.834124,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 43,
      "punto": 23,
      "latitudeE7": 5.369877,
      "longitudeE7": -71.834086,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 43,
      "punto": 24,
      "latitudeE7": 5.369871,
      "longitudeE7": -71.834049,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 43,
      "punto": 25,
      "latitudeE7": 5.369865,
      "longitudeE7": -71.834011,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 43,
      "punto": 26,
      "latitudeE7": 5.369859,
      "longitudeE7": -71.833973,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 43,
      "punto": 27,
      "latitudeE7": 5.369853,
      "longitudeE7": -71.833936,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 43,
      "punto": 28,
      "latitudeE7": 5.369847,
      "longitudeE7": -71.833898,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 43,
      "punto": 29,
      "latitudeE7": 5.369841,
      "longitudeE7": -71.83386,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 43,
      "punto": 30,
      "latitudeE7": 5.369835,
      "longitudeE7": -71.833822,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 43,
      "punto": 31,
      "latitudeE7": 5.369829,
      "longitudeE7": -71.833785,
      "accuracy": 5,
      "porcentaje": 0.8
    },
    {
      "linea": 43,
      "punto": 32,
      "latitudeE7": 5.369823,
      "longitudeE7": -71.833747,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 43,
      "punto": 33,
      "latitudeE7": 5.369817,
      "longitudeE7": -71.833709,
      "accuracy": 5,
      "porcentaje": 0.24
    },
    {
      "linea": 43,
      "punto": 34,
      "latitudeE7": 5.369811,
      "longitudeE7": -71.833672,
      "accuracy": 5,
      "porcentaje": 0.36
    },
    {
      "linea": 43,
      "punto": 35,
      "latitudeE7": 5.369805,
      "longitudeE7": -71.833634,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 43,
      "punto": 36,
      "latitudeE7": 5.369799,
      "longitudeE7": -71.833596,
      "accuracy": 5,
      "porcentaje": 0.08
    },
    {
      "linea": 43,
      "punto": 37,
      "latitudeE7": 5.369793,
      "longitudeE7": -71.833558,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 43,
      "punto": 38,
      "latitudeE7": 5.369787,
      "longitudeE7": -71.833521,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 43,
      "punto": 39,
      "latitudeE7": 5.369781,
      "longitudeE7": -71.833483,
      "accuracy": 5,
      "porcentaje": 0.64
    },
    {
      "linea": 43,
      "punto": 40,
      "latitudeE7": 5.369775,
      "longitudeE7": -71.833445,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 43,
      "punto": 41,
      "latitudeE7": 5.369769,
      "longitudeE7": -71.833408,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 43,
      "punto": 42,
      "latitudeE7": 5.369763,
      "longitudeE7": -71.83337,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 43,
      "punto": 43,
      "latitudeE7": 5.369757,
      "longitudeE7": -71.833332,
      "accuracy": 5,
      "porcentaje": 0.04
    },
    {
      "linea": 43,
      "punto": 44,
      "latitudeE7": 5.369751,
      "longitudeE7": -71.833294,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 43,
      "punto": 45,
      "latitudeE7": 5.369745,
      "longitudeE7": -71.833257,
      "accuracy": 5,
      "porcentaje": 0.68
    },
    {
      "linea": 43,
      "punto": 46,
      "latitudeE7": 5.369739,
      "longitudeE7": -71.833219,
      "accuracy": 5,
      "porcentaje": 0.76
    },
    {
      "linea": 43,
      "punto": 47,
      "latitudeE7": 5.369733,
      "longitudeE7": -71.833181,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 43,
      "punto": 48,
      "latitudeE7": 5.369727,
      "longitudeE7": -71.833143,
      "accuracy": 5,
      "porcentaje": 0.16
    },
    {
      "linea": 43,
      "punto": 49,
      "latitudeE7": 5.369721,
      "longitudeE7": -71.833106,
      "accuracy": 5,
      "porcentaje": 0.6
    },
    {
      "linea": 43,
      "punto": 50,
      "latitudeE7": 5.369715,
      "longitudeE7": -71.833068,
      "accuracy": 5,
      "porcentaje": 0.32
    },
    {
      "linea": 43,
      "punto": 51,
      "latitudeE7": 5.369709,
      "longitudeE7": -71.83303,
      "accuracy": 5,
      "porcentaje": 0
    },
    {
      "linea": 43,
      "punto": 52,
      "latitudeE7": 5.369703,
      "longitudeE7": -71.832993,
      "accuracy": 5,
      "porcentaje": 0.44
    },
    {
      "linea": 43,
      "punto": 53,
      "latitudeE7": 5.369697,
      "longitudeE7": -71.832955,
      "accuracy": 5,
      "porcentaje": 0.4
    },
    {
      "linea": 43,
      "punto": 54,
      "latitudeE7": 5.369691,
      "longitudeE7": -71.832917,
      "accuracy": 5,
      "porcentaje": 0.28
    },
    {
      "linea": 43,
      "punto": 55,
      "latitudeE7": 5.369685,
      "longitudeE7": -71.832879,
      "accuracy": 5,
      "porcentaje": 0.72
    },
    {
      "linea": 43,
      "punto": 56,
      "latitudeE7": 5.369679,
      "longitudeE7": -71.832842,
      "accuracy": 5,
      "porcentaje": 0.56
    },
    {
      "linea": 43,
      "punto": 57,
      "latitudeE7": 5.369673,
      "longitudeE7": -71.832804,
      "accuracy": 15,
      "porcentaje": 0.68
    },
    {
      "linea": 43,
      "punto": 58,
      "latitudeE7": 5.369667,
      "longitudeE7": -71.832766,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 43,
      "punto": 59,
      "latitudeE7": 5.369661,
      "longitudeE7": -71.832729,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 43,
      "punto": 60,
      "latitudeE7": 5.369655,
      "longitudeE7": -71.832691,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 43,
      "punto": 61,
      "latitudeE7": 5.369649,
      "longitudeE7": -71.832653,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 43,
      "punto": 62,
      "latitudeE7": 5.369643,
      "longitudeE7": -71.832615,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 43,
      "punto": 63,
      "latitudeE7": 5.369637,
      "longitudeE7": -71.832578,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 43,
      "punto": 64,
      "latitudeE7": 5.369631,
      "longitudeE7": -71.83254,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 43,
      "punto": 65,
      "latitudeE7": 5.369625,
      "longitudeE7": -71.832502,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 43,
      "punto": 66,
      "latitudeE7": 5.369619,
      "longitudeE7": -71.832465,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 43,
      "punto": 67,
      "latitudeE7": 5.369613,
      "longitudeE7": -71.832427,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 43,
      "punto": 68,
      "latitudeE7": 5.369607,
      "longitudeE7": -71.832389,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 43,
      "punto": 69,
      "latitudeE7": 5.369601,
      "longitudeE7": -71.832351,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 43,
      "punto": 70,
      "latitudeE7": 5.369595,
      "longitudeE7": -71.832314,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 43,
      "punto": 71,
      "latitudeE7": 5.369589,
      "longitudeE7": -71.832276,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 43,
      "punto": 72,
      "latitudeE7": 5.369583,
      "longitudeE7": -71.832238,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 43,
      "punto": 73,
      "latitudeE7": 5.369577,
      "longitudeE7": -71.8322,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 43,
      "punto": 74,
      "latitudeE7": 5.369571,
      "longitudeE7": -71.832163,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 43,
      "punto": 75,
      "latitudeE7": 5.369565,
      "longitudeE7": -71.832125,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 43,
      "punto": 76,
      "latitudeE7": 5.369559,
      "longitudeE7": -71.832087,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 43,
      "punto": 77,
      "latitudeE7": 5.369553,
      "longitudeE7": -71.83205,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 43,
      "punto": 78,
      "latitudeE7": 5.369547,
      "longitudeE7": -71.832012,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 43,
      "punto": 79,
      "latitudeE7": 5.369541,
      "longitudeE7": -71.831974,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 43,
      "punto": 80,
      "latitudeE7": 5.369535,
      "longitudeE7": -71.831936,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 43,
      "punto": 81,
      "latitudeE7": 5.369529,
      "longitudeE7": -71.831899,
      "accuracy": 25,
      "porcentaje": 0
    },
    {
      "linea": 43,
      "punto": 82,
      "latitudeE7": 5.369523,
      "longitudeE7": -71.831861,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 43,
      "punto": 83,
      "latitudeE7": 5.369517,
      "longitudeE7": -71.831823,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 43,
      "punto": 84,
      "latitudeE7": 5.369511,
      "longitudeE7": -71.831786,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 43,
      "punto": 85,
      "latitudeE7": 5.369505,
      "longitudeE7": -71.831748,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 43,
      "punto": 86,
      "latitudeE7": 5.369499,
      "longitudeE7": -71.83171,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 43,
      "punto": 87,
      "latitudeE7": 5.369493,
      "longitudeE7": -71.831672,
      "accuracy": 25,
      "porcentaje": 0.8
    },
    {
      "linea": 43,
      "punto": 88,
      "latitudeE7": 5.369487,
      "longitudeE7": -71.831635,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 43,
      "punto": 89,
      "latitudeE7": 5.369481,
      "longitudeE7": -71.831597,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 43,
      "punto": 90,
      "latitudeE7": 5.369475,
      "longitudeE7": -71.831559,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 43,
      "punto": 91,
      "latitudeE7": 5.369469,
      "longitudeE7": -71.831522,
      "accuracy": 25,
      "porcentaje": 0.16
    },
    {
      "linea": 43,
      "punto": 92,
      "latitudeE7": 5.369463,
      "longitudeE7": -71.831484,
      "accuracy": 25,
      "porcentaje": 0.48
    },
    {
      "linea": 43,
      "punto": 93,
      "latitudeE7": 5.369457,
      "longitudeE7": -71.831446,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 43,
      "punto": 94,
      "latitudeE7": 5.369451,
      "longitudeE7": -71.831408,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 43,
      "punto": 95,
      "latitudeE7": 5.369445,
      "longitudeE7": -71.831371,
      "accuracy": 25,
      "porcentaje": 0.76
    },
    {
      "linea": 43,
      "punto": 96,
      "latitudeE7": 5.369439,
      "longitudeE7": -71.831333,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 43,
      "punto": 97,
      "latitudeE7": 5.369433,
      "longitudeE7": -71.831295,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 43,
      "punto": 98,
      "latitudeE7": 5.369427,
      "longitudeE7": -71.831257,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 43,
      "punto": 99,
      "latitudeE7": 5.369421,
      "longitudeE7": -71.83122,
      "accuracy": 25,
      "porcentaje": 0.32
    },
    {
      "linea": 43,
      "punto": 100,
      "latitudeE7": 5.369415,
      "longitudeE7": -71.831182,
      "accuracy": 25,
      "porcentaje": 0.4
    },
    {
      "linea": 43,
      "punto": 101,
      "latitudeE7": 5.369409,
      "longitudeE7": -71.831144,
      "accuracy": 25,
      "porcentaje": 0.56
    },
    {
      "linea": 43,
      "punto": 102,
      "latitudeE7": 5.369403,
      "longitudeE7": -71.831107,
      "accuracy": 25,
      "porcentaje": 0.2
    },
    {
      "linea": 43,
      "punto": 103,
      "latitudeE7": 5.369397,
      "longitudeE7": -71.831069,
      "accuracy": 25,
      "porcentaje": 0.68
    },
    {
      "linea": 43,
      "punto": 104,
      "latitudeE7": 5.369391,
      "longitudeE7": -71.831031,
      "accuracy": 25,
      "porcentaje": 0.04
    },
    {
      "linea": 43,
      "punto": 105,
      "latitudeE7": 5.369385,
      "longitudeE7": -71.830993,
      "accuracy": 25,
      "porcentaje": 0.12
    },
    {
      "linea": 43,
      "punto": 106,
      "latitudeE7": 5.369379,
      "longitudeE7": -71.830956,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 43,
      "punto": 107,
      "latitudeE7": 5.369373,
      "longitudeE7": -71.830918,
      "accuracy": 25,
      "porcentaje": 0.52
    },
    {
      "linea": 43,
      "punto": 108,
      "latitudeE7": 5.369367,
      "longitudeE7": -71.83088,
      "accuracy": 25,
      "porcentaje": 0.64
    },
    {
      "linea": 43,
      "punto": 109,
      "latitudeE7": 5.369361,
      "longitudeE7": -71.830843,
      "accuracy": 25,
      "porcentaje": 0.72
    },
    {
      "linea": 43,
      "punto": 110,
      "latitudeE7": 5.369355,
      "longitudeE7": -71.830805,
      "accuracy": 25,
      "porcentaje": 0.6
    },
    {
      "linea": 43,
      "punto": 111,
      "latitudeE7": 5.369349,
      "longitudeE7": -71.830767,
      "accuracy": 25,
      "porcentaje": 0.44
    },
    {
      "linea": 43,
      "punto": 112,
      "latitudeE7": 5.369343,
      "longitudeE7": -71.830729,
      "accuracy": 25,
      "porcentaje": 0.24
    },
    {
      "linea": 43,
      "punto": 113,
      "latitudeE7": 5.369337,
      "longitudeE7": -71.830692,
      "accuracy": 25,
      "porcentaje": 0.36
    },
    {
      "linea": 43,
      "punto": 114,
      "latitudeE7": 5.369331,
      "longitudeE7": -71.830654,
      "accuracy": 25,
      "porcentaje": 0.2
    }
   ]